
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("cJVho", function(module, exports) {

$parcel$export(module.exports, "socket", () => $94661e82873784cd$export$4f55ed1789bc2dcb);
$parcel$export(module.exports, "getPortfolioId", () => $94661e82873784cd$export$141bbd10c4c06cba);
$parcel$export(module.exports, "connectWebSocket", () => $94661e82873784cd$export$72947bc920927fd0);
$parcel$export(module.exports, "waitForSocketConnection", () => $94661e82873784cd$export$8c106f812aa1ca2a);

var $73MNt = parcelRequire("73MNt");

var $eD3DY = parcelRequire("eD3DY");

var $86ioh = parcelRequire("86ioh");

var $2C8cW = parcelRequire("2C8cW");

var $jL4uR = parcelRequire("jL4uR");

var $bNbKd = parcelRequire("bNbKd");

var $1cx8d = parcelRequire("1cx8d");

var $1NhFL = parcelRequire("1NhFL");

var $8X27K = parcelRequire("8X27K");

var $eevDZ = parcelRequire("eevDZ");

var $29zN8 = parcelRequire("29zN8");

var $alKwv = parcelRequire("alKwv");

var $bzRv7 = parcelRequire("bzRv7");

var $eCgl8 = parcelRequire("eCgl8");

var $gwQDn = parcelRequire("gwQDn");

var $iD9HX = parcelRequire("iD9HX");

var $cNeIB = parcelRequire("cNeIB");

var $fUPn2 = parcelRequire("fUPn2");
parcelRequire("15BR8");

var $epcPG = parcelRequire("epcPG");

var $lfdrK = parcelRequire("lfdrK");
let $94661e82873784cd$export$4f55ed1789bc2dcb;
let $94661e82873784cd$var$isProcessingMessage = false;
const $94661e82873784cd$export$8d5992b88d21f8fe = [];
let $94661e82873784cd$var$reconnectTimeout;
let $94661e82873784cd$var$isConnected = false;
let $94661e82873784cd$var$reconnectAttempts = 0;
const $94661e82873784cd$var$MAX_RECONNECT_ATTEMPTS = 5;
const $94661e82873784cd$var$RECONNECT_DELAY = 3000;
// Track attached handlers for cleanup
let $94661e82873784cd$var$handlersAttached = false;
let $94661e82873784cd$var$emotionalMeter = null;
let $94661e82873784cd$var$beforeUnloadHandler = null;
class $94661e82873784cd$var$MessageQueue {
    constructor(){
        this.queue = [];
        this.isProcessing = false;
        this.maxSize = 50;
    }
    enqueue(message) {
        if (this.queue.length >= this.maxSize) {
            const removed = this.queue.shift();
            console.warn("\u26A0\uFE0F MessageQueue full - dropped oldest message:", removed);
        }
        this.queue.push(message);
        this.processQueue();
    }
    async processQueue() {
        if (this.isProcessing || this.queue.length === 0 || !$94661e82873784cd$export$4f55ed1789bc2dcb || !$94661e82873784cd$export$4f55ed1789bc2dcb.connected) return;
        this.isProcessing = true;
        while(this.queue.length > 0 && $94661e82873784cd$export$4f55ed1789bc2dcb.connected){
            const message = this.queue.shift();
            try {
                await this.sendMessage(message);
            } catch (error) {
                console.error('Error sending message:', error);
                this.queue.unshift(message);
                break;
            }
        }
        this.isProcessing = false;
    }
    sendMessage(message) {
        return new Promise((resolve, reject)=>{
            $94661e82873784cd$export$4f55ed1789bc2dcb.emit('message', message, (error)=>{
                if (error) reject(error);
                else resolve();
            });
        });
    }
    clear() {
        this.queue = [];
        this.isProcessing = false;
    }
}
const $94661e82873784cd$var$clientMessageQueue = new $94661e82873784cd$var$MessageQueue();
function $94661e82873784cd$var$getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
function $94661e82873784cd$export$141bbd10c4c06cba() {
    return $94661e82873784cd$var$getCookie('portfolioId') || localStorage.getItem('portfolioId');
}
/**
 * A trigger (steal / ransom / LBO / subsidy / dark pool / communist assault) has
 * just been granted to this trader mid-session.
 *
 * These five socket handlers used to call displayDeletePortfolioButton(true),
 * displayLBOButton(true) &c. directly — but those functions are module-private
 * inner functions of trader.js and were never imported here, so every call was
 * an unresolved identifier that threw ReferenceError. A trigger granted during
 * a session therefore never appeared on ANY page until a manual reload.
 *
 * Announcing it instead lets each interface react in its own way: trader.js
 * calls its local display*Button(true), and zfloor.js refetches the portfolio
 * (the has*Button flags are authoritative there) and re-runs its armed check.
 */ function $94661e82873784cd$var$announceToolGranted(toolId) {
    document.dispatchEvent(new CustomEvent('zx:toolGranted', {
        detail: toolId
    }));
}
function $94661e82873784cd$export$28707ccaee758d3c() {
    console.log("\uD83D\uDD04 [resetSocket] Resetting socket state for fresh simulation...");
    // Clean up emotional meter
    if ($94661e82873784cd$var$emotionalMeter) $94661e82873784cd$var$emotionalMeter = null;
    // Remove beforeunload handler
    if ($94661e82873784cd$var$beforeUnloadHandler) {
        window.removeEventListener('beforeunload', $94661e82873784cd$var$beforeUnloadHandler);
        $94661e82873784cd$var$beforeUnloadHandler = null;
    }
    if ($94661e82873784cd$export$4f55ed1789bc2dcb) {
        $94661e82873784cd$export$4f55ed1789bc2dcb.removeAllListeners();
        if ($94661e82873784cd$export$4f55ed1789bc2dcb.connected) $94661e82873784cd$export$4f55ed1789bc2dcb.disconnect();
        $94661e82873784cd$export$4f55ed1789bc2dcb = null;
    }
    // Reset module state
    $94661e82873784cd$var$isConnected = false;
    $94661e82873784cd$var$reconnectAttempts = 0;
    $94661e82873784cd$var$handlersAttached = false;
    if ($94661e82873784cd$var$reconnectTimeout) {
        clearTimeout($94661e82873784cd$var$reconnectTimeout);
        $94661e82873784cd$var$reconnectTimeout = null;
    }
    // Clear message queues
    $94661e82873784cd$var$clientMessageQueue.clear();
    $94661e82873784cd$export$8d5992b88d21f8fe.length = 0;
    $94661e82873784cd$var$isProcessingMessage = false;
    // Remove any lingering popup/modal elements
    const popupSelectors = [
        '#eulogy-loading-popup',
        '#phase-transition-modal',
        '.simulation-warning',
        '#simulationTimer'
    ];
    popupSelectors.forEach((selector)=>{
        const element = document.querySelector(selector);
        if (element) {
            element.remove();
            console.log(`\u{1F9F9} [resetSocket] Removed lingering element: ${selector}`);
        }
    });
    console.log("\u2705 [resetSocket] Socket state reset complete");
}
function $94661e82873784cd$export$72947bc920927fd0(botToken = null, botPortfolioId = null, botSessionId = null) {
    if ($94661e82873784cd$export$4f55ed1789bc2dcb && ($94661e82873784cd$export$4f55ed1789bc2dcb.connected || $94661e82873784cd$export$4f55ed1789bc2dcb.connecting)) {
        console.log('WebSocket is already connected or connecting.');
        return;
    }
    const portfolioId = botPortfolioId || $94661e82873784cd$export$141bbd10c4c06cba();
    const token = botToken || $94661e82873784cd$var$getCookie('token') || localStorage.getItem('token');
    const sessionId = localStorage.getItem('sessionId');
    const hyperUserPortfolioId = "675170ea341c0618fbec21ee";
    const isHyperUser = portfolioId === hyperUserPortfolioId;
    const isBot = !!(botToken && botPortfolioId);
    console.log("\uD83D\uDD0C Connecting WebSocket:", {
        isBot: isBot,
        portfolioId: portfolioId?.substring(0, 8) + '...',
        hasToken: !!token,
        sessionId: sessionId?.substring(0, 8) + '...'
    });
    if (!isHyperUser && (!portfolioId || !token || !sessionId)) {
        console.error('No portfolio ID, token, or session ID found. Cannot connect to WebSocket.');
        return;
    }
    $94661e82873784cd$export$4f55ed1789bc2dcb = (0, $73MNt.default)(`${(0, $cNeIB.apiBaseSocket)}`, {
        query: isHyperUser ? {
            userId: portfolioId
        } : {
            userId: portfolioId,
            token: token,
            sessionId: sessionId,
            isBot: isBot
        },
        transports: [
            'websocket'
        ],
        reconnectionAttempts: $94661e82873784cd$var$MAX_RECONNECT_ATTEMPTS,
        reconnectionDelay: 1000,
        timeout: 10000
    });
    $94661e82873784cd$export$4f55ed1789bc2dcb.on('connect', ()=>{
        console.log('Connected to WebSocket');
        $94661e82873784cd$var$isConnected = true;
        $94661e82873784cd$var$reconnectAttempts = 0;
        window.popupTrackerSocket = $94661e82873784cd$export$4f55ed1789bc2dcb;
        window.socket = $94661e82873784cd$export$4f55ed1789bc2dcb;
        if (window.popupTracker) {
            window.popupTracker.initialize($94661e82873784cd$export$4f55ed1789bc2dcb);
            console.log("\uD83D\uDD17 [SocketU] Initialized popup tracker with socket connection");
        }
        if (isBot) {
            console.log(`\u{1F916} Registering bot: ${botPortfolioId}`);
            $94661e82873784cd$export$4f55ed1789bc2dcb.emit('registerBot', {
                portfolioId: botPortfolioId,
                token: botToken,
                socketId: $94661e82873784cd$export$4f55ed1789bc2dcb.id
            });
        } else localStorage.setItem('socketId', $94661e82873784cd$export$4f55ed1789bc2dcb.id);
        $94661e82873784cd$var$clientMessageQueue.processQueue();
        // Attach handlers only once per socket instance
        if (!$94661e82873784cd$var$handlersAttached) {
            $94661e82873784cd$var$attachSocketHandlers($94661e82873784cd$export$4f55ed1789bc2dcb, isBot, portfolioId);
            $94661e82873784cd$var$handlersAttached = true;
        }
    });
    $94661e82873784cd$export$4f55ed1789bc2dcb.on('connect_error', (error)=>{
        console.error('WebSocket connection error:', error);
        $94661e82873784cd$var$handleReconnect();
    });
    $94661e82873784cd$export$4f55ed1789bc2dcb.on('disconnect', (reason)=>{
        console.log(`WebSocket connection closed: ${reason}`);
        $94661e82873784cd$var$isConnected = false;
    });
}


/**
 * Attach all socket event handlers - called only once per connection
 */ function $94661e82873784cd$var$attachSocketHandlers(socket, isBot, portfolioId) {
    console.log("\uD83D\uDD17 [SocketU] Attaching socket handlers...");
    socket.on('simulation:ended', (payload)=>{
        const isSimulated = localStorage.getItem('isSimulated') === 'true';
        const simulationType = localStorage.getItem('simulationType');
        if (isSimulated || simulationType) {
            console.log("\uD83C\uDFAF Simulation ended for simulated user:", payload);
            window.dispatchEvent(new CustomEvent('simulation-ended', {
                detail: {
                    payload: payload
                }
            }));
        } else console.log("\uD83D\uDEE1\uFE0F Ignored simulation:ended event for normal user.");
    });
    socket.on('receiveMessage', (message)=>{
        if (message.senderName && (message.senderName.includes('_') || message.senderName.match(/\d{4}$/))) message.isBot = true;
        if (message.botData && message.botData._id) {
            const currentUserId = localStorage.getItem('portfolioId');
            if (currentUserId) {
                const storageKey = `botMessage_${message.botData._id}_${currentUserId}`;
                const messageData = {
                    content: message.content,
                    botData: message.botData,
                    tradingContext: message.tradingContext,
                    recommendedAction: message.recommendedAction,
                    specificStock: message.specificStock,
                    specificItem: message.specificItem,
                    tradingLinks: message.tradingLinks,
                    timestamp: Date.now()
                };
                localStorage.setItem(storageKey, JSON.stringify(messageData));
                console.log("\uD83D\uDCBE Stored bot message in localStorage:", storageKey);
            }
        }
        (0, $29zN8.displayReceivedMessage)(message);
        // FIX: Use setTimeout cleanup instead of creating orphan DOM elements
        const messageElement = document.createElement('div');
        messageElement.innerText = message.content;
        document.body.appendChild(messageElement);
        const cleanupTimer = setTimeout(()=>{
            if (messageElement && messageElement.parentNode) messageElement.parentNode.removeChild(messageElement);
        }, 5000);
        // Store timer reference for potential cleanup
        messageElement._cleanupTimer = cleanupTimer;
    });
    socket.on('messageError', (error)=>{
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.messageError', 'Error sending message:')} ${error}`, false);
    });
    socket.on('zollarAssigned', (data)=>{
        console.log('Received zollarAssigned event:', data);
        const portfolioId = data.portfolioId || null;
        (0, $jL4uR.showZollarSelectedAssign)([
            portfolioId
        ], data.message);
    });
    // The curator. Relayed as a DOM event rather than handled here, the same way
    // announceToolGranted() relays zx:toolGranted: socketU owns the socket, the
    // floor owns the floor. Only zfloor listens, so this is inert elsewhere.
    // More time was added to the session. Relayed like curatorEvent; the floor
    // decides what to do with it.
    socket.on('sessionExtended', (data)=>{
        try {
            document.dispatchEvent(new CustomEvent('zx:sessionExtended', {
                detail: data
            }));
        } catch (err) {
            console.warn('[socketU] sessionExtended relay failed:', err?.message || err);
        }
    });
    socket.on('curatorEvent', (data)=>{
        try {
            document.dispatchEvent(new CustomEvent('zx:curator', {
                detail: data
            }));
        } catch (err) {
            console.warn('[socketU] curatorEvent relay failed:', err?.message || err);
        }
    });
    socket.on('cdsEvent', (payload)=>{
        try {
            console.log("\uD83D\uDCE1 CDS Event Received:", payload);
            if (!payload || !payload.data) return;
            const { role: role, phase: phase, data: data } = payload;
            if (role === 'victim' && phase === 'collapse') (0, $iD9HX.handleCDSVictimCollapse)(data);
            else if (role === 'exploiter' && phase === 'collapse') (0, $iD9HX.handleCDSExploiterGuilt)(data);
            else if (phase === 'init') (0, $iD9HX.handleCDSInitiation)(data);
            else console.warn("\u26A0\uFE0F Unknown CDS phase:", phase);
        } catch (err) {
            console.error("\u274C Error handling cdsEvent:", err);
        }
    });
    // === Emotional Updates ===
    socket.on('emotionalUpdate', async ({ sessionId: sessionId })=>{
        const portfolioId = localStorage.getItem('portfolioId');
        if (!portfolioId) return;
        if (!$94661e82873784cd$var$emotionalMeter) {
            $94661e82873784cd$var$emotionalMeter = new (0, $gwQDn.default)('emotional-debt-meter', portfolioId);
            await $94661e82873784cd$var$emotionalMeter.init();
        } else await $94661e82873784cd$var$emotionalMeter.fetchData();
        console.log(`\u{1F4AB} Emotional debt meter updated for session ${sessionId}`);
    });
    // === Social Economy Requests ===
    socket.on('socialEconomyRequest', (data)=>{
        console.log('Social economy request received:', data);
        const { type: type, fromName: fromName, requesterName: requesterName, amount: amount, humanInterest: humanInterest, package: pkg, vulnerabilityReason: vulnerabilityReason, vulnerabilityScore: vulnerabilityScore, abstractRequest: abstractRequest, principalType: principalType } = data;
        const sender = fromName || requesterName || 'Someone';
        let msg, title, modalType;
        const getQualitativeDescriptor = (quantity, max)=>{
            const q = Number(quantity) || 0;
            const m = Number(max);
            if (q <= 0) return 'None';
            if (m && m > 0) {
                const r = q / m;
                if (r <= 0.01) return 'None';
                if (r <= 0.03) return 'Barely Any';
                if (r <= 0.07) return 'A Trace';
                if (r <= 0.12) return 'A Hint';
                if (r <= 0.18) return 'A Little';
                if (r <= 0.26) return 'A Few';
                if (r <= 0.33) return 'Some';
                if (r <= 0.40) return 'Several';
                if (r <= 0.50) return 'Moderate';
                if (r <= 0.58) return 'Noticeable';
                if (r <= 0.65) return 'Considerable';
                if (r <= 0.72) return 'Many';
                if (r <= 0.78) return 'A Lot';
                if (r <= 0.83) return 'Abundant';
                if (r <= 0.88) return 'Heaps';
                if (r <= 0.92) return 'A Great Deal';
                if (r <= 0.95) return 'Almost All';
                if (r <= 0.97) return 'Nearly Everything';
                if (r <= 0.985) return 'Overflowing';
                if (r <= 0.995) return 'Virtually Everything';
                return 'All You Have';
            }
            if (q <= 0) return 'None';
            if (q <= 1) return 'Barely Any';
            if (q <= 2) return 'A Trace';
            if (q <= 3) return 'A Hint';
            if (q <= 4) return 'A Little';
            if (q <= 6) return 'A Few';
            if (q <= 9) return 'Some';
            if (q <= 12) return 'Several';
            if (q <= 16) return 'Moderate';
            if (q <= 20) return 'Noticeable';
            if (q <= 26) return 'Considerable';
            if (q <= 33) return 'Many';
            if (q <= 40) return 'A Lot';
            if (q <= 55) return 'Abundant';
            if (q <= 70) return 'Heaps';
            if (q <= 90) return 'A Great Deal';
            if (q <= 120) return 'Substantial';
            if (q <= 160) return 'Ample';
            if (q <= 210) return 'Extensive';
            if (q <= 260) return 'Vast';
            if (q <= 320) return 'Profuse';
            if (q <= 380) return 'Almost All';
            if (q <= 440) return 'Nearly Everything';
            if (q <= 490) return 'Virtually Everything';
            return 'All You Have';
        };
        const qLabel = getQualitativeDescriptor;
        if (type === 'help') {
            title = 'Gift Offer';
            const zCount = pkg?.zollars ? typeof pkg.zollars === 'number' ? pkg.zollars : Object.values(pkg.zollars || {}).reduce((a, b)=>a + (Number(b) || 0), 0) : 0;
            const zollarLabel = zCount > 0 ? qLabel(zCount, 100) : null;
            const capitalLabel = !zollarLabel && amount ? qLabel(amount, 1000) : null;
            const giftText = zollarLabel ? `${zollarLabel} Z$` : capitalLabel ? `${capitalLabel} capital` : 'some assets';
            msg = `<p><strong>${sender}</strong> wants to give you <strong>${giftText}</strong>.</p><p>Accept this generous gift?</p>`;
            modalType = 'success';
        } else if (type === 'loan') {
            const vulnText = vulnerabilityReason ? `<div style="margin:16px 0;padding:12px;background:rgba(252,186,3,0.15);border:2px solid #fcba03;border-radius:8px;">
	   <p style="font-family:'bithigh',monospace;font-size:0.95em;color:#fcba03;margin-bottom:6px;font-weight:bold;">Their vulnerability disclosure:</p>
	   <p style="font-style:italic;color:#fff;font-size:1.05em;line-height:1.5;">"${vulnerabilityReason}"</p>
	 </div>` : '';
            const zollarMag = abstractRequest?.zollarMagnitude || 0;
            const capitalMag = abstractRequest?.capitalMagnitude || 0;
            const requestMagnitude = getQualitativeDescriptor(Math.max(zollarMag, capitalMag), 100);
            title = 'M Note Loan Request';
            msg = `<p style="margin-bottom:12px;"><strong>${sender}</strong> is requesting a loan from you.</p>${vulnText}<p style="margin-top:12px;color:#999;font-size:0.9em;">Request magnitude: <strong style="color:#fcba03;">${requestMagnitude}</strong></p><p style="margin-top:8px;font-size:0.9em;color:#999;">Will you provide this loan?</p>`;
            modalType = 'warning';
        } else if (type === 'cds') {
            const pType = (principalType || pkg && pkg.principalType || 'capital').toLowerCase();
            let offeredQty;
            if (pType === 'zollars') {
                const rawZ = pkg?.zollars;
                if (typeof rawZ === 'object' && rawZ !== null && !Array.isArray(rawZ)) offeredQty = Object.values(rawZ).reduce((a, b)=>a + (Number(b) || 0), 0);
                else {
                    const zCount = Array.isArray(rawZ) ? rawZ.length : Number(rawZ);
                    offeredQty = Number.isFinite(zCount) && zCount > 0 ? zCount : Number(amount) || 0;
                }
            } else offeredQty = Number(amount) || 0;
            const headline = pType === 'zollars' ? `<strong>${qLabel(offeredQty, 100)} \u{1B5}</strong> available immediately!` : `<strong>${offeredQty.toLocaleString()} capital</strong> available immediately!`;
            title = 'Premium Funding Opportunity';
            msg = `<p><strong>${sender}</strong> is offering you an <strong>exclusive Z-Payday Premium Package</strong>:</p>
	   <p style="font-size:1.1em;color:#3dd202;margin:10px 0;">${headline}</p>
	   <p style="color:#fcba03;">Fast-track financing with flexible terms</p>
	   <p style="color:#fcba03;">Quick access to capital when you need it most</p>
	   <p style="color:#fcba03;">Dynamic growth potential for your portfolio</p>
	   <p style="font-size:0.85em;color:#888;margin-top:12px;">Accept this limited-time opportunity?</p>`;
            modalType = 'success';
        } else if (type === 'v_note') {
            const vulnText = vulnerabilityReason ? `<div style="margin:16px 0;padding:12px;background:rgba(252,186,3,0.15);border:2px solid #fcba03;border-radius:8px;">
	   <p style="font-family:'bithigh',monospace;font-size:0.95em;color:#fcba03;margin-bottom:6px;font-weight:bold;">Their vulnerability disclosure:</p>
	   <p style="font-style:italic;color:#fff;font-size:1.05em;line-height:1.5;">"${vulnerabilityReason}"</p>
	 </div>` : '';
            const severityText = typeof vulnerabilityScore === 'number' ? `<p style="font-size:0.9em;color:#999;margin-top:8px;">Situation severity: <strong style="color:#fcba03;">${(0, $iD9HX.qualitativeFromFraction_LOCAL)(Math.max(0, Math.min(1, vulnerabilityScore)))}</strong></p>` : '';
            title = 'V Note Aid Request';
            msg = `<p style="margin-bottom:12px;"><strong>${sender}</strong> is requesting aid from you and has disclosed their vulnerability:</p>${vulnText}${severityText}<p style="margin-top:12px;font-size:0.9em;color:#999;">Will you grant aid to this request?</p>`;
            modalType = 'warning';
        } else {
            title = 'Social Economy Request';
            msg = `<p><strong>${sender}</strong> sent you a social economy request.</p>`;
            modalType = 'warning';
        }
        (0, $epcPG.showHoloConfirm)({
            title: title,
            message: msg,
            type: modalType,
            acceptText: 'Accept',
            declineText: 'Decline',
            onAccept: ()=>{
                socket.emit('socialEconomyResponse', {
                    accepted: true,
                    type: type,
                    fromName: sender,
                    amount: amount,
                    package: pkg,
                    requesterId: data.requesterId,
                    sessionId: data.sessionId,
                    humanInterest: data.humanInterest,
                    vulnerabilityReason: data.vulnerabilityReason,
                    vulnerabilityScore: data.vulnerabilityScore,
                    principalType: data.principalType
                });
            },
            onDecline: ()=>{
                socket.emit('socialEconomyResponse', {
                    accepted: false,
                    type: type,
                    fromName: sender,
                    amount: amount,
                    package: pkg,
                    requesterId: data.requesterId,
                    sessionId: data.sessionId,
                    humanInterest: data.humanInterest,
                    vulnerabilityReason: data.vulnerabilityReason,
                    vulnerabilityScore: data.vulnerabilityScore,
                    principalType: data.principalType
                });
            }
        });
    });
    // === Debt Instrument Events ===
    (0, $lfdrK.registerDebtPopupHandlers)(socket);
    // === Social Economy Responses ===
    socket.on('socialEconomyResponse', (data)=>{
        console.log("\uD83D\uDCAC [Frontend] Social economy response received!");
        console.log("\uD83D\uDCAC [Frontend] Data:", JSON.stringify(data, null, 2));
        const message = data.accepted ? `${data.fromName} accepted your ${data.type} request.` : `${data.fromName} declined your ${data.type} request.`;
        if (typeof (0, $iD9HX.modalManager) !== 'undefined' && (0, $iD9HX.modalManager).showMessage) (0, $iD9HX.modalManager).showMessage(message, data.accepted, null);
        else (0, $eD3DY.showNotification)(message, data.accepted);
        if (window.emotionalMeter) window.emotionalMeter.fetchData();
    });
    socket.on('botVulnerabilityShared', (data)=>{
        console.log("\uD83D\uDCAD Bot vulnerability message received:", data);
        const { botName: botName, message: message, vulnerabilityType: vulnerabilityType, emotionalContext: emotionalContext } = data;
        const displayMessage = message || (0, $fUPn2.t)('socketFront.botVulnerabilityDefault', '{botName} has shared something personal with you.').replace('{botName}', botName || 'A bot');
        if (typeof (0, $iD9HX.modalManager) !== 'undefined' && (0, $iD9HX.modalManager).showMessage) (0, $iD9HX.modalManager).showMessage(displayMessage, true, null);
        else (0, $eD3DY.showNotification)(displayMessage, true);
        if (window.emotionalMeter) window.emotionalMeter.fetchData();
    });
    socket.on('memento_mori_announced', (data)=>{
        console.log("\uD83C\uDFFA Memento Mori announced:", data);
        (0, $1cx8d.showMementoMoriAnnouncement)(data);
    });
    socket.on('memento_mori_completed', (data)=>{
        console.log("\u2705 Memento Mori completed:", data);
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.mementoComplete', 'You have completed your contemplation of mortality.'), true);
    });
    socket.on('memento_mori_session_event', (data)=>{
        console.log("\uD83C\uDFFA Session event:", data);
        (0, $eD3DY.showNotification)(data.message, true);
    });
    socket.on('memento_mori_symbolic_death', (data)=>{
        console.log("\uD83D\uDC80 Symbolic death:", data);
        (0, $eD3DY.showNotification)(data.message, false);
    });
    socket.on('memento_mori_price_update', (data)=>{
        console.log("\u26B0\uFE0F Global stock price updated:", data);
        const { companyName: companyName, newPrice: newPrice, systemCompanyId: systemCompanyId } = data;
        if (typeof updateStockPriceDisplay === 'function') updateStockPriceDisplay(systemCompanyId, newPrice);
        (0, $eD3DY.showNotification)(`${companyName} value changed to ${newPrice.toFixed(2)} due to global trading`, true);
        if (localStorage.getItem('simulationType') === 'memento-mori') updateEulogyValue();
    });
    socket.on('memento_mori_timer_expired', (data)=>{
        console.log("\u23F0 Memento Mori timer expired for user:", data);
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) {
            if (typeof handleMementoMoriTimeout === 'function') handleMementoMoriTimeout();
        } else (0, $eD3DY.showNotification)(`${data.portfolioName} has reached their symbolic death`, true);
    });
    socket.on('memento_mori_phase_change', (data)=>{
        console.log("\u26B0\uFE0F Memento Mori phase change:", data);
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId !== portfolioId) (0, $eD3DY.showNotification)(`${data.portfolioName} entered ${data.newPhase} phase`, true);
    });
    socket.on('deletePortfolioUpdate', (data)=>{
        (0, $alKwv.displayDeletePortfolioUpdate)(data);
    });
    socket.on('deletePortfolioButtonReceived', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('deletePortfolioButton');
    });
    socket.on('LBOButtonReceived', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('LBOButton');
    });
    socket.on('LBOUpdate', (data)=>{
        if (data && data.message) (0, $alKwv.handleLBOUpdateForTarget)(data);
    });
    socket.on('SubsidyButtonReceived', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('SubsidyButton');
    });
    socket.on('SubsidyUpdate', (data)=>{
        if (data && data.message) (0, $alKwv.handleSubsidyUpdateForTarget)(data);
    });
    socket.on('SubsidyReceived', (data)=>{
        if (data && data.message) (0, $alKwv.handleSubsidyReceived)(data);
    });
    socket.on('itemStolen', (data)=>{
        if (data && data.message) (0, $alKwv.handleItemStolen)(data);
    });
    socket.on('specialActionNotification', (data)=>{
        if (data && data.message) (0, $alKwv.handleSpecialActionNotification)(data);
    });
    socket.on('ransomButtonReceived', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('ransomButton');
    });
    socket.on('RansomUpdate', (data)=>{
        console.log('RansomUpdate received:', data);
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId || !data.portfolioId) (parcelRequire("ehiC0")).then(({ showRansomNotification: showRansomNotification, disablePortfolioInteractions: disablePortfolioInteractions })=>{
            disablePortfolioInteractions();
            showRansomNotification(portfolioId, data.ransomBy, data.ransomPoints);
        }).catch((err)=>{
            console.error('Failed to load ransom.js:', err);
        });
    });
    socket.on('ransomPaid', (data)=>{
        console.log('Ransom paid notification received:', data);
        const { payerName: payerName, amount: amount, payerId: payerId } = data;
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.ransomPaidNotification', '{userName} has paid the ransom of {points} capital. The funds have been transferred to your account.').replace('{userName}', payerName || 'A trader').replace('{points}', amount || 0), true);
    });
    socket.on('communityInvitation', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.initiatorPortfolioId !== portfolioId) (0, $eevDZ.showCommunityInvitationPopup)(data);
    });
    socket.on('communityJoinStatus', (data)=>{
        if (data.success) {
            (0, $eevDZ.startCommunityTimer)(data.communityId);
            (0, $eevDZ.showCommunityInterface)(data.communityId);
            (0, $eD3DY.showNotification)(data.message, true);
        } else (0, $eD3DY.showNotification)(`Error: ${data.message}`, false);
    });
    socket.on('communityStarted', (data)=>{
        const { communityId: communityId, expirationTime: expirationTime } = data;
        (0, $eevDZ.showCommunityInterface)(communityId);
        (0, $eevDZ.startCommunityTimer)(expirationTime);
    });
    socket.on('communityUpdate', (data)=>{
        if (typeof handleCommunityUpdate === 'function') handleCommunityUpdate(data);
    });
    socket.on('communityCreationStatus', (data)=>{
        if (data.success) {
            (0, $eevDZ.startCommunityTimer)(data.communityId);
            (0, $eevDZ.showCommunityInterface)(data.communityId);
            localStorage.setItem('activeCommunity', data.communityId);
            (0, $eD3DY.showNotification)(data.message, true);
        } else (0, $eD3DY.showNotification)(`Error: ${data.message}`, false);
    });
    socket.on('createCommunityButtonAssigned', (data)=>{
        const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
        if (data.portfolioId === portfolioId) $94661e82873784cd$var$announceToolGranted('createCommunityButton');
    });
    socket.on('communityEnded', (data)=>{
        const { communityId: communityId } = data;
        const communityTimer = document.getElementById('communityTimer');
        const communityInterface = document.getElementById('communityInterface');
        if (communityTimer) communityTimer.remove();
        if (communityInterface) communityInterface.remove();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.darkPoolEnded', 'The Dark Pool has ended. You are back to normal status.'), true);
    });
    socket.on('communityExpired', (data)=>{
        const { communityId: communityId } = data;
        const communityTimer = document.getElementById('communityTimer');
        const communityInterface = document.getElementById('communityInterface');
        if (communityTimer) communityTimer.remove();
        if (communityInterface) communityInterface.remove();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.darkPoolExpired', 'The Dark Pool has expired. You are back to normal status.'), true);
    });
    socket.on('messageSent', (response)=>{
        console.log('Message sent response:', response);
        if (response.success) (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.messageSent', 'Message sent successfully!'), true);
        else (0, $eD3DY.showNotification)(response.message, false);
    });
    socket.on('tradeCompleted', (data)=>{
        console.log("\u2705 Trade completed event received:", data);
        const msg = data.message || (0, $fUPn2.t)('socketFront.tradeAccepted', 'Trade accepted!');
        try {
            localStorage.setItem('pendingNotification', JSON.stringify({
                message: msg,
                success: true,
                ts: Date.now()
            }));
        } catch (_) {}
        if (window.cleanupOfferSentPopup) window.cleanupOfferSentPopup();
        try {
            window.__removeWaitingPopup?.();
        } catch  {}
        document.getElementById('offerSentPopup')?.remove();
        document.getElementById('offerSentOverlay')?.remove();
        document.getElementById('waitingPopup')?.remove();
        localStorage.removeItem('pendingOffer');
        localStorage.removeItem('pendingWaitPopup');
    });
    socket.on('tradeDeclined', (data)=>{
        console.log("\u274C Trade declined event received:", data);
        const msg = data.message || (0, $fUPn2.t)('socketFront.tradeDeclined', 'Trade declined.');
        try {
            localStorage.setItem('pendingNotification', JSON.stringify({
                message: msg,
                success: false,
                ts: Date.now()
            }));
        } catch (_) {}
        if (window.cleanupOfferSentPopup) window.cleanupOfferSentPopup();
        try {
            window.__removeWaitingPopup?.();
        } catch  {}
        document.getElementById('offerSentPopup')?.remove();
        document.getElementById('offerSentOverlay')?.remove();
        document.getElementById('waitingPopup')?.remove();
        localStorage.removeItem('pendingOffer');
        localStorage.removeItem('pendingWaitPopup');
    });
    socket.on('tradeError', (data)=>{
        console.error("\u274C Trade error:", data);
        const msg = data.message || (0, $fUPn2.t)('socketFront.tradeError', 'An error occurred with your trade offer');
        try {
            localStorage.setItem('pendingNotification', JSON.stringify({
                message: msg,
                success: false,
                ts: Date.now()
            }));
        } catch (_) {}
        if (window.cleanupOfferSentPopup) window.cleanupOfferSentPopup();
        try {
            window.__removeWaitingPopup?.();
        } catch  {}
        document.getElementById('offerSentPopup')?.remove();
        document.getElementById('offerSentOverlay')?.remove();
        document.getElementById('waitingPopup')?.remove();
        localStorage.removeItem('pendingOffer');
        localStorage.removeItem('pendingWaitPopup');
    });
    socket.on('tradeExpired', (data)=>{
        console.log("\u23F0 Trade expired:", data);
        const msg = data.message || (0, $fUPn2.t)('socketFront.tradeExpired', 'Your trade offer has expired');
        try {
            localStorage.setItem('pendingNotification', JSON.stringify({
                message: msg,
                success: false,
                ts: Date.now()
            }));
        } catch (_) {}
        if (window.cleanupOfferSentPopup) window.cleanupOfferSentPopup();
        try {
            window.__removeWaitingPopup?.();
        } catch  {}
        document.getElementById('offerSentPopup')?.remove();
        document.getElementById('offerSentOverlay')?.remove();
        document.getElementById('waitingPopup')?.remove();
        localStorage.removeItem('pendingOffer');
        localStorage.removeItem('pendingWaitPopup');
    });
    socket.on('tradeTimerExtended', (payload)=>{
        const { initiatorUserId: initiatorUserId, targetUserId: targetUserId, newDuration: newDuration } = payload || {};
        try {
            if (typeof window.updateTradeTimerFromSocket === 'function') window.updateTradeTimerFromSocket(payload);
        } catch (e) {
            console.warn('[socketU] tradeTimerExtended delegation failed:', e);
        }
        (0, $eD3DY.showNotification)(`Timer extended to ${newDuration} seconds`, true);
    });
    socket.on('offerReceived', async (offerData)=>{
        console.log('Offer received with data:', offerData);
        if (offerData.hasStory && offerData.tradeStory) console.log('Story included in offer:', offerData.tradeStory);
        const isCurrentUserBot = localStorage.getItem('isBot') === 'true';
        if (isCurrentUserBot) {
            console.log("\uD83E\uDD16 Bot is the receiver. Auto-accepting offer from:", offerData.initiatorPortfolioName);
            try {
                const { acceptTrade: acceptTrade } = await Promise.resolve((parcelRequire("86ioh")));
                await acceptTrade(offerData);
                console.log("\u2705 Bot offer auto-accepted successfully");
                return;
            } catch (error) {
                console.error("\u274C Bot failed to auto-accept trade:", error);
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.tradeAcceptFailed', 'Failed to accept trade:')} ${error.message}`, false);
            }
        }
        (0, $86ioh.showOfferPopup)(offerData, localStorage.getItem('portfolioId'));
    });
    socket.on('buyOfferReceived', async (buyOfferData)=>{
        console.log('Buy offer received with data:', buyOfferData);
        (0, $86ioh.showReceiveBuyOfferPopup)(buyOfferData);
    });
    socket.on('botTradeOffer', (payload)=>{
        try {
            showBotTradeOffer(payload);
        } catch (e) {
            console.error('botTradeOffer handler error:', e);
        }
    });
    socket.on('narrativeResponse', (data)=>{
        console.log('Received narrative response:', data);
        (0, $eD3DY.showNotification)(`${data.response.fromName} ${(0, $fUPn2.t)('socketFront.respondedToAnalysis', 'has responded to your trade analysis')}`, true);
        if (data.botResponse) setTimeout(()=>{
            showUpdatedOfferPopup({
                ...data.originalOffer,
                narrativeExchange: data.narrativeExchange
            });
        }, 2000);
    });
    socket.on('narrativeResponseReceived', (payload)=>{
        try {
            const { originalOffer: originalOffer, narrativeExchange: narrativeExchange } = payload || {};
            const offerForDialog = {
                botName: originalOffer?.botName,
                portfolioName: originalOffer?.portfolioName,
                points: originalOffer?.offerAmount,
                zollars: originalOffer?.zollarBid,
                itemName: originalOffer?.item_name || originalOffer?.itemName,
                isBot: !!originalOffer?.isBot,
                originalOffer: originalOffer,
                narrativeExchange: narrativeExchange
            };
            if (typeof window.showNarrativeResponseDialog === 'function') window.showNarrativeResponseDialog(offerForDialog);
            else {
                const last = narrativeExchange?.[narrativeExchange.length - 1]?.message || '';
                (0, $eD3DY.showNotification)(`Narrative reply from ${offerForDialog.portfolioName || offerForDialog.botName || 'Trader'}: ${last}`, true);
                console.log('[socketU] narrativeResponseReceived (fallback):', payload);
            }
        } catch (err) {
            console.error('[socketU] narrativeResponseReceived handler error:', err);
        }
    });
    socket.on('llmResponseReceived', (data)=>{
        try {
            if (typeof window.handleLLMResponse === 'function') window.handleLLMResponse(data);
            else {
                (0, $eD3DY.showNotification)('New response received.', true);
                console.log('[socketU] llmResponseReceived (fallback):', data);
            }
        } catch (e) {
            console.error('[socketU] llmResponseReceived handler error:', e);
        }
    });
    socket.on('botNarrativeResponse', (data)=>{
        console.log('Bot narrative response received:', data);
        const existingPopup = document.getElementById('offerSentPopup') || document.getElementById('tradeOfferPopup');
        if (existingPopup) {
            window.dispatchEvent(new Event('beforeunload'));
            if (navigator.userAgent.includes('Firefox')) document.dispatchEvent(new Event('visibilitychange'));
            if (existingPopup.parentNode) existingPopup.parentNode.removeChild(existingPopup);
            else existingPopup.remove();
            const overlay = existingPopup.parentElement;
            if (overlay && overlay.style.position === 'fixed') overlay.remove();
        }
        localStorage.removeItem('pendingOffer');
        showUpdatedOfferPopup({
            ...data.originalOffer,
            narrativeExchange: data.narrativeExchange,
            hasLLMResponse: true,
            llmResponse: data.botResponse
        });
    });
    socket.on('redeemOffer', (payload)=>{
        try {
            (0, $2C8cW.showRedeemOfferPopup)?.(payload);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('redeemResponse', (payload)=>{
        try {
            handleRedeemResponse?.(payload);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('freebieZ1Event', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('giveItemSelect', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('givePoints', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('taxEventNotification', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('deductPoints', (data)=>{
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('displayArtwork', (data)=>{
        console.log('Received displayArtwork event:', data);
        if (data.exhibitionId && data.artworkId) (0, $eCgl8.showDisplayedArtwork)(data.exhibitionId, data.artworkId);
        else console.error('displayArtwork event received invalid data:', data);
    });
    socket.on('itemReceived', (data)=>{
        console.log('Received itemReceived event:', data);
        $94661e82873784cd$var$processMessage(data);
    });
    socket.on('message', async (event)=>{
        console.log('Raw message received on client:', event);
        if ($94661e82873784cd$var$isProcessingMessage) {
            $94661e82873784cd$export$8d5992b88d21f8fe.push(event);
            return;
        }
        $94661e82873784cd$var$isProcessingMessage = true;
        try {
            let processedData;
            if (event instanceof Blob) {
                const text = await event.text();
                console.log('Received message blob:', text);
                processedData = JSON.parse(text);
            } else if (typeof event === 'string') {
                console.log('Received message:', event);
                processedData = JSON.parse(event);
            } else if (typeof event === 'object') {
                console.log('Received JSON message object:', event);
                processedData = event;
            } else {
                console.error('Received unknown message type:', typeof event);
                return;
            }
            if (processedData && processedData.messageId) socket.emit('messageAck', {
                messageId: processedData.messageId,
                received: true
            });
            $94661e82873784cd$var$processMessage(processedData);
        } catch (error) {
            console.error('Error processing WebSocket message:', error);
        } finally{
            $94661e82873784cd$var$isProcessingMessage = false;
            if ($94661e82873784cd$export$8d5992b88d21f8fe.length > 0) {
                const nextMessage = $94661e82873784cd$export$8d5992b88d21f8fe.shift();
                if (nextMessage && nextMessage.messageId) socket.emit('messageAck', {
                    messageId: nextMessage.messageId,
                    received: true
                });
                $94661e82873784cd$var$processMessage(nextMessage);
            }
        }
    });
    socket.on('bidReceived', (data)=>{
        try {
            const me = $94661e82873784cd$export$141bbd10c4c06cba?.() || localStorage.getItem('portfolioId');
            const target = data?.targetPortfolioId ?? data?.targetUserId;
            if (target && target !== me) return;
            console.log('Bid received:', data);
            const isMementoMori = localStorage.getItem('simulationType') === 'memento-mori';
            if (isMementoMori && data.bidType === 'philosophical') showMementoMoriBidPopup(data, me);
            else (0, $1NhFL.showStockBidPopup)(data, me);
        } catch (e) {
            console.error('bidReceived handler error:', e);
        }
    });
    socket.on('waitingForResponse', (data)=>{
        console.log('Waiting for response:', data);
        if (document.getElementById('bidSubmittingOverlay') || document.getElementById('waitingPopup')) return;
        if (typeof (0, $1NhFL.showWaitingForResponsePopup) === 'function') (0, $1NhFL.showWaitingForResponsePopup)(data?.message);
    });
    socket.on('moodAnalysis', (data)=>{
        try {
            console.log("\uD83E\uDDE0 moodAnalysis event:", data);
            if (!data || data.success === false) {
                try {
                    (0, $1NhFL.closeWaitingForResponsePopup)?.();
                } catch (_) {}
                return;
            }
            const mood = data.analysis;
            if (!mood) return;
            const isResponder = window.__userIsInitiator === false;
            if (!isResponder) try {
                sessionStorage.setItem('pendingMoodAnalysis', JSON.stringify(mood));
            } catch (_) {}
            else try {
                sessionStorage.removeItem('pendingMoodAnalysis');
            } catch (_) {}
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
        } catch (e) {
            console.error('moodAnalysis handler error:', e);
        }
    });
    socket.on('bidAccepted', (data)=>{
        try {
            console.log('Bid accepted (initiator view):', data);
            const { message: message, transactionId: transactionId } = data;
            const mood = data.moodResult || data.analysis;
            const msg = message || (0, $fUPn2.t)('socketFront.offerAcceptedLong', 'Your offer has been accepted!');
            try {
                localStorage.setItem('pendingNotification', JSON.stringify({
                    message: msg,
                    success: true,
                    ts: Date.now()
                }));
            } catch (_) {}
            (0, $eD3DY.showNotification)(msg, true);
            const isRealUser = !localStorage.getItem('isBot');
            if (mood && isRealUser) try {
                sessionStorage.setItem('pendingMoodAnalysis', JSON.stringify(mood));
            } catch (_) {}
            console.log('Transaction accepted:', {
                transactionId: transactionId,
                message: message
            });
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
            try {
                document.getElementById('waitingPopup')?.remove();
            } catch (_) {}
            try {
                document.getElementById('bidSubmittingOverlay')?.remove();
            } catch (_) {}
        } catch (e) {
            console.error('bidAccepted handler error:', e);
        }
    });
    socket.on('bidDeclined', (data)=>{
        try {
            console.log('Bid declined (initiator view):', data);
            const { message: message, transactionId: transactionId } = data;
            const mood = data.moodResult || data.analysis;
            const msg = message || (0, $fUPn2.t)('socketFront.offerDeclinedLong', 'Your offer has been declined!');
            try {
                localStorage.setItem('pendingNotification', JSON.stringify({
                    message: msg,
                    success: false,
                    ts: Date.now()
                }));
            } catch (_) {}
            (0, $eD3DY.showNotification)(msg, false);
            const isRealUser = !localStorage.getItem('isBot');
            if (mood && isRealUser) try {
                sessionStorage.setItem('pendingMoodAnalysis', JSON.stringify(mood));
            } catch (_) {}
            console.log('Bid declined:', {
                transactionId: transactionId,
                message: message
            });
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
            try {
                document.getElementById('waitingPopup')?.remove();
            } catch (_) {}
            try {
                document.getElementById('bidSubmittingOverlay')?.remove();
            } catch (_) {}
        } catch (e) {
            console.error('bidDeclined handler error:', e);
        }
    });
    socket.on('bidAcceptSuccess', (data)=>{
        try {
            console.log("\u2705 Bid accept success (seller view):", data);
            const { message: message } = data;
            const mood = data.moodResult || data.analysis;
            const msg = message || (0, $fUPn2.t)('socketFront.offerAccepted', 'You accepted the bid.');
            (0, $eD3DY.showNotification)(msg, true);
            const isRealUser = !localStorage.getItem('isBot');
            if (mood && isRealUser) {
                try {
                    (0, $bNbKd.showMoodAnalysisPopup)(mood);
                } catch (e) {
                    console.error('Error showing mood popup:', e);
                }
                try {
                    sessionStorage.removeItem('pendingMoodAnalysis');
                } catch (_) {}
            }
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
            try {
                document.getElementById('waitingPopup')?.remove();
            } catch (_) {}
            try {
                document.getElementById('bidSubmittingOverlay')?.remove();
            } catch (_) {}
        } catch (e) {
            console.error('bidAcceptSuccess handler error:', e);
        }
    });
    socket.on('bidDeclineSuccess', (data)=>{
        try {
            console.log("\u2705 Bid decline success (seller view):", data);
            const { message: message, transactionId: transactionId } = data;
            const mood = data.moodResult || data.analysis;
            const msg = message || (0, $fUPn2.t)('socketFront.offerDeclined', 'You declined the bid.');
            (0, $eD3DY.showNotification)(msg, false);
            const isRealUser = !localStorage.getItem('isBot');
            if (mood && isRealUser) {
                try {
                    (0, $bNbKd.showMoodAnalysisPopup)(mood);
                } catch (e) {
                    console.error('Error showing mood popup:', e);
                }
                try {
                    sessionStorage.removeItem('pendingMoodAnalysis');
                } catch (_) {}
            }
            console.log('Bid declined:', {
                transactionId: transactionId,
                message: message
            });
            try {
                (0, $1NhFL.closeWaitingForResponsePopup)?.();
            } catch (_) {}
            try {
                document.getElementById('waitingPopup')?.remove();
            } catch (_) {}
            try {
                document.getElementById('bidSubmittingOverlay')?.remove();
            } catch (_) {}
        } catch (e) {
            console.error('bidDeclineSuccess handler error:', e);
        }
    });
    socket.on('bidClosed', (data)=>{
        console.log('Bid closed:', data);
    });
    socket.on('bidExpired', (data)=>{
        console.log('Bid expired:', data);
        (0, $eD3DY.showNotification)(data.message || (0, $fUPn2.t)('socketFront.offerExpired', 'Your offer has expired'), false);
        try {
            if (document.getElementById('waitingPopup')) (0, $1NhFL.closeWaitingForResponsePopup)?.(false);
        } catch (_) {}
        try {
            if (window.shouldRedirectToMarket && window.shouldRedirectToMarket()) setTimeout(()=>window.doMarketRedirectIfNeeded?.(), 1500);
        } catch (_) {}
    });
    socket.on('bidError', (data)=>{
        console.error('Bid error:', data);
        (0, $eD3DY.showNotification)(data.message || (0, $fUPn2.t)('socketFront.offerError', 'An error occurred with your offer'), false);
        try {
            if (document.getElementById('waitingPopup')) (0, $1NhFL.closeWaitingForResponsePopup)?.(false);
        } catch (_) {}
        try {
            if (window.shouldRedirectToMarket && window.shouldRedirectToMarket()) setTimeout(()=>window.doMarketRedirectIfNeeded?.(), 1500);
        } catch (_) {}
    });
    socket.on('transactionBurst', (data)=>{
        console.log("\uD83C\uDF89 Transaction burst triggered:", data);
        const { moodScore: moodScore } = data;
        if (typeof moodScore === 'number') (0, $bNbKd.triggerBurst)(moodScore);
    });
    socket.on('stockShorted', (data)=>{
        console.log('Stock shorted:', data);
        if (data.success) (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.shortSuccess', 'Short position placed successful!'), true);
        else (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.shortFailed', 'Short position failed:')} ${data.message}`, false);
    });
    socket.on('stockShortedNotification', (data)=>{
        console.log('Owner notification:', data);
        (0, $eD3DY.showNotification)(data.message, true);
    });
    socket.on('shortPositionClosed', (data)=>{
        console.log('Short position closed:', data);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.shortClosedPrefix', 'Your short position on stock')} "${data.symbol}" ${(0, $fUPn2.t)('socketFront.shortClosedSuffix2', 'has been automatically closed.')}`, true);
    });
    socket.on('bondBidReceived', (data)=>{
        console.log('Bond bid received:', data);
        (0, $8X27K.showBondBidPopup)(data, $94661e82873784cd$export$141bbd10c4c06cba());
    });
    socket.on('bondBidAccepted', (data)=>{
        console.log('Bond bid accepted:', data);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.bondBidPrefix', 'Your bid for bond')} "${data.bondName}" ${(0, $fUPn2.t)('socketFront.bondAccepted', 'has been accepted.')}`, true);
    });
    socket.on('bondBidDeclined', (data)=>{
        console.log('Bond bid declined:', data);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.bondBidPrefix', 'Your bid for bond')} "${data.bondName}" ${(0, $fUPn2.t)('socketFront.bondDeclined', 'has been declined.')}`, false);
    });
    socket.on('bondBidActionSuccess', (data)=>{
        console.log('Bond bid action success:', data);
        (0, $eD3DY.showNotification)(data.message, data.success);
    });
    socket.on('bondBidError', (data)=>{
        console.error('Bond bid error:', data.error);
        (0, $eD3DY.showNotification)(`Error: ${data.error}`, false);
    });
    socket.on('bondMatured', (data)=>{
        console.log('Bond matured:', data);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('socketFront.yourBond', 'Your bond')} "${data.bondName}" ${(0, $fUPn2.t)('socketFront.bondMatured', 'has matured, and zollars have been issued.')}`, true);
        // displayPortfolioItems() was a BARE global that only ever existed on the
        // retired market/trader pages. This module is loaded by the 3D floor, where
        // the identifier is undefined — so maturing a bond threw a ReferenceError
        // right here, inside the handler, every time. Guard it, and tell the floor
        // to refresh through the channel it already listens on.
        if (typeof window.displayPortfolioItems === 'function') try {
            window.displayPortfolioItems();
        } catch (e) {
            console.warn('displayPortfolioItems:', e);
        }
        try {
            document.dispatchEvent(new CustomEvent('zx:refetch'));
        } catch (_) {}
    });
    socket.on('forceLogout', ()=>{
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.loggedOutByAdmin', 'You have been logged out by the administrator.'), false);
        localStorage.removeItem('portfolioId');
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('socketId');
        localStorage.removeItem('initialPortfolioState');
        localStorage.removeItem('selectedItems');
        localStorage.removeItem('superUserId');
        document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'sessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'portfolioId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie.split(";").forEach((cookie)=>{
            const name = cookie.split("=")[0];
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        });
        $94661e82873784cd$export$a0973bcfe11b05c9();
        window.location.href = '/index.html';
    });
    socket.on('tokenExpired', ()=>{
        (0, $eD3DY.showNotification)("Session expired. Please log in again.", false);
        $94661e82873784cd$export$a0973bcfe11b05c9();
        setTimeout(()=>{
            window.location.href = '/index.html';
        }, 2000);
    });
    socket.on('playRandomPub', (data)=>{
        console.log('Received playRandomPub event:', data);
        if (data && data.introVideoUrl && data.mainVideoUrl) (0, $alKwv.playPubVideo)(data.mainVideoUrl, data.introVideoUrl);
        else console.error('Received playRandomPub event without valid video URLs:', data);
    });
    socket.on('playRandomZnews', (data)=>{
        console.log('Received playRandomZnews event:', data);
        if (data && data.introVideoUrl && data.mainVideoUrl) (0, $alKwv.playZnewsVideo)(data.mainVideoUrl, data.introVideoUrl);
        else console.error('Received playRandomZnews event without valid video URLs:', data);
    });
    // FIX: Store reference and clean up properly
    $94661e82873784cd$var$beforeUnloadHandler = ()=>{
        if (socket) socket.disconnect();
    };
    window.addEventListener('beforeunload', $94661e82873784cd$var$beforeUnloadHandler);
    console.log("\u2705 [SocketU] All socket handlers attached");
}
function $94661e82873784cd$var$handleReconnect() {
    if ($94661e82873784cd$var$reconnectTimeout) clearTimeout($94661e82873784cd$var$reconnectTimeout);
    if ($94661e82873784cd$var$reconnectAttempts < $94661e82873784cd$var$MAX_RECONNECT_ATTEMPTS) {
        $94661e82873784cd$var$reconnectAttempts++;
        console.log(`Attempting to reconnect (${$94661e82873784cd$var$reconnectAttempts}/${$94661e82873784cd$var$MAX_RECONNECT_ATTEMPTS})...`);
        $94661e82873784cd$var$reconnectTimeout = setTimeout($94661e82873784cd$export$72947bc920927fd0, $94661e82873784cd$var$RECONNECT_DELAY * $94661e82873784cd$var$reconnectAttempts);
    } else console.error('Max reconnection attempts reached. Please refresh the page.');
}
function $94661e82873784cd$export$8c106f812aa1ca2a() {
    return new Promise((resolve)=>{
        if ($94661e82873784cd$export$4f55ed1789bc2dcb && $94661e82873784cd$export$4f55ed1789bc2dcb.connected) resolve();
        else // FIX: Use once() to prevent listener accumulation
        $94661e82873784cd$export$4f55ed1789bc2dcb.once('connect', resolve);
    });
}
function $94661e82873784cd$var$processMessage(data) {
    const portfolioId = $94661e82873784cd$export$141bbd10c4c06cba();
    console.log('Received JSON message:', data);
    console.log('Portfolio ID from cookie/localStorage:', portfolioId);
    console.log('Target Portfolio ID from message:', data.targetPortfolioId);
    if (data.action === 'offer' && data.targetPortfolioId === portfolioId) {
        console.log('Offer received, attempting to display popup:', data);
        (0, $86ioh.showOfferPopup)(data, portfolioId);
    } else if (data.action === 'socialTradeReceived') (0, $86ioh.showSocialTradeReceived)(data);
    else if (data.action === 'socialTradeResponse') (0, $86ioh.showSocialTradeResponse)(data);
    else if (data.action === 'taxEventNotification') {
        console.log('Tax Event Notification received, displaying tax decision popup.');
        (0, $jL4uR.showTaxDecisionPopup)(portfolioId, data.pointAmount);
    } else if (data.action === 'zollarAssigned' && Array.isArray(data.portfolioIds) && data.portfolioIds.map(String).includes(portfolioId)) {
        window.__seenZollarEvents = window.__seenZollarEvents || new Set();
        if (data.eventId && window.__seenZollarEvents.has(data.eventId)) return;
        if (data.eventId) window.__seenZollarEvents.add(data.eventId);
        (0, $jL4uR.showZollarSelectedAssign)(data.portfolioIds, data.message, data.amount);
        return;
    } else if (data.action === 'taxNotice' && Array.isArray(data.portfolioIds) && data.portfolioIds.map(String).includes(portfolioId)) {
        (0, $jL4uR.displayNotification)(data.message || 'An asset was taxed by the Zederal Reserve.');
        return;
    } else if (data.action === 'freebieZ1') {
        console.log('Zederal Reserve Free Item Notification received, displaying popup.');
        (0, $jL4uR.displayNotification)(data.message);
    } else if (data.action === 'pointsGivenNotice' && Array.isArray(data.portfolioIds) && data.portfolioIds.map(String).includes(portfolioId)) {
        (0, $jL4uR.showPointsAssignedNotification)(data.portfolioIds, Number(data.points) || 0);
        return;
    } else if (data.action === 'pointsDeductedNotice' && Array.isArray(data.portfolioIds) && data.portfolioIds.map(String).includes(portfolioId)) {
        (0, $jL4uR.showPointsDeductedNotification)(data.portfolioIds, Number(data.points) || 0, data.message);
        return;
    } else if (data.action === 'itemReceived') (0, $86ioh.showItemReceivedNotification)(data.giverName, data.itemName);
    else if (data.action === 'deductPoints' && Array.isArray(data.portfolioIds) && data.portfolioIds.includes(portfolioId)) (0, $jL4uR.showPointsDeductedNotification)(data.portfolioIds, data.points, data.message);
    else if (data.action === 'giveItemSelect' && Array.isArray(data.portfolioIds) && data.portfolioIds.includes(portfolioId)) (0, $jL4uR.showItemSelectedAssign)(data.portfolioIds, data.message);
    else if (data.action === 'givePoints' && Array.isArray(data.portfolioIds) && data.portfolioIds.includes(portfolioId)) (0, $jL4uR.showPointsAssignedNotification)(data.portfolioIds, data.points);
    else if (data.targetPortfolioId === portfolioId) {
        if (data.action === 'makeBuyOffer') {
            console.log('Buy offer received, showing buy offer popup.');
            (0, $86ioh.showReceiveBuyOfferPopup)(data);
        } else if (data.action === 'rejectBuyOffer') {
            console.log('Buy offer rejected:', data);
            (0, $86ioh.handleRejectBuyOffer)(data);
        } else if (data.action === 'acceptBuyOffer') {
            console.log('Buy offer accepted:', data);
            (0, $86ioh.handleBuyOfferAcceptedByOther)(data);
        }
    } else console.log('Received message is not relevant to this user or action is not recognized.');
}
async function $94661e82873784cd$export$a0973bcfe11b05c9() {
    const portfolioId = localStorage.getItem('portfolioId');
    const token = localStorage.getItem('token');
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    if (!portfolioId || !token) {
        console.error('Portfolio ID or token not found in local storage');
        return;
    }
    try {
        if (isSimulated && $94661e82873784cd$export$4f55ed1789bc2dcb && $94661e82873784cd$export$4f55ed1789bc2dcb.connected) {
            console.log("\uD83E\uDD16 Disconnecting bots for simulated user logout...");
            $94661e82873784cd$export$4f55ed1789bc2dcb.emit('disconnectUserBots', {
                portfolioId: portfolioId
            });
            await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/${portfolioId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                active: false
            })
        });
        if (!response.ok) throw new Error('Failed to update active status during logout');
    } catch (error) {
        console.error('Error updating active status during logout:', error);
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.logoutActiveUpdateError', 'Error updating active status during logout. Please try again.'), false);
    }
    try {
        const logoutResponse = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                isSimulated: isSimulated
            }),
            credentials: 'include'
        });
        if (!logoutResponse.ok) throw new Error('Failed to logout from server');
        const logoutData = await logoutResponse.json();
        console.log(logoutData.message);
        if (isSimulated) console.log("\uD83C\uDFAF Simulation cleanup completed successfully");
    } catch (error) {
        console.error('Error during server logout:', error);
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('socketFront.logoutServerError', 'Error during server logout. Please try again.'), false);
    }
    const simulationEnding = localStorage.getItem('simulationEnding') === 'true';
    if (isSimulated && $94661e82873784cd$export$4f55ed1789bc2dcb && $94661e82873784cd$export$4f55ed1789bc2dcb.connected && !simulationEnding) {
        console.log("\uD83E\uDD16 Disconnecting bots for simulated user logout...");
        $94661e82873784cd$export$4f55ed1789bc2dcb.emit('disconnectUserBots', {
            portfolioId: portfolioId
        });
        await new Promise((resolve)=>setTimeout(resolve, 1000));
    }
    // Disconnect main socket
    if ($94661e82873784cd$export$4f55ed1789bc2dcb && $94661e82873784cd$export$4f55ed1789bc2dcb.connected) {
        console.log("\uD83D\uDD0C Disconnecting main socket...");
        $94661e82873784cd$export$4f55ed1789bc2dcb.disconnect();
    }
    const isMementoMori = localStorage.getItem('simulationType') === 'memento-mori';
    const isStorySimulation = localStorage.getItem('simulationType') === 'story-simulation';
    if (simulationEnding || isSimulated || isMementoMori) {
        try {
            document.getElementById('mortality-oracle-interface')?.remove();
            document.getElementById('reflection-interface')?.remove();
            document.getElementById('value-analysis-results')?.remove();
            document.getElementById('persistent-memento-timer')?.remove();
        } catch (e) {
            console.warn('Error cleaning Memento Mori UI:', e);
        }
        (0, $bzRv7.cleanupSimulationTimer)();
        (0, $1cx8d.cleanupMementoMoriTimer)();
    }
    if (isStorySimulation) try {
        document.getElementById('story-bullet-points')?.remove();
        document.getElementById('story-phase-timer')?.remove();
    } catch (e) {
        console.warn('Error cleaning Story Simulation UI:', e);
    }
    localStorage.removeItem('portfolioId');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('socketId');
    localStorage.removeItem('initialPortfolioState');
    localStorage.removeItem('selectedItems');
    localStorage.removeItem('superUserId');
    localStorage.removeItem('isSimulated');
    localStorage.removeItem('simulatedCompany');
    localStorage.removeItem('firstLogin');
    localStorage.removeItem('activeMementoMori');
    localStorage.removeItem('mementoMoriChecked');
    localStorage.removeItem('mementoMoriStarted');
    localStorage.removeItem('simulationType');
    localStorage.removeItem('mementoMoriObjectiveId');
    localStorage.removeItem('mementoMoriMode');
    localStorage.removeItem('mementoShowAllCompanies');
    localStorage.removeItem('stockBidData');
    localStorage.removeItem('tradeStory');
    localStorage.removeItem('tradeStoryTimestamp');
    localStorage.removeItem('lastConnectedStableKey');
    localStorage.removeItem('simulationEndTime');
    localStorage.removeItem('simulationTimerId');
    localStorage.removeItem('simulationEnding');
    localStorage.removeItem('botTradeOffer');
    localStorage.removeItem('botTradeRecommendation');
    localStorage.removeItem('tradingRecommendation');
    localStorage.removeItem('botTradeTimestamp');
    localStorage.removeItem('storyId');
    localStorage.removeItem('storyTheme');
    localStorage.removeItem('storyPhase');
    localStorage.removeItem('storyPhaseEndsAt');
    for(let i = localStorage.length - 1; i >= 0; i--){
        const key = localStorage.key(i);
        if (key && key.startsWith('trade_')) localStorage.removeItem(key);
    }
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'sessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'portfolioId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    window.location.href = '/index.html';
}
function $94661e82873784cd$export$7437ef272097e625(botToken, botPortfolioId, botSessionId) {
    console.log(`\u{1F916} Connecting bot WebSocket for: ${botPortfolioId}`);
    return $94661e82873784cd$export$72947bc920927fd0(botToken, botPortfolioId, botSessionId);
}

});
parcelRegister("86ioh", function(module, exports) {

$parcel$export(module.exports, "showItemReceivedNotification", () => $5e5d264206c87423$export$671595af69028742);
$parcel$export(module.exports, "showOfferSentPopup", () => $5e5d264206c87423$export$f96bc44d9ad77c90);
$parcel$export(module.exports, "showOfferPopup", () => $5e5d264206c87423$export$48ca6cbcb2b01599);
$parcel$export(module.exports, "acceptTrade", () => $5e5d264206c87423$export$c9d68d666177c59c);
$parcel$export(module.exports, "showReceiveBuyOfferPopup", () => $5e5d264206c87423$export$54641e155c9500d5);
$parcel$export(module.exports, "handleRejectBuyOffer", () => $5e5d264206c87423$export$5bc1b41b6ea3d1d5);
$parcel$export(module.exports, "showSocialTradeReceived", () => $5e5d264206c87423$export$e6bbcc1b0179915c);
$parcel$export(module.exports, "showSocialTradeResponse", () => $5e5d264206c87423$export$e8b9a359288bb90c);
$parcel$export(module.exports, "handleBuyOfferAcceptedByOther", () => $5e5d264206c87423$export$e696bf2320418566);
//offer.js

var $cNeIB = parcelRequire("cNeIB");

var $fUPn2 = parcelRequire("fUPn2");

var $eD3DY = parcelRequire("eD3DY");
parcelRequire("21EbS");
const $5e5d264206c87423$var$tr = (0, $fUPn2.t);
function $5e5d264206c87423$var$getPortfolioId() {
    return localStorage.getItem('portfolioId');
}
function $5e5d264206c87423$var$unblockUI() {
    // reset body
    document.body.style.overflow = '';
    document.body.style.pointerEvents = '';
    // nuke any stray overlays/popups we create
    [
        'offerSentOverlay',
        'offerSentPopup',
        'tradeOfferPopup',
        'popup-container',
        'social-trade-dialog'
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    // belt + suspenders: remove any full-screen divs we created with huge z-index
    [
        ...document.querySelectorAll('div')
    ].filter((el)=>{
        const s = getComputedStyle(el);
        return (socket.position === 'fixed' || s.position === 'absolute') && parseInt(s.zIndex || '0', 10) >= 9999 && (el.id || '').includes('overlay');
    }).forEach((el)=>el.parentNode && el.parentNode.removeChild(el));
}
window.forceUnblockUI = $5e5d264206c87423$var$unblockUI; // handy for debugging in console
function $5e5d264206c87423$export$671595af69028742(giverName, itemName) {
    const message = (0, $fUPn2.t)('offer.item_received', 'You received {item} from {giver}!').replace('{item}', itemName).replace('{giver}', giverName);
    (0, $eD3DY.showNotification)(message, true);
}
function $5e5d264206c87423$export$f96bc44d9ad77c90(portfolioId, knownItemIdsAtPageLoad) {
    // Guard: only show if an offer was just sent (flag set by your send flow)
    if (localStorage.getItem('pendingOffer') !== 'true') return;
    // Prevent duplicates if somehow called twice
    if (document.getElementById('offerSentPopup')) return;
    // --- Overlay & popup
    const overlay = document.createElement('div');
    overlay.id = 'offerSentOverlay'; // ADD ID so it can be cleaned up externally
    overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; justify-content: center; align-items: center; display: flex;";
    document.body.appendChild(overlay);
    const popup = document.createElement('div');
    popup.id = 'offerSentPopup';
    popup.style = "position: relative; width:100%; max-width: 100%; height: 100%; max-height: 100%; padding: 20px; border-radius: 0px; border: 2px solid #00ff00; color: #00ff00; font-family: 'bithigh', sans-serif; text-align: center; z-index: 10001; overflow: hidden; display: flex; justify-content: center; align-items: center;";
    overlay.appendChild(popup);
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'offer-sent');
    // --- Background video container
    const videoContainer = document.createElement('div');
    videoContainer.style = "position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: -1;";
    popup.appendChild(videoContainer);
    // --- Content
    const content = document.createElement('div');
    content.style = "position: relative; z-index: 1; padding: 20px; background-color: rgba(1, 32, 59, 0.7); border-radius: 3px; max-width: 80%;";
    content.innerHTML = `
	<h2>${(0, $fUPn2.t)('offer.offer_sent', 'Offer Sent')} <br><br> ${(0, $fUPn2.t)('offer.do_not_leave_page', 'DO NOT LEAVE PAGE.')} <br><br></h2>
	<p>${(0, $fUPn2.t)('offer.awaiting_response', 'Awaiting response. Please wait...')}</p>
	<p id="offerSentTimerText"></p>
  `;
    popup.appendChild(content);
    // Initialize timer line as PLAIN TEXT (no inner HTML templating)
    const timerP = content.querySelector('#offerSentTimerText');
    const timerLine = (sec)=>(0, $fUPn2.t)('offer.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', String(sec));
    timerP.textContent = timerLine(10);
    // --- Background HLS (with robust fallback)
    const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/itemTrade/`;
    const totalVideos = 10;
    let currentVideoIndex = 0;
    let hlsInstance = null;
    let videoInterval = null;
    let interval = null;
    let isCleanedUp = false; // ADD FLAG to prevent duplicate cleanup
    function loadRandomVideo() {
        currentVideoIndex = Math.floor(Math.random() * totalVideos) + 1;
        loadVideo();
    }
    function loadVideo() {
        if (!document.body.contains(overlay)) return; // already closed
        const videoUrl = `${videoBaseUrl}${currentVideoIndex}/playlist.m3u8`;
        const video = document.createElement('video');
        video.style = "position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; pointer-events: none; z-index: -1;";
        video.setAttribute('playsinline', 'true');
        video.setAttribute('webkit-playsinline', 'true');
        video.setAttribute('muted', 'true');
        video.setAttribute('autoplay', 'true');
        video.setAttribute('loop', 'true');
        video.setAttribute('controls', 'false');
        video.setAttribute('disablePictureInPicture', 'true');
        video.setAttribute('controlsList', 'nodownload nofullscreen noremoteplaybook');
        video.setAttribute('x-webkit-airplay', 'deny');
        video.setAttribute('preload', 'metadata');
        video.muted = true;
        video.controls = false;
        video.playsInline = true;
        video.tabIndex = -1;
        const preventEvent = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            return false;
        };
        [
            'contextmenu',
            'touchstart',
            'touchend',
            'touchmove',
            'click',
            'dblclick',
            'mousedown',
            'mouseup',
            'mousemove',
            'focus',
            'blur'
        ].forEach((ev)=>{
            video.addEventListener(ev, preventEvent, {
                passive: false
            });
        });
        [
            'webkitfullscreenchange',
            'fullscreenchange',
            'webkitbeginfullscreen',
            'webkitendfullscreen'
        ].forEach((ev)=>{
            video.addEventListener(ev, preventEvent);
        });
        // Tear down any existing HLS instance
        if (hlsInstance) {
            try {
                hlsInstance.destroy();
            } catch  {}
            hlsInstance = null;
        }
        if (window.Hls && Hls.isSupported()) {
            hlsInstance = new Hls();
            hlsInstance.loadSource(videoUrl);
            hlsInstance.attachMedia(video);
            hlsInstance.on(Hls.Events.MANIFEST_PARSED, ()=>video.play().catch(()=>{}));
            hlsInstance.on(Hls.Events.ERROR, (event, data)=>{
                console.error('HLS error:', data);
                if (data?.fatal) loadRandomVideo();
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = videoUrl;
            video.addEventListener('loadedmetadata', ()=>video.play().catch(()=>{}));
            video.addEventListener('error', ()=>loadRandomVideo());
        }
        videoContainer.innerHTML = '';
        videoContainer.appendChild(video);
    }
    loadRandomVideo();
    videoInterval = setInterval(loadRandomVideo, 10000);
    // --- Countdown (UI-only)
    let timeLeft = 10;
    function cleanup() {
        if (isCleanedUp) return;
        isCleanedUp = true;
        try {
            if (interval) clearInterval(interval);
        } catch  {}
        try {
            if (videoInterval) clearInterval(videoInterval);
        } catch  {}
        try {
            if (hlsInstance) hlsInstance.destroy();
        } catch  {}
        hlsInstance = null;
        interval = null;
        videoInterval = null;
        localStorage.removeItem('pendingOffer');
        // Unregister popups from popupTracker before removing
        if (window.popupTracker) try {
            window.popupTracker.unregisterPopup('offerSentPopup');
            window.popupTracker.unregisterPopup('offerSentOverlay');
        } catch (e) {
            console.warn('Error unregistering popups:', e);
        }
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
        const overlayById = document.getElementById('offerSentOverlay');
        if (overlayById && overlayById.parentNode) overlayById.parentNode.removeChild(overlayById);
        const popupById = document.getElementById('offerSentPopup');
        if (popupById && popupById.parentNode) popupById.parentNode.removeChild(popupById);
        // Navigate away after cleanup — back to the 3D floor if that is where the
        // swap was started from (it sets zxReturnTo), otherwise the classic page.
        // zxReturnTo is CONSUMED by whoever reads it first, and on this page
        // zxTakeReturn() is racing us. Falling through to the hardcoded 'trader.html'
        // is how a floor user ends up stranded on the classic page. goTrade() also
        // mirrors the destination into sessionStorage, which nothing consumes — so
        // check that before giving up.
        // zxHome last before the hardcoded default: zfloor.js stamps it on every load,
        // so a tab that has been on the floor goes back to the floor even when both
        // zxReturnTo copies are gone (consumed by whichever reader won the race).
        // That fallthrough to 'trader.html' is how a floor user still ended up in the
        // classic system after a completed swap.
        setTimeout(()=>{
            if (location.pathname.endsWith('/transaction.html')) {
                const target = localStorage.getItem('zxReturnTo');
                if (target) localStorage.removeItem('zxReturnTo');
                let mirrored = null, home = null;
                try {
                    mirrored = sessionStorage.getItem('zxReturnTo');
                } catch (_) {}
                try {
                    home = sessionStorage.getItem('zxHome');
                } catch (_) {}
                // The classic pages are abandoned: a user forwarded there is locked in
                // (their graphics live on the floor now). The floor is the only default.
                window.location.href = target || mirrored || home || 'zfloor.html';
            }
        }, 100);
    }
    // Make cleanup accessible globally for external calls
    window.cleanupOfferSentPopup = cleanup;
    window.handleOfferAccepted = ()=>{
        cleanup();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.offer_accepted', 'Offer accepted!'), true);
    };
    window.handleOfferDeclined = ()=>{
        cleanup();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.offer_declined', 'Offer declined.'), false);
    };
    // Ensure fast unload → no lag on trader.js
    const onPageHide = ()=>cleanup();
    const onBeforeUnload = ()=>cleanup();
    const onVis = ()=>{
        if (document.hidden) cleanup();
    };
    window.addEventListener('pagehide', onPageHide, {
        once: true
    });
    window.addEventListener('beforeunload', onBeforeUnload, {
        once: true
    });
    document.addEventListener('visibilitychange', onVis, {
        once: true
    });
    interval = setInterval(()=>{
        if (isCleanedUp) return; // Stop if already cleaned up
        timeLeft -= 1;
        if (timeLeft < 0) timeLeft = 0;
        if (document.body.contains(overlay) && timerP) timerP.textContent = timerLine(timeLeft);
        if (timeLeft === 0) {
            // Store notification for display after redirect to trader.html
            const msg = (0, $fUPn2.t)('offer.still_waiting', "Still waiting for a response\u2026");
            try {
                localStorage.setItem('pendingNotification', JSON.stringify({
                    message: msg,
                    success: false,
                    ts: Date.now()
                }));
            } catch (_) {}
            cleanup();
        }
    }, 1000);
}
function $5e5d264206c87423$export$48ca6cbcb2b01599(offerData, portfolioId, timeoutDuration = 10000) {
    try {
        window.__removeWaitingPopup?.();
    } catch  {}
    document.getElementById('waitingPopup')?.remove();
    console.log('Attempting to show offer popup:', offerData);
    if (!offerData) return;
    // Clean up any previous trade session when a new offer arrives
    const currentActiveSession = localStorage.getItem('activeTradeSession');
    if (currentActiveSession) {
        console.log('Clearing previous trade session:', currentActiveSession);
        localStorage.setItem(`${currentActiveSession}_active`, 'false');
        localStorage.removeItem(`${currentActiveSession}_offerData`);
        localStorage.removeItem(`${currentActiveSession}_expiryTime`);
    }
    const tradeSessionId = `trade_${offerData.offeredItemId}_${offerData.transactionItemId}_${Date.now()}`;
    localStorage.setItem('activeTradeSession', tradeSessionId);
    localStorage.setItem(`${tradeSessionId}_active`, 'true');
    localStorage.setItem(`${tradeSessionId}_offerData`, JSON.stringify(offerData));
    let tradeActive = true;
    let timerInterval = null;
    // Remove existing popup if present
    const old = document.getElementById('tradeOfferPopup');
    if (old) old.remove();
    const popup = document.createElement('div');
    popup.id = 'tradeOfferPopup';
    popup.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif; color: #00ff00; overflow-y: auto; overflow-x: hidden;
	-webkit-overflow-scrolling: touch; padding: env(safe-area-inset-top,0) env(safe-area-inset-right,0) env(safe-area-inset-bottom,0) env(safe-area-inset-left,0);
  `;
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'trade-offer');
    // Background video
    const video = document.createElement('video');
    video.id = 'offerPopupBackground';
    video.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; object-fit: cover; z-index: -1; pointer-events: none; background:#000;
  `;
    [
        'playsinline',
        'webkit-playsinline',
        'muted',
        'autoplay',
        'loop',
        'controls',
        'disablePictureInPicture',
        'preload',
        'x-webkit-airplay'
    ].forEach((attr)=>video.setAttribute(attr, attr === 'controls' ? 'false' : attr === 'preload' ? 'metadata' : 'true'));
    video.muted = true;
    video.controls = false;
    video.playsInline = true;
    video.tabIndex = -1;
    const preventEvent = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        return false;
    };
    [
        'contextmenu',
        'touchstart',
        'touchend',
        'touchmove',
        'click',
        'dblclick',
        'mousedown',
        'mouseup',
        'mousemove',
        'focus',
        'blur'
    ].forEach((ev)=>video.addEventListener(ev, preventEvent, {
            passive: false
        }));
    [
        'webkitfullscreenchange',
        'fullscreenchange',
        'webkitbeginfullscreen',
        'webkitendfullscreen'
    ].forEach((ev)=>video.addEventListener(ev, preventEvent));
    popup.appendChild(video);
    // Story section
    const storySection = offerData.tradeStory && offerData.hasStory ? `
	<div style="background: rgba(0, 255, 0, 0.1); border: 1px solid rgba(0, 255, 0, 0.3); border-radius: 5px; padding: 10px; margin: 15px 0;">
	  <h5 style="margin:0 0 8px 0;color:#00ff00;">${(0, $fUPn2.t)('offer.reason', 'Reason:')}</h5>
	  <p style="margin: 0; font-style: italic; font-size: 0.7em; line-height: 1.3;">"${offerData.tradeStory}"</p>
	</div>
  ` : '';
    const content = document.createElement('div');
    content.style = "position: relative; z-index: 1; min-height: 100vh; display:flex; align-items:center; justify-content:center; padding:20px; box-sizing:border-box;";
    content.innerHTML = `
	<div class="tradeOffPop">
	  <h2>${(0, $fUPn2.t)('offer.trade_offer', 'Trade Offer')}</h2>
	  <p class="zx-sec-explain" style="text-align:left;">${(0, $fUPn2.t)('floor.exp_trade_offer', "A trader is proposing a straight swap: their thing for yours. The floor's bots trade too \u2014 respond exactly as you would to a person.")}</p>
	  <p>${(0, $fUPn2.t)('offer.offers_you', '{initiator} offers you: {offered} in exchange for: {requested}').replace('{initiator}', offerData.initiatorPortfolioName).replace('{offered}', offerData.offeredItemName).replace('{requested}', offerData.transactionItemName)}</p>
	  ${storySection}
	  ${storySection ? `<div style="margin-top: 15px;">
			<button id="respondOffer" style="width: 100%; background: rgba(255, 165, 0, 0.6); color: #000; border: 1px solid #ffaa00; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">
			  ${(0, $fUPn2.t)('offer.respond', 'Respond')}
			</button>
		  </div>` : ''}
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="acceptOffer" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${(0, $fUPn2.t)('offer.accept', 'Accept')}</button>
		<button id="declineOffer" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${(0, $fUPn2.t)('offer.decline', 'Decline')}</button>
	  </div>
	  <div id="timer" style="margin-top:10px;text-align:center;"></div>
	</div>
  `;
    popup.appendChild(content);
    const style = document.createElement('style');
    style.textContent = `
	.tradeOffPop {
	  position: relative !important; transform: none !important; top:auto !important; left:auto !important;
	  width: 90%; max-width: 600px; padding: 20px; background-color: rgba(0, 8, 36, 0.9);
	  border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.5); z-index: 10000;
	  font-family: 'bithigh', Arial, sans-serif; color: #00ff00; text-align: center; margin: 0 auto;
	  box-sizing: border-box; backdrop-filter: blur(5px); -webkit-backdrop-filter: blur(5px);
	}
	@media (max-width: 600px){ .tradeOffPop { width:95%; max-width:95%; padding:15px; margin:10px auto; } }
	@media (max-height: 700px){ .tradeOffPop { margin:10px auto; } }
	.tradeOffPop button { min-height:44px; touch-action:manipulation; -webkit-appearance:none; appearance:none; }
  `;
    document.head.appendChild(style);
    // Load background HLS
    const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/itemTrade/`;
    const totalVideos = 10;
    const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
    const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;
    if (window.Hls && Hls.isSupported()) {
        const hls = new Hls({
            debug: false,
            enableWorker: false,
            lowLatencyMode: true,
            backBufferLength: 90
        });
        hls.loadSource(videoUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, ()=>video.play().catch(()=>{
                video.style.display = 'none';
            }));
        hls.on(Hls.Events.ERROR, ()=>{
            video.style.display = 'none';
        });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoUrl;
        video.addEventListener('loadedmetadata', ()=>video.play().catch(()=>{
                video.style.display = 'none';
            }));
        video.addEventListener('error', ()=>{
            video.style.display = 'none';
        });
    }
    // Timer
    const timerEl = content.querySelector('#timer');
    let remainingTime = Math.floor(timeoutDuration / 1000);
    localStorage.setItem(`${tradeSessionId}_timerType`, 'initial');
    localStorage.setItem(`${tradeSessionId}_expiryTime`, String(Date.now() + timeoutDuration));
    const renderTime = ()=>{
        if (timerEl) timerEl.textContent = (0, $fUPn2.t)('offer.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', remainingTime);
    };
    renderTime();
    const autoDecline = ()=>{
        console.log('autoDecline called - checking session:', tradeSessionId);
        const sessionActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
        const currentActiveSession = localStorage.getItem('activeTradeSession');
        if (!sessionActive || currentActiveSession !== tradeSessionId || !tradeActive) return;
        // lock
        localStorage.setItem(`${tradeSessionId}_active`, 'false');
        tradeActive = false;
        const declineBtn = document.getElementById('declineOffer');
        if (declineBtn) declineBtn.disabled = true;
        $5e5d264206c87423$export$40e1fe1299acaf1b(offerData).then(()=>console.log('Trade successfully auto-declined.')).catch((err)=>console.error('Error auto-declining trade:', err?.message || err)).finally(closePopup);
    };
    timerInterval = setInterval(()=>{
        const sessionActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
        const currentActiveSession = localStorage.getItem('activeTradeSession');
        if (!sessionActive || currentActiveSession !== tradeSessionId) {
            clearInterval(timerInterval);
            return;
        }
        const currentTimerType = localStorage.getItem(`${tradeSessionId}_timerType`);
        if (currentTimerType === 'extended') {
            clearInterval(timerInterval);
            return;
        }
        remainingTime -= 1;
        renderTime();
        if (remainingTime <= 0) {
            clearInterval(timerInterval);
            const stillActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
            const stillInitial = localStorage.getItem(`${tradeSessionId}_timerType`) === 'initial';
            if (stillActive && stillInitial && tradeActive) autoDecline();
        }
    }, 1000);
    // Buttons
    const acceptButton = document.getElementById('acceptOffer');
    const declineButton = document.getElementById('declineOffer');
    acceptButton.onclick = async ()=>{
        localStorage.setItem(`${tradeSessionId}_active`, 'false');
        if (timerInterval) clearInterval(timerInterval);
        if (!tradeActive) return;
        tradeActive = false;
        acceptButton.disabled = true;
        try {
            await $5e5d264206c87423$export$c9d68d666177c59c(offerData);
            closePopup();
        } catch (e) {
            console.error('Error accepting trade:', e);
            (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_accepting_offer', 'Error accepting offer: {message}').replace('{message}', e.message)}`, false);
            acceptButton.disabled = false;
            tradeActive = true;
            localStorage.setItem(`${tradeSessionId}_active`, 'true');
        }
    };
    declineButton.onclick = async ()=>{
        localStorage.setItem(`${tradeSessionId}_active`, 'false');
        if (timerInterval) clearInterval(timerInterval);
        if (!tradeActive) return;
        tradeActive = false;
        declineButton.disabled = true;
        try {
            await $5e5d264206c87423$export$40e1fe1299acaf1b(offerData);
            closePopup();
        } catch (e) {
            console.error('Error declining trade:', e);
            (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_declining_offer', 'Error declining offer: {message}').replace('{message}', e.message)}`, false);
            declineButton.disabled = false;
            tradeActive = true;
            localStorage.setItem(`${tradeSessionId}_active`, 'true');
        }
    };
    // Respond (extends timer 60s and opens narrative dialog)
    if (storySection) {
        const respondButton = document.getElementById('respondOffer');
        respondButton.onclick = ()=>{
            if (!tradeActive) return;
            localStorage.setItem(`${tradeSessionId}_timerType`, 'extended');
            localStorage.setItem(`${tradeSessionId}_expiryTime`, String(Date.now() + 60000));
            if (timerInterval) clearInterval(timerInterval);
            remainingTime = 60;
            renderTime();
            timerInterval = setInterval(()=>{
                const sessionActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
                const currentActiveSession = localStorage.getItem('activeTradeSession');
                if (!sessionActive || currentActiveSession !== tradeSessionId || !tradeActive) {
                    clearInterval(timerInterval);
                    return;
                }
                remainingTime -= 1;
                renderTime();
                if (remainingTime <= 0) {
                    clearInterval(timerInterval);
                    if (sessionActive && tradeActive) autoDecline();
                }
            }, 1000);
            const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
            if (s && s.connected) s.emit('extendTradeTimer', {
                offeredItemId: offerData.offeredItemId,
                transactionItemId: offerData.transactionItemId,
                initiatorUserId: offerData.initiatorUserId,
                targetUserId: offerData.targetUserId,
                newDuration: 60000
            });
            $5e5d264206c87423$var$showNarrativeResponseDialog(offerData);
        };
    }
    function closePopup() {
        localStorage.setItem(`${tradeSessionId}_active`, 'false');
        localStorage.removeItem(`${tradeSessionId}_timerType`);
        localStorage.removeItem(`${tradeSessionId}_expiryTime`);
        localStorage.removeItem(`${tradeSessionId}_offerData`);
        if (localStorage.getItem('activeTradeSession') === tradeSessionId) localStorage.removeItem('activeTradeSession');
        tradeActive = false;
        if (timerInterval) clearInterval(timerInterval);
        if (window.currentTradeTimerExtension) delete window.currentTradeTimerExtension;
        const pop = document.getElementById('tradeOfferPopup');
        if (pop) {
            // Unregister from popupTracker before removing
            if (window.popupTracker) window.popupTracker.unregisterPopup('tradeOfferPopup');
            pop.remove();
            document.body.style.overflow = '';
        }
    }
    // Clean up stale sessions
    const allKeys = Object.keys(localStorage);
    const fiveMinutesAgo = Date.now() - 300000;
    allKeys.forEach((key)=>{
        if (key.startsWith('trade_') && key.endsWith('_expiryTime')) {
            const expiryTime = parseInt(localStorage.getItem(key), 10);
            if (!Number.isNaN(expiryTime) && expiryTime < fiveMinutesAgo) {
                const sessionId = key.replace('_expiryTime', '');
                localStorage.removeItem(`${sessionId}_active`);
                localStorage.removeItem(`${sessionId}_timerType`);
                localStorage.removeItem(`${sessionId}_expiryTime`);
            }
        }
    });
}
async function $5e5d264206c87423$export$c9d68d666177c59c(offerData) {
    if (!offerData) throw new Error('Missing offer data');
    return new Promise((resolve, reject)=>{
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (!s) return reject(new Error('Socket not available'));
        if (!s.connected) return reject(new Error('Socket is not connected'));
        s.emit('acceptTrade', {
            offeredItemId: offerData.offeredItemId,
            transactionItemId: offerData.transactionItemId,
            initiatorUserId: offerData.initiatorUserId,
            targetUserId: offerData.targetUserId
        }, (response)=>{
            if (response && response.success) {
                console.log('Trade acceptance confirmed by server');
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.offer_accepted', 'Offer accepted!'), true);
                resolve(response);
            } else {
                const errorMsg = response?.error || 'No response from server';
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.offer_accept_error', 'Error accepting offer: {message}').replace('{message}', errorMsg)}`, false);
                reject(new Error(errorMsg));
            }
        });
    });
}
async function $5e5d264206c87423$export$40e1fe1299acaf1b(offerData) {
    if (!offerData) throw new Error('Missing offer data');
    return new Promise((resolve, reject)=>{
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (!s) return reject(new Error('Socket not available'));
        const missing = [
            'offeredItemId',
            'transactionItemId',
            'initiatorUserId',
            'targetUserId'
        ].filter((k)=>!offerData[k]);
        if (missing.length) return reject(new Error('Incomplete trade data. Missing: ' + missing.join(', ')));
        if (!s.connected) return reject(new Error('Socket is not connected'));
        s.emit('declineTrade', {
            offeredItemId: offerData.offeredItemId,
            transactionItemId: offerData.transactionItemId,
            initiatorUserId: offerData.initiatorUserId,
            targetUserId: offerData.targetUserId
        }, (response)=>{
            if (response?.success) {
                console.log('Trade declination confirmed by server');
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.offer_declined', 'Offer declined.'), false);
                resolve(response);
            } else {
                const errorMsg = response?.error || 'No response from server';
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.offer_decline_error', 'Error declining offer: {message}').replace('{message}', errorMsg)}`, false);
                reject(new Error(errorMsg));
            }
        });
    });
}
let $5e5d264206c87423$var$clients = new Map();
function $5e5d264206c87423$export$54641e155c9500d5(data) {
    console.log('Attempting to show buy offer popup:', data);
    if (!data) return;
    // Check if this offer was recently handled (prevent duplicate popups from message replay)
    const offerKey = `buyOffer_handled_${data.itemId}_${data.buyerId}`;
    const handledTime = localStorage.getItem(offerKey);
    if (handledTime && Date.now() - parseInt(handledTime) < 30000) {
        console.log('Skipping buy offer popup - recently handled:', offerKey);
        return;
    }
    // Clean up any previous buy offer session
    const currentBuySession = localStorage.getItem('activeBuyOfferSession');
    if (currentBuySession) {
        console.log('Clearing previous buy offer session:', currentBuySession);
        localStorage.setItem(`${currentBuySession}_active`, 'false');
        localStorage.removeItem(`${currentBuySession}_offerData`);
        localStorage.removeItem(`${currentBuySession}_expiryTime`);
    }
    const buySessionId = `buy_${data.itemId}_${data.buyerId}_${Date.now()}`;
    localStorage.setItem('activeBuyOfferSession', buySessionId);
    localStorage.setItem(`${buySessionId}_active`, 'true');
    localStorage.setItem(`${buySessionId}_offerData`, JSON.stringify(data));
    let offerActive = true;
    let timerInterval = null;
    // Remove existing popup if present
    const old = document.getElementById('buyOfferPopup');
    if (old) old.remove();
    const popup = document.createElement('div');
    popup.id = 'buyOfferPopup';
    popup.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif; color: #00ff00; overflow-y: auto; overflow-x: hidden;
	-webkit-overflow-scrolling: touch; padding: env(safe-area-inset-top,0) env(safe-area-inset-right,0) env(safe-area-inset-bottom,0) env(safe-area-inset-left,0);
  `;
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'buy-offer');
    // Background video
    const video = document.createElement('video');
    video.id = 'buyOfferPopupBackground';
    video.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; object-fit: cover; z-index: -1; pointer-events: none; background:#000;
  `;
    [
        'playsinline',
        'webkit-playsinline',
        'muted',
        'autoplay',
        'loop',
        'controls',
        'disablePictureInPicture',
        'preload',
        'x-webkit-airplay'
    ].forEach((attr)=>video.setAttribute(attr, attr === 'controls' ? 'false' : attr === 'preload' ? 'metadata' : 'true'));
    video.muted = true;
    video.controls = false;
    video.playsInline = true;
    video.tabIndex = -1;
    const preventEvent = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        return false;
    };
    [
        'contextmenu',
        'touchstart',
        'touchend',
        'touchmove',
        'click',
        'dblclick',
        'mousedown',
        'mouseup',
        'mousemove',
        'focus',
        'blur'
    ].forEach((ev)=>video.addEventListener(ev, preventEvent, {
            passive: false
        }));
    [
        'webkitfullscreenchange',
        'fullscreenchange',
        'webkitbeginfullscreen',
        'webkitendfullscreen'
    ].forEach((ev)=>video.addEventListener(ev, preventEvent));
    popup.appendChild(video);
    // Build offer text
    let offerText = '';
    if (data.bidType === 'points') offerText = (0, $fUPn2.t)('offer.buy_offer_points', '{portfolio} offers {amount} points for {item}').replace('{portfolio}', data.portfolioName || 'Someone').replace('{amount}', data.offerAmount).replace('{item}', data.item_name || 'your item');
    else if (data.bidType === 'zollars') offerText = (0, $fUPn2.t)('offer.buy_offer_zollars', '{portfolio} offers zollars for {item}').replace('{portfolio}', data.portfolioName || 'Someone').replace('{item}', data.item_name || 'your item');
    else offerText = `${data.portfolioName || 'Someone'} ${(0, $fUPn2.t)('offer.wants_to_buy', 'wants to buy')} ${data.item_name || 'your item'}`;
    // Show buy reason if provided
    const reasonSection = data.buyReason ? `
	<div style="background: rgba(0, 255, 0, 0.1); border: 1px solid rgba(0, 255, 0, 0.3); border-radius: 5px; padding: 10px; margin: 15px 0;">
	  <h5 style="margin:0 0 8px 0;color:#00ff00;">${(0, $fUPn2.t)('offer.reason', 'Reason:')}</h5>
	  <p style="margin: 0; font-style: italic; font-size: 0.85em; line-height: 1.3;">"${data.buyReason}"</p>
	</div>
  ` : '';
    const content = document.createElement('div');
    content.style = "position: relative; z-index: 1; min-height: 100vh; display:flex; align-items:center; justify-content:center; padding:20px; box-sizing:border-box;";
    content.innerHTML = `
	<div class="buyOfferPop">
	  <h2>${(0, $fUPn2.t)('offer.buy_offer_received', 'Buy Offer Received')}</h2>
	  <p class="zx-sec-explain" style="text-align:left;">${(0, $fUPn2.t)('floor.exp_buy_offer', "Someone wants something you carry and is paying for it. Accept and the payment moves to you, the thing to them; decline and you keep it.")}</p>
	  <p>${offerText}</p>
	  ${reasonSection}
	  ${data.bidType === 'zollars' ? `<div style="margin: 10px 0;">${$5e5d264206c87423$var$displayZollarDetails(data.zollarBid || {})}</div>` : ''}
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="acceptBuyOffer" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${(0, $fUPn2.t)('offer.accept', 'Accept')}</button>
		<button id="declineBuyOffer" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${(0, $fUPn2.t)('offer.decline', 'Decline')}</button>
	  </div>
	  <div id="buyTimer" style="margin-top:10px;text-align:center;"></div>
	</div>
  `;
    popup.appendChild(content);
    // Setup close function first (offerKey already defined above for dedup check)
    function closePopup() {
        // Mark this offer as handled to prevent duplicate popups from message replay
        localStorage.setItem(offerKey, String(Date.now()));
        // Schedule cleanup of the handled marker after 30 seconds
        setTimeout(()=>localStorage.removeItem(offerKey), 30000);
        localStorage.setItem(`${buySessionId}_active`, 'false');
        localStorage.removeItem(`${buySessionId}_expiryTime`);
        localStorage.removeItem(`${buySessionId}_offerData`);
        if (localStorage.getItem('activeBuyOfferSession') === buySessionId) localStorage.removeItem('activeBuyOfferSession');
        offerActive = false;
        if (timerInterval) clearInterval(timerInterval);
        const pop = document.getElementById('buyOfferPopup');
        if (pop) {
            if (window.popupTracker) window.popupTracker.unregisterPopup('buyOfferPopup');
            pop.remove();
            document.body.style.overflow = '';
        }
    }
    // Setup buttons IMMEDIATELY after content is appended
    const acceptBtn = content.querySelector('#acceptBuyOffer');
    const declineBtn = content.querySelector('#declineBuyOffer');
    if (acceptBtn) acceptBtn.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem(`${buySessionId}_active`, 'false');
        if (timerInterval) clearInterval(timerInterval);
        if (!offerActive) return;
        offerActive = false;
        this.disabled = true;
        // Close popup immediately - don't wait for server response
        closePopup();
        try {
            await $5e5d264206c87423$export$fd3a0a3b7b4dc710({
                itemId: data.itemId,
                buyerId: data.buyerId,
                sellerId: data.sellerId,
                offerAmount: data.offerAmount,
                bidType: data.bidType,
                zollarBid: data.zollarBid || {},
                item_name: data.item_name
            });
        } catch (err) {
            console.error('Error in handleAcceptBuyOffer:', err);
            (0, $eD3DY.showNotification)(`Error: ${err.message}`, false);
        }
    });
    if (declineBtn) declineBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem(`${buySessionId}_active`, 'false');
        if (timerInterval) clearInterval(timerInterval);
        if (!offerActive) return;
        offerActive = false;
        this.disabled = true;
        // Close popup immediately - don't wait for server response
        closePopup();
        $5e5d264206c87423$export$5bc1b41b6ea3d1d5(data);
    });
    // Setup timer
    let remainingTime = 10;
    localStorage.setItem(`${buySessionId}_expiryTime`, String(Date.now() + 10000));
    const updateTimer = ()=>{
        const timerEl = content.querySelector('#buyTimer');
        if (timerEl) timerEl.textContent = `Time remaining: ${remainingTime} seconds`;
    };
    updateTimer();
    timerInterval = setInterval(()=>{
        const sessionActive = localStorage.getItem(`${buySessionId}_active`) === 'true';
        const currentSession = localStorage.getItem('activeBuyOfferSession');
        if (!sessionActive || currentSession !== buySessionId) {
            clearInterval(timerInterval);
            return;
        }
        remainingTime -= 1;
        updateTimer();
        if (remainingTime <= 0) {
            clearInterval(timerInterval);
            const stillActive = localStorage.getItem(`${buySessionId}_active`) === 'true';
            if (stillActive && offerActive) {
                localStorage.setItem(`${buySessionId}_active`, 'false');
                offerActive = false;
                $5e5d264206c87423$export$5bc1b41b6ea3d1d5(data);
                closePopup();
            }
        }
    }, 1000);
    const style = document.createElement('style');
    style.textContent = `
	.buyOfferPop {
	  position: relative !important; transform: none !important; top:auto !important; left:auto !important;
	  width: 90%; max-width: 600px; padding: 20px; background-color: rgba(0, 8, 36, 0.9);
	  border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.5); z-index: 10000;
	  font-family: 'bithigh', Arial, sans-serif; color: #00ff00; text-align: center; margin: 0 auto;
	  box-sizing: border-box; backdrop-filter: blur(5px); -webkit-backdrop-filter: blur(5px);
	}
	@media (max-width: 600px){ .buyOfferPop { width:95%; max-width:95%; padding:15px; margin:10px auto; } }
	@media (max-height: 700px){ .buyOfferPop { margin:10px auto; } }
	.buyOfferPop button { min-height:44px; touch-action:manipulation; -webkit-appearance:none; appearance:none; }
  `;
    document.head.appendChild(style);
    // Load background HLS (using same item trade backgrounds)
    const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/itemTrade/`;
    const totalVideos = 10;
    const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
    const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;
    if (window.Hls && Hls.isSupported()) {
        const hls = new Hls({
            debug: false,
            enableWorker: false,
            lowLatencyMode: true,
            backBufferLength: 90
        });
        hls.loadSource(videoUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, ()=>video.play().catch(()=>{
                video.style.display = 'none';
            }));
        hls.on(Hls.Events.ERROR, ()=>{
            video.style.display = 'none';
        });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoUrl;
        video.addEventListener('loadedmetadata', ()=>video.play().catch(()=>{
                video.style.display = 'none';
            }));
        video.addEventListener('error', ()=>{
            video.style.display = 'none';
        });
    }
}
function $5e5d264206c87423$var$displayZollarDetails(zollarBid) {
    if (!zollarBid || Object.keys(zollarBid).length === 0) return `<p>${(0, $fUPn2.t)('offer.no_zollar_details', 'No Zollar details available.')}</p>`;
    let zollarHtml = '<ul>';
    for (const [type, value] of Object.entries(zollarBid))if (value > 0) {
        const descriptor = $5e5d264206c87423$var$getQualitativeDescriptor(value);
        zollarHtml += `<li>${type}: ${descriptor}</li>`; // Only display the descriptor
    }
    zollarHtml += '</ul>';
    return zollarHtml;
}
let $5e5d264206c87423$var$isProcessing = false;
function $5e5d264206c87423$export$fd3a0a3b7b4dc710(data) {
    return new Promise((resolve, reject)=>{
        if ($5e5d264206c87423$var$isProcessing) return reject(new Error('Transaction is already being processed.'));
        $5e5d264206c87423$var$isProcessing = true;
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        const trySocketFirst = !!(s && s.connected);
        const doSocket = ()=>$5e5d264206c87423$export$d789718bde385b17({
                itemId: data.itemId,
                buyerId: data.buyerId,
                sellerId: data.sellerId,
                bidType: data.bidType,
                offerAmount: data.offerAmount,
                zollarBid: data.zollarBid || {},
                sessionId: localStorage.getItem('sessionId')
            });
        const doHttp = ()=>fetch(`${(0, $cNeIB.apiBaseUrl)}/api/button/acceptBuyOffer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    buyerId: data.buyerId,
                    sellerId: data.sellerId,
                    itemId: data.itemId,
                    offerAmount: data.offerAmount,
                    bidType: data.bidType,
                    zollarBid: data.zollarBid || {},
                    sessionId: localStorage.getItem('sessionId')
                })
            }).then((r)=>r.json()).then((result)=>{
                if (!result?.success) throw new Error(result?.message || 'Failed to accept the buy offer');
                return result;
            });
        (trySocketFirst ? doSocket() : doHttp()).then((result)=>{
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.success_buy_offer_accepted', 'Success: Buy offer accepted for {item}').replace('{item}', data.item_name || (0, $fUPn2.t)('offer.item', 'item')), true);
            $5e5d264206c87423$var$closeBuyOfferPopupAfterAccept();
            resolve(result);
        }).catch(async (err)=>{
            // Fallback to HTTP if socket path failed
            if (trySocketFirst) try {
                const result = await doHttp();
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.success_buy_offer_accepted', 'Success: Buy offer accepted for {item}').replace('{item}', data.item_name || (0, $fUPn2.t)('offer.item', 'item')), true);
                $5e5d264206c87423$var$closeBuyOfferPopupAfterAccept();
                resolve(result);
                return;
            } catch (err2) {
                console.error('Failed via socket and HTTP:', err2);
                (0, $eD3DY.showNotification)(`Error: ${err2.message}`, false);
                reject(err2);
                return;
            }
            else {
                console.error('Failed to process the transaction:', err);
                (0, $eD3DY.showNotification)(`Error: ${err.message}`, false);
                reject(err);
            }
        }).finally(()=>{
            $5e5d264206c87423$var$isProcessing = false;
        });
    });
}
function $5e5d264206c87423$export$5bc1b41b6ea3d1d5(data) {
    console.log('Handling rejected buy offer:', data);
    // If you want to notify server about explicit declines, emit here:
    // if (socket && socket.connected) socket.emit('rejectBuyOffer', { ...data, sessionId: localStorage.getItem('sessionId') });
    (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.buy_offer_declined', 'Buy offer declined.'), false);
    $5e5d264206c87423$var$closeBuyOfferPopupAfterDecline();
}
async function $5e5d264206c87423$export$d789718bde385b17(data) {
    return new Promise((resolve, reject)=>{
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (!s) return reject(new Error('Socket not available'));
        if (!s.connected) return reject(new Error('Socket is not connected'));
        const message = {
            itemId: data.itemId,
            buyerId: data.buyerId,
            sellerId: data.sellerId,
            sessionId: data.sessionId || localStorage.getItem('sessionId'),
            bidType: data.bidType,
            offerAmount: data.offerAmount,
            zollarBid: data.zollarBid || {}
        };
        let resolved = false;
        const timeout = setTimeout(()=>{
            if (!resolved) {
                resolved = true;
                reject(new Error('Socket timeout - no response from server'));
            }
        }, 8000);
        s.emit('acceptBuyOfferSocket', message, (response)=>{
            if (resolved) return;
            resolved = true;
            clearTimeout(timeout);
            if (response?.success) {
                console.log('Buy offer accepted via socket:', response);
                resolve(response);
            } else {
                const errorMsg = response?.error || 'No response from server';
                reject(new Error(errorMsg));
            }
        });
    });
}
function $5e5d264206c87423$var$getQualitativeDescriptor(quantity) {
    if (quantity === 0) return (0, $fUPn2.t)('offer.zollar_none', 'None');
    if (quantity <= 3) return (0, $fUPn2.t)('offer.zollar_few', 'A Few');
    if (quantity <= 7) return (0, $fUPn2.t)('offer.zollar_some', 'Some');
    if (quantity <= 15) return (0, $fUPn2.t)('offer.zollar_many', 'Many');
    return (0, $fUPn2.t)('offer.zollar_huge', 'A Huge Amount');
}
function $5e5d264206c87423$var$closeBuyOfferPopupAfterAccept() {
    const popup = document.getElementById('buyOfferPopup');
    if (popup) {
        if (window.popupTracker) window.popupTracker.unregisterPopup('buyOfferPopup');
        popup.remove();
        document.body.style.overflow = '';
    }
}
function $5e5d264206c87423$var$closeBuyOfferPopupAfterDecline() {
    const popup = document.getElementById('buyOfferPopup');
    if (popup) {
        if (window.popupTracker) window.popupTracker.unregisterPopup('buyOfferPopup');
        popup.remove();
        document.body.style.overflow = '';
    }
}
function $5e5d264206c87423$var$showLoadingIndicator() {
    const popupContainer = document.getElementById('popup-container');
    if (popupContainer) {
        const loadingText = document.createElement("p");
        loadingText.textContent = (0, $fUPn2.t)('offer.processing', 'Processing transaction...');
        loadingText.style.color = "#00ff00";
        popupContainer.appendChild(loadingText);
    }
}
function $5e5d264206c87423$var$makeClientMessageId() {
    return `msg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
function $5e5d264206c87423$export$2e349d3452c1a401(itemId, itemName, targetUsers, transactionData) {
    // Create overlay
    const overlay = document.createElement("div");
    overlay.id = 'storyCustomizationOverlay';
    overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; justify-content: center; align-items: center; display: flex;";
    // Create form container
    const formContainer = document.createElement("div");
    formContainer.style = "background: rgba(1, 32, 59, 0.95); border: 2px solid #00ff00; color: #00ff00; padding: 20px; border-radius: 5px; max-width: 500px; width: 90%;";
    formContainer.innerHTML = `
    <h2 style="text-align:center;margin-bottom:20px;">
      ${(0, $fUPn2.t)('offer.customize_story_element', 'Customize Your Story Element')}
    </h2>

    <p style="font-style:italic;margin-bottom:15px;font-size:.9em;">
      "${(0, $fUPn2.t)('offer.story_element_description', 'Each trade shapes your story. Describe how you want this element to appear in the final narrative.')}"
    </p>

    <div style="margin-bottom:15px;background:rgba(0,255,0,0.1);padding:10px;border-radius:5px;">
      <strong>${(0, $fUPn2.t)('offer.trading_item', 'Trading Item:')} </strong> ${itemName}
    </div>

    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:5px;">
        ${(0, $fUPn2.t)('offer.how_customize', 'How would you like to customize this story element?')}
      </label>
      <textarea id="story-customization-text"
                placeholder="${(0, $fUPn2.t)('offer.customization_placeholder', 'Describe your vision for this story element... (e.g., character traits, setting details, plot twists)')}"
                style="width:100%;height:100px;padding:8px;background:rgba(36,65,192,.8);
                       color:#00ff00;border:1px solid #00ff00;resize:vertical;box-sizing:border-box;"
                maxlength="300"></textarea>
      <div style="text-align:right;font-size:.7em;margin-top:5px;">
        <span id="custom-char-count">0</span>/300
      </div>
    </div>

    <div style="display:flex;gap:10px;">
      <button id="cancel-story-customization"
              style="flex:1;padding:10px;background:rgba(255,0,0,.6);color:#fff;
                     border:1px solid #ff0000;cursor:pointer;border-radius:3px;">
        ${(0, $fUPn2.t)('offer.cancel', 'Cancel')}
      </button>
      <button id="submit-story-customization"
              style="flex:1;padding:10px;background:rgba(0,255,0,.6);color:#000;
                     border:1px solid #00ff00;cursor:pointer;border-radius:3px;" disabled>
        ${(0, $fUPn2.t)('offer.continue_trade', 'Continue Trade')}
      </button>
    </div>
  `;
    overlay.appendChild(formContainer);
    document.body.appendChild(overlay);
    if (window.popupTracker) window.popupTracker.trackElement(overlay, 'story-customization-form');
    // Add event listeners
    const customizationTextarea = document.getElementById('story-customization-text');
    const charCount = document.getElementById('custom-char-count');
    const submitButton = document.getElementById('submit-story-customization');
    const cancelButton = document.getElementById('cancel-story-customization');
    // Character counter and validation
    customizationTextarea.addEventListener('input', ()=>{
        const length = customizationTextarea.value.length;
        charCount.textContent = length;
        const isValid = customizationTextarea.value.trim().length >= 10;
        submitButton.disabled = !isValid;
        submitButton.style.opacity = isValid ? '1' : '0.5';
    });
    // Cancel button
    cancelButton.addEventListener('click', ()=>{
        document.body.removeChild(overlay);
    });
    // Submit button
    submitButton.addEventListener('click', async ()=>{
        const customization = customizationTextarea.value.trim();
        try {
            submitButton.disabled = true;
            submitButton.textContent = (0, $fUPn2.t)('offer.saving', 'Saving...');
            // Save the customization to the backend
            const portfolioId = localStorage.getItem('portfolioId');
            const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/storysim/save-customization`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    portfolioId: portfolioId,
                    itemId: itemId,
                    itemName: itemName,
                    customization: customization
                })
            });
            const result = await response.json();
            if (result.success) {
                document.body.removeChild(overlay);
                // Store customization in transaction data for the offer
                if (transactionData) transactionData.storyCustomization = customization;
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.customization_saved', 'Story element customized!'), true);
                // Now proceed with the actual trade offer (call original transaction logic)
                // This will be handled by the calling function
                if (window.proceedWithStoryTrade) window.proceedWithStoryTrade(customization);
            } else throw new Error(result.error || 'Failed to save customization');
        } catch (error) {
            console.error('Error saving story customization:', error);
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_generic', 'Error: {message}').replace('{message}', error.message), false);
            submitButton.textContent = (0, $fUPn2.t)('offer.continue_trade', 'Continue Trade');
            submitButton.disabled = false;
        }
    });
}
function $5e5d264206c87423$export$d6f732f4663dfbc(itemId, targetUsers) {
    // Create overlay
    const overlay = document.createElement("div");
    overlay.id = 'offerSentOverlay';
    overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; justify-content: center; align-items: center; display: flex;";
    // Create form container
    const formContainer = document.createElement("div");
    formContainer.style = "background: rgba(1, 32, 59, 0.95); border: 2px solid #00ff00; color: #00ff00; padding: 20px; border-radius: 5px; max-width: 500px; width: 90%;";
    formContainer.innerHTML = `
   <h2 style="text-align:center;margin-bottom:20px;">
	 ${(0, $fUPn2.t)('offer.meaningful_exchange', 'Meaningful Exchange')}
   </h2>
 
   <p style="font-style:italic;margin-bottom:15px;font-size:.7em;">
	 "${(0, $fUPn2.t)('offer.value_quote', 'Value exists in perception, play and speculation, not just utility or rarity.')}"
   </p>
 
   <div style="margin-bottom:15px;">
	 <label style="display:block;margin-bottom:5px;">
	   ${(0, $fUPn2.t)('offer.who_to_trade_with', 'Who would you like to trade with?')}
	 </label>
	 <select id="social-target-select"
			 style="width:100%;padding:8px;background:rgba(36,65,192,.8);
					color:#00ff00;border:1px solid #00ff00;">
	   <option value="">${(0, $fUPn2.t)('offer.select_trader', 'Select a trader...')}</option>
	   ${targetUsers.map((u)=>`<option value="${u._id}">${u.name}${u.isBot ? " \uD83E\uDD16" : ''}</option>`).join('')}
	 </select>
   </div>
 
   <div style="margin-bottom:15px;">
	 <label style="display:block;margin-bottom:5px;">
	   ${(0, $fUPn2.t)('offer.why_trade', 'Why do you want to make this trade?')}
	 </label>
	 <textarea id="social-trade-reason"
			   placeholder="${(0, $fUPn2.t)('offer.describe_motivation', 'Describe your motivation, emotion or story...')}"
			   style="width:100%;height:80px;padding:8px;background:rgba(36,65,192,.8);
					  color:#00ff00;border:1px solid #00ff00;resize:none;"
			   maxlength="500"></textarea>
	 <div style="text-align:right;font-size:.7em;margin-top:5px;">
	   <span id="char-count">0</span>/500
	 </div>
   </div>
 
   <div style="margin-bottom:20px;">
	 <label style="display:block;margin-bottom:5px;">
	   ${(0, $fUPn2.t)('offer.trade_with', 'Trade with:')}
	 </label>
	 <div style="display:flex;gap:15px;">
	   <label style="display:flex;align-items:center;">
		 <input type="radio" name="bidType" value="points" checked style="margin-right:5px;">
		 ${(0, $fUPn2.t)('offer.capital', 'Capital')}
	   </label>
	   <label style="display:flex;align-items:center;">
		 <input type="radio" name="bidType" value="zollars" style="margin-right:5px;">
		 ${(0, $fUPn2.t)('offer.zollars', 'Zollars')}
	   </label>
	 </div>
   </div>
 
   <div style="display:flex;gap:10px;">
	 <button id="cancel-social-trade"
			 style="flex:1;padding:10px;background:rgba(255,0,0,.6);color:#fff;
					border:1px solid #ff0000;cursor:pointer;">
	   ${(0, $fUPn2.t)('offer.cancel', 'Cancel')}
	 </button>
	 <button id="submit-social-trade"
			 style="flex:1;padding:10px;background:rgba(0,255,0,.6);color:#000;
					border:1px solid #00ff00;cursor:pointer;" disabled>
	   ${(0, $fUPn2.t)('offer.send_offer', 'Send Offer')}
	 </button>
   </div>
 `;
    overlay.appendChild(formContainer);
    document.body.appendChild(overlay);
    if (window.popupTracker) window.popupTracker.trackElement(overlay, 'social-trade-form');
    // Add event listeners
    const targetSelect = document.getElementById('social-target-select');
    const reasonTextarea = document.getElementById('social-trade-reason');
    const charCount = document.getElementById('char-count');
    const submitButton = document.getElementById('submit-social-trade');
    const cancelButton = document.getElementById('cancel-social-trade');
    // Character counter and validation
    reasonTextarea.addEventListener('input', ()=>{
        const length = reasonTextarea.value.length;
        charCount.textContent = length;
        const isValid = targetSelect.value && reasonTextarea.value.trim().length >= 10;
        submitButton.disabled = !isValid;
        submitButton.style.opacity = isValid ? '1' : '0.5';
    });
    targetSelect.addEventListener('change', ()=>{
        const isValid = targetSelect.value && reasonTextarea.value.trim().length >= 10;
        submitButton.disabled = !isValid;
        submitButton.style.opacity = isValid ? '1' : '0.5';
    });
    // Cancel button
    cancelButton.addEventListener('click', ()=>{
        document.body.removeChild(overlay);
    });
    // Submit button  
    submitButton.addEventListener('click', async ()=>{
        const targetUserId = targetSelect.value;
        const reason = reasonTextarea.value.trim();
        const bidType = document.querySelector('input[name="bidType"]:checked').value;
        try {
            submitButton.disabled = true;
            submitButton.textContent = (0, $fUPn2.t)('offer.sending', 'Sending...');
            const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-trade-offer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    itemId: itemId,
                    targetUserId: targetUserId,
                    reason: reason,
                    bidType: bidType
                })
            });
            const result = await response.json();
            if (result.success) {
                document.body.removeChild(overlay);
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.meaningful_offer_sent', 'Meaningful trade offer sent! {insight}').replace('{insight}', result.llmInsight || ''), true);
                // Show the existing offer sent popup
                localStorage.setItem('pendingOffer', 'true');
                $5e5d264206c87423$export$f96bc44d9ad77c90(localStorage.getItem('portfolioId'), []);
            } else throw new Error(result.error || 'Failed to send offer');
        } catch (error) {
            console.error('Error sending social trade offer:', error);
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_generic', 'Error: {message}').replace('{message}', error.message), false);
            submitButton.textContent = (0, $fUPn2.t)('offer.send_meaningful_offer', 'Send Meaningful Offer');
            submitButton.disabled = false;
        }
    });
}
function $5e5d264206c87423$export$c8555101b1151e80(itemId, itemName, targetPortfolioId, targetPortfolioName) {
    const portfolioId = localStorage.getItem('portfolioId');
    const userPortfolioName = localStorage.getItem('portfolioName') || 'Your Portfolio';
    // Create the dialog
    const dialog = document.createElement('div');
    dialog.className = 'social-trade-overlay';
    dialog.id = 'social-trade-dialog'; // Add ID for easier removal
    dialog.style.cssText = `
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10000;
	font-family: 'bithigh', monospace;
  `;
    dialog.innerHTML = `
	<div style="background:linear-gradient(135deg,#001122 0%,#003344 100%);
				border:2px solid #00ff00;border-radius:5px;padding:30px;
				max-width:500px;width:90%;color:#00ff00;box-shadow:0 0 30px rgba(0,255,0,.3);">
	  <h2 style="margin:0 0 20px;text-align:center;color:#00ff00;">
		${(0, $fUPn2.t)('transaction.explain_trade_reason', 'Explain why you want to make this trade.')}
	  </h2>
  
	  <div style="margin-bottom:20px;padding:15px;background:rgba(0,255,0,.1);border-radius:5px;">
		<p style="margin:0;font-size:12px;">
		  <strong>${(0, $fUPn2.t)('transaction.item_name', 'Item')}:</strong> ${itemName}<br>
		  <strong>${(0, $fUPn2.t)('market.owner', 'Owner')}:</strong> ${targetPortfolioName}<br>
		  <strong>${(0, $fUPn2.t)('trader.your_portfolio', 'Your Portfolio')}:</strong> ${userPortfolioName}
		</p>
	  </div>
  
	  <div style="margin-bottom:20px;">
		<label style="display:block;margin-bottom:10px;font-weight:bold;">
		  ${(0, $fUPn2.t)('transaction.why_trade_question', 'Why do you want to make this trade? What is your goal?')}
		</label>
		<textarea id="tradeStoryText"
				  placeholder="${$5e5d264206c87423$var$tr('offer.share_reason_placeholder', 'Share your reason, motivation, memory, or vision... To create meaningful connections by trading.')}"
				  style="width:100%;height:120px;background:rgba(0,0,0,.7);
						 border:1px solid #00ff00;color:#00ff00;padding:10px;
						 border-radius:2px;font-family:'bithigh',Arial,sans-serif;
						 font-size:12px;resize:vertical;box-sizing:border-box;"
				  required></textarea>
		<div id="storyError"
			 style="color:#ff0000;font-size:12px;margin-top:5px;display:none;">
		  ${(0, $fUPn2.t)('transaction.narrative_error', 'Please write at least 15 characters to explain your goal.')}
		</div>
	  </div>
  
	  <div style="display:flex;gap:15px;justify-content:center;">
		<button id="sendTradeStory"
				style="background:linear-gradient(45deg,#00ff00,#00aa00);color:#000;
					   border:none;padding:12px 25px;border-radius:3px;cursor:pointer;
					   font-weight:bold;font-family:'bithigh',Arial,sans-serif;">
		  ${(0, $fUPn2.t)('transaction.send_trade_with_intention', 'Send trade with intention')}
		</button>
		<button id="cancelTradeStory"
				style="background:linear-gradient(45deg,#666,#444);color:#fff;
					   border:none;padding:12px 25px;border-radius:4px;cursor:pointer;
					   font-family:'bithigh',Arial,sans-serif;">
		  ${$5e5d264206c87423$var$tr('offer.cancel', 'Cancel')}
		</button>
	  </div>
	</div>
  `;
    document.body.appendChild(dialog);
    if (window.popupTracker) {
        const popupHandle = window.popupTracker.trackElement(dialog, 'social-trade-dialog');
    }
    // Handle send button
    const sendButton = document.getElementById('sendTradeStory');
    const cancelButton = document.getElementById('cancelTradeStory');
    const storyTextarea = document.getElementById('tradeStoryText');
    const errorDiv = document.getElementById('storyError');
    sendButton.onclick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const storyText = storyTextarea.value.trim();
        if (!storyText || storyText.length < 10) {
            errorDiv.style.display = 'block';
            errorDiv.textContent = (0, $fUPn2.t)('offer.response_min_10', 'Please write at least 10 characters about why you want this asset.');
            storyTextarea.focus();
            return;
        }
        // Store the story in localStorage for the transaction page
        localStorage.setItem('tradeStory', storyText);
        localStorage.setItem('tradeStoryTimestamp', new Date().toISOString());
        // Remove dialog
        dialog.remove();
        // Navigate to transaction page with story flag
        const url = `transaction.html?itemId=${encodeURIComponent(itemId)}&itemName=${encodeURIComponent(itemName)}&portfolioId=${encodeURIComponent(targetPortfolioId)}&portfolioName=${encodeURIComponent(targetPortfolioName)}&hasStory=true`;
        console.log('Navigating to:', url);
        window.location.href = url;
    };
    // Handle cancel button
    cancelButton.onclick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        console.log('Cancel button clicked');
        dialog.remove();
    };
    // Handle escape key
    const escapeHandler = (e)=>{
        if (e.key === 'Escape') {
            dialog.remove();
            document.removeEventListener('keydown', escapeHandler);
        }
    };
    document.addEventListener('keydown', escapeHandler);
    // Focus on textarea
    setTimeout(()=>{
        storyTextarea.focus();
    }, 100);
    // Add click outside to close (optional)
    dialog.addEventListener('click', (e)=>{
        if (e.target === dialog) dialog.remove();
    });
}
function $5e5d264206c87423$export$e6bbcc1b0179915c(data) {
    // Guard & destructure safely
    if (!data || typeof data !== 'object') return;
    const { itemName: itemName = (0, $fUPn2.t)?.('offer.item', 'item'), reason: reason = '', initiatorName: initiatorName = (0, $fUPn2.t)?.('offer.trader', 'Trader'), initiatorUserId: initiatorUserId, itemId: itemId } = data;
    // Must have these to route replies
    if (!initiatorUserId || !itemId) {
        console.warn('showSocialTradeReceived: missing initiatorUserId or itemId', data);
        return;
    }
    // Socket must be available now
    const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
    if (!s || !s.connected) {
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_no_socket', 'Not connected. Please try again.'), false);
        return;
    }
    // DOM
    const overlay = document.createElement('div');
    overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%;background: rgba(0,0,0,0.8); z-index: 9999; display: flex; justify-content: center; align-items: center;";
    const popup = document.createElement('div');
    popup.style = "background: rgba(1, 32, 59, 0.95); border: 2px solid #00ff00; color: #00ff00; padding: 20px;border-radius: 5px; max-width: 500px; width: 90%; font-family: 'bithigh', sans-serif;";
    popup.innerHTML = `
	<h4 style="margin-top:0; text-align:center;">
	  ${(0, $fUPn2.t)('offer.meaningful_trade_offer', 'Meaningful Trade Offer')}
	</h4>
	<div style="margin-bottom:15px;">
	  <strong>${initiatorName}</strong> ${(0, $fUPn2.t)('offer.wants_to_trade', 'wants to trade')}
	  <strong>${itemName}</strong>
	</div>
	<div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 3px; margin-bottom: 15px; font-style: italic;">
	  "${reason || ''}"
	</div>
	<textarea id="response-message"
	  placeholder="${(0, $fUPn2.t)('offer.respond_optional', 'Respond to their story (optional)...')}"
	  style="width:100%; height:60px; padding:8px; background: rgba(36,65,192,0.8); color:#00ff00;
			 border:1px solid #00ff00; resize:none; margin-bottom:15px;"
	  maxlength="200"></textarea>
	<div style="display:flex; gap:10px;">
	  <button id="not-interested" style="flex:1; padding:10px; background: rgba(255,0,0,0.6); color:#fff; border:1px solid #ff0000; cursor:pointer;">
		${(0, $fUPn2.t)('offer.not_interested', 'Not Interested')}
	  </button>
	  <button id="interested" style="flex:1; padding:10px; background: rgba(0,255,0,0.6); color:#000; border:1px solid #00ff00; cursor:pointer;">
		${(0, $fUPn2.t)('offer.im_interested', "I'm Interested!")}
	  </button>
	</div>
  `;
    overlay.appendChild(popup);
    document.body.appendChild(overlay);
    if (window.popupTracker) window.popupTracker.trackElement(overlay, 'social-trade-received');
    const autoClose = setTimeout(removeOverlay, 30000);
    function removeOverlay() {
        clearTimeout(autoClose);
        if (document.body.contains(overlay)) document.body.removeChild(overlay);
    }
    // Close on ESC and click-outside
    const onEsc = (e)=>{
        if (e.key === 'Escape') removeOverlay();
    };
    document.addEventListener('keydown', onEsc);
    overlay.addEventListener('click', (e)=>{
        if (e.target === overlay) removeOverlay();
    });
    // Common send routine (no waitForReadySocket; we already checked)
    function sendReply({ interested: interested }) {
        const message = (document.getElementById('response-message')?.value || '').trim();
        const myPortfolioId = $5e5d264206c87423$var$getPortfolioId();
        const content = message || (interested ? (0, $fUPn2.t)('offer.default_interested', "I'm interested in this trade!") : (0, $fUPn2.t)('offer.default_not_interested', 'Not interested in this trade.'));
        if (!s || !s.connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_no_socket', 'Not connected. Please try again.'), false);
            return;
        }
        s.emit('socialTradeResponse', {
            initiatorUserId: initiatorUserId,
            targetUserId: myPortfolioId,
            itemId: itemId,
            interested: !!interested,
            message: content
        }, (ack)=>{
            if (ack && ack.success === false) {
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_sending', 'Error: {m}').replace('{m}', ack.error || 'Failed to send'), false);
                return;
            }
            removeOverlay();
            (0, $eD3DY.showNotification)(interested ? (0, $fUPn2.t)('offer.interest_shown', 'Interest shown! They may contact you directly.') : (0, $fUPn2.t)('offer.response_sent', 'Response sent'), !!interested);
        });
    }
    // Wire buttons
    popup.querySelector('#not-interested').addEventListener('click', ()=>sendReply({
            interested: false
        }));
    popup.querySelector('#interested').addEventListener('click', ()=>sendReply({
            interested: true
        }));
}
function $5e5d264206c87423$export$e8b9a359288bb90c(data) {
    const { responderName: responderName, interested: interested, message: message } = data;
    const emotion = interested ? 'yes' : 'meh';
    const color = interested ? 'rgba(0, 255, 0, 0.8)' : 'rgba(255, 165, 0, 0.8)';
    (0, $eD3DY.showNotification)(`${emotion} ${responderName}: "${message}"`, interested);
}
function $5e5d264206c87423$var$showNarrativeResponseDialog(offerData) {
    const overlay = document.createElement('div');
    overlay.style.cssText = `
	position: fixed; top: 0; left: 0; width: 100%; height: 100%;
	background: rgba(0,0,0,0.9); z-index: 10001;
	display: flex; align-items: flex-start; justify-content: center;
	overflow-y: auto; overflow-x: hidden; padding: 20px 0; box-sizing: border-box;
  `;
    const dialog = document.createElement('div');
    dialog.style.cssText = `
	background: linear-gradient(135deg, #001122 0%, #003344 100%);
	border: 2px solid #00ff00; border-radius: 10px; padding: 30px;
	max-width: 500px; width: 90%; color: #00ff00; font-family: 'bithigh', monospace;
	margin: auto; max-height: calc(100vh - 40px); overflow-y: auto; box-sizing: border-box; position: relative;
  `;
    dialog.innerHTML = `
	<h5 style="margin: 0 0 15px 0; text-align: center;">${(0, $fUPn2.t)('offer.respond_to_offer', 'Respond to offer.')}</h5>
	<div style="background: rgba(0,255,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
	  <strong>${(0, $fUPn2.t)('offer.the_why', 'The why:')}</strong><br>
	  <em>"${offerData.tradeStory || ''}"</em>
	</div>
	<textarea id="responseText" placeholder="${(0, $fUPn2.t)('offer.response_placeholder', 'Share your thoughts, ask questions, or explain your perspective...')}"
	  style="width: 100%; height: 100px; background: rgba(0,0,0,0.7); border: 1px solid #00ff00; color: #00ff00; padding: 10px; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif; resize: vertical; box-sizing: border-box;" maxlength="300" required></textarea>
	<div style="text-align: right; font-size: 0.8em; margin: 5px 0;">
	  <span id="responseCharCount">0</span>/300
	</div>
	<div id="responseError" style="color: #ff0000; font-size: 12px; margin: 5px 0; display: none;">
	  ${(0, $fUPn2.t)('offer.response_min_chars', 'Please write at least 10 characters in your response.')}
	</div>
	<div style="display: flex; gap: 10px; margin-top: 15px;">
	  <button id="sendResponse" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 5px;">
		${(0, $fUPn2.t)('offer.send_response', 'Send Response')}
	  </button>
	  <button id="cancelResponse" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 5px;">
		${(0, $fUPn2.t)('offer.cancel', 'Cancel')}
	  </button>
	</div>
  `;
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    if (window.popupTracker) window.popupTracker.trackElement(overlay, 'narrative-response');
    const responseText = dialog.querySelector('#responseText');
    const charCount = dialog.querySelector('#responseCharCount');
    const sendButton = dialog.querySelector('#sendResponse');
    const cancelButton = dialog.querySelector('#cancelResponse');
    const errorDiv = dialog.querySelector('#responseError');
    let listenerAttached = false;
    let sending = false;
    responseText.addEventListener('input', ()=>{
        charCount.textContent = responseText.value.length;
        if (responseText.value.length > 0) errorDiv.style.display = 'none';
    });
    const cleanup = ()=>{
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (listenerAttached && s) s.off('llmResponseReceived', handleLLMResponse);
        listenerAttached = false;
        document.body.style.overflow = '';
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    };
    cancelButton.onclick = (e)=>{
        e.preventDefault();
        if (sending) return;
        cleanup();
    };
    function handleLLMResponse(data) {
        if (!data?.originalOffer) return;
        const match = data.originalOffer.offeredItemId === offerData.offeredItemId && data.originalOffer.transactionItemId === offerData.transactionItemId;
        if (!match) return;
        // Update dialog with bot response
        dialog.innerHTML = `
	  <h4 style="margin: 0 0 15px 0; text-align: center;">${(0, $fUPn2.t)('offer.they_responded', 'They Responded')}</h4>
	  <div style="background: rgba(0,255,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 10px;">
		<strong>${(0, $fUPn2.t)('offer.their_original_why', 'Their original why:')}</strong><br>
		<em>"${offerData.tradeStory || ''}"</em>
	  </div>
	  <div style="background: rgba(0,100,255,0.1); padding: 10px; border-radius: 5px; margin-bottom: 10px;">
		<strong>${(0, $fUPn2.t)('offer.your_response', 'Your response:')}</strong><br>
		<em>"${data.userResponse || ''}"</em>
	  </div>
	  <div style="background: rgba(255,165,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
		<strong>${(0, $fUPn2.t)('offer.their_response', 'Their response:')}</strong><br>
		<em>"${data.botResponse || ''}"</em>
	  </div>
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="finalAcceptFromDialog" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 5px;">
		  ${(0, $fUPn2.t)('offer.accept', 'Accept')}
		</button>
		<button id="finalDeclineFromDialog" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 5px;">
		  ${(0, $fUPn2.t)('offer.decline', 'Decline')}
		</button>
	  </div>
	`;
        const finalAccept = dialog.querySelector('#finalAcceptFromDialog');
        const finalDecline = dialog.querySelector('#finalDeclineFromDialog');
        finalAccept.onclick = async ()=>{
            try {
                await $5e5d264206c87423$export$c9d68d666177c59c(offerData);
                cleanup();
                const original = document.getElementById('tradeOfferPopup');
                if (original) original.remove();
            } catch (e) {
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_accepting_offer', 'Error accepting offer: {message}').replace('{message}', e.message)}`, false);
            }
        };
        finalDecline.onclick = async ()=>{
            try {
                await $5e5d264206c87423$export$40e1fe1299acaf1b(offerData);
                cleanup();
                const original = document.getElementById('tradeOfferPopup');
                if (original) original.remove();
            } catch (e) {
                (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_declining_offer', 'Error declining offer: {message}').replace('{message}', e.message)}`, false);
            }
        };
        // detach, handled once
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (listenerAttached && s) {
            s.off('llmResponseReceived', handleLLMResponse);
            listenerAttached = false;
        }
    }
    sendButton.onclick = async (e)=>{
        e.preventDefault();
        if (sending) return;
        const response = responseText.value.trim();
        if (!response || response.length < 10) {
            errorDiv.style.display = 'block';
            errorDiv.textContent = (0, $fUPn2.t)('offer.response_min_chars', 'Please write at least 10 characters in your response.');
            responseText.focus();
            return;
        }
        try {
            sending = true;
            sendButton.disabled = true;
            sendButton.textContent = (0, $fUPn2.t)('offer.sending', 'Sending...');
            sendButton.style.opacity = '0.5';
            const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
            if (!s || !s.connected) throw new Error('Socket connection not available');
            s.emit('requestLlmResponseOffer', {
                originalOffer: offerData,
                userResponse: response,
                responderUserId: localStorage.getItem('portfolioId')
            }, (ack)=>{
                if (!ack?.success) (0, $eD3DY.showNotification)(`Error: ${ack?.error || 'LLM request failed'}`, false);
            });
            dialog.innerHTML = `
		<h3 style="margin: 0 0 15px 0; text-align: center;">${(0, $fUPn2.t)('offer.response_sent', 'Response Sent')}</h3>
		<div style="background: rgba(0,255,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
		  <strong>${(0, $fUPn2.t)('offer.the_why', 'The why:')}</strong><br>
		  <em>"${offerData.tradeStory || ''}"</em>
		</div>
		<div style="background: rgba(0,100,255,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
		  <strong>${(0, $fUPn2.t)('offer.your_response', 'Your response:')}</strong><br>
		  <em>"${response}"</em>
		</div>
		<div style="text-align: center; color: #ffaa00;">
		  <p>${(0, $fUPn2.t)('offer.waiting_for_their_response', 'Waiting for their response...')}</p>
		  <p style="font-size: 0.9em; color: #00ff00;">${(0, $fUPn2.t)('offer.timer_extended', 'Timer extended to 60 seconds')}</p>
		</div>
	  `;
            // listen once (guard against stacking)
            if (!listenerAttached && s) {
                s.off('llmResponseReceived', handleLLMResponse);
                s.on('llmResponseReceived', handleLLMResponse);
                listenerAttached = true;
            }
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.response_sent_wait', 'Response sent! Waiting for their response...'), true);
        } catch (err) {
            (0, $eD3DY.showNotification)(`Error: ${err.message}`, false);
            sending = false;
            sendButton.disabled = false;
            sendButton.textContent = (0, $fUPn2.t)('offer.send_response', 'Send Response');
            sendButton.style.opacity = '1';
        }
    };
    // Escape & outside to close
    const escapeHandler = (e)=>{
        if (e.key === 'Escape' && !sending) {
            cleanup();
            document.removeEventListener('keydown', escapeHandler);
        }
    };
    document.addEventListener('keydown', escapeHandler);
    setTimeout(()=>responseText.focus(), 100);
    overlay.addEventListener('click', (e)=>{
        if (e.target === overlay && !sending) cleanup();
    });
}
function $5e5d264206c87423$var$showUpdatedOfferPopup(offerData) {
    if (!offerData) return;
    // Remove existing popup
    const existingPopup = document.getElementById('tradeOfferPopup');
    if (existingPopup) existingPopup.remove();
    // Show new popup with narrative exchange
    const popup = document.createElement('div');
    popup.id = 'tradeOfferPopup';
    popup.style.cssText = `
	position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
	width: 100%; max-width: 100%; height: 100%; max-height: 100%;
	border-radius: 0px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif; color: #00ff00;
	text-align: center; align-content: center; overflow: hidden;
  `;
    let exchangeHtml = '';
    if (Array.isArray(offerData.narrativeExchange) && offerData.narrativeExchange.length > 0) exchangeHtml = `
	  <div style="background: rgba(0,255,0,0.1); border: 1px solid rgba(0,255,0,0.3);
				  border-radius: 3px; padding: 10px; margin: 15px 0; max-height: 200px; overflow-y: auto;">
		<h5 style="margin: 0 0 10px 0;">${(0, $fUPn2.t)('offer.conversation', 'Conversation:')}</h5>
		${offerData.narrativeExchange.map((msg)=>`
		  <div style="margin: 5px 0; padding: 5px; background: rgba(0,0,0,0.3); border-radius: 3px;">
			<strong>${msg.from === offerData.initiatorUserId ? offerData.initiatorPortfolioName || (0, $fUPn2.t)('offer.trader', 'Trader') : (0, $fUPn2.t)('offer.you', 'You')}:</strong>
			<span style="font-style: italic;">"${(msg.message ?? '').toString()}"</span>
		  </div>
		`).join('')}
	  </div>
	`;
    const content = document.createElement('div');
    content.style.cssText = `position: relative; z-index: 1; padding: 20px; border-radius: 10px;`;
    content.innerHTML = `
	<div class="tradeOffPop">
	  <h2>${(0, $fUPn2.t)('offer.updated_trade_offer', 'Updated Trade Offer')}</h2>
	  <p>${(0, $fUPn2.t)('offer.offer_sentence_simple', '{name} offers you {offered} and requests {requested} in return.').replace('{name}', offerData.initiatorPortfolioName || (0, $fUPn2.t)('offer.trader', 'Trader')).replace('{offered}', offerData.offeredItemName || (0, $fUPn2.t)('offer.item', 'item')).replace('{requested}', offerData.transactionItemName || (0, $fUPn2.t)('offer.item', 'item'))}</p>
	  ${exchangeHtml}
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="finalAccept" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000;
			   border: 1px solid #00ff00; padding: 10px; cursor: pointer;">${(0, $fUPn2.t)('offer.accept', 'Accept')}</button>
		<button id="finalDecline" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff;
			   border: 1px solid #ff0000; padding: 10px; cursor: pointer;">${(0, $fUPn2.t)('offer.decline', 'Decline')}</button>
	  </div>
	</div>
  `;
    popup.appendChild(content);
    document.body.appendChild(popup);
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'updated-trade-offer');
    // Final decision buttons with double-click guard
    const acceptBtn = document.getElementById('finalAccept');
    const declineBtn = document.getElementById('finalDecline');
    let busy = false;
    const setBusy = (state)=>{
        busy = state;
        if (acceptBtn) {
            acceptBtn.disabled = state;
            acceptBtn.style.opacity = state ? '0.6' : '1';
        }
        if (declineBtn) {
            declineBtn.disabled = state;
            declineBtn.style.opacity = state ? '0.6' : '1';
        }
    };
    if (acceptBtn) acceptBtn.onclick = async ()=>{
        if (busy) return;
        setBusy(true);
        try {
            await $5e5d264206c87423$export$c9d68d666177c59c(offerData); // uses window.popupTrackerSocket internally
            popup.remove();
        } catch (error) {
            console.error('Error accepting trade:', error);
            (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_accepting_offer', 'Error accepting offer: {message}').replace('{message}', error.message)}`, false);
            setBusy(false);
        }
    };
    if (declineBtn) declineBtn.onclick = async ()=>{
        if (busy) return;
        setBusy(true);
        try {
            await $5e5d264206c87423$export$40e1fe1299acaf1b(offerData); // uses window.popupTrackerSocket internally
            popup.remove();
        } catch (error) {
            console.error('Error declining trade:', error);
            (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('offer.error_declining_offer', 'Error declining offer: {message}').replace('{message}', error.message)}`, false);
            setBusy(false);
        }
    };
}
function $5e5d264206c87423$export$e696bf2320418566(data) {
    if (!data || typeof data !== 'object') {
        console.warn('handleBuyOfferAcceptedByOther: missing/invalid payload', data);
        return;
    }
    // Try to clean up any UI remnants from the offer flow
    [
        'popup-container',
        'offerSentPopup',
        'offerSentOverlay',
        'tradeOfferPopup'
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) {
            // Unregister from popupTracker before removing
            if (window.popupTracker) window.popupTracker.unregisterPopup(id);
            el.remove();
        }
    });
    // Call the global cleanup function if it exists
    if (window.cleanupOfferSentPopup) try {
        window.cleanupOfferSentPopup();
    } catch (e) {
        console.warn('Error calling cleanupOfferSentPopup:', e);
    }
    localStorage.removeItem('pendingOffer');
    // NOTE: Notification is already shown by showProcessingAndResultPopup() in market.js
    // This function only handles cleanup and LED display updates
    // Reflect potential balance changes - LED display updated automatically
    try {
        (0, $eD3DY.updateTotalPointsDisplay)();
    } catch (e) {}
}
// Bot trade offer handler function
// Bot trade offer handler function (robust: handles string/object, de-dupes, ACKs)
function $5e5d264206c87423$var$showBotTradeOffer(tradeDataStrOrObj) {
    try {
        // 1) Parse safely (server may send an object OR a JSON string)
        const raw = typeof tradeDataStrOrObj === 'string' ? JSON.parse(tradeDataStrOrObj) : tradeDataStrOrObj || {};
        // 2) Normalize expected fields (tolerate alternate keys)
        const myId = localStorage.getItem('portfolioId');
        const offerData = {
            initiatorUserId: raw.initiatorUserId ?? raw.botId ?? raw.fromUserId,
            initiatorPortfolioName: raw.initiatorPortfolioName ?? raw.botName ?? (0, $fUPn2.t)('offer.trader', 'Trader'),
            targetUserId: raw.targetUserId ?? raw.toUserId ?? myId,
            offeredItemId: raw.offeredItemId ?? raw.offered_id ?? raw.offerItemId,
            transactionItemId: raw.transactionItemId ?? raw.requested_id ?? raw.requestItemId,
            offeredItemName: raw.offeredItemName ?? raw.offerName ?? (0, $fUPn2.t)('offer.item', 'item'),
            transactionItemName: raw.transactionItemName ?? raw.requestName ?? (0, $fUPn2.t)('offer.item', 'item'),
            narrativeExchange: Array.isArray(raw.narrativeExchange) ? raw.narrativeExchange : raw.exchange || [],
            tradeStory: raw.tradeStory ?? raw.story ?? '',
            expiresAt: raw.expiresAt ?? raw.expireAt ?? null,
            // include all original fields in case your UI needs more
            ...raw
        };
        // 3) Only show if it's actually for this user (when explicitly targeted)
        if (offerData.targetUserId && offerData.targetUserId !== myId) {
            console.warn('Bot trade offer not for this user. Skipping.', {
                myId: myId,
                target: offerData.targetUserId
            });
            return;
        }
        // 4) De-duplicate: compute a stable message id and suppress repeats for 30s
        const msgId = raw.msgId || `${offerData.initiatorUserId || 'bot'}:${myId}:${offerData.offeredItemId || ''}:${offerData.transactionItemId || ''}:${raw.timestamp || ''}`;
        const now = Date.now();
        window._botOfferSeen = window._botOfferSeen || new Map();
        const seen = window._botOfferSeen.get(msgId);
        if (seen && now - seen < 30000) // Already processed recently; skip duplicate
        return;
        window._botOfferSeen.set(msgId, now);
        // Optional prune to prevent unbounded growth
        if (window._botOfferSeen.size > 200) {
            // delete oldest ~50
            let count = 0;
            for (const k of window._botOfferSeen.keys()){
                window._botOfferSeen.delete(k);
                if (++count >= 50) break;
            }
        }
        // 5) ACK back to server that we displayed it (best-effort)
        try {
            const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
            if (s && s.connected) s.emit('ackBotTradeOffer', {
                msgId: msgId,
                recipientId: myId
            }, ()=>{});
        } catch (_) {
        // non-fatal
        }
        // 6) Finally show the popup using your existing UI
        console.log('Bot trade offer (normalized):', offerData);
        $5e5d264206c87423$export$48ca6cbcb2b01599(offerData, myId);
    } catch (error) {
        console.error('Error handling bot trade offer:', error, tradeDataStrOrObj);
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('offer.error_processing_trade', 'Error processing trade offer'), false);
    }
}
// Refresh offer texts when language changes
window.refreshOfferTexts = function() {
    console.log('Refreshing offer texts...');
    // Update any visible offer popups
    const offerPopup = document.getElementById('tradeOfferPopup');
    if (offerPopup) {
        const acceptBtn = offerPopup.querySelector('#acceptOffer');
        const declineBtn = offerPopup.querySelector('#declineOffer');
        if (acceptBtn) acceptBtn.textContent = (0, $fUPn2.t)('offer.accept', 'Accept');
        if (declineBtn) declineBtn.textContent = (0, $fUPn2.t)('offer.decline', 'Decline');
        // Trade popup uses <div id="timer">plain text</div> — keep it plain
        const tradeTimerEl = offerPopup.querySelector('#timer');
        if (tradeTimerEl) {
            const text = (0, $fUPn2.t)('offer.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', tradeTimerEl.textContent || '0');
        // render nearby if you want, or skip since your timer already writes directly
        // tradeTimerEl.textContent = text;
        }
    }
    // Update offer sent popup if present
    const offerSentPopup = document.getElementById('offerSentPopup');
    if (offerSentPopup) {
        const content = offerSentPopup.querySelector('div[style*="position: relative"]');
        if (content) {
            const current = content.querySelector('#offerSentTimer')?.textContent || '10';
            const timerP = content.querySelector('#offerSentTimerText');
            if (timerP) timerP.innerHTML = (0, $fUPn2.t)('offer.time_remaining_html', 'Time remaining: <span id="offerSentTimer">{seconds}</span> seconds').replace('{seconds}', current);
        }
    }
};
// Make functions globally available for integration with your existing system
window.showSocialTradeDialog = $5e5d264206c87423$export$c8555101b1151e80;
window.showBotTradeOffer = $5e5d264206c87423$var$showBotTradeOffer;

});
parcelRegister("cNeIB", function(module, exports) {

$parcel$export(module.exports, "apiBaseUrl", () => $95057a6d002adfe4$export$8ebae31efd30e025);
$parcel$export(module.exports, "apiBaseSocket", () => $95057a6d002adfe4$export$75aa299b0f1eb0a5);
// frontend/config.public.js  (browser-safe; no secrets, no Node deps)
const $95057a6d002adfe4$export$8ebae31efd30e025 = 'https://zexchange.me';
const $95057a6d002adfe4$export$75aa299b0f1eb0a5 = 'wss://zexchange.me';
const $95057a6d002adfe4$export$4c08e273c9d8d8ae = 'https://zexchange.me:8888';

});

parcelRegister("fUPn2", function(module, exports) {

$parcel$export(module.exports, "t", () => $b963ef1eb952fbbf$export$625550452a3fa3ec);
// frontend/js/translationHelper.js
const $b963ef1eb952fbbf$var$get = (obj, path)=>path.split('.').reduce((o, k)=>o && o[k] != null ? o[k] : undefined, obj);
const $b963ef1eb952fbbf$var$fmt = (str, params)=>!params ? str : str.replace(/\{(\w+)\}/g, (_, k)=>k in params ? params[k] : `{${k}}`);
const $b963ef1eb952fbbf$export$625550452a3fa3ec = (key, paramsOrFallback)=>{
    const i18n = window.i18n;
    const hasParamsObj = paramsOrFallback && typeof paramsOrFallback === 'object' && !Array.isArray(paramsOrFallback);
    const params = hasParamsObj ? paramsOrFallback : undefined;
    const fallback = !hasParamsObj && typeof paramsOrFallback !== 'undefined' ? paramsOrFallback : undefined;
    // detect language once, consistently
    const lang = (i18n?.lang || localStorage.getItem('preferredLanguage') || 'en').toString().slice(0, 2);
    // markers like "[traduction manquante] ..." or "[translation missing] ..."
    const MISSING_RE = /^\s*\[(?:traduction manquante|translation missing)[^\]]*\]\s*$/i;
    // If user is English, always show the provided fallback (base text) when available
    if (lang === 'en' && typeof fallback !== 'undefined') return typeof fallback === 'string' ? $b963ef1eb952fbbf$var$fmt(fallback, params) : fallback;
    let val;
    if (i18n?.t) val = i18n.t(key, params);
    else {
        const dict = window.__STATIC_TRANSLATIONS__ || globalThis.ZTranslations || {};
        const root = dict[lang] || dict.en || {};
        const base = root.translation || root;
        const found = $b963ef1eb952fbbf$var$get(base, key);
        val = typeof found === 'string' ? $b963ef1eb952fbbf$var$fmt(found, params) : undefined;
    }
    // Standard fallbacks
    if (val == null || val === key || typeof val === 'string' && MISSING_RE.test(val)) {
        if (typeof fallback !== 'undefined') return typeof fallback === 'string' ? $b963ef1eb952fbbf$var$fmt(fallback, params) : fallback;
    }
    return val ?? key;
};
const $b963ef1eb952fbbf$export$4e5aab1c9b62a422 = (key, fallbackOrParams)=>confirm($b963ef1eb952fbbf$export$625550452a3fa3ec(key, fallbackOrParams));
const $b963ef1eb952fbbf$export$d66adb1ff1c28d62 = (sel, key, fallbackOrParams)=>{
    const el = typeof sel === 'string' ? document.querySelector(sel) : sel;
    if (el) el.textContent = $b963ef1eb952fbbf$export$625550452a3fa3ec(key, fallbackOrParams);
};
const $b963ef1eb952fbbf$export$aad808f2718ba5af = (sel, attr, key, fallbackOrParams)=>{
    const el = typeof sel === 'string' ? document.querySelector(sel) : sel;
    if (el) el.setAttribute(attr, $b963ef1eb952fbbf$export$625550452a3fa3ec(key, fallbackOrParams));
};

});

parcelRegister("21EbS", function(module, exports) {

$parcel$export(module.exports, "getAuthToken", () => $179ad9ca248c7149$export$38e1f53b76ec7fed);
//import jwt from 'jsonwebtoken';
//import { secretKey } from '../backend/config.js';
parcelRequire("5W4EI");
function $179ad9ca248c7149$export$38e1f53b76ec7fed() {
    return localStorage.getItem('token'); // Retrieves the token from localStorage
}

});


parcelRegister("2C8cW", function(module, exports) {

$parcel$export(module.exports, "showRedeemOfferPopup", () => $1e757f4920ee6373$export$e02688e921d36782);
// Ensure imports are correct

var $cJVho = parcelRequire("cJVho");

var $cNeIB = parcelRequire("cNeIB");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");

var $eD3DY = parcelRequire("eD3DY");
let $1e757f4920ee6373$var$knownItemIdsAtPageLoad = [];
let $1e757f4920ee6373$var$userHasInteracted = false; // Flag to track if the user has interacted with the popup
// Burst effect state for commodity exchange visuals
let $1e757f4920ee6373$var$burstParticles = [];
let $1e757f4920ee6373$var$burstCanvas = null;
let $1e757f4920ee6373$var$burstAnimationFrame = null;
// Commodity Exchange Burst Effect - creates animated particles
function $1e757f4920ee6373$var$createBurstEffect(container) {
    // Create canvas for burst particles
    $1e757f4920ee6373$var$burstCanvas = document.createElement('canvas');
    $1e757f4920ee6373$var$burstCanvas.style.cssText = `
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 2;
  `;
    container.appendChild($1e757f4920ee6373$var$burstCanvas);
    const ctx = $1e757f4920ee6373$var$burstCanvas.getContext('2d');
    $1e757f4920ee6373$var$burstCanvas.width = container.offsetWidth;
    $1e757f4920ee6373$var$burstCanvas.height = container.offsetHeight;
    // Create initial burst particles
    const particleCount = 30;
    for(let i = 0; i < particleCount; i++)$1e757f4920ee6373$var$burstParticles.push({
        x: Math.random() * $1e757f4920ee6373$var$burstCanvas.width,
        y: Math.random() * $1e757f4920ee6373$var$burstCanvas.height,
        vx: (Math.random() - 0.5) * 2,
        vy: (Math.random() - 0.5) * 2,
        life: Math.random() * 100 + 100,
        maxLife: 200,
        size: Math.random() * 3 + 2,
        hue: 120 + Math.random() * 40 // Green range
    });
    // Animation loop
    function animate() {
        ctx.clearRect(0, 0, $1e757f4920ee6373$var$burstCanvas.width, $1e757f4920ee6373$var$burstCanvas.height);
        $1e757f4920ee6373$var$burstParticles.forEach((particle, index)=>{
            // Update position
            particle.x += particle.vx;
            particle.y += particle.vy;
            particle.life--;
            // Bounce off edges
            if (particle.x < 0 || particle.x > $1e757f4920ee6373$var$burstCanvas.width) particle.vx *= -1;
            if (particle.y < 0 || particle.y > $1e757f4920ee6373$var$burstCanvas.height) particle.vy *= -1;
            // Draw particle with glow
            const alpha = particle.life / particle.maxLife;
            ctx.save();
            ctx.shadowBlur = 15;
            ctx.shadowColor = `hsla(${particle.hue}, 100%, 50%, ${alpha})`;
            ctx.fillStyle = `hsla(${particle.hue}, 100%, 50%, ${alpha * 0.8})`;
            ctx.beginPath();
            ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
            ctx.fill();
            ctx.restore();
            // Remove dead particles and spawn new ones
            if (particle.life <= 0) $1e757f4920ee6373$var$burstParticles[index] = {
                x: Math.random() * $1e757f4920ee6373$var$burstCanvas.width,
                y: Math.random() * $1e757f4920ee6373$var$burstCanvas.height,
                vx: (Math.random() - 0.5) * 2,
                vy: (Math.random() - 0.5) * 2,
                life: Math.random() * 100 + 100,
                maxLife: 200,
                size: Math.random() * 3 + 2,
                hue: 120 + Math.random() * 40
            };
        });
        $1e757f4920ee6373$var$burstAnimationFrame = requestAnimationFrame(animate);
    }
    animate();
}
// Clean up burst effect
function $1e757f4920ee6373$var$cleanupBurstEffect() {
    if ($1e757f4920ee6373$var$burstAnimationFrame) {
        cancelAnimationFrame($1e757f4920ee6373$var$burstAnimationFrame);
        $1e757f4920ee6373$var$burstAnimationFrame = null;
    }
    if ($1e757f4920ee6373$var$burstCanvas) {
        $1e757f4920ee6373$var$burstCanvas.remove();
        $1e757f4920ee6373$var$burstCanvas = null;
    }
    $1e757f4920ee6373$var$burstParticles = [];
}
async function $1e757f4920ee6373$export$e02688e921d36782(data) {
    console.log('Redeem offer received:', data);
    // Ensure socket is up (no-op if already connected)
    try {
        (0, $cJVho.connectWebSocket)?.();
    } catch (_) {}
    // Remove any existing popup
    const existingPopup = document.getElementById("redeemOfferPopup");
    if (existingPopup) existingPopup.remove();
    // Build popup shell
    const RedeemPopup = document.createElement("div");
    RedeemPopup.id = "redeemOfferPopup";
    RedeemPopup.style.cssText = `
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10001;
	font-family: 'bithigh', Arial, sans-serif;
	color: #00ff00;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: linear-gradient(135deg, rgba(0, 40, 80, 0.95) 0%, rgba(0, 0, 0, 0.98) 100%);
  `;
    // Background video
    const video = document.createElement("video");
    video.id = "redeemPopupBackground";
    video.style.cssText = `
	position: absolute; top: 0; left: 0; width: 100%; height: 100%;
	object-fit: cover; z-index: -1; pointer-events: none; user-select: none;
  `;
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    RedeemPopup.appendChild(video);
    // Foreground content with enhanced styling
    const content = document.createElement("div");
    content.id = "redeemContentBox";
    content.style.cssText = `
	position: relative;
	z-index: 3;
	padding: 40px 30px;
	background: linear-gradient(135deg, rgba(0, 40, 80, 0.85) 0%, rgba(0, 0, 0, 0.92) 100%);
	border: 3px solid #00ff00;
	border-radius: 8px;
	max-width: 85%;
	width: 500px;
	box-shadow:
	  0 0 30px rgba(0, 255, 0, 0.6),
	  inset 0 0 20px rgba(0, 255, 0, 0.1);
	animation: pulseGlow 2s ease-in-out infinite;
  `;
    // Get offer details
    const senderName = $1e757f4920ee6373$var$sanitize(data?.senderName || 'Unknown');
    const itemName = $1e757f4920ee6373$var$sanitize(data?.itemName || 'Unknown Item');
    content.innerHTML = `
	<div style="margin-bottom: 20px; font-size: 0.85rem; color: #00ff00; opacity: 0.7; letter-spacing: 2px;">
	  INCOMING COMMODITY EXCHANGE
	</div>
	<h2 style="color: #00ff00; font-size: 1.8rem; margin: 20px 0; text-shadow: 0 0 10px rgba(0, 255, 0, 0.8);">
	  ${(0, $fUPn2.t)('Redemption Offer', 'Redemption Offer')}
	</h2>
	<div style="background: rgba(0, 255, 0, 0.1); border: 1px solid #00ff00; border-radius: 5px; padding: 15px; margin: 20px 0;">
	  <p style="color: #00ff00; font-size: 1rem; margin: 8px 0;">
		<strong>${(0, $fUPn2.t)('From:', 'From:')}</strong> ${senderName}
	  </p>
	  <p style="color: #00ff00; font-size: 1rem; margin: 8px 0;">
		<strong>${(0, $fUPn2.t)('Commodity:', 'Commodity:')}</strong> ${itemName}
	  </p>
	</div>
	<div style="display: flex; gap: 15px; justify-content: center; margin-top: 30px;">
	  <button id="acceptRedeemButton" style="
		flex: 1;
		max-width: 180px;
		padding: 15px 25px;
		background: linear-gradient(135deg, rgba(0, 100, 0, 0.9) 0%, rgba(0, 50, 0, 0.9) 100%);
		border: 2px solid #00ff00;
		border-radius: 5px;
		color: #00ff00;
		font-family: 'bithigh', sans-serif;
		font-size: 1.1rem;
		cursor: pointer;
		box-shadow: 0 0 15px rgba(0, 255, 0, 0.4);
		transition: all 0.3s ease;
		text-shadow: 0 0 5px rgba(0, 255, 0, 0.6);
	  " onmouseover="this.style.boxShadow='0 0 25px rgba(0, 255, 0, 0.8)'; this.style.transform='scale(1.05)'" onmouseout="this.style.boxShadow='0 0 15px rgba(0, 255, 0, 0.4)'; this.style.transform='scale(1)'">
		\u{2713} ${(0, $fUPn2.t)('Accept', 'Accept')}
	  </button>
	  <button id="declineRedeemButton" style="
		flex: 1;
		max-width: 180px;
		padding: 15px 25px;
		background: linear-gradient(135deg, rgba(100, 0, 0, 0.9) 0%, rgba(50, 0, 0, 0.9) 100%);
		border: 2px solid #ff6666;
		border-radius: 5px;
		color: #ff6666;
		font-family: 'bithigh', sans-serif;
		font-size: 1.1rem;
		cursor: pointer;
		box-shadow: 0 0 15px rgba(255, 0, 0, 0.4);
		transition: all 0.3s ease;
		text-shadow: 0 0 5px rgba(255, 0, 0, 0.6);
	  " onmouseover="this.style.boxShadow='0 0 25px rgba(255, 0, 0, 0.8)'; this.style.transform='scale(1.05)'" onmouseout="this.style.boxShadow='0 0 15px rgba(255, 0, 0, 0.4)'; this.style.transform='scale(1)'">
		\u{2715} ${(0, $fUPn2.t)('Decline', 'Decline')}
	  </button>
	</div>
	<div id="timer" style="font-size: 1.5rem; text-align: center; color: #00ff00; margin-top: 25px; font-weight: bold; text-shadow: 0 0 15px rgba(0, 255, 0, 0.9);"></div>
  `;
    // Add pulsing glow animation
    const style = document.createElement('style');
    style.textContent = `
	@keyframes pulseGlow {
	  0%, 100% {
		box-shadow:
		  0 0 30px rgba(0, 255, 0, 0.6),
		  inset 0 0 20px rgba(0, 255, 0, 0.1);
		border-color: #00ff00;
	  }
	  50% {
		box-shadow:
		  0 0 50px rgba(0, 255, 0, 0.9),
		  0 0 100px rgba(0, 255, 0, 0.4),
		  inset 0 0 30px rgba(0, 255, 0, 0.2);
		border-color: #00ff66;
	  }
	}
  `;
    document.head.appendChild(style);
    const escHandler = (e)=>{
        if (e.key === 'Escape') {
            cleanup();
            document.removeEventListener('keydown', escHandler);
        }
    };
    document.addEventListener('keydown', escHandler);
    RedeemPopup.addEventListener('click', (e)=>{
        // only close if the click is on the outer container (not content)
        if (e.target === RedeemPopup) cleanup();
    });
    RedeemPopup.appendChild(content);
    document.body.appendChild(RedeemPopup);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    // Start burst particle effect
    $1e757f4920ee6373$var$createBurstEffect(content);
    function cleanup() {
        clearInterval(timerInterval);
        $1e757f4920ee6373$var$cleanupBurstEffect();
        if (RedeemPopup && RedeemPopup.parentNode) RedeemPopup.parentNode.removeChild(RedeemPopup);
        document.body.style.overflow = prevOverflow;
        document.removeEventListener('keydown', escHandler);
    }
    // Load random background video
    try {
        const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/redeemBack/`;
        const totalVideos = 45;
        const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
        const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;
        if (window.Hls && window.Hls.isSupported()) {
            const hls = new window.Hls();
            hls.loadSource(videoUrl);
            hls.attachMedia(video);
            hls.on(window.Hls.Events.MANIFEST_PARSED, ()=>video.play().catch(()=>{}));
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = videoUrl;
            video.addEventListener('loadedmetadata', ()=>video.play().catch(()=>{}));
        }
    } catch (e) {
        // Non-fatal
        console.warn('Redeem background video load error:', e);
    }
    // Timer with enhanced formatting
    const timerElement = document.getElementById('timer');
    let remainingTime = Number(data?.timeoutSeconds) || 10;
    const tick = ()=>{
        if (timerElement) {
            const secondsLabel = remainingTime === 1 ? (0, $fUPn2.t)('second', 'second') : (0, $fUPn2.t)('seconds', 'seconds');
            timerElement.textContent = `${remainingTime} ${secondsLabel}`;
        }
    };
    tick();
    const timerInterval = setInterval(()=>{
        remainingTime -= 1;
        tick();
        if (remainingTime <= 0) {
            clearInterval(timerInterval);
            if (timerElement) {
                timerElement.textContent = (0, $fUPn2.t)('Time expired', 'Time expired');
                timerElement.style.color = '#ff6666';
                timerElement.style.textShadow = '0 0 15px rgba(255, 0, 0, 0.9)';
            }
            setTimeout(()=>cleanup(), 1000); // Brief delay before closing
        }
    }, 1000);
    // Helpers
    const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
    const myPortfolioId = localStorage.getItem('portfolioId') || '';
    const initiatorUserId = $1e757f4920ee6373$var$sanitize(data?.initiatorUserId);
    const preselectedItemId = $1e757f4920ee6373$var$sanitize(data?.preselectedItems?.[0]?.itemId ?? data?.preselectedItemId);
    const preselectedItemName = $1e757f4920ee6373$var$sanitize(data?.preselectedItems?.[0]?.itemName ?? data?.preselectedItemName);
    const offeredItemId = $1e757f4920ee6373$var$sanitize(data?.itemId);
    const transactionItemId = $1e757f4920ee6373$var$sanitize(data?.itemId);
    async function postDecision(url, pointsAdjustment) {
        return fetch(`${(0, $cNeIB.apiBaseUrl)}${url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                initiatorUserId: initiatorUserId,
                targetUserId: myPortfolioId,
                pointsAdjustment: pointsAdjustment,
                preselectedItemId: preselectedItemId,
                preselectedItemName: preselectedItemName,
                offeredItemId: offeredItemId,
                transactionItemId: transactionItemId
            })
        });
    }
    function emitDecision(accepted) {
        if (!s || !s.connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.ws_not_connected', 'Not connected. Please try again.'), false);
            return;
        }
        s.emit('redeemResponse', {
            accepted: accepted,
            preselectedItemId: preselectedItemId,
            preselectedItemName: preselectedItemName,
            initiatorUserId: initiatorUserId,
            targetUserId: myPortfolioId
        }, (ack)=>{
            if (ack && ack.success === false) {
                console.error('redeemResponse ack error:', ack.error);
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.notify_failed', 'Failed to notify initiator.'), false);
            }
        });
    }
    // Wire buttons
    const acceptButton = document.getElementById("acceptRedeemButton");
    const declineButton = document.getElementById("declineRedeemButton");
    if (acceptButton) acceptButton.addEventListener('click', async ()=>{
        clearInterval(timerInterval);
        try {
            const resp = await postDecision('/api/acceptRedemption', 70);
            if (!resp.ok) {
                console.error('Failed to accept redeem.', await resp.text());
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.accept_failed', 'Failed to accept redemption.'), false);
            } else {
                console.log('Redeem accepted successfully.');
                emitDecision(true);
            }
        } catch (err) {
            console.error('Error accepting redeem:', err);
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.accept_failed', 'Failed to accept redemption.'), false);
        }
        cleanup();
    });
    if (declineButton) declineButton.addEventListener('click', async ()=>{
        clearInterval(timerInterval);
        try {
            const resp = await postDecision('/api/declineRedemption', -70);
            if (!resp.ok) {
                console.error('Failed to decline redeem.', await resp.text());
                (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.decline_failed', 'Failed to decline redemption.'), false);
            } else {
                console.log('Redeem declined successfully.');
                emitDecision(false);
            }
        } catch (err) {
            console.error('Error declining redeem:', err);
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('redeem.decline_failed', 'Failed to decline redemption.'), false);
        }
        cleanup();
    });
    // Block interactions with the background video
    [
        'click',
        'dblclick',
        'contextmenu'
    ].forEach((evt)=>video.addEventListener(evt, (e)=>{
            e.stopPropagation();
            e.preventDefault();
        }));
}
function $1e757f4920ee6373$var$sanitize(input) {
    const div = document.createElement('div');
    div.textContent = (input ?? '').toString();
    return div.innerHTML;
}

});

parcelRegister("jL4uR", function(module, exports) {

$parcel$export(module.exports, "showTaxDecisionPopup", () => $e625e50e5a3be76b$export$2fc91085295dc61);
$parcel$export(module.exports, "displayNotification", () => $e625e50e5a3be76b$export$6c932663eba61047);
$parcel$export(module.exports, "showPointsDeductedNotification", () => $e625e50e5a3be76b$export$3695e4081b3eabdd);
$parcel$export(module.exports, "showItemSelectedAssign", () => $e625e50e5a3be76b$export$25c21df5493fc2da);
$parcel$export(module.exports, "showPointsAssignedNotification", () => $e625e50e5a3be76b$export$4b96634ee2744b8b);
$parcel$export(module.exports, "showZollarSelectedAssign", () => $e625e50e5a3be76b$export$e859aac445856345);

var $5W4EI = parcelRequire("5W4EI");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
globalThis.ZTranslations = globalThis.ZTranslations || (0, $15BR8.default);
function $e625e50e5a3be76b$var$_get(obj, pathArr) {
    return pathArr.reduce((o, k)=>o && o[k] !== undefined ? o[k] : undefined, obj);
}
function $e625e50e5a3be76b$var$T(key, fallback = '') {
    try {
        const res = (0, $fUPn2.t)(key, null);
        if (typeof res === 'string' && res && res !== key) return res;
    } catch (_) {}
    const lang = globalThis.Z_LANG || globalThis.Z_LOCALE || localStorage.getItem('language') || localStorage.getItem('locale') || (navigator.language || '').slice(0, 2) || 'en';
    const dict = (0, $15BR8.default)?.[lang] || (0, $15BR8.default)?.fr || (0, $15BR8.default)?.en || null;
    if (dict) {
        const val = $e625e50e5a3be76b$var$_get(dict, key.split('.'));
        if (typeof val === 'string' && val) return val;
    }
    return fallback || key;
}
const $e625e50e5a3be76b$var$tx = (k, fb)=>$e625e50e5a3be76b$var$T(`tax.${k}`, fb);
// Qualitative descriptor function for Zollars (users see descriptions, not numbers)
function $e625e50e5a3be76b$var$getQualitativeDescriptor(quantity, max) {
    const q = Number(quantity) || 0;
    const m = Number(max);
    if (q <= 0) return 'None';
    if (m && m > 0) {
        const r = q / m;
        if (r <= 0.01) return 'None';
        if (r <= 0.03) return 'Barely Any';
        if (r <= 0.07) return 'A Trace';
        if (r <= 0.12) return 'A Hint';
        if (r <= 0.18) return 'A Little';
        if (r <= 0.26) return 'A Few';
        if (r <= 0.33) return 'Some';
        if (r <= 0.40) return 'Several';
        if (r <= 0.50) return 'Moderate';
        if (r <= 0.58) return 'Noticeable';
        if (r <= 0.65) return 'Considerable';
        if (r <= 0.72) return 'Many';
        if (r <= 0.78) return 'A Lot';
        if (r <= 0.83) return 'Abundant';
        if (r <= 0.88) return 'Heaps';
        if (r <= 0.92) return 'A Great Deal';
        if (r <= 0.95) return 'Almost All';
        if (r <= 0.97) return 'Nearly Everything';
        if (r <= 0.985) return 'Overflowing';
        if (r <= 0.995) return 'Virtually Everything';
        return 'All You Have';
    }
    if (q <= 0) return 'None';
    if (q <= 1) return 'Barely Any';
    if (q <= 2) return 'A Trace';
    if (q <= 3) return 'A Hint';
    if (q <= 4) return 'A Little';
    if (q <= 6) return 'A Few';
    if (q <= 9) return 'Some';
    if (q <= 12) return 'Several';
    if (q <= 16) return 'Moderate';
    if (q <= 20) return 'Noticeable';
    if (q <= 26) return 'Considerable';
    if (q <= 33) return 'Many';
    if (q <= 40) return 'A Lot';
    if (q <= 55) return 'Abundant';
    if (q <= 70) return 'Heaps';
    if (q <= 90) return 'A Great Deal';
    if (q <= 120) return 'Substantial';
    if (q <= 160) return 'Ample';
    if (q <= 210) return 'Extensive';
    if (q <= 260) return 'Vast';
    if (q <= 320) return 'Profuse';
    if (q <= 380) return 'Almost All';
    if (q <= 440) return 'Nearly Everything';
    if (q <= 490) return 'Virtually Everything';
    return 'All You Have';
}
let $e625e50e5a3be76b$var$taxEventInProgress = false;
function $e625e50e5a3be76b$export$2fc91085295dc61(userId, pointAmount, zollarAmount) {
    console.log('showTaxDecisionPopup called with userId:', userId, 'pointAmount:', pointAmount, 'zollarAmount:', zollarAmount);
    if ($e625e50e5a3be76b$var$taxEventInProgress) return;
    $e625e50e5a3be76b$var$taxEventInProgress = true;
    $e625e50e5a3be76b$export$a67e7b472120cdc7(userId, pointAmount, zollarAmount);
}
// Function to directly proceed with points deduction if no items are available
function $e625e50e5a3be76b$var$directlyProceedWithPointsDecision(userId) {
    const userWantsToGiveItem = confirm((0, $fUPn2.t)('tax.tax_call_no_assets', 'Zederal Reserve has issued a tax call. Press OK to lose capital, no assets available for payment.'));
    if (!userWantsToGiveItem) $e625e50e5a3be76b$var$submitUserDecision(userId, 'points', null);
}
function $e625e50e5a3be76b$export$a67e7b472120cdc7(userId, pointAmount, zollarAmount) {
    console.log('showTaxPrompt called for user:', userId);
    $e625e50e5a3be76b$var$removeExistingTaxModal();
    $e625e50e5a3be76b$var$renderDecisionModal(userId, pointAmount, zollarAmount);
    $e625e50e5a3be76b$var$initiateCountdown(userId, 10, pointAmount, zollarAmount);
}
// Function to render the decision modal
function $e625e50e5a3be76b$var$renderDecisionModal(userId, pointAmount, zollarAmount) {
    console.log('Rendering decision modal for user:', userId, 'with pointAmount:', pointAmount, 'zollarAmount:', zollarAmount);
    // Ensure minimum of 1 zollar if not specified
    const actualZollarAmount = Math.max(1, zollarAmount || 1);
    // Convert zollar amount to qualitative descriptor (users don't see numbers for Zollars)
    const zollarDescriptor = $e625e50e5a3be76b$var$getQualitativeDescriptor(actualZollarAmount);
    const decisionModalHTML = `
	<div id="taxDecisionModal" class="tax-modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.8); display: flex; justify-content: center; align-items: center; z-index: 99999;">
	  <div class="tax-modal-content" style="background-color: #000; padding: 20px; border: 2px solid #00ff00; border-radius: 10px; text-align: center; color: #00ff00; max-width: 92vw;">
		<p class="zx-sec-explain" style="text-align:left;max-width:420px;margin:0 auto 10px;">${(0, $fUPn2.t)('floor.exp_tax', "This is the Zederal Reserve \u2014 the market's system player. It taxes every trader from time to time. Choose what to give up before the timer runs out, or it takes both.")}</p>
		<p>${(0, $fUPn2.t)('tax.tax_alert_timer', 'TAX ALERT! You have 10 seconds to choose or lose both:')}</p>
		<p id="countdown" style="font-size: 24px; font-weight: bold;">10</p>
		<button id="deductPoints" style="margin: 5px; padding: 15px; background-color: #333; color: #00ff00; border: 1px solid #00ff00; min-width: 250px; line-height: 1.5; cursor: pointer;">
		  <div style="font-weight: bold; margin-bottom: 8px; pointer-events: none;">${(0, $fUPn2.t)('tax.lose_capital_zollars', 'Lose capital & Zollars')}</div>
		  <div style="font-size: 12px; margin-bottom: 3px; pointer-events: none;">${pointAmount} capital</div>
		  <div style="font-size: 12px; pointer-events: none;">${zollarDescriptor} relationship zollars</div>
		</button>
		<button id="giveRandomItem" style="margin: 5px; padding: 10px; background-color: #333; color: #00ff00; border: 1px solid #00ff00; min-width: 250px; cursor: pointer;">
		  <span style="pointer-events: none;">${(0, $fUPn2.t)('tax.give_random_asset', 'Give random asset')}</span>
		</button>
	  </div>
	</div>
  `;
    document.body.insertAdjacentHTML('beforeend', decisionModalHTML);
    console.log('Decision modal rendered');
}
function $e625e50e5a3be76b$var$initiateCountdown(userId, timeLeft, pointAmount, zollarAmount) {
    console.log('Initiating countdown for user:', userId);
    const startTime = new Date();
    // Ensure minimum of 1 zollar
    const actualZollarAmount = Math.max(1, zollarAmount || 1);
    localStorage.setItem('taxDecisionState', JSON.stringify({
        userId: userId,
        timeLeft: timeLeft,
        startTime: startTime,
        pointAmount: pointAmount,
        zollarAmount: actualZollarAmount
    }));
    const countdownTimer = setInterval(()=>{
        const countdownElement = document.getElementById("countdown");
        if (countdownElement) countdownElement.textContent = Math.max(0, timeLeft);
        if (timeLeft <= 0) {
            clearInterval(countdownTimer);
            console.log('Countdown finished, enforcing tax decision');
            $e625e50e5a3be76b$var$enforceTaxDecision(userId, pointAmount, actualZollarAmount);
        }
        timeLeft--;
    }, 1000);
    document.getElementById('taxDecisionModal').addEventListener('click', (event)=>{
        if (event.target.id === 'deductPoints' || event.target.id === 'giveRandomItem') {
            console.log(`User clicked ${event.target.id}`);
            $e625e50e5a3be76b$var$handleDecision(userId, event.target.id === 'deductPoints' ? 'points' : 'item', countdownTimer, pointAmount, actualZollarAmount);
        }
    });
}
function $e625e50e5a3be76b$var$handleDecision(userId, decision, countdownTimer, pointAmount, zollarAmount) {
    console.log(`Handling decision for user ${userId}: ${decision}`);
    clearInterval(countdownTimer);
    $e625e50e5a3be76b$var$submitUserDecision(userId, decision, null, pointAmount, zollarAmount);
    $e625e50e5a3be76b$var$removeDecisionModal();
}
function $e625e50e5a3be76b$var$removeExistingTaxModal() {
    const existingModal = document.getElementById("taxDecisionModal");
    if (existingModal) existingModal.remove();
    localStorage.removeItem('taxDecisionState');
}
function $e625e50e5a3be76b$var$removeDecisionModal() {
    console.log('Removing decision modal');
    const existingModal = document.getElementById("taxDecisionModal");
    if (existingModal) existingModal.remove();
    localStorage.removeItem('taxDecisionState');
    $e625e50e5a3be76b$var$taxEventInProgress = false;
}
function $e625e50e5a3be76b$var$enforceTaxDecision(userId, pointAmount, zollarAmount) {
    $e625e50e5a3be76b$var$submitUserDecision(userId, "both", null, pointAmount, zollarAmount);
    $e625e50e5a3be76b$var$removeDecisionModal();
}
function $e625e50e5a3be76b$var$submitUserDecision(userId, decision, itemId, pointAmount, zollarAmount) {
    const sessionId = localStorage.getItem('sessionId');
    const decisionData = {
        userId: userId,
        decision: decision,
        itemId: itemId || undefined,
        sessionId: sessionId,
        pointAmount: pointAmount,
        zollarAmount: zollarAmount
    };
    fetch(`${(0, $5W4EI.apiBaseUrl)}/api/boss/userDecision`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
        },
        body: JSON.stringify(decisionData)
    }).then(async (response)=>{
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const text = await response.text();
        try {
            return JSON.parse(text);
        } catch (e) {
            console.error("Could not parse JSON:", text);
            throw e;
        }
    }).then((data)=>{
        console.log("Decision submitted:", data.message);
        $e625e50e5a3be76b$var$showAlertTax(data.message);
    }).catch((error)=>console.error('Error submitting decision:', error));
}
// Function to show an alert after submitting the tax decision
function $e625e50e5a3be76b$var$showAlertTax(message) {
    const alertOverlay = document.createElement('div');
    alertOverlay.style.position = 'fixed';
    alertOverlay.style.top = '0';
    alertOverlay.style.left = '0';
    alertOverlay.style.width = '100vw';
    alertOverlay.style.height = '100vh';
    alertOverlay.style.backgroundColor = 'rgba(0, 0, 0, 1)'; // Black background
    alertOverlay.style.display = 'flex';
    alertOverlay.style.alignItems = 'center';
    alertOverlay.style.justifyContent = 'center';
    alertOverlay.style.zIndex = '99999';
    const alertBox = document.createElement('div');
    alertBox.style.backgroundColor = '#000'; // Black background
    alertBox.style.padding = '20px 40px';
    alertBox.style.border = '2px solid #00ff00'; // Green border
    alertBox.style.borderRadius = '10px';
    alertBox.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
    alertBox.style.textAlign = 'center';
    alertBox.style.maxWidth = '80%'; // Adjust the max-width
    alertBox.style.color = '#00ff00'; // Green text
    alertBox.innerText = message;
    alertOverlay.appendChild(alertBox);
    document.body.appendChild(alertOverlay);
    setTimeout(()=>{
        alertOverlay.remove();
    }, 3500);
}
let $e625e50e5a3be76b$var$isNotificationDisplayed = false;
const $e625e50e5a3be76b$var$userLocks = {};
function $e625e50e5a3be76b$var$debounceAsync(func, delay) {
    let timeoutId;
    let isExecuting = false;
    let pendingArgs = null;
    const execute = async (args, resolve, reject)=>{
        isExecuting = true;
        console.log('Executing function with args:', args);
        try {
            await func(...args);
            resolve();
        } catch (error) {
            reject(error);
        } finally{
            isExecuting = false;
            if (pendingArgs) {
                const nextArgs = pendingArgs;
                pendingArgs = null;
                execute(nextArgs.args, nextArgs.resolve, nextArgs.reject);
            }
        }
    };
    return (...args)=>{
        return new Promise((resolve, reject)=>{
            if (isExecuting) {
                pendingArgs = {
                    args: args,
                    resolve: resolve,
                    reject: reject
                };
                return;
            }
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                execute(args, resolve, reject);
            }, delay);
        });
    };
}
const $e625e50e5a3be76b$var$assignQueue = $e625e50e5a3be76b$var$debounceAsync(async function(userId) {
    if ($e625e50e5a3be76b$var$userLocks[userId] || $e625e50e5a3be76b$var$isNotificationDisplayed) return;
    $e625e50e5a3be76b$var$userLocks[userId] = true;
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/boss/assignNewItem`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message || (0, $fUPn2.t)('tax.assign_failed', 'Failed to assign new item to all portfolios.'));
        }
        $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.new_asset_assigned', 'Zederal Reserve has assigned a new asset to your portfolio.'));
    } catch (error) {
        console.error(`Error during commondity assignment process for user ${userId}:`, error);
    } finally{
        $e625e50e5a3be76b$var$userLocks[userId] = false;
    }
}, 1000);
const $e625e50e5a3be76b$export$f740b4822616dff0 = $e625e50e5a3be76b$var$debounceAsync(async function() {
    if ($e625e50e5a3be76b$var$isNotificationDisplayed) return;
    $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.new_asset_assigned', 'Zederal Reserve has assigned a new asset to your portfolio.'));
}, 1000);
let $e625e50e5a3be76b$var$isItemIssued = false;
let $e625e50e5a3be76b$var$userItemIssued = {};
let $e625e50e5a3be76b$var$userPointsIssued = {};
const $e625e50e5a3be76b$export$19ed5f257772fcea = $e625e50e5a3be76b$var$debounceAsync(async function(userId, portfolioIds) {
    if ($e625e50e5a3be76b$var$userLocks[userId] || $e625e50e5a3be76b$var$isNotificationDisplayed) return;
    if (!portfolioIds || portfolioIds.length === 0) return;
    $e625e50e5a3be76b$var$userLocks[userId] = true;
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/boss/taxSingleItem`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                portfolioIds: portfolioIds
            })
        });
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message || 'Failed to notify the backend.');
        }
        const responseData = await response.json();
        console.log('Tax single item response:', responseData);
        if (responseData.removedItems && responseData.removedItems.length > 0) {
            $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.asset_taxed', 'You have been taxed an asset by the Zederal Reserve.'));
            $e625e50e5a3be76b$var$userItemIssued[userId] = false;
            $e625e50e5a3be76b$var$isItemIssued = false;
        } else $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.no_items_available', 'No non-traded items available for taxation.'));
    } catch (error) {
        console.error('Error during item taxing:', error);
        $e625e50e5a3be76b$export$6c932663eba61047((0, $fUPn2.t)('tax.tax_item_failed', 'Failed to tax an item.'), false);
    } finally{
        $e625e50e5a3be76b$var$userLocks[userId] = false;
    }
}, 1000);
const $e625e50e5a3be76b$export$3695e4081b3eabdd = $e625e50e5a3be76b$var$debounceAsync(async function(portfolioIds, points, message) {
    if (!portfolioIds || portfolioIds.length === 0 || !points || isNaN(points) || points <= 0) return;
    const defaultMsg = `${(0, $fUPn2.t)('tax.capital_taxed_prefix', 'You have been taxed capital by the Zederal Reserve!')} ${points} ${(0, $fUPn2.t)('tax.points', 'capitaux')}`;
    $e625e50e5a3be76b$export$6c932663eba61047(message || defaultMsg);
}, 1000);
const $e625e50e5a3be76b$export$25c21df5493fc2da = $e625e50e5a3be76b$var$debounceAsync(async function(portfolioIds, message) {
    if (!portfolioIds || portfolioIds.length === 0) return;
    $e625e50e5a3be76b$export$6c932663eba61047(message || (0, $fUPn2.t)('tax.new_asset_received', 'You have received a new asset from the Zederal Reserve'));
}, 1000);
const $e625e50e5a3be76b$export$4b96634ee2744b8b = $e625e50e5a3be76b$var$debounceAsync(async function(portfolioIds, points) {
    if (!portfolioIds || portfolioIds.length === 0 || !points || isNaN(points) || points <= 0) return;
    const msg = `${(0, $fUPn2.t)('tax.refund_received_prefix', 'You have received a refund of capital from the Zederal Reserve')} ${points} ${(0, $fUPn2.t)('tax.points', 'Capital')}`;
    $e625e50e5a3be76b$export$6c932663eba61047(msg);
}, 1000);
const $e625e50e5a3be76b$export$e859aac445856345 = $e625e50e5a3be76b$var$debounceAsync(async function(portfolioIds, message, amount) {
    if (!portfolioIds || portfolioIds.length === 0) return;
    const amt = Number(amount) > 0 ? Number(amount) : null;
    const fallback = amt ? `${(0, $fUPn2.t)('tax.zollar_assigned', 'You have received Zollars from the Zederal Reserve.')} (+${amt})` : (0, $fUPn2.t)('tax.zollar_assigned', 'You have received Zollars from the Zederal Reserve.');
    $e625e50e5a3be76b$export$6c932663eba61047(message || fallback);
}, 1000);
function $e625e50e5a3be76b$export$6c932663eba61047(message) {
    if ($e625e50e5a3be76b$var$isNotificationDisplayed) return;
    $e625e50e5a3be76b$var$isNotificationDisplayed = true;
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 1)';
    overlay.style.display = 'flex';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    overlay.style.zIndex = '99999';
    const notification = document.createElement('div');
    notification.textContent = message;
    notification.style.backgroundColor = '#000';
    notification.style.padding = '20px 40px';
    notification.style.border = '2px solid #00ff00';
    notification.style.borderRadius = '10px';
    notification.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
    notification.style.textAlign = 'center';
    notification.style.maxWidth = '80%';
    notification.style.color = '#00ff00';
    overlay.appendChild(notification);
    document.body.appendChild(overlay);
    setTimeout(()=>{
        overlay.remove();
        $e625e50e5a3be76b$var$isNotificationDisplayed = false;
    }, 2000);
}
window.showtaxSingleItem = $e625e50e5a3be76b$export$19ed5f257772fcea;
window.showPointsDeductedNotification = $e625e50e5a3be76b$export$3695e4081b3eabdd;
window.showItemSelectedAssign = $e625e50e5a3be76b$export$25c21df5493fc2da;
window.showPointsAssignedNotification = $e625e50e5a3be76b$export$4b96634ee2744b8b;
window.showZollarSelectedAssign = $e625e50e5a3be76b$export$e859aac445856345;

});

parcelRegister("bNbKd", function(module, exports) {

$parcel$export(module.exports, "triggerBurst", () => $895d6185463ab8db$export$f41080da4e2fdf9f);
$parcel$export(module.exports, "showMoodAnalysisPopup", () => $895d6185463ab8db$export$8a958c527fd8c83f);
// mood.js
parcelRequire("eCgl8");

var $21EbS = parcelRequire("21EbS");

var $5W4EI = parcelRequire("5W4EI");

var $73MNt = parcelRequire("73MNt");

var $fUPn2 = parcelRequire("fUPn2");
// Create a completely new WebSocket connection for the Mood Board
let $895d6185463ab8db$var$moodSocket = null;
const $895d6185463ab8db$var$sessionId = localStorage.getItem("sessionId");
const $895d6185463ab8db$var$storedSocketId = localStorage.getItem("socketId");
const $895d6185463ab8db$var$authToken = (0, $21EbS.getAuthToken)();
let $895d6185463ab8db$var$userMoodScore = 0;
let $895d6185463ab8db$var$marketMoodScore = 0;
let $895d6185463ab8db$var$p5Instance = null;
let $895d6185463ab8db$var$updateTimer = null;
let $895d6185463ab8db$var$lastTransactionTime = null;
let $895d6185463ab8db$var$lastTransactionMood = 0;
let $895d6185463ab8db$var$burstCells = [];
let $895d6185463ab8db$var$cols = 0;
let $895d6185463ab8db$var$rows = 0;
let $895d6185463ab8db$var$cellSize = 10;
const $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR = 1.8;
let $895d6185463ab8db$var$moodSocketSetupComplete = false;
let $895d6185463ab8db$var$socketSetupComplete = false;
let $895d6185463ab8db$var$isConnected = false;
let $895d6185463ab8db$var$reconnectAttempts = 0;
const $895d6185463ab8db$var$MAX_RECONNECT_ATTEMPTS = 5;
function $895d6185463ab8db$var$connectMoodSocket() {
    const token = (0, $21EbS.getAuthToken)() || localStorage.getItem('token');
    const sessionId = localStorage.getItem('sessionId');
    if (!token || !sessionId) {
        console.error("\u274C Missing token or sessionId. Cannot connect mood socket.");
        return;
    }
    $895d6185463ab8db$var$moodSocket = (0, $73MNt.default)((0, $5W4EI.apiBaseSocket), {
        query: {
            token: token,
            userId: sessionId,
            sessionId: sessionId,
            page: 'moodBoard' // This is critical - ensures server knows this is a mood board client
        },
        transports: [
            'websocket'
        ]
    });
    $895d6185463ab8db$var$moodSocket.on('connect', ()=>{
        console.log("\u2705 Connected to mood board socket:", $895d6185463ab8db$var$moodSocket.id);
        localStorage.setItem('moodSocketId', $895d6185463ab8db$var$moodSocket.id);
        $895d6185463ab8db$var$moodSocket.emit('registerMoodBoard', {
            moodSocketId: $895d6185463ab8db$var$moodSocket.id,
            sessionId: sessionId
        });
    });
    $895d6185463ab8db$var$moodSocket.on('disconnect', (reason)=>{
        console.warn(`\u{274C} Mood board socket disconnected: ${reason}`);
    });
    $895d6185463ab8db$var$moodSocket.on('connect_error', (err)=>{
        console.error("\u274C Connection error:", err);
    });
    $895d6185463ab8db$var$moodSocket.on('transactionBurst', (data)=>{
        console.log("\uD83C\uDF86 Received transactionBurst:", data);
        if (!data) return;
        let moodScore = Number(data.moodScore);
        if (!isNaN(moodScore)) $895d6185463ab8db$export$f41080da4e2fdf9f(moodScore);
        else console.warn("\u26A0\uFE0F Invalid moodScore in transactionBurst:", data.moodScore);
    });
}
function $895d6185463ab8db$var$handleReconnect() {
    if ($895d6185463ab8db$var$reconnectAttempts < $895d6185463ab8db$var$MAX_RECONNECT_ATTEMPTS) {
        $895d6185463ab8db$var$reconnectAttempts++;
        console.log(`\u{1F504} Reattempting connection (${$895d6185463ab8db$var$reconnectAttempts}/${$895d6185463ab8db$var$MAX_RECONNECT_ATTEMPTS})...`);
        setTimeout($895d6185463ab8db$var$connectMoodSocket, 2000);
    } else console.error(`\u{274C} Maximum reconnection attempts (${$895d6185463ab8db$var$MAX_RECONNECT_ATTEMPTS}) reached.`);
}
function $895d6185463ab8db$var$setupMoodBoardListeners() {
    if ($895d6185463ab8db$var$moodSocketSetupComplete) {
        console.log("\uD83C\uDFA7 Mood Board listeners already set up. Skipping.");
        return;
    }
    console.log("\u2705 Setting up Mood Board WebSocket listeners.");
    // Check if we're using socket.io or native WebSockets
    if ($895d6185463ab8db$var$moodSocket && typeof $895d6185463ab8db$var$moodSocket.on === 'function') // Socket.io style already handled in connectMoodSocket
    console.log("\u2705 Using Socket.io style listeners (already configured).");
    else if ($895d6185463ab8db$var$moodSocket) // Native WebSocket API
    $895d6185463ab8db$var$moodSocket.onmessage = (event)=>{
        try {
            const data = JSON.parse(event.data);
            console.log("\uD83D\uDCAC Mood Board WebSocket received message:", data);
            if (data.type === "authenticated") console.log("\u2705 WebSocket authentication successful!");
            else if (data.type === "burstMessage") handleBurstMessage(data);
        } catch (err) {
            console.error("\u26A0\uFE0F Error processing Mood Board WebSocket message:", err);
        }
    };
    else console.error("\u274C Cannot set up listeners - moodSocket is not initialized.");
    $895d6185463ab8db$var$moodSocketSetupComplete = true;
}
function $895d6185463ab8db$var$ensureBurstListener() {
    if ($895d6185463ab8db$var$socketSetupComplete) {
        console.log("\uD83C\uDFA7 Burst listener already set up. Skipping.");
        return;
    }
    console.log("\u2705 Setting up burst listener.");
    $895d6185463ab8db$var$setupBurstListener();
    $895d6185463ab8db$var$socketSetupComplete = true;
    $895d6185463ab8db$var$moodSocketSetupComplete = true;
}
async function $895d6185463ab8db$var$loadP5() {
    if (!window.p5) {
        const script = document.createElement("script");
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/p5.js/1.4.0/p5.min.js";
        script.onload = ()=>$895d6185463ab8db$var$initP5Sketch(); // Call initP5Sketch after loading
        document.body.appendChild(script);
    } else $895d6185463ab8db$var$initP5Sketch(); // Initialize if p5 is already loaded
}
function $895d6185463ab8db$var$initP5Sketch() {
    const container = document.getElementById('moodCanvas');
    if (!container) {
        console.error("\u274C moodCanvas not found. Aborting p5.js initialization.");
        return;
    }
    if ($895d6185463ab8db$var$p5Instance && typeof $895d6185463ab8db$var$p5Instance.remove === 'function') {
        console.log("\uD83D\uDED1 Removing previous p5 instance...");
        $895d6185463ab8db$var$p5Instance.remove();
    }
    console.log("\u2705 moodCanvas found. Initializing p5 sketch...");
    $895d6185463ab8db$var$p5Instance = new window.p5($895d6185463ab8db$var$pixelMoodArt, "moodCanvas");
}
function $895d6185463ab8db$var$setupBurstListener() {
    if ($895d6185463ab8db$var$socketSetupComplete) {
        console.log("\uD83C\uDFA7 Burst listener already set up. Skipping.");
        return;
    }
    console.log("\u2705 Setting up burst listener.");
    document.addEventListener("transactionBurst", (event)=>{
        const data = event.detail;
        console.log("\uD83C\uDF86 TRANSACTION BURST EVENT RECEIVED:", JSON.stringify(data));
        if (!data) {
            console.error("\u26A0\uFE0F Empty transaction burst data received");
            return;
        }
        const { moodScore: moodScore, transactionId: transactionId } = data;
        if (typeof moodScore === "number") {
            console.log(`\u{1F525} Triggering burst with mood score: ${moodScore} for transaction: ${transactionId}`);
            $895d6185463ab8db$export$f41080da4e2fdf9f(moodScore);
        } else console.warn("\u26A0\uFE0F Invalid mood score in transaction burst event:", data);
    });
    document.addEventListener("bidAcceptSuccess", (event)=>{
        const data = event.detail;
        console.log("\uD83D\uDCE3 Bid accept success received:", data);
        if (data.moodResult && typeof data.moodResult.transactionMoodScore === "number") {
            console.log("\uD83D\uDCCA Transaction mood score from acceptance:", data.moodResult.transactionMoodScore);
            $895d6185463ab8db$export$f41080da4e2fdf9f(data.moodResult.transactionMoodScore);
        }
    });
    document.addEventListener("bidDeclineSuccess", (event)=>{
        const data = event.detail;
        console.log("\uD83D\uDCE3 Bid decline success received:", data);
        if (data.moodResult && typeof data.moodResult.transactionMoodScore === "number") {
            console.log("\uD83D\uDCCA Transaction mood score from decline:", data.moodResult.transactionMoodScore);
            $895d6185463ab8db$export$f41080da4e2fdf9f(data.moodResult.transactionMoodScore);
        }
    });
    $895d6185463ab8db$var$socketSetupComplete = true;
    console.log("\u2705 Burst listener setup complete.");
}
async function $895d6185463ab8db$var$initializeBoard() {
    // Establish the WebSocket connection only once.
    if (!$895d6185463ab8db$var$moodSocket || typeof $895d6185463ab8db$var$moodSocket.connected !== 'undefined' && !$895d6185463ab8db$var$moodSocket.connected) {
        console.log("\uD83D\uDD0C Establishing WebSocket connection...");
        $895d6185463ab8db$var$connectMoodSocket();
    }
    $895d6185463ab8db$var$ensureBurstListener();
    await $895d6185463ab8db$var$loadP5();
    await $895d6185463ab8db$var$initMoodPage();
    // Start periodic mood data updates (e.g., every 15 seconds).
    if ($895d6185463ab8db$var$updateTimer) clearInterval($895d6185463ab8db$var$updateTimer);
    $895d6185463ab8db$var$updateTimer = setInterval($895d6185463ab8db$var$initMoodPage, 15000);
}
async function $895d6185463ab8db$var$initMoodPage() {
    try {
        console.log("\uD83D\uDCCC Refreshing Mood Page Data...");
        $895d6185463ab8db$var$sessionId = localStorage.getItem("sessionId");
        if (!$895d6185463ab8db$var$sessionId) {
            console.error("\u274C No session ID found in localStorage. Are you logged in?");
            $895d6185463ab8db$var$showNotification("Session ID is missing. Please log in.", false);
            return;
        }
        console.log("\u2705 Session ID retrieved:", $895d6185463ab8db$var$sessionId);
        const traderMood = await $895d6185463ab8db$var$fetchTraderMood($895d6185463ab8db$var$sessionId);
        const marketMood = await $895d6185463ab8db$var$fetchMarketMood($895d6185463ab8db$var$sessionId);
        // Log raw responses for debugging.
        console.log("\uD83D\uDCCA Raw market mood response:", marketMood);
        // (Optional) Store previous values for logging.
        const oldUserMoodScore = $895d6185463ab8db$var$userMoodScore;
        const oldMarketMoodScore = $895d6185463ab8db$var$marketMoodScore;
        // --- CALCULATE USER MOOD ---
        if (traderMood) {
            if (typeof traderMood.averageMood !== "undefined" && !isNaN(parseFloat(traderMood.averageMood))) {
                $895d6185463ab8db$var$userMoodScore = parseFloat(traderMood.averageMood);
                console.log("\uD83D\uDCCA Using API-provided user mood:", $895d6185463ab8db$var$userMoodScore);
            } else if (traderMood.details?.moodHistory && traderMood.details.moodHistory.length > 0) {
                $895d6185463ab8db$var$userMoodScore = $895d6185463ab8db$var$calculateWeightedMood(traderMood.details.moodHistory);
                console.log("\uD83D\uDCCA Calculated user mood from details.moodHistory:", $895d6185463ab8db$var$userMoodScore);
            } else if (traderMood.moodHistory && traderMood.moodHistory.length > 0) {
                $895d6185463ab8db$var$userMoodScore = $895d6185463ab8db$var$calculateWeightedMood(traderMood.moodHistory);
                console.log("\uD83D\uDCCA Calculated user mood from moodHistory:", $895d6185463ab8db$var$userMoodScore);
            } else {
                console.warn("\u26A0\uFE0F No valid user mood data in API response");
                $895d6185463ab8db$var$userMoodScore = isNaN($895d6185463ab8db$var$userMoodScore) || $895d6185463ab8db$var$userMoodScore === 0 ? 0.25 : $895d6185463ab8db$var$userMoodScore;
            }
        } else {
            console.warn("\u26A0\uFE0F Failed to retrieve trader mood data");
            $895d6185463ab8db$var$userMoodScore = isNaN($895d6185463ab8db$var$userMoodScore) || $895d6185463ab8db$var$userMoodScore === 0 ? 0.25 : $895d6185463ab8db$var$userMoodScore;
        }
        // Apply the amplification factor to the user mood.
        $895d6185463ab8db$var$userMoodScore *= $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        console.log("\uD83D\uDCCA Amplified user mood:", $895d6185463ab8db$var$userMoodScore);
        // --- CALCULATE MARKET MOOD ---
        if (marketMood) {
            if (typeof marketMood.averageMood !== "undefined" && !isNaN(parseFloat(marketMood.averageMood))) {
                $895d6185463ab8db$var$marketMoodScore = parseFloat(marketMood.averageMood);
                console.log("\uD83D\uDCCA Base market mood from API:", $895d6185463ab8db$var$marketMoodScore);
                $895d6185463ab8db$var$marketMoodScore *= $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
                console.log("\uD83D\uDCCA Amplified market mood:", $895d6185463ab8db$var$marketMoodScore);
            } else {
                console.warn("\u26A0\uFE0F No valid market mood average in API response");
                $895d6185463ab8db$var$marketMoodScore = isNaN($895d6185463ab8db$var$marketMoodScore) ? -1.8 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR : $895d6185463ab8db$var$marketMoodScore;
            }
        } else {
            console.warn("\u26A0\uFE0F Failed to retrieve market mood data");
            $895d6185463ab8db$var$marketMoodScore = isNaN($895d6185463ab8db$var$marketMoodScore) ? -1.8 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR : $895d6185463ab8db$var$marketMoodScore;
        }
        // Ensure mood scores are finite numbers.
        $895d6185463ab8db$var$userMoodScore = isFinite($895d6185463ab8db$var$userMoodScore) ? $895d6185463ab8db$var$userMoodScore : 0.25 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        $895d6185463ab8db$var$marketMoodScore = isFinite($895d6185463ab8db$var$marketMoodScore) ? $895d6185463ab8db$var$marketMoodScore : -0.15 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        // Update UI elements.
        if (traderMood) $895d6185463ab8db$var$displayTraderMood(traderMood);
        if (marketMood) $895d6185463ab8db$var$displayMarketMood(marketMood);
        $895d6185463ab8db$var$displayMoodScores();
        console.log("\u2705 Final mood values:", {
            userMoodScore: $895d6185463ab8db$var$userMoodScore.toFixed(3),
            marketMoodScore: $895d6185463ab8db$var$marketMoodScore.toFixed(3)
        });
    } catch (error) {
        console.error("\u274C Error in initMoodPage:", error);
        $895d6185463ab8db$var$userMoodScore = isNaN($895d6185463ab8db$var$userMoodScore) ? 0.25 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR : $895d6185463ab8db$var$userMoodScore;
        $895d6185463ab8db$var$marketMoodScore = isNaN($895d6185463ab8db$var$marketMoodScore) ? -0.15 * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR : $895d6185463ab8db$var$marketMoodScore;
        $895d6185463ab8db$var$displayMoodScores();
        $895d6185463ab8db$var$showNotification("Error loading mood data. Using fallback values.", false);
    }
}
function $895d6185463ab8db$var$calculateWeightedMood(moodHistory1) {
    if (!moodHistory1 || !Array.isArray(moodHistory1) || moodHistory1.length === 0) {
        console.warn("\u26A0\uFE0F Invalid mood history data");
        return 0;
    }
    // Process and validate entries
    const validEntries = moodHistory1.filter((entry)=>entry && (typeof entry.positiveImpact !== 'undefined' || typeof entry.negativeImpact !== 'undefined' || typeof entry.value !== 'undefined')).map((entry)=>({
            positiveImpact: parseFloat(entry.positiveImpact) || 0,
            negativeImpact: parseFloat(entry.negativeImpact) || 0,
            value: parseFloat(entry.value) || entry.positiveImpact - entry.negativeImpact || 0,
            timestamp: entry.timestamp || new Date().toISOString()
        }));
    if (validEntries.length === 0) {
        console.warn("\u26A0\uFE0F No valid entries in mood history");
        return 0;
    }
    // Sort by timestamp (newest first) and take most recent 5
    const recentHistory = [
        ...validEntries
    ].sort((a, b)=>new Date(b.timestamp) - new Date(a.timestamp)).slice(0, 5);
    console.log("\uD83D\uDCCA Recent mood history entries for calculation:", recentHistory.length);
    // Apply weighted calculation with decaying importance
    let weightedMood = 0;
    let totalWeight = 0;
    recentHistory.forEach((entry, index)=>{
        const weight = Math.pow(2, 4 - index); // Exponential decay: 16, 8, 4, 2, 1
        const entryMood = entry.value || entry.positiveImpact - entry.negativeImpact;
        console.log(`Entry mood ${index}: ${entryMood} with weight ${weight}`);
        weightedMood += entryMood * weight;
        totalWeight += weight;
    });
    const result = totalWeight > 0 ? weightedMood / totalWeight : 0;
    console.log(`Weighted mood calculation result: ${result}`);
    return result;
}
async function $895d6185463ab8db$var$fetchTraderMood(sessionId) {
    if (!sessionId) sessionId = localStorage.getItem("sessionId"); // Fallback
    if (!sessionId) {
        console.error("\u274C Missing sessionId in localStorage!");
        $895d6185463ab8db$var$showNotification("Error: No session ID found", false);
        return null;
    }
    try {
        console.log("\uD83D\uDCCA Fetching trader mood with sessionId:", sessionId);
        const startTime = Date.now();
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/mood/trader/${sessionId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            cache: 'no-store'
        });
        const elapsedTime = Date.now() - startTime;
        console.log(`\u{1F4CA} Trader mood API response time: ${elapsedTime}ms`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        // Parse the JSON response
        const data = await response.json();
        console.log("\uD83D\uDCCA Trader mood data received:", data);
        // Verify the data structure
        if (typeof data.averageMood === 'undefined') console.warn("\u26A0\uFE0F Trader mood response missing averageMood field");
        return data;
    } catch (error) {
        console.error('Error fetching trader mood:', error);
        $895d6185463ab8db$var$showNotification(`Error fetching trader mood: ${error.message}`, false);
        return null;
    }
}
function $895d6185463ab8db$var$displayTraderMood(traderMood) {
    if (!traderMood) return;
    const traderMoodElement = document.getElementById('traderMood');
    if (traderMoodElement) {
        // Check each possible location for averageMood in the API response
        let moodValue;
        if (traderMood.averageMood !== undefined && !isNaN(parseFloat(traderMood.averageMood))) moodValue = parseFloat(traderMood.averageMood);
        else if (traderMood.details?.averageMood !== undefined && !isNaN(parseFloat(traderMood.details.averageMood))) moodValue = parseFloat(traderMood.details.averageMood);
        else moodValue = null;
        if (moodValue !== null) {
            traderMoodElement.textContent = `Your Mood: ${moodValue.toFixed(2)}`;
            traderMoodElement.style.color = $895d6185463ab8db$var$getMoodTextColor(moodValue);
        } else {
            traderMoodElement.textContent = `Your Mood: N/A`;
            traderMoodElement.style.color = $895d6185463ab8db$var$getMoodTextColor(0);
        }
    }
    // Display baseline factors if available
    if (traderMood.baseline || traderMood.details?.baseline) $895d6185463ab8db$var$displayMoodFactors(traderMood.baseline || traderMood.details?.baseline);
}
async function $895d6185463ab8db$var$fetchMarketMood(sessionId) {
    if (!sessionId) sessionId = localStorage.getItem("sessionId"); // Fallback
    if (!sessionId) {
        console.error("\u274C Error: Missing sessionId in localStorage!");
        $895d6185463ab8db$var$showNotification("Error: No session ID found", false);
        return null;
    }
    try {
        console.log(`\u{1F4CA} Fetching market mood with sessionId: ${sessionId}`);
        const startTime = Date.now();
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/mood/market/${sessionId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            cache: 'no-store'
        });
        const elapsedTime = Date.now() - startTime;
        console.log(`\u{1F4CA} Market mood API response time: ${elapsedTime}ms`);
        if (!response.ok) {
            console.error(`\u{274C} HTTP error! status: ${response.status}`);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("\uD83D\uDCCA Market mood response:", data);
        // Verify the data structure
        if (typeof data.averageMood === 'undefined') console.warn("\u26A0\uFE0F Market mood response missing averageMood field");
        return data;
    } catch (error) {
        console.error("\u274C Error fetching market mood:", error);
        $895d6185463ab8db$var$showNotification(`Error fetching market mood: ${error.message}`, false);
        return null;
    }
}
function $895d6185463ab8db$var$displayMarketMood(marketMood) {
    if (!marketMood) return;
    const marketMoodElement = document.getElementById('marketMood');
    if (marketMoodElement) {
        // Check if averageMood exists and is a number
        if (marketMood.averageMood !== undefined && !isNaN(parseFloat(marketMood.averageMood))) {
            const moodValue = parseFloat(marketMood.averageMood);
            marketMoodElement.textContent = `Market Mood: ${moodValue.toFixed(2)}`;
            marketMoodElement.style.color = $895d6185463ab8db$var$getMoodTextColor(moodValue);
        } else {
            marketMoodElement.textContent = `Market Mood: N/A`;
            marketMoodElement.style.color = $895d6185463ab8db$var$getMoodTextColor(0);
        }
    }
    // Display transaction count if available
    const txCountElement = document.getElementById('transactionCount');
    if (txCountElement && marketMood.transactionCount) txCountElement.textContent = `Based on ${marketMood.transactionCount} transactions`;
}
function $895d6185463ab8db$export$f41080da4e2fdf9f(moodScore) {
    console.log(`\u{1F3AF} triggerBurst called with score: ${moodScore}`);
    if (!$895d6185463ab8db$var$p5Instance) {
        console.error("\u26A0\uFE0F Cannot trigger burst - p5Instance not initialized");
        return;
    }
    // If grid dimensions are not set, recalc using p5Instance's width/height.
    if (!$895d6185463ab8db$var$cols || !$895d6185463ab8db$var$rows) {
        console.warn("Grid dimensions missing. Recomputing grid.");
        const grid = computeGrid($895d6185463ab8db$var$p5Instance.width, $895d6185463ab8db$var$p5Instance.height, 0);
        $895d6185463ab8db$var$cellSize = grid.cellSize;
        $895d6185463ab8db$var$cols = grid.cols;
        $895d6185463ab8db$var$rows = grid.rows;
    }
    const burstColor = $895d6185463ab8db$var$moodToColor(moodScore);
    const intensity = Math.min(5, Math.abs(moodScore));
    const burstCount = Math.floor(20 * (intensity / 5)) + 5;
    console.log(`\u{1F3A8} Creating ${burstCount} bursts with color ${burstColor} (intensity: ${intensity})`);
    for(let i = 0; i < burstCount; i++){
        const centerX = Math.floor(Math.random() * $895d6185463ab8db$var$cols);
        const centerY = Math.floor(Math.random() * $895d6185463ab8db$var$rows);
        const offset = i / burstCount * Math.PI * 2;
        const distance = Math.random() * 10;
        const x = Math.floor(centerX + Math.cos(offset) * distance);
        const y = Math.floor(centerY + Math.sin(offset) * distance);
        const clampedX = Math.max(0, Math.min($895d6185463ab8db$var$cols - 1, x));
        const clampedY = Math.max(0, Math.min($895d6185463ab8db$var$rows - 1, y));
        $895d6185463ab8db$var$burstCells.push({
            x: clampedX,
            y: clampedY,
            color: burstColor,
            life: 120 + Math.random() * 60,
            size: 1.5 + Math.random() * 1.5,
            alpha: 0.85 + Math.random() * 0.15,
            intensity: intensity
        });
    }
    console.log(`\u{2728} Created ${burstCount} burst cells with color ${burstColor}`);
    // Restart the loop if it's not active.
    if ($895d6185463ab8db$var$p5Instance && typeof $895d6185463ab8db$var$p5Instance.loop === 'function' && !$895d6185463ab8db$var$p5Instance.isLooping()) $895d6185463ab8db$var$p5Instance.loop();
}
function $895d6185463ab8db$var$displayMoodScores() {
    const scoresContainer = document.getElementById('moodScoresContainer');
    if (!scoresContainer) {
        console.error("Error: moodScoresContainer not found in the DOM");
        return;
    }
    // Get current time for the update timestamp
    const now = new Date();
    const timeStr = now.toLocaleTimeString();
    // Format values to display (fixing any potential NaN issues)
    const userScore = isFinite($895d6185463ab8db$var$userMoodScore) ? $895d6185463ab8db$var$userMoodScore.toFixed(3) : "0.000";
    const marketScore = isFinite($895d6185463ab8db$var$marketMoodScore) ? $895d6185463ab8db$var$marketMoodScore.toFixed(3) : "0.000";
    const difference = isFinite($895d6185463ab8db$var$userMoodScore) && isFinite($895d6185463ab8db$var$marketMoodScore) ? Math.abs($895d6185463ab8db$var$userMoodScore - $895d6185463ab8db$var$marketMoodScore).toFixed(3) : "0.000";
    // Update the HTML content
    scoresContainer.innerHTML = `
	  <div style="text-align: center; margin-bottom: 8px; border-bottom: 1px solid #00FFFF; padding-bottom: 5px;">
		<span style="color: #FF00FF; font-size: 16px; font-weight: bold;">MOOD SCORES</span>
	  </div>
	  <div style="margin-bottom: 8px;">
		<span style="color: #FFA500; font-weight: bold;">User Score: </span>
		<span style="color: ${$895d6185463ab8db$var$getMoodTextColor($895d6185463ab8db$var$userMoodScore)}; font-weight: bold;">${userScore}</span>
	  </div>
	  <div style="margin-bottom: 8px;">
		<span style="color: #FFA500; font-weight: bold;">Market Score: </span>
		<span style="color: ${$895d6185463ab8db$var$getMoodTextColor($895d6185463ab8db$var$marketMoodScore)}; font-weight: bold;">${marketScore}</span>
	  </div>
	  <div style="margin-bottom: 8px;">
		<span style="color: #FFA500;">Difference: </span>
		<span style="font-weight: bold;">${difference}</span>
	  </div>
	  <div style="margin-bottom: 8px;">
		<span style="color: #FFA500;">Amp Factor: </span>
		<span style="font-weight: bold;">${$895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR}</span>
	  </div>
	  <div style="font-size: 12px; color: #999; text-align: right; margin-top: 10px; border-top: 1px dotted #555; padding-top: 5px;">
		Updated: ${timeStr}
	  </div>
	`;
}
function $895d6185463ab8db$var$displayMoodFactors(baseline) {
    const factorsContainer = document.getElementById('moodFactors');
    if (!factorsContainer) return;
    factorsContainer.innerHTML = '';
    const factors = [
        {
            name: 'Positive Mental',
            value: baseline.positiveMental
        },
        {
            name: 'Negative Mental',
            value: baseline.negativeMental
        },
        {
            name: 'Positive Experience',
            value: baseline.positiveExperience
        },
        {
            name: 'Negative Experience',
            value: baseline.negativeExperience
        }
    ];
    factors.forEach((factor)=>{
        const factorElement = document.createElement('div');
        factorElement.className = 'mood-factor';
        factorElement.innerHTML = `
	  <span>${factor.name}:</span>
	  <div class="factor-bar">
		<div class="factor-fill" style="width: ${Math.abs(factor.value) * 10}%; 
									   background-color: ${factor.value >= 0 ? '#4CAF50' : '#F44336'}"></div>
	  </div>
	  <span>${factor.value.toFixed(2)}</span>
	`;
        factorsContainer.appendChild(factorElement);
    });
}
function $895d6185463ab8db$var$getMoodTextColor(moodScore) {
    if (moodScore >= 2) return "#FF4500"; // Red (Very Positive)
    if (moodScore >= 1) return "#FFA500"; // Orange (Positive)
    if (moodScore >= 0) return "#00FF00"; // Green (Neutral to Slightly Positive)
    if (moodScore >= -1) return "#00BFFF"; // Blue (Negative)
    return "#4B0082"; // Indigo (Very Negative)
}
function $895d6185463ab8db$var$moodToColor(moodScore) {
    if (moodScore >= 2) return "rgb(255, 69, 0)"; // Red (Very Positive)
    if (moodScore >= 1) return "rgba(255, 135, 0, 0.858)"; // Orange (Positive)
    if (moodScore >= 0) return "rgb(0, 255, 0)"; // Green (Neutral to Slightly Positive)
    if (moodScore >= -1) return "rgb(0, 191, 255)"; // Blue (Negative)
    return "rgb(75, 0, 130)"; // Indigo (Very Negative)
}
// Enhanced pixelated mood art with improved sensitivity and color diversity
function $895d6185463ab8db$var$pixelMoodArt(p) {
    let t = 0;
    let palette = [];
    let moodDifference = 0;
    let lastUserMood = null;
    let lastMarketMood = null;
    p.setup = function() {
        const w = Math.min(window.innerWidth, 800);
        const h = Math.min(window.innerHeight, 600);
        p.createCanvas(w, h);
        p.noSmooth(); // Ensures a pixelated look
        p.frameRate(30); // Increase framerate for smoother animations
        updatePalette();
    };
    function updatePalette() {
        // Only regenerate palette if mood scores have changed
        if (lastUserMood !== $895d6185463ab8db$var$userMoodScore || lastMarketMood !== $895d6185463ab8db$var$marketMoodScore) {
            console.log("\uD83D\uDD04 Regenerating mood palette with scores:", $895d6185463ab8db$var$userMoodScore, $895d6185463ab8db$var$marketMoodScore);
            // Dynamically adjust grid resolution based on market activity and mood difference
            moodDifference = Math.abs($895d6185463ab8db$var$marketMoodScore - $895d6185463ab8db$var$userMoodScore);
            $895d6185463ab8db$var$cellSize = Math.floor(Math.min(p.width, p.height) / (45 + moodDifference * 15));
            // Update the global variables so triggerBurst can access them
            $895d6185463ab8db$var$cols = Math.ceil(p.width / $895d6185463ab8db$var$cellSize);
            $895d6185463ab8db$var$rows = Math.ceil(p.height / $895d6185463ab8db$var$cellSize);
            palette = $895d6185463ab8db$var$generateHypersensitivePalette($895d6185463ab8db$var$userMoodScore, $895d6185463ab8db$var$marketMoodScore);
            // Store current values for comparison
            lastUserMood = $895d6185463ab8db$var$userMoodScore;
            lastMarketMood = $895d6185463ab8db$var$marketMoodScore;
        }
    }
    p.draw = function() {
        updatePalette();
        p.background(0);
        // Animation speed responds to market volatility
        const volatilityFactor = Math.abs($895d6185463ab8db$var$marketMoodScore) * 0.015;
        t += 0.015 + volatilityFactor;
        // Draw the base mood grid
        for(let i = 0; i < $895d6185463ab8db$var$cols; i++)for(let j = 0; j < $895d6185463ab8db$var$rows; j++){
            const x = i * $895d6185463ab8db$var$cellSize;
            const y = j * $895d6185463ab8db$var$cellSize;
            const noiseVal = p.noise(i * 0.1 + Math.sin(t * 0.02) * 0.1, j * 0.1 + Math.cos(t * 0.02) * 0.1, t * 0.1);
            const moodFactor = p.map($895d6185463ab8db$var$userMoodScore, -5, 5, 0.5, 1.2) * p.map($895d6185463ab8db$var$marketMoodScore, -5, 5, 0.7, 1.1);
            const paletteIndex = Math.floor(noiseVal * palette.length * moodFactor) % palette.length;
            let col = p.color(palette[paletteIndex]);
            const moodRelationship = $895d6185463ab8db$var$userMoodScore / ($895d6185463ab8db$var$marketMoodScore !== 0 ? $895d6185463ab8db$var$marketMoodScore : 0.01);
            const brightnessMod = p.map(moodRelationship, -5, 5, 0.5, 1.2);
            const contrastMod = p.map($895d6185463ab8db$var$marketMoodScore, -5, 5, 0.7, 1.1);
            let r = p.constrain(p.red(col) * brightnessMod * contrastMod, 0, 255);
            let g = p.constrain(p.green(col) * brightnessMod, 0, 255);
            let b = p.constrain(p.blue(col) * (2 - brightnessMod), 0, 255);
            let alpha = p.map(p.noise(i * 0.2, j * 0.2, t * 0.1), 0, 1, 180, 255);
            col = p.color(r, g, b, alpha);
            p.fill(col);
            p.noStroke();
            const flowSpeed = p.map(Math.abs($895d6185463ab8db$var$marketMoodScore), 0, 1, 0.1, 0.5);
            let xOffset = p.sin(t * flowSpeed + i * 0.1) * $895d6185463ab8db$var$cellSize * 0.15;
            let yOffset = p.cos(t * flowSpeed + j * 0.1) * $895d6185463ab8db$var$cellSize * 0.15;
            const pulseSize = $895d6185463ab8db$var$cellSize * (1 + Math.sin(t * 0.15) * 0.1 * Math.abs($895d6185463ab8db$var$marketMoodScore));
            p.rect(x + xOffset, y + yOffset, pulseSize, pulseSize);
        }
        // Draw burst cells on top (IMPORTANT: This needs to be outside the grid loops)
        if ($895d6185463ab8db$var$burstCells.length > 0) {
            p.push(); // Save drawing state
            for(let i = $895d6185463ab8db$var$burstCells.length - 1; i >= 0; i--){
                const cell = $895d6185463ab8db$var$burstCells[i];
                // Calculate alpha based on life
                const lifeRatio = cell.life / 120; // Normalize to 0-1
                const alpha = lifeRatio * (cell.alpha || 0.9);
                const intensity = cell.intensity || 1;
                // Calculate size with pulsing effect
                const pulseFactor = 1 + 0.2 * Math.sin(p.frameCount * 0.2);
                const size = $895d6185463ab8db$var$cellSize * (cell.size || 1.5) * pulseFactor;
                // Position with slight movement
                const wobbleX = Math.sin(p.frameCount * 0.1 + i) * $895d6185463ab8db$var$cellSize * 0.1 * lifeRatio;
                const wobbleY = Math.cos(p.frameCount * 0.1 + i) * $895d6185463ab8db$var$cellSize * 0.1 * lifeRatio;
                const x = cell.x * $895d6185463ab8db$var$cellSize + wobbleX;
                const y = cell.y * $895d6185463ab8db$var$cellSize + wobbleY;
                // Parse the color
                let r, g, b;
                if (typeof cell.color === 'string') {
                    const match = cell.color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
                    if (match) {
                        r = parseInt(match[1]);
                        g = parseInt(match[2]);
                        b = parseInt(match[3]);
                    } else {
                        // Fallback color if parsing fails
                        r = 255;
                        g = 255;
                        b = 255;
                    }
                } else {
                    // Another fallback
                    r = 255;
                    g = 255;
                    b = 255;
                }
                // Draw outer glow
                const glowSize = size * 1.5;
                const glowAlpha = alpha * 0.3;
                p.fill(p.color(`rgba(${r}, ${g}, ${b}, ${glowAlpha})`));
                p.rect(x - (glowSize - size) / 2, y - (glowSize - size) / 2, glowSize, glowSize);
                // Draw main burst
                p.fill(p.color(`rgba(${r}, ${g}, ${b}, ${alpha})`));
                p.rect(x, y, size, size);
                // Draw bright core
                if (cell.life > 60) {
                    const coreSize = size * 0.5;
                    const coreAlpha = alpha * 1.5; // Brighter than the main burst
                    p.fill(p.color(`rgba(255, 255, 255, ${coreAlpha})`));
                    p.rect(x + size / 2 - coreSize / 2, y + size / 2 - coreSize / 2, coreSize, coreSize);
                }
                // Update life
                cell.life -= 1 + intensity * 0.5; // Higher intensity = faster decay
                // Remove expired cells
                if (cell.life <= 0) $895d6185463ab8db$var$burstCells.splice(i, 1);
            }
            p.pop(); // Restore drawing state
        }
    };
    p.windowResized = function() {
        const w = Math.min(window.innerWidth, 800);
        const h = Math.min(window.innerHeight, 600);
        p.resizeCanvas(w, h);
        updatePalette();
    };
}
// Generate an ultra-sensitive palette with micro-gradations for market mood visualization
function $895d6185463ab8db$var$generateHypersensitivePalette(userMood, marketMood) {
    let palette = [];
    // Precise decimal calculation to avoid floating point errors
    const moodRounded = Math.round(marketMood * 100) / 100;
    // Clamp the market mood to a safe range to prevent errors
    const safeMarketMood = Math.max(-5, Math.min(5, moodRounded));
    if (safeMarketMood >= 5.0) // Ultra bright golden yellow
    palette = [
        "rgba(255, 255, 100, 0.95)",
        "rgba(255, 250, 50, 0.9)",
        "rgba(255, 245, 0, 0.85)",
        "rgba(255, 240, 0, 0.8)",
        "rgba(255, 235, 0, 0.75)",
        "rgba(255, 230, 50, 0.7)",
        "rgba(255, 225, 100, 0.65)",
        "rgba(255, 220, 150, 0.6)"
    ];
    else if (safeMarketMood >= 4.9) palette = [
        "rgba(255, 253, 95, 0.95)",
        "rgba(255, 248, 48, 0.9)",
        "rgba(255, 243, 0, 0.85)",
        "rgba(255, 238, 0, 0.8)",
        "rgba(255, 233, 0, 0.75)",
        "rgba(255, 228, 48, 0.7)",
        "rgba(255, 223, 95, 0.65)",
        "rgba(255, 218, 145, 0.6)"
    ];
    else if (safeMarketMood >= 4.8) palette = [
        "rgba(255, 252, 90, 0.95)",
        "rgba(255, 247, 45, 0.9)",
        "rgba(255, 242, 0, 0.85)",
        "rgba(255, 237, 0, 0.8)",
        "rgba(255, 232, 0, 0.75)",
        "rgba(255, 227, 45, 0.7)",
        "rgba(255, 222, 90, 0.65)",
        "rgba(255, 217, 140, 0.6)"
    ];
    else if (safeMarketMood >= 4.7) palette = [
        "rgba(255, 251, 85, 0.95)",
        "rgba(255, 246, 43, 0.9)",
        "rgba(255, 241, 0, 0.85)",
        "rgba(255, 236, 0, 0.8)",
        "rgba(255, 231, 0, 0.75)",
        "rgba(255, 226, 43, 0.7)",
        "rgba(255, 221, 85, 0.65)",
        "rgba(255, 216, 135, 0.6)"
    ];
    else if (safeMarketMood >= 4.6) palette = [
        "rgba(255, 250, 83, 0.95)",
        "rgba(255, 245, 42, 0.9)",
        "rgba(255, 240, 0, 0.85)",
        "rgba(255, 235, 0, 0.8)",
        "rgba(255, 230, 0, 0.75)",
        "rgba(255, 225, 42, 0.7)",
        "rgba(255, 220, 83, 0.65)",
        "rgba(255, 215, 130, 0.6)"
    ];
    else if (safeMarketMood >= 4.5) palette = [
        "rgba(255, 250, 80, 0.95)",
        "rgba(255, 245, 40, 0.9)",
        "rgba(255, 240, 0, 0.85)",
        "rgba(255, 235, 0, 0.8)",
        "rgba(255, 230, 0, 0.75)",
        "rgba(255, 225, 40, 0.7)",
        "rgba(255, 220, 80, 0.65)",
        "rgba(255, 215, 120, 0.6)"
    ];
    else if (safeMarketMood >= 4.4) palette = [
        "rgba(255, 248, 75, 0.95)",
        "rgba(255, 243, 38, 0.9)",
        "rgba(255, 238, 0, 0.85)",
        "rgba(255, 233, 0, 0.8)",
        "rgba(255, 228, 0, 0.75)",
        "rgba(255, 223, 38, 0.7)",
        "rgba(255, 218, 75, 0.65)",
        "rgba(255, 213, 115, 0.6)"
    ];
    else if (safeMarketMood >= 4.3) palette = [
        "rgba(255, 247, 70, 0.95)",
        "rgba(255, 242, 35, 0.9)",
        "rgba(255, 237, 0, 0.85)",
        "rgba(255, 232, 0, 0.8)",
        "rgba(255, 227, 0, 0.75)",
        "rgba(255, 222, 35, 0.7)",
        "rgba(255, 217, 70, 0.65)",
        "rgba(255, 212, 110, 0.6)"
    ];
    else if (safeMarketMood >= 4.2) palette = [
        "rgba(255, 246, 65, 0.95)",
        "rgba(255, 241, 33, 0.9)",
        "rgba(255, 236, 0, 0.85)",
        "rgba(255, 231, 0, 0.8)",
        "rgba(255, 226, 0, 0.75)",
        "rgba(255, 221, 33, 0.7)",
        "rgba(255, 216, 65, 0.65)",
        "rgba(255, 211, 105, 0.6)"
    ];
    else if (safeMarketMood >= 4.1) palette = [
        "rgba(255, 245, 63, 0.95)",
        "rgba(255, 240, 32, 0.9)",
        "rgba(255, 235, 0, 0.85)",
        "rgba(255, 230, 0, 0.8)",
        "rgba(255, 225, 0, 0.75)",
        "rgba(255, 220, 32, 0.7)",
        "rgba(255, 215, 63, 0.65)",
        "rgba(255, 210, 100, 0.6)"
    ];
    else if (safeMarketMood >= 4.0) palette = [
        "rgba(255, 245, 60, 0.95)",
        "rgba(255, 240, 30, 0.9)",
        "rgba(255, 235, 0, 0.85)",
        "rgba(255, 230, 0, 0.8)",
        "rgba(255, 225, 0, 0.75)",
        "rgba(255, 220, 30, 0.7)",
        "rgba(255, 215, 60, 0.65)",
        "rgba(255, 210, 90, 0.6)"
    ];
    else if (safeMarketMood >= 3.9) palette = [
        "rgba(255, 244, 55, 0.95)",
        "rgba(255, 239, 28, 0.9)",
        "rgba(255, 234, 0, 0.85)",
        "rgba(255, 229, 0, 0.8)",
        "rgba(255, 224, 0, 0.75)",
        "rgba(255, 219, 28, 0.7)",
        "rgba(255, 214, 55, 0.65)",
        "rgba(255, 209, 85, 0.6)"
    ];
    else if (safeMarketMood >= 3.8) palette = [
        "rgba(255, 243, 53, 0.95)",
        "rgba(255, 238, 26, 0.9)",
        "rgba(255, 233, 0, 0.85)",
        "rgba(255, 228, 0, 0.8)",
        "rgba(255, 223, 0, 0.75)",
        "rgba(255, 218, 26, 0.7)",
        "rgba(255, 213, 53, 0.65)",
        "rgba(255, 208, 83, 0.6)"
    ];
    else if (safeMarketMood >= 3.7) palette = [
        "rgba(255, 242, 50, 0.95)",
        "rgba(255, 237, 25, 0.9)",
        "rgba(255, 232, 0, 0.85)",
        "rgba(255, 227, 0, 0.8)",
        "rgba(255, 222, 0, 0.75)",
        "rgba(255, 217, 25, 0.7)",
        "rgba(255, 212, 50, 0.65)",
        "rgba(255, 207, 80, 0.6)"
    ];
    else if (safeMarketMood >= 3.6) palette = [
        "rgba(255, 241, 48, 0.95)",
        "rgba(255, 236, 24, 0.9)",
        "rgba(255, 231, 0, 0.85)",
        "rgba(255, 226, 0, 0.8)",
        "rgba(255, 221, 0, 0.75)",
        "rgba(255, 216, 24, 0.7)",
        "rgba(255, 211, 48, 0.65)",
        "rgba(255, 206, 75, 0.6)"
    ];
    else if (safeMarketMood >= 3.5) palette = [
        "rgba(255, 240, 45, 0.95)",
        "rgba(255, 235, 22, 0.9)",
        "rgba(255, 230, 0, 0.85)",
        "rgba(255, 225, 0, 0.8)",
        "rgba(255, 220, 0, 0.75)",
        "rgba(255, 215, 22, 0.7)",
        "rgba(255, 210, 45, 0.65)",
        "rgba(255, 205, 70, 0.6)"
    ];
    else if (safeMarketMood >= 3.4) palette = [
        "rgba(255, 239, 40, 0.95)",
        "rgba(255, 234, 20, 0.9)",
        "rgba(255, 229, 0, 0.85)",
        "rgba(255, 224, 0, 0.8)",
        "rgba(255, 219, 0, 0.75)",
        "rgba(255, 214, 20, 0.7)",
        "rgba(255, 209, 40, 0.65)",
        "rgba(255, 204, 65, 0.6)"
    ];
    else if (safeMarketMood >= 3.3) palette = [
        "rgba(255, 238, 38, 0.95)",
        "rgba(255, 233, 18, 0.9)",
        "rgba(255, 228, 0, 0.85)",
        "rgba(255, 223, 0, 0.8)",
        "rgba(255, 218, 0, 0.75)",
        "rgba(255, 213, 18, 0.7)",
        "rgba(255, 208, 38, 0.65)",
        "rgba(255, 203, 60, 0.6)"
    ];
    else if (safeMarketMood >= 3.2) palette = [
        "rgba(255, 237, 35, 0.95)",
        "rgba(255, 232, 16, 0.9)",
        "rgba(255, 227, 0, 0.85)",
        "rgba(255, 222, 0, 0.8)",
        "rgba(255, 217, 0, 0.75)",
        "rgba(255, 212, 16, 0.7)",
        "rgba(255, 207, 35, 0.65)",
        "rgba(255, 202, 55, 0.6)"
    ];
    else if (safeMarketMood >= 3.1) palette = [
        "rgba(255, 236, 30, 0.95)",
        "rgba(255, 231, 14, 0.9)",
        "rgba(255, 226, 0, 0.85)",
        "rgba(255, 221, 0, 0.8)",
        "rgba(255, 216, 0, 0.75)",
        "rgba(255, 211, 14, 0.7)",
        "rgba(255, 206, 30, 0.65)",
        "rgba(255, 201, 50, 0.6)"
    ];
    else if (safeMarketMood >= 3.0) palette = [
        "rgba(255, 235, 25, 0.95)",
        "rgba(255, 230, 12, 0.9)",
        "rgba(255, 225, 0, 0.85)",
        "rgba(255, 220, 0, 0.8)",
        "rgba(255, 215, 0, 0.75)",
        "rgba(255, 210, 12, 0.7)",
        "rgba(255, 205, 25, 0.65)",
        "rgba(255, 200, 45, 0.6)"
    ];
    else if (safeMarketMood >= 2.9) palette = [
        "rgba(255, 234, 23, 0.95)",
        "rgba(255, 229, 11, 0.9)",
        "rgba(255, 224, 0, 0.85)",
        "rgba(255, 219, 0, 0.8)",
        "rgba(255, 214, 0, 0.75)",
        "rgba(255, 209, 11, 0.7)",
        "rgba(255, 204, 23, 0.65)",
        "rgba(255, 199, 43, 0.6)"
    ];
    else if (safeMarketMood >= 2.8) palette = [
        "rgba(255, 232, 20, 0.95)",
        "rgba(255, 227, 10, 0.9)",
        "rgba(255, 222, 0, 0.85)",
        "rgba(255, 217, 0, 0.8)",
        "rgba(255, 212, 0, 0.75)",
        "rgba(255, 207, 10, 0.7)",
        "rgba(255, 202, 20, 0.65)",
        "rgba(255, 197, 40, 0.6)"
    ];
    else if (safeMarketMood >= 2.7) palette = [
        "rgba(255, 230, 18, 0.95)",
        "rgba(255, 225, 8, 0.9)",
        "rgba(255, 220, 0, 0.85)",
        "rgba(255, 215, 0, 0.8)",
        "rgba(255, 210, 0, 0.75)",
        "rgba(255, 205, 8, 0.7)",
        "rgba(255, 200, 18, 0.65)",
        "rgba(255, 195, 38, 0.6)"
    ];
    else if (safeMarketMood >= 2.6) palette = [
        "rgba(255, 228, 15, 0.95)",
        "rgba(255, 223, 7, 0.9)",
        "rgba(255, 218, 0, 0.85)",
        "rgba(255, 213, 0, 0.8)",
        "rgba(255, 208, 0, 0.75)",
        "rgba(255, 203, 7, 0.7)",
        "rgba(255, 198, 15, 0.65)",
        "rgba(255, 193, 35, 0.6)"
    ];
    else if (safeMarketMood >= 2.5) palette = [
        "rgba(255, 225, 12, 0.95)",
        "rgba(255, 220, 6, 0.9)",
        "rgba(255, 215, 0, 0.85)",
        "rgba(255, 210, 0, 0.8)",
        "rgba(255, 205, 0, 0.75)",
        "rgba(255, 200, 6, 0.7)",
        "rgba(255, 195, 12, 0.65)",
        "rgba(255, 190, 32, 0.6)"
    ];
    else if (safeMarketMood >= 2.4) palette = [
        "rgba(255, 223, 10, 0.95)",
        "rgba(255, 218, 5, 0.9)",
        "rgba(255, 213, 0, 0.85)",
        "rgba(255, 208, 0, 0.8)",
        "rgba(255, 203, 0, 0.75)",
        "rgba(255, 198, 5, 0.7)",
        "rgba(255, 193, 10, 0.65)",
        "rgba(255, 188, 30, 0.6)"
    ];
    else if (safeMarketMood >= 2.3) palette = [
        "rgba(255, 222, 8, 0.95)",
        "rgba(255, 217, 4, 0.9)",
        "rgba(255, 212, 0, 0.85)",
        "rgba(255, 207, 0, 0.8)",
        "rgba(255, 202, 0, 0.75)",
        "rgba(255, 197, 4, 0.7)",
        "rgba(255, 192, 8, 0.65)",
        "rgba(255, 187, 28, 0.6)"
    ];
    else if (safeMarketMood >= 2.2) palette = [
        "rgba(255, 221, 6, 0.95)",
        "rgba(255, 216, 3, 0.9)",
        "rgba(255, 211, 0, 0.85)",
        "rgba(255, 206, 0, 0.8)",
        "rgba(255, 201, 0, 0.75)",
        "rgba(255, 196, 3, 0.7)",
        "rgba(255, 191, 6, 0.65)",
        "rgba(255, 186, 26, 0.6)"
    ];
    else if (safeMarketMood >= 2.1) palette = [
        "rgba(255, 220, 4, 0.95)",
        "rgba(255, 215, 2, 0.9)",
        "rgba(255, 210, 0, 0.85)",
        "rgba(255, 205, 0, 0.8)",
        "rgba(255, 200, 0, 0.75)",
        "rgba(255, 195, 2, 0.7)",
        "rgba(255, 190, 4, 0.65)",
        "rgba(255, 185, 24, 0.6)"
    ];
    else if (safeMarketMood >= 2.0) palette = [
        "rgba(255, 255, 30, 0.9)",
        "rgba(255, 240, 0, 0.85)",
        "rgba(255, 220, 0, 0.8)",
        "rgba(255, 215, 0, 0.78)",
        "rgba(255, 235, 60, 0.75)",
        "rgba(255, 248, 130, 0.7)",
        "rgba(255, 253, 190, 0.65)",
        "rgba(255, 255, 220, 0.6)"
    ];
    else if (safeMarketMood >= 1.95) palette = [
        "rgba(255, 253, 25, 0.9)",
        "rgba(255, 235, 0, 0.85)",
        "rgba(255, 215, 0, 0.8)",
        "rgba(255, 210, 0, 0.78)",
        "rgba(255, 230, 55, 0.75)",
        "rgba(255, 245, 125, 0.7)",
        "rgba(255, 250, 185, 0.65)",
        "rgba(255, 253, 215, 0.6)"
    ];
    else if (safeMarketMood >= 1.9) palette = [
        "rgba(255, 250, 20, 0.9)",
        "rgba(255, 230, 0, 0.85)",
        "rgba(255, 210, 0, 0.8)",
        "rgba(255, 205, 0, 0.78)",
        "rgba(255, 225, 50, 0.75)",
        "rgba(255, 240, 120, 0.7)",
        "rgba(255, 245, 180, 0.65)",
        "rgba(255, 250, 210, 0.6)"
    ];
    else if (safeMarketMood >= 1.85) palette = [
        "rgba(255, 245, 15, 0.9)",
        "rgba(255, 225, 0, 0.85)",
        "rgba(255, 205, 0, 0.8)",
        "rgba(255, 200, 0, 0.78)",
        "rgba(255, 220, 45, 0.75)",
        "rgba(255, 235, 115, 0.7)",
        "rgba(255, 240, 175, 0.65)",
        "rgba(255, 245, 205, 0.6)"
    ];
    else if (safeMarketMood >= 1.8) palette = [
        "rgba(255, 240, 10, 0.9)",
        "rgba(255, 220, 0, 0.85)",
        "rgba(255, 200, 0, 0.8)",
        "rgba(255, 195, 0, 0.78)",
        "rgba(255, 215, 40, 0.75)",
        "rgba(255, 230, 110, 0.7)",
        "rgba(255, 235, 170, 0.65)",
        "rgba(255, 240, 200, 0.6)"
    ];
    else if (safeMarketMood >= 1.75) palette = [
        "rgba(255, 235, 5, 0.9)",
        "rgba(255, 215, 0, 0.85)",
        "rgba(255, 195, 0, 0.8)",
        "rgba(255, 190, 0, 0.78)",
        "rgba(255, 210, 35, 0.75)",
        "rgba(255, 225, 105, 0.7)",
        "rgba(255, 230, 165, 0.65)",
        "rgba(255, 235, 195, 0.6)"
    ];
    else if (safeMarketMood >= 1.7) // Transitions to more orange-gold tones
    palette = [
        "rgba(255, 230, 0, 0.9)",
        "rgba(255, 210, 0, 0.85)",
        "rgba(255, 190, 0, 0.8)",
        "rgba(255, 185, 0, 0.78)",
        "rgba(255, 205, 30, 0.75)",
        "rgba(255, 220, 100, 0.7)",
        "rgba(255, 225, 160, 0.65)",
        "rgba(255, 230, 190, 0.6)"
    ];
    else if (safeMarketMood >= 1.65) palette = [
        "rgba(255, 225, 0, 0.9)",
        "rgba(255, 205, 0, 0.85)",
        "rgba(255, 185, 0, 0.8)",
        "rgba(255, 180, 0, 0.78)",
        "rgba(255, 200, 25, 0.75)",
        "rgba(255, 215, 95, 0.7)",
        "rgba(255, 220, 155, 0.65)",
        "rgba(255, 225, 185, 0.6)"
    ];
    else if (safeMarketMood >= 1.6) palette = [
        "rgba(255, 220, 0, 0.9)",
        "rgba(255, 200, 0, 0.85)",
        "rgba(255, 180, 0, 0.8)",
        "rgba(255, 175, 0, 0.78)",
        "rgba(255, 195, 20, 0.75)",
        "rgba(255, 210, 90, 0.7)",
        "rgba(255, 215, 150, 0.65)",
        "rgba(255, 220, 180, 0.6)"
    ];
    else if (safeMarketMood >= 1.55) palette = [
        "rgba(255, 215, 0, 0.9)",
        "rgba(255, 195, 0, 0.85)",
        "rgba(255, 175, 0, 0.8)",
        "rgba(255, 170, 0, 0.78)",
        "rgba(255, 190, 15, 0.75)",
        "rgba(255, 205, 85, 0.7)",
        "rgba(255, 210, 145, 0.65)",
        "rgba(255, 215, 175, 0.6)"
    ];
    else if (safeMarketMood >= 1.5) palette = [
        "rgba(255, 210, 0, 0.9)",
        "rgba(255, 190, 0, 0.85)",
        "rgba(255, 170, 0, 0.8)",
        "rgba(255, 165, 0, 0.78)",
        "rgba(255, 185, 10, 0.75)",
        "rgba(255, 200, 80, 0.7)",
        "rgba(255, 205, 140, 0.65)",
        "rgba(255, 210, 170, 0.6)"
    ];
    else if (safeMarketMood >= 1.45) palette = [
        "rgba(255, 205, 0, 0.9)",
        "rgba(255, 185, 0, 0.85)",
        "rgba(255, 165, 0, 0.8)",
        "rgba(255, 160, 0, 0.78)",
        "rgba(255, 180, 5, 0.75)",
        "rgba(255, 195, 75, 0.7)",
        "rgba(255, 200, 135, 0.65)",
        "rgba(255, 205, 165, 0.6)"
    ];
    else if (safeMarketMood >= 1.4) palette = [
        "rgba(255, 200, 0, 0.9)",
        "rgba(255, 180, 0, 0.85)",
        "rgba(255, 160, 0, 0.8)",
        "rgba(255, 155, 0, 0.78)",
        "rgba(255, 175, 0, 0.75)",
        "rgba(255, 190, 70, 0.7)",
        "rgba(255, 195, 130, 0.65)",
        "rgba(255, 200, 160, 0.6)"
    ];
    else if (safeMarketMood >= 1.35) palette = [
        "rgba(255, 195, 0, 0.9)",
        "rgba(255, 175, 0, 0.85)",
        "rgba(255, 155, 0, 0.8)",
        "rgba(255, 150, 0, 0.78)",
        "rgba(255, 170, 0, 0.75)",
        "rgba(255, 185, 65, 0.7)",
        "rgba(255, 190, 125, 0.65)",
        "rgba(255, 195, 155, 0.6)"
    ];
    else if (safeMarketMood >= 1.3) palette = [
        "rgba(255, 190, 0, 0.9)",
        "rgba(255, 170, 0, 0.85)",
        "rgba(255, 150, 0, 0.8)",
        "rgba(255, 145, 0, 0.78)",
        "rgba(255, 165, 0, 0.75)",
        "rgba(255, 180, 60, 0.7)",
        "rgba(255, 185, 120, 0.65)",
        "rgba(255, 190, 150, 0.6)"
    ];
    else if (safeMarketMood >= 1.25) palette = [
        "rgba(255, 185, 0, 0.9)",
        "rgba(255, 165, 0, 0.85)",
        "rgba(255, 145, 0, 0.8)",
        "rgba(255, 140, 0, 0.78)",
        "rgba(255, 160, 0, 0.75)",
        "rgba(255, 175, 55, 0.7)",
        "rgba(255, 180, 115, 0.65)",
        "rgba(255, 185, 145, 0.6)"
    ];
    else if (safeMarketMood >= 1.2) palette = [
        "rgba(255, 180, 0, 0.9)",
        "rgba(255, 160, 0, 0.85)",
        "rgba(255, 140, 0, 0.8)",
        "rgba(255, 135, 0, 0.78)",
        "rgba(255, 155, 0, 0.75)",
        "rgba(255, 170, 50, 0.7)",
        "rgba(255, 175, 110, 0.65)",
        "rgba(255, 180, 140, 0.6)"
    ];
    else if (safeMarketMood >= 1.15) palette = [
        "rgba(255, 175, 0, 0.9)",
        "rgba(255, 155, 0, 0.85)",
        "rgba(255, 135, 0, 0.8)",
        "rgba(255, 130, 0, 0.78)",
        "rgba(255, 150, 0, 0.75)",
        "rgba(255, 165, 45, 0.7)",
        "rgba(255, 170, 105, 0.65)",
        "rgba(255, 175, 135, 0.6)"
    ];
    else if (safeMarketMood >= 1.1) palette = [
        "rgba(255, 170, 0, 0.9)",
        "rgba(255, 150, 0, 0.85)",
        "rgba(255, 130, 0, 0.8)",
        "rgba(255, 125, 0, 0.78)",
        "rgba(255, 145, 0, 0.75)",
        "rgba(255, 160, 40, 0.7)",
        "rgba(255, 165, 100, 0.65)",
        "rgba(255, 170, 130, 0.6)"
    ];
    else if (safeMarketMood >= 1.05) palette = [
        "rgba(255, 165, 0, 0.9)",
        "rgba(255, 145, 0, 0.85)",
        "rgba(255, 125, 0, 0.8)",
        "rgba(255, 120, 0, 0.78)",
        "rgba(255, 140, 0, 0.75)",
        "rgba(255, 155, 35, 0.7)",
        "rgba(255, 160, 95, 0.65)",
        "rgba(255, 165, 125, 0.6)"
    ];
    else if (safeMarketMood >= 1.0) palette = [
        "rgba(255, 160, 0, 0.9)",
        "rgba(255, 140, 0, 0.85)",
        "rgba(255, 120, 0, 0.8)",
        "rgba(255, 115, 0, 0.78)",
        "rgba(255, 135, 0, 0.75)",
        "rgba(255, 150, 30, 0.7)",
        "rgba(255, 155, 90, 0.65)",
        "rgba(255, 160, 120, 0.6)"
    ];
    else if (safeMarketMood >= 0.95) // Transition to softer oranges with blue accents beginning
    palette = [
        "rgba(255, 155, 0, 0.9)",
        "rgba(255, 135, 0, 0.85)",
        "rgba(255, 115, 0, 0.8)",
        "rgba(255, 110, 0, 0.78)",
        "rgba(255, 130, 0, 0.75)",
        "rgba(255, 145, 25, 0.7)",
        "rgba(245, 150, 85, 0.65)",
        "rgba(235, 155, 120, 0.6)"
    ];
    else if (safeMarketMood >= 0.9) palette = [
        "rgba(255, 150, 0, 0.9)",
        "rgba(255, 130, 0, 0.85)",
        "rgba(255, 110, 0, 0.8)",
        "rgba(255, 105, 0, 0.78)",
        "rgba(255, 125, 0, 0.75)",
        "rgba(245, 140, 20, 0.7)",
        "rgba(235, 145, 80, 0.65)",
        "rgba(225, 150, 120, 0.6)"
    ];
    else if (safeMarketMood >= 0.85) palette = [
        "rgba(255, 145, 0, 0.9)",
        "rgba(255, 125, 0, 0.85)",
        "rgba(250, 105, 0, 0.8)",
        "rgba(240, 100, 0, 0.78)",
        "rgba(235, 120, 0, 0.75)",
        "rgba(225, 135, 20, 0.7)",
        "rgba(215, 140, 80, 0.65)",
        "rgba(205, 145, 130, 0.6)"
    ];
    else if (safeMarketMood >= 0.8) palette = [
        "rgba(250, 140, 0, 0.9)",
        "rgba(245, 120, 0, 0.85)",
        "rgba(240, 100, 0, 0.8)",
        "rgba(230, 95, 10, 0.78)",
        "rgba(220, 115, 20, 0.75)",
        "rgba(210, 130, 40, 0.7)",
        "rgba(200, 135, 90, 0.65)",
        "rgba(190, 140, 140, 0.6)"
    ];
    else if (safeMarketMood >= 0.75) palette = [
        "rgba(245, 135, 0, 0.9)",
        "rgba(235, 115, 0, 0.85)",
        "rgba(225, 95, 10, 0.8)",
        "rgba(215, 90, 20, 0.78)",
        "rgba(205, 110, 30, 0.75)",
        "rgba(195, 125, 50, 0.7)",
        "rgba(185, 130, 100, 0.65)",
        "rgba(175, 135, 150, 0.6)"
    ];
    else if (safeMarketMood >= 0.7) palette = [
        "rgba(240, 130, 10, 0.9)",
        "rgba(230, 110, 15, 0.85)",
        "rgba(220, 90, 20, 0.8)",
        "rgba(210, 85, 30, 0.78)",
        "rgba(200, 105, 40, 0.75)",
        "rgba(190, 120, 60, 0.7)",
        "rgba(180, 125, 110, 0.65)",
        "rgba(170, 130, 160, 0.6)"
    ];
    else if (safeMarketMood >= 0.65) palette = [
        "rgba(235, 125, 20, 0.9)",
        "rgba(225, 105, 25, 0.85)",
        "rgba(215, 85, 30, 0.8)",
        "rgba(205, 80, 40, 0.78)",
        "rgba(195, 100, 50, 0.75)",
        "rgba(185, 115, 70, 0.7)",
        "rgba(175, 120, 120, 0.65)",
        "rgba(165, 125, 170, 0.6)"
    ];
    else if (safeMarketMood >= 0.6) palette = [
        "rgba(230, 120, 30, 0.9)",
        "rgba(220, 100, 35, 0.85)",
        "rgba(210, 80, 40, 0.8)",
        "rgba(200, 75, 50, 0.78)",
        "rgba(190, 95, 60, 0.75)",
        "rgba(180, 110, 80, 0.7)",
        "rgba(170, 115, 130, 0.65)",
        "rgba(160, 120, 180, 0.6)"
    ];
    else if (safeMarketMood >= 0.55) palette = [
        "rgba(225, 115, 40, 0.9)",
        "rgba(215, 95, 45, 0.85)",
        "rgba(205, 75, 50, 0.8)",
        "rgba(195, 70, 60, 0.78)",
        "rgba(185, 90, 70, 0.75)",
        "rgba(175, 105, 90, 0.7)",
        "rgba(165, 110, 140, 0.65)",
        "rgba(155, 115, 190, 0.6)"
    ];
    else if (safeMarketMood >= 0.5) palette = [
        "rgba(220, 110, 50, 0.9)",
        "rgba(210, 90, 55, 0.85)",
        "rgba(200, 70, 60, 0.8)",
        "rgba(190, 65, 70, 0.78)",
        "rgba(180, 85, 80, 0.75)",
        "rgba(170, 100, 100, 0.7)",
        "rgba(160, 105, 150, 0.65)",
        "rgba(150, 110, 200, 0.6)"
    ];
    else if (safeMarketMood >= 0.45) // Orange fading, blue intensifying
    palette = [
        "rgba(215, 105, 60, 0.9)",
        "rgba(205, 85, 65, 0.85)",
        "rgba(195, 65, 70, 0.8)",
        "rgba(185, 60, 80, 0.78)",
        "rgba(175, 80, 90, 0.75)",
        "rgba(165, 95, 110, 0.7)",
        "rgba(155, 100, 160, 0.65)",
        "rgba(145, 105, 210, 0.6)"
    ];
    else if (safeMarketMood >= 0.4) palette = [
        "rgba(210, 100, 70, 0.9)",
        "rgba(200, 80, 75, 0.85)",
        "rgba(190, 60, 80, 0.8)",
        "rgba(180, 55, 90, 0.78)",
        "rgba(170, 75, 100, 0.75)",
        "rgba(160, 90, 120, 0.7)",
        "rgba(150, 95, 170, 0.65)",
        "rgba(140, 100, 220, 0.6)"
    ];
    else if (safeMarketMood >= 0.35) palette = [
        "rgba(205, 95, 80, 0.9)",
        "rgba(195, 75, 85, 0.85)",
        "rgba(185, 55, 90, 0.8)",
        "rgba(175, 50, 100, 0.78)",
        "rgba(165, 70, 110, 0.75)",
        "rgba(155, 85, 130, 0.7)",
        "rgba(145, 90, 180, 0.65)",
        "rgba(135, 95, 230, 0.6)"
    ];
    else if (safeMarketMood >= 0.3) palette = [
        "rgba(200, 90, 90, 0.9)",
        "rgba(190, 70, 95, 0.85)",
        "rgba(180, 50, 100, 0.8)",
        "rgba(170, 45, 110, 0.78)",
        "rgba(160, 65, 120, 0.75)",
        "rgba(150, 80, 140, 0.7)",
        "rgba(140, 85, 190, 0.65)",
        "rgba(130, 90, 235, 0.6)"
    ];
    else if (safeMarketMood >= 0.25) palette = [
        "rgba(195, 85, 100, 0.9)",
        "rgba(185, 65, 105, 0.85)",
        "rgba(175, 45, 110, 0.8)",
        "rgba(165, 40, 120, 0.78)",
        "rgba(155, 60, 130, 0.75)",
        "rgba(145, 75, 150, 0.7)",
        "rgba(135, 80, 200, 0.65)",
        "rgba(125, 85, 240, 0.6)"
    ];
    else if (safeMarketMood >= 0.2) palette = [
        "rgba(190, 80, 110, 0.9)",
        "rgba(180, 60, 115, 0.85)",
        "rgba(170, 40, 120, 0.8)",
        "rgba(160, 35, 130, 0.78)",
        "rgba(150, 55, 140, 0.75)",
        "rgba(140, 70, 160, 0.7)",
        "rgba(130, 75, 210, 0.65)",
        "rgba(120, 80, 245, 0.6)"
    ];
    else if (safeMarketMood >= 0.15) palette = [
        "rgba(185, 75, 120, 0.9)",
        "rgba(175, 55, 125, 0.85)",
        "rgba(165, 35, 130, 0.8)",
        "rgba(155, 30, 140, 0.78)",
        "rgba(145, 50, 150, 0.75)",
        "rgba(135, 65, 170, 0.7)",
        "rgba(125, 70, 220, 0.65)",
        "rgba(115, 75, 250, 0.6)"
    ];
    else if (safeMarketMood >= 0.1) palette = [
        "rgba(180, 70, 130, 0.9)",
        "rgba(170, 50, 135, 0.85)",
        "rgba(160, 30, 140, 0.8)",
        "rgba(150, 25, 150, 0.78)",
        "rgba(140, 45, 160, 0.75)",
        "rgba(130, 60, 180, 0.7)",
        "rgba(120, 65, 225, 0.65)",
        "rgba(110, 70, 255, 0.6)"
    ];
    else if (safeMarketMood >= 0.05) palette = [
        "rgba(175, 65, 140, 0.9)",
        "rgba(165, 45, 145, 0.85)",
        "rgba(155, 25, 150, 0.8)",
        "rgba(145, 20, 160, 0.78)",
        "rgba(135, 40, 170, 0.75)",
        "rgba(125, 55, 190, 0.7)",
        "rgba(115, 60, 230, 0.65)",
        "rgba(105, 65, 255, 0.6)"
    ];
    else if (safeMarketMood >= 0.0) palette = [
        "rgba(170, 60, 150, 0.9)",
        "rgba(160, 40, 155, 0.85)",
        "rgba(150, 20, 160, 0.8)",
        "rgba(140, 15, 170, 0.78)",
        "rgba(130, 35, 180, 0.75)",
        "rgba(120, 50, 200, 0.7)",
        "rgba(110, 55, 235, 0.65)",
        "rgba(100, 60, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.05) palette = [
        "rgba(160, 50, 165, 0.9)",
        "rgba(150, 35, 170, 0.85)",
        "rgba(140, 15, 175, 0.8)",
        "rgba(130, 10, 180, 0.78)",
        "rgba(120, 30, 190, 0.75)",
        "rgba(110, 45, 210, 0.7)",
        "rgba(100, 50, 240, 0.65)",
        "rgba(90, 55, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.1) palette = [
        "rgba(150, 45, 175, 0.9)",
        "rgba(140, 30, 180, 0.85)",
        "rgba(130, 10, 185, 0.8)",
        "rgba(120, 5, 190, 0.78)",
        "rgba(110, 25, 200, 0.75)",
        "rgba(100, 40, 220, 0.7)",
        "rgba(90, 45, 245, 0.65)",
        "rgba(80, 50, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.15) palette = [
        "rgba(140, 40, 185, 0.9)",
        "rgba(130, 25, 190, 0.85)",
        "rgba(120, 5, 195, 0.8)",
        "rgba(110, 0, 200, 0.78)",
        "rgba(100, 20, 210, 0.75)",
        "rgba(90, 35, 225, 0.7)",
        "rgba(80, 40, 245, 0.65)",
        "rgba(70, 45, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.2) palette = [
        "rgba(130, 35, 195, 0.9)",
        "rgba(120, 20, 200, 0.85)",
        "rgba(110, 0, 205, 0.8)",
        "rgba(100, 0, 210, 0.78)",
        "rgba(90, 15, 215, 0.75)",
        "rgba(80, 30, 230, 0.7)",
        "rgba(70, 35, 245, 0.65)",
        "rgba(60, 40, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.25) palette = [
        "rgba(120, 30, 205, 0.9)",
        "rgba(110, 15, 210, 0.85)",
        "rgba(100, 0, 215, 0.8)",
        "rgba(90, 0, 220, 0.78)",
        "rgba(80, 10, 225, 0.75)",
        "rgba(70, 25, 235, 0.7)",
        "rgba(60, 30, 245, 0.65)",
        "rgba(50, 35, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.3) palette = [
        "rgba(110, 25, 215, 0.9)",
        "rgba(100, 10, 220, 0.85)",
        "rgba(90, 0, 225, 0.8)",
        "rgba(80, 0, 230, 0.78)",
        "rgba(70, 5, 235, 0.75)",
        "rgba(60, 20, 240, 0.7)",
        "rgba(50, 25, 245, 0.65)",
        "rgba(40, 30, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.35) palette = [
        "rgba(100, 20, 225, 0.9)",
        "rgba(90, 5, 230, 0.85)",
        "rgba(80, 0, 235, 0.8)",
        "rgba(70, 0, 240, 0.78)",
        "rgba(60, 0, 245, 0.75)",
        "rgba(50, 15, 245, 0.7)",
        "rgba(40, 20, 250, 0.65)",
        "rgba(30, 25, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.4) palette = [
        "rgba(90, 15, 230, 0.9)",
        "rgba(80, 0, 235, 0.85)",
        "rgba(70, 0, 240, 0.8)",
        "rgba(60, 0, 245, 0.78)",
        "rgba(50, 0, 250, 0.75)",
        "rgba(40, 10, 250, 0.7)",
        "rgba(30, 15, 252, 0.65)",
        "rgba(20, 20, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.45) palette = [
        "rgba(80, 10, 235, 0.9)",
        "rgba(70, 0, 240, 0.85)",
        "rgba(60, 0, 245, 0.8)",
        "rgba(50, 0, 250, 0.78)",
        "rgba(40, 0, 252, 0.75)",
        "rgba(30, 5, 254, 0.7)",
        "rgba(20, 10, 255, 0.65)",
        "rgba(10, 15, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.5) palette = [
        "rgba(70, 5, 240, 0.9)",
        "rgba(60, 0, 245, 0.85)",
        "rgba(50, 0, 250, 0.8)",
        "rgba(40, 0, 252, 0.78)",
        "rgba(30, 0, 254, 0.75)",
        "rgba(20, 0, 255, 0.7)",
        "rgba(10, 5, 255, 0.65)",
        "rgba(0, 10, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.6) palette = [
        "rgba(60, 0, 245, 0.9)",
        "rgba(50, 0, 250, 0.85)",
        "rgba(40, 0, 252, 0.8)",
        "rgba(30, 0, 254, 0.78)",
        "rgba(20, 0, 255, 0.75)",
        "rgba(10, 0, 255, 0.7)",
        "rgba(5, 0, 255, 0.65)",
        "rgba(0, 0, 255, 0.6)"
    ];
    else if (safeMarketMood >= -0.7) palette = [
        "rgba(50, 0, 240, 0.9)",
        "rgba(40, 0, 245, 0.85)",
        "rgba(30, 0, 250, 0.8)",
        "rgba(20, 0, 252, 0.78)",
        "rgba(10, 0, 255, 0.75)",
        "rgba(5, 0, 255, 0.7)",
        "rgba(0, 0, 255, 0.65)",
        "rgba(0, 10, 230, 0.6)"
    ];
    else if (safeMarketMood >= -0.8) palette = [
        "rgba(40, 0, 235, 0.9)",
        "rgba(30, 0, 240, 0.85)",
        "rgba(20, 0, 245, 0.8)",
        "rgba(10, 0, 250, 0.78)",
        "rgba(5, 0, 255, 0.75)",
        "rgba(0, 0, 255, 0.7)",
        "rgba(0, 10, 230, 0.65)",
        "rgba(0, 20, 210, 0.6)"
    ];
    else if (safeMarketMood >= -0.9) palette = [
        "rgba(30, 0, 230, 0.9)",
        "rgba(20, 0, 235, 0.85)",
        "rgba(10, 0, 240, 0.8)",
        "rgba(5, 0, 245, 0.78)",
        "rgba(0, 0, 250, 0.75)",
        "rgba(0, 10, 230, 0.7)",
        "rgba(0, 20, 210, 0.65)",
        "rgba(0, 30, 190, 0.6)"
    ];
    else if (safeMarketMood >= -1) palette = [
        "rgba(20, 0, 225, 0.95)",
        "rgba(10, 0, 230, 0.9)",
        "rgba(5, 0, 235, 0.85)",
        "rgba(0, 0, 240, 0.8)",
        "rgba(0, 5, 230, 0.75)",
        "rgba(0, 15, 210, 0.7)",
        "rgba(0, 25, 190, 0.65)",
        "rgba(0, 35, 170, 0.6)"
    ];
    else if (safeMarketMood >= -1.1) palette = [
        "rgba(18, 0, 222, 0.95)",
        "rgba(8, 0, 227, 0.9)",
        "rgba(3, 0, 232, 0.85)",
        "rgba(0, 0, 237, 0.8)",
        "rgba(0, 8, 227, 0.75)",
        "rgba(0, 18, 207, 0.7)",
        "rgba(0, 28, 187, 0.65)",
        "rgba(0, 38, 167, 0.6)"
    ];
    else if (safeMarketMood >= -1.2) palette = [
        "rgba(15, 0, 220, 0.95)",
        "rgba(5, 0, 225, 0.9)",
        "rgba(0, 0, 230, 0.85)",
        "rgba(0, 5, 235, 0.8)",
        "rgba(0, 15, 220, 0.75)",
        "rgba(0, 25, 200, 0.7)",
        "rgba(0, 35, 180, 0.65)",
        "rgba(0, 45, 160, 0.6)"
    ];
    else if (safeMarketMood >= -1.3) palette = [
        "rgba(10, 0, 218, 0.95)",
        "rgba(5, 0, 223, 0.9)",
        "rgba(0, 0, 228, 0.85)",
        "rgba(0, 8, 233, 0.8)",
        "rgba(0, 18, 218, 0.75)",
        "rgba(0, 28, 198, 0.7)",
        "rgba(0, 38, 178, 0.65)",
        "rgba(0, 48, 158, 0.6)"
    ];
    else if (safeMarketMood >= -1.4) palette = [
        "rgba(8, 0, 216, 0.95)",
        "rgba(3, 0, 221, 0.9)",
        "rgba(0, 0, 226, 0.85)",
        "rgba(0, 10, 231, 0.8)",
        "rgba(0, 20, 216, 0.75)",
        "rgba(0, 30, 196, 0.7)",
        "rgba(0, 40, 176, 0.65)",
        "rgba(0, 50, 156, 0.6)"
    ];
    else if (safeMarketMood >= -1.5) palette = [
        "rgba(5, 0, 214, 0.95)",
        "rgba(0, 0, 219, 0.9)",
        "rgba(0, 5, 224, 0.85)",
        "rgba(0, 15, 229, 0.8)",
        "rgba(0, 25, 214, 0.75)",
        "rgba(0, 35, 194, 0.7)",
        "rgba(0, 45, 174, 0.65)",
        "rgba(0, 55, 154, 0.6)"
    ];
    else if (safeMarketMood >= -1.6) palette = [
        "rgba(3, 0, 212, 0.95)",
        "rgba(0, 0, 217, 0.9)",
        "rgba(0, 8, 222, 0.85)",
        "rgba(0, 18, 227, 0.8)",
        "rgba(0, 28, 212, 0.75)",
        "rgba(0, 38, 192, 0.7)",
        "rgba(0, 48, 172, 0.65)",
        "rgba(0, 58, 152, 0.6)"
    ];
    else if (safeMarketMood >= -1.7) palette = [
        "rgba(0, 0, 210, 0.95)",
        "rgba(0, 5, 215, 0.9)",
        "rgba(0, 10, 220, 0.85)",
        "rgba(0, 20, 225, 0.8)",
        "rgba(0, 30, 210, 0.75)",
        "rgba(0, 40, 190, 0.7)",
        "rgba(0, 50, 170, 0.65)",
        "rgba(0, 60, 150, 0.6)"
    ];
    else if (safeMarketMood >= -1.8) palette = [
        "rgba(0, 0, 208, 0.95)",
        "rgba(0, 8, 213, 0.9)",
        "rgba(0, 15, 218, 0.85)",
        "rgba(0, 25, 223, 0.8)",
        "rgba(0, 35, 208, 0.75)",
        "rgba(0, 45, 188, 0.7)",
        "rgba(0, 55, 168, 0.65)",
        "rgba(0, 65, 148, 0.6)"
    ];
    else if (safeMarketMood >= -1.9) palette = [
        "rgba(0, 0, 205, 0.95)",
        "rgba(0, 10, 210, 0.9)",
        "rgba(0, 20, 215, 0.85)",
        "rgba(0, 30, 220, 0.8)",
        "rgba(0, 40, 205, 0.75)",
        "rgba(0, 50, 185, 0.7)",
        "rgba(0, 60, 165, 0.65)",
        "rgba(0, 70, 145, 0.6)"
    ];
    else if (safeMarketMood >= -2) palette = [
        "rgba(0, 0, 200, 0.95)",
        "rgba(0, 15, 205, 0.9)",
        "rgba(0, 25, 210, 0.85)",
        "rgba(0, 35, 215, 0.8)",
        "rgba(0, 45, 200, 0.75)",
        "rgba(0, 55, 180, 0.7)",
        "rgba(0, 65, 160, 0.65)",
        "rgba(0, 75, 140, 0.6)"
    ];
    else if (safeMarketMood >= -2.1) palette = [
        "rgba(0, 5, 195, 0.95)",
        "rgba(0, 20, 200, 0.9)",
        "rgba(0, 30, 205, 0.85)",
        "rgba(0, 40, 210, 0.8)",
        "rgba(0, 50, 195, 0.75)",
        "rgba(0, 60, 175, 0.7)",
        "rgba(0, 70, 155, 0.65)",
        "rgba(0, 80, 135, 0.6)"
    ];
    else if (safeMarketMood >= -2.2) palette = [
        "rgba(0, 10, 190, 0.95)",
        "rgba(0, 25, 195, 0.9)",
        "rgba(0, 35, 200, 0.85)",
        "rgba(0, 45, 205, 0.8)",
        "rgba(0, 55, 190, 0.75)",
        "rgba(0, 65, 170, 0.7)",
        "rgba(0, 75, 150, 0.65)",
        "rgba(0, 85, 130, 0.6)"
    ];
    else if (safeMarketMood >= -2.3) palette = [
        "rgba(0, 15, 185, 0.95)",
        "rgba(0, 30, 190, 0.9)",
        "rgba(0, 40, 195, 0.85)",
        "rgba(0, 50, 200, 0.8)",
        "rgba(0, 60, 185, 0.75)",
        "rgba(0, 70, 165, 0.7)",
        "rgba(0, 80, 145, 0.65)",
        "rgba(0, 90, 125, 0.6)"
    ];
    else if (safeMarketMood >= -2.4) palette = [
        "rgba(0, 20, 180, 0.95)",
        "rgba(0, 35, 185, 0.9)",
        "rgba(0, 45, 190, 0.85)",
        "rgba(0, 55, 195, 0.8)",
        "rgba(0, 65, 180, 0.75)",
        "rgba(0, 75, 160, 0.7)",
        "rgba(0, 85, 140, 0.65)",
        "rgba(0, 95, 120, 0.6)"
    ];
    else if (safeMarketMood >= -2.5) palette = [
        "rgba(0, 25, 175, 0.95)",
        "rgba(0, 40, 180, 0.9)",
        "rgba(0, 50, 185, 0.85)",
        "rgba(0, 60, 190, 0.8)",
        "rgba(0, 70, 175, 0.75)",
        "rgba(0, 80, 155, 0.7)",
        "rgba(0, 90, 135, 0.65)",
        "rgba(0, 100, 115, 0.6)"
    ];
    else if (safeMarketMood >= -2.6) palette = [
        "rgba(0, 30, 170, 0.95)",
        "rgba(0, 45, 175, 0.9)",
        "rgba(0, 55, 180, 0.85)",
        "rgba(0, 65, 185, 0.8)",
        "rgba(0, 75, 170, 0.75)",
        "rgba(0, 85, 150, 0.7)",
        "rgba(0, 95, 130, 0.65)",
        "rgba(0, 105, 110, 0.6)"
    ];
    else if (safeMarketMood >= -2.7) palette = [
        "rgba(0, 35, 165, 0.95)",
        "rgba(0, 50, 170, 0.9)",
        "rgba(0, 60, 175, 0.85)",
        "rgba(0, 70, 180, 0.8)",
        "rgba(0, 80, 165, 0.75)",
        "rgba(0, 90, 145, 0.7)",
        "rgba(0, 100, 125, 0.65)",
        "rgba(0, 110, 105, 0.6)"
    ];
    else if (safeMarketMood >= -2.8) palette = [
        "rgba(0, 40, 160, 0.95)",
        "rgba(0, 55, 165, 0.9)",
        "rgba(0, 65, 170, 0.85)",
        "rgba(0, 75, 175, 0.8)",
        "rgba(0, 85, 160, 0.75)",
        "rgba(0, 95, 140, 0.7)",
        "rgba(0, 105, 120, 0.65)",
        "rgba(0, 115, 100, 0.6)"
    ];
    else if (safeMarketMood >= -2.9) palette = [
        "rgba(0, 45, 155, 0.95)",
        "rgba(0, 60, 160, 0.9)",
        "rgba(0, 70, 165, 0.85)",
        "rgba(0, 80, 170, 0.8)",
        "rgba(0, 90, 155, 0.75)",
        "rgba(0, 100, 135, 0.7)",
        "rgba(0, 110, 115, 0.65)",
        "rgba(0, 120, 95, 0.6)"
    ];
    else if (safeMarketMood >= -3) palette = [
        "rgba(0, 50, 150, 0.95)",
        "rgba(0, 65, 155, 0.9)",
        "rgba(0, 75, 160, 0.85)",
        "rgba(0, 85, 165, 0.8)",
        "rgba(0, 95, 150, 0.75)",
        "rgba(0, 105, 130, 0.7)",
        "rgba(0, 115, 110, 0.65)",
        "rgba(0, 125, 90, 0.6)"
    ];
    else if (safeMarketMood >= -3.1) palette = [
        "rgba(0, 55, 145, 0.95)",
        "rgba(0, 70, 150, 0.9)",
        "rgba(0, 80, 155, 0.85)",
        "rgba(0, 90, 160, 0.8)",
        "rgba(0, 100, 145, 0.75)",
        "rgba(0, 110, 125, 0.7)",
        "rgba(0, 120, 105, 0.65)",
        "rgba(0, 130, 85, 0.6)"
    ];
    else if (safeMarketMood >= -3.2) palette = [
        "rgba(0, 60, 140, 0.95)",
        "rgba(0, 75, 145, 0.9)",
        "rgba(0, 85, 150, 0.85)",
        "rgba(0, 95, 155, 0.8)",
        "rgba(0, 105, 140, 0.75)",
        "rgba(0, 115, 120, 0.7)",
        "rgba(0, 125, 100, 0.65)",
        "rgba(0, 135, 80, 0.6)"
    ];
    else if (safeMarketMood >= -3.3) palette = [
        "rgba(0, 65, 135, 0.95)",
        "rgba(0, 80, 140, 0.9)",
        "rgba(0, 90, 145, 0.85)",
        "rgba(0, 100, 150, 0.8)",
        "rgba(0, 110, 135, 0.75)",
        "rgba(0, 120, 115, 0.7)",
        "rgba(0, 130, 95, 0.65)",
        "rgba(0, 140, 75, 0.6)"
    ];
    else if (safeMarketMood >= -3.4) palette = [
        "rgba(0, 70, 130, 0.95)",
        "rgba(0, 85, 135, 0.9)",
        "rgba(0, 95, 140, 0.85)",
        "rgba(0, 105, 145, 0.8)",
        "rgba(0, 115, 130, 0.75)",
        "rgba(0, 125, 110, 0.7)",
        "rgba(0, 135, 90, 0.65)",
        "rgba(0, 145, 70, 0.6)"
    ];
    else if (safeMarketMood >= -3.5) palette = [
        "rgba(0, 75, 125, 0.95)",
        "rgba(0, 90, 130, 0.9)",
        "rgba(0, 100, 135, 0.85)",
        "rgba(0, 110, 140, 0.8)",
        "rgba(0, 120, 125, 0.75)",
        "rgba(0, 130, 105, 0.7)",
        "rgba(0, 140, 85, 0.65)",
        "rgba(0, 150, 65, 0.6)"
    ];
    else if (safeMarketMood >= -3.6) palette = [
        "rgba(0, 80, 120, 0.95)",
        "rgba(0, 95, 125, 0.9)",
        "rgba(0, 105, 130, 0.85)",
        "rgba(0, 115, 135, 0.8)",
        "rgba(0, 125, 120, 0.75)",
        "rgba(0, 135, 100, 0.7)",
        "rgba(0, 145, 80, 0.65)",
        "rgba(0, 155, 60, 0.6)"
    ];
    else if (safeMarketMood >= -3.7) palette = [
        "rgba(0, 85, 115, 0.95)",
        "rgba(0, 100, 120, 0.9)",
        "rgba(0, 110, 125, 0.85)",
        "rgba(0, 120, 130, 0.8)",
        "rgba(0, 130, 115, 0.75)",
        "rgba(0, 140, 95, 0.7)",
        "rgba(0, 150, 75, 0.65)",
        "rgba(0, 160, 55, 0.6)"
    ];
    else if (safeMarketMood >= -3.8) palette = [
        "rgba(0, 90, 110, 0.95)",
        "rgba(0, 105, 115, 0.9)",
        "rgba(0, 115, 120, 0.85)",
        "rgba(0, 125, 125, 0.8)",
        "rgba(0, 135, 110, 0.75)",
        "rgba(0, 145, 90, 0.7)",
        "rgba(0, 155, 70, 0.65)",
        "rgba(0, 165, 50, 0.6)"
    ];
    else if (safeMarketMood >= -3.9) palette = [
        "rgba(0, 95, 105, 0.95)",
        "rgba(0, 110, 110, 0.9)",
        "rgba(0, 120, 115, 0.85)",
        "rgba(0, 130, 120, 0.8)",
        "rgba(0, 140, 105, 0.75)",
        "rgba(0, 150, 85, 0.7)",
        "rgba(0, 160, 65, 0.65)",
        "rgba(0, 170, 45, 0.6)"
    ];
    else if (safeMarketMood >= -4) palette = [
        "rgba(0, 100, 100, 0.95)",
        "rgba(0, 115, 105, 0.9)",
        "rgba(0, 125, 110, 0.85)",
        "rgba(0, 135, 115, 0.8)",
        "rgba(0, 145, 100, 0.75)",
        "rgba(0, 155, 80, 0.7)",
        "rgba(0, 165, 60, 0.65)",
        "rgba(0, 175, 40, 0.6)"
    ];
    else if (safeMarketMood >= -4.1) palette = [
        "rgba(0, 105, 95, 0.95)",
        "rgba(0, 120, 100, 0.9)",
        "rgba(0, 130, 105, 0.85)",
        "rgba(0, 140, 110, 0.8)",
        "rgba(0, 150, 95, 0.75)",
        "rgba(0, 160, 75, 0.7)",
        "rgba(0, 170, 55, 0.65)",
        "rgba(0, 180, 35, 0.6)"
    ];
    else if (safeMarketMood >= -4.2) palette = [
        "rgba(0, 110, 90, 0.95)",
        "rgba(0, 125, 95, 0.9)",
        "rgba(0, 135, 100, 0.85)",
        "rgba(0, 145, 105, 0.8)",
        "rgba(0, 155, 90, 0.75)",
        "rgba(0, 165, 70, 0.7)",
        "rgba(0, 175, 50, 0.65)",
        "rgba(0, 185, 30, 0.6)"
    ];
    else if (safeMarketMood >= -4.3) palette = [
        "rgba(0, 115, 85, 0.95)",
        "rgba(0, 130, 90, 0.9)",
        "rgba(0, 140, 95, 0.85)",
        "rgba(0, 150, 100, 0.8)",
        "rgba(0, 160, 85, 0.75)",
        "rgba(0, 170, 65, 0.7)",
        "rgba(0, 180, 45, 0.65)",
        "rgba(0, 190, 25, 0.6)"
    ];
    else if (safeMarketMood >= -4.4) palette = [
        "rgba(0, 120, 80, 0.95)",
        "rgba(0, 135, 85, 0.9)",
        "rgba(0, 145, 90, 0.85)",
        "rgba(0, 155, 95, 0.8)",
        "rgba(0, 165, 80, 0.75)",
        "rgba(0, 175, 60, 0.7)",
        "rgba(0, 185, 40, 0.65)",
        "rgba(0, 195, 20, 0.6)"
    ];
    else if (safeMarketMood >= -4.5) palette = [
        "rgba(0, 125, 75, 0.95)",
        "rgba(0, 140, 80, 0.9)",
        "rgba(0, 150, 85, 0.85)",
        "rgba(0, 160, 90, 0.8)",
        "rgba(0, 170, 75, 0.75)",
        "rgba(0, 180, 55, 0.7)",
        "rgba(0, 190, 35, 0.65)",
        "rgba(0, 200, 15, 0.6)"
    ];
    else if (safeMarketMood >= -4.6) palette = [
        "rgba(0, 130, 70, 0.95)",
        "rgba(0, 145, 75, 0.9)",
        "rgba(0, 155, 80, 0.85)",
        "rgba(0, 165, 85, 0.8)",
        "rgba(0, 175, 70, 0.75)",
        "rgba(0, 185, 50, 0.7)",
        "rgba(0, 195, 30, 0.65)",
        "rgba(0, 205, 10, 0.6)"
    ];
    else if (safeMarketMood >= -4.7) palette = [
        "rgba(0, 135, 65, 0.95)",
        "rgba(0, 150, 70, 0.9)",
        "rgba(0, 160, 75, 0.85)",
        "rgba(0, 170, 80, 0.8)",
        "rgba(0, 180, 65, 0.75)",
        "rgba(0, 190, 45, 0.7)",
        "rgba(0, 200, 25, 0.65)",
        "rgba(0, 210, 5, 0.6)"
    ];
    else if (safeMarketMood >= -4.8) palette = [
        "rgba(0, 140, 60, 0.95)",
        "rgba(0, 155, 65, 0.9)",
        "rgba(0, 165, 70, 0.85)",
        "rgba(0, 175, 75, 0.8)",
        "rgba(0, 185, 60, 0.75)",
        "rgba(0, 195, 40, 0.7)",
        "rgba(0, 205, 20, 0.65)",
        "rgba(0, 215, 0, 0.6)"
    ];
    else if (safeMarketMood >= -4.9) palette = [
        "rgba(0, 145, 55, 0.95)",
        "rgba(0, 160, 60, 0.9)",
        "rgba(0, 170, 65, 0.85)",
        "rgba(0, 180, 70, 0.8)",
        "rgba(0, 190, 55, 0.75)",
        "rgba(0, 200, 35, 0.7)",
        "rgba(0, 210, 15, 0.65)",
        "rgba(0, 220, 0, 0.6)"
    ];
    else if (safeMarketMood >= -5) palette = [
        "rgba(0, 150, 50, 0.95)",
        "rgba(0, 165, 55, 0.9)",
        "rgba(0, 175, 60, 0.85)",
        "rgba(0, 185, 65, 0.8)",
        "rgba(0, 195, 50, 0.75)",
        "rgba(0, 205, 30, 0.7)",
        "rgba(0, 215, 10, 0.65)",
        "rgba(0, 225, 0, 0.6)"
    ];
    // ---- Enhanced user mood intensity impact on palette ----
    // User mood now has more influence on the palette colors
    const userInfluence = Math.abs(userMood) / 2; // Scale to half the maximum influence
    if (userMood > 0) // For positive user mood: Brighten and shift toward yellows/oranges
    palette = palette.map((color)=>{
        let rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
        if (!rgbaMatch) return color;
        let r = parseInt(rgbaMatch[1]);
        let g = parseInt(rgbaMatch[2]);
        let b = parseInt(rgbaMatch[3]);
        let a = parseFloat(rgbaMatch[4]);
        // Brighten reds and greens more than blues for a warmer tone
        r = Math.min(255, r + Math.round(userInfluence * 30));
        g = Math.min(255, g + Math.round(userInfluence * 25));
        b = Math.min(255, b + Math.round(userInfluence * 10));
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    });
    else if (userMood < 0) // For negative user mood: Deepen and shift toward blues/purples
    palette = palette.map((color)=>{
        let rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
        if (!rgbaMatch) return color;
        let r = parseInt(rgbaMatch[1]);
        let g = parseInt(rgbaMatch[2]);
        let b = parseInt(rgbaMatch[3]);
        let a = parseFloat(rgbaMatch[4]);
        // Increase blues, decrease reds and greens for a cooler tone
        r = Math.max(0, r - Math.round(userInfluence * 20));
        g = Math.max(0, g - Math.round(userInfluence * 15));
        b = Math.min(255, b + Math.round(userInfluence * 30));
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    });
    // ---- Market-User Mood Relationship ----
    // Add special coloration for situations where market and user moods diverge significantly
    const moodDivergence = marketMood * userMood;
    if (moodDivergence < -1) {
        // Strong negative correlation (user and market in opposite directions)
        // Add contrasting highlights to the palette
        const contrastColor = userMood > 0 ? "rgba(255, 255, 50, 0.7)" // Bright yellow highlight if user is positive
         : "rgba(50, 50, 255, 0.7)"; // Bright blue highlight if user is negative
        palette.push(contrastColor);
    }
    return palette;
}
// Helper functions for color manipulation
function $895d6185463ab8db$var$lightenColor(color, percent) {
    let rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
    if (!rgbaMatch) return color;
    let r = parseInt(rgbaMatch[1]);
    let g = parseInt(rgbaMatch[2]);
    let b = parseInt(rgbaMatch[3]);
    let a = parseFloat(rgbaMatch[4]);
    r = Math.min(255, r + Math.round(2.55 * percent));
    g = Math.min(255, g + Math.round(2.55 * percent));
    b = Math.min(255, b + Math.round(2.55 * percent));
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
function $895d6185463ab8db$var$darkenColor(color, percent) {
    let rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
    if (!rgbaMatch) return color;
    let r = parseInt(rgbaMatch[1]);
    let g = parseInt(rgbaMatch[2]);
    let b = parseInt(rgbaMatch[3]);
    let a = parseFloat(rgbaMatch[4]);
    r = Math.max(0, r - Math.round(2.55 * percent));
    g = Math.max(0, g - Math.round(2.55 * percent));
    b = Math.max(0, b - Math.round(2.55 * percent));
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
function $895d6185463ab8db$var$startMoodUpdates(interval = 10000) {
    if ($895d6185463ab8db$var$updateTimer) clearInterval($895d6185463ab8db$var$updateTimer);
    console.log(`\u{1F504} Starting mood update timer with interval: ${interval}ms`);
    // Run immediately
    $895d6185463ab8db$var$initMoodPage();
    // Then set interval
    $895d6185463ab8db$var$updateTimer = setInterval(async ()=>{
        console.log("\uD83D\uDD04 Periodic update of mood data...");
        await $895d6185463ab8db$var$initMoodPage();
    }, interval);
}
function $895d6185463ab8db$var$calculateUserMood() {
    // Get 5 most recent transactions from moodHistory
    const recentHistory = [
        ...moodHistory
    ].sort((a, b)=>new Date(b.timestamp) - new Date(a.timestamp)).slice(0, 5);
    // Apply weighted calculation - most recent has more impact
    let weightedMood = 0;
    let totalWeight = 0;
    recentHistory.forEach((entry, index)=>{
        const weight = 5 - index; // 5 for most recent, 1 for oldest
        const entryMood = (entry.positiveImpact || 0) - (entry.negativeImpact || 0);
        weightedMood += entryMood * weight;
        totalWeight += weight;
    });
    return totalWeight > 0 ? weightedMood / totalWeight : 0;
}
document.addEventListener("DOMContentLoaded", async ()=>{
    // mood.js is pulled into every page's bundle (socketU imports
    // showMoodAnalysisPopup), so only initialize on the actual mood board page —
    // otherwise the "Session ID is missing" toast flashes on index/login.
    if (!document.getElementById("moodScoresContainer")) return;
    try {
        console.log("\uD83D\uDE80 Initializing mood interface...");
        $895d6185463ab8db$var$sessionId = localStorage.getItem("sessionId");
        if (!$895d6185463ab8db$var$sessionId) {
            console.error("\u274C No session ID found in localStorage.");
            $895d6185463ab8db$var$showNotification("Session ID is missing. Please log in.", false);
            return;
        }
        if (!$895d6185463ab8db$var$moodSocket || !(typeof $895d6185463ab8db$var$moodSocket.connected !== 'undefined' && $895d6185463ab8db$var$moodSocket.connected || typeof $895d6185463ab8db$var$moodSocket.readyState !== 'undefined' && $895d6185463ab8db$var$moodSocket.readyState === WebSocket.OPEN)) {
            console.log("\uD83D\uDD0C Establishing WebSocket connection...");
            $895d6185463ab8db$var$connectMoodSocket();
        }
        await $895d6185463ab8db$var$loadP5();
        await $895d6185463ab8db$var$initMoodPage();
        // Initialize visualization
        $895d6185463ab8db$var$initP5Sketch();
        // Test the burst functionality after initialization
        setTimeout(()=>{
            console.log("\uD83E\uDDEA Testing burst mechanism...");
            $895d6185463ab8db$export$f41080da4e2fdf9f(3.5); // Test with a strong positive mood
        }, 3000);
        // Start periodic data updates
        $895d6185463ab8db$var$startMoodUpdates(15000);
        console.log("\u2705 Mood interface initialization complete");
    } catch (error) {
        console.error("\u274C Error during initialization:", error);
        $895d6185463ab8db$var$showNotification("Error initializing mood display. Using fallback data.", false);
        // Use fallback data
        const fallbackData = $895d6185463ab8db$var$generateFallbackMoodData();
        $895d6185463ab8db$var$userMoodScore = fallbackData.userMood.averageMood * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        $895d6185463ab8db$var$marketMoodScore = fallbackData.marketMood.averageMood * $895d6185463ab8db$var$MOOD_AMPLIFICATION_FACTOR;
        $895d6185463ab8db$var$displayMoodScores();
        $895d6185463ab8db$var$initP5Sketch();
        // Start updates with longer interval when in fallback mode
        $895d6185463ab8db$var$startMoodUpdates(30000);
    }
});
// Add a debug flag to globals to allow manual burst triggering from console
window.debugMood = {
    triggerBurst: (score)=>{
        console.log("\uD83D\uDD27 Manual burst triggered with score:", score);
        $895d6185463ab8db$export$f41080da4e2fdf9f(score || 4);
    },
    checkSocket: ()=>{
        console.log("\uD83D\uDD0C Socket status:", socket ? socket.connected ? "Connected \u2705" : "Disconnected \u274C" : "Not initialized \u26A0\uFE0F");
        return socket;
    },
    listenerTest: ()=>{
        // Test if the transactionBurst listener exists
        const hasListener = socket && socket._callbacks && socket._callbacks['$transactionBurst'] && socket._callbacks['$transactionBurst'].length > 0;
        console.log("\uD83D\uDD08 Transaction burst listener:", hasListener ? "Active \u2705" : "Not found \u274C");
        // If no listener, try to set it up
        if (!hasListener && socket) {
            console.log("\uD83D\uDD04 Attempting to re-establish burst listener");
            $895d6185463ab8db$var$setupBurstListener();
        }
        return hasListener;
    }
};
// --- Redirect guard: only forward from stockTransaction.html
window.isOn ||= (file)=>location.pathname.endsWith(`/${file}`) || location.pathname.endsWith(file);
// See stockTrade.js for both of these: zxHome is the per-tab backstop under
// every return path, zxTakeReturn is the explicit hand-off marker. Kept
// identical across all three definitions of this guard.
window.zxHome ||= ()=>{
    try {
        return sessionStorage.getItem('zxHome');
    } catch (_) {
        return null;
    }
};
window.zxTakeReturn ||= ()=>{
    const target = localStorage.getItem('zxReturnTo');
    if (!target) return window.zxHome?.() || 'zfloor.html';
    localStorage.removeItem('zxReturnTo');
    return target;
};
window.shouldRedirectToMarket ||= ()=>window.isOn('stockTransaction.html') || window.isOn('transaction.html') && !!localStorage.getItem('zxReturnTo');
window.doMarketRedirectIfNeeded ||= ()=>{
    if (window.shouldRedirectToMarket()) window.location.href = window.zxTakeReturn();
};
// Helper to show notifications
function $895d6185463ab8db$var$showNotification(message, isSuccess = true) {
    console.log(`${isSuccess ? "\u2705" : "\u274C"} ${message}`);
    // Create or get notification element
    let notificationElement = document.getElementById('moodNotification');
    if (!notificationElement) {
        notificationElement = document.createElement('div');
        notificationElement.id = 'moodNotification';
        Object.assign(notificationElement.style, {
            position: 'fixed',
            top: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '8px 16px',
            borderRadius: '3px',
            fontSize: '14px',
            fontFamily: 'sans-serif',
            zIndex: '10001',
            opacity: '0',
            transition: 'opacity 0.3s ease'
        });
        document.body.appendChild(notificationElement);
    }
    // Set styles based on success/error
    Object.assign(notificationElement.style, {
        backgroundColor: isSuccess ? 'rgba(76, 175, 80, 0.9)' : 'rgba(244, 67, 54, 0.9)',
        color: 'white',
        boxShadow: `0 2px 10px ${isSuccess ? 'rgba(76, 175, 80, 0.5)' : 'rgba(244, 67, 54, 0.5)'}`
    });
    notificationElement.textContent = message;
    notificationElement.style.opacity = '1';
    // Hide after 4 seconds
    setTimeout(()=>{
        notificationElement.style.opacity = '0';
    }, 4000);
}
function $895d6185463ab8db$export$8a958c527fd8c83f(analysis) {
    console.log("\uD83D\uDCCC showMoodAnalysisPopup called with:", analysis);
    // The 3D floor renders the market's verdict as a comment docked in the room
    // rather than as this full-screen hologram (zfloor.js installs
    // window.zxMarketComment). Same call site, different aesthetic — exactly the
    // arrangement showNotification/zxNotify already uses for the LED ticker.
    //
    // The delegation lives HERE, at the one exported entry point, and not at each
    // caller: five call sites reach this function and two of them are the SELLER's
    // side in socketU (bidAcceptSuccess / bidDeclineSuccess). Those fire on
    // whatever page the seller happens to be on, so a floor-side check in only the
    // buyer's path would still throw the modal over the floor for whoever accepted.
    if (typeof window !== 'undefined' && typeof window.zxMarketComment === 'function') return window.zxMarketComment(analysis);
    if (!analysis || !analysis.analysisTitle) {
        console.error("\u274C Invalid analysis data:", analysis);
        return;
    }
    // ---- Pick main commentary safely ----
    const marketText = (analysis.marketCommentary || "").trim();
    const summaryText = (analysis.analysisSummary || "").trim();
    const detailsText = (analysis.detailedDiscussion || "").trim();
    let primaryText = marketText || summaryText || detailsText || "No analysis available.";
    const hasDistinctSummary = summaryText && summaryText !== primaryText;
    const hasDistinctDetails = detailsText && detailsText !== primaryText;
    const onlyOneSection = !hasDistinctSummary && !hasDistinctDetails;
    // ---- Smoky hologram palette (layered, dark, neon-friendly) ----
    const HOLOGRAM_BACKGROUNDS = [
        `
	  radial-gradient(1200px 600px at -10% -20%, rgba(0,255,255,0.14), transparent 60%),
	  radial-gradient(900px 500px  at 120% 130%, rgba(255,0,160,0.12), transparent 60%),
	  radial-gradient(700px 400px  at 100% -10%, rgba(0,200,255,0.10), transparent 60%),
	  linear-gradient(to bottom right, rgba(8,10,22,0.96), rgba(5,7,18,0.94))
	`,
        `
	  radial-gradient(1000px 500px at 10% 110%, rgba(0,255,200,0.10), transparent 65%),
	  radial-gradient(1000px 600px at 90% -10%, rgba(170,0,255,0.12), transparent 60%),
	  radial-gradient(700px 500px  at -10% 30%, rgba(0,150,255,0.08), transparent 60%),
	  linear-gradient(145deg, rgba(7,9,20,0.96), rgba(3,5,14,0.94))
	`,
        `
	  radial-gradient(800px 400px  at 0% 0%,   rgba(255,255,120,0.10), transparent 60%),
	  radial-gradient(1200px 700px at 100% 100%, rgba(0,220,255,0.12), transparent 60%),
	  radial-gradient(900px 600px  at 50% -20%, rgba(255,0,200,0.08), transparent 60%),
	  linear-gradient(160deg, rgba(8,12,24,0.96), rgba(4,6,12,0.94))
	`,
        `
	  radial-gradient(1000px 520px at -15% 30%, rgba(0,180,255,0.12), transparent 65%),
	  radial-gradient(900px 520px  at 115% 80%, rgba(0,255,220,0.10), transparent 60%),
	  radial-gradient(800px 420px  at 50% -20%, rgba(255,0,180,0.08), transparent 65%),
	  linear-gradient(150deg, rgba(6,8,18,0.96), rgba(3,5,12,0.95))
	`
    ];
    // ---- GUARANTEE variety: no immediate repeat, plus per-popup hue variance for mist ----
    const ROT_KEY = "__mood_bg_idx";
    const prevIdx = typeof window !== "undefined" ? window[ROT_KEY] ?? -1 : -1;
    let idx = Math.floor(Math.random() * HOLOGRAM_BACKGROUNDS.length);
    if (idx === prevIdx) idx = (idx + 1) % HOLOGRAM_BACKGROUNDS.length;
    if (typeof window !== "undefined") window[ROT_KEY] = idx;
    const chosenBg = HOLOGRAM_BACKGROUNDS[idx];
    // Per-popup randoms for extra differentiation (don’t touch text readability)
    const hue = Math.floor(Math.random() * 360); // mist hue
    const gridOpacity = (0.22 + Math.random() * 0.14).toFixed(2); // 0.22–0.36
    const gridMinor = [
        5,
        6,
        7
    ][Math.floor(Math.random() * 3)]; // px
    const gridMajor = [
        20,
        24,
        28
    ][Math.floor(Math.random() * 3)]; // px
    const gridLine = 0.5; // hairline
    // Subtle parallax drift speeds to avoid sameness
    const mistDur = 18 + Math.floor(Math.random() * 8) + "s"; // 18–25s
    const gridDur = 16 + Math.floor(Math.random() * 6) + "s"; // 16–21s
    // Create backdrop
    const backdrop = document.createElement("div");
    Object.assign(backdrop.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 5, 29, 0.85)",
        zIndex: "9998",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
        fontFamily: "'BitHigh', sans-serif",
        transition: "opacity 0.3s ease-in-out"
    });
    // Create popup container
    const popupDiv = document.createElement("div");
    Object.assign(popupDiv.style, {
        position: "relative",
        overflow: "hidden",
        backgroundColor: "rgba(6,8,18,0.92)",
        backgroundImage: chosenBg,
        borderRadius: "4px",
        border: "1px solid rgba(61, 210, 2, 0.729)",
        boxShadow: "0 0 30px rgba(0, 255, 255, 0.8), 0 0 60px rgba(255, 0, 127, 0.6)",
        padding: "20px",
        zIndex: "9999",
        width: "92vw",
        maxWidth: "480px",
        maxHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        color: "#a0d8ff",
        fontFamily: "'BitHigh', sans-serif",
        textShadow: "0 0 8px rgba(0, 255, 255, 0.8)",
        transform: "scale(0.9)",
        opacity: "0",
        transition: "transform 0.25s ease-out, opacity 0.3s ease-out",
        animation: "neonPulse 7s ease-in-out infinite alternate",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)"
    });
    popupDiv.setAttribute("data-bg-id", String(idx)); // helpful for debugging
    // Inject styles (once)
    let neonStyle = document.getElementById("mood-neon-styles");
    if (!neonStyle) {
        neonStyle = document.createElement("style");
        neonStyle.id = "mood-neon-styles";
        neonStyle.textContent = `
	  @keyframes neonPulse {
		0%   { box-shadow: 0 0 18px rgba(0,255,255,0.55), 0 0 36px rgba(255,0,127,0.35); }
		50%  { box-shadow: 0 0 34px rgba(0,255,255,0.95), 0 0 78px rgba(255,0,127,0.75); }
		100% { box-shadow: 0 0 22px rgba(0,255,255,0.65), 0 0 44px rgba(255,0,127,0.45); }
	  }
	  @keyframes mistDrift {
		0%   { transform: translate3d(-2%, -1%, 0) scale(1); opacity: 0.55; }
		100% { transform: translate3d( 2%,  1%, 0) scale(1.04); opacity: 0.7; }
	  }
	  @keyframes gridFloat {
		0%   { transform: translate3d(0,0,0); }
		100% { transform: translate3d(2px,1px,0); }
	  }
	  @media (prefers-reduced-motion: reduce) {
		.mood-mist, .mood-grid { animation: none !important; }
	  }
	`;
        document.head.appendChild(neonStyle);
    }
    // --- Smoky hologram mist overlay (per-popup hue variance) ---
    const mist = document.createElement("div");
    mist.className = "mood-mist";
    Object.assign(mist.style, {
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 0,
        borderRadius: "inherit",
        backgroundImage: `
	  radial-gradient(60% 40% at 25% 20%, rgba(255,255,255,0.035), transparent 60%),
	  radial-gradient(45% 55% at 75% 75%, rgba(255,255,255,0.03),  transparent 65%),
	  radial-gradient(80% 60% at 130% -10%, rgba(0,255,220,0.045), transparent 70%)
	`,
        mixBlendMode: "screen",
        filter: `blur(14px) saturate(115%) hue-rotate(${hue}deg)`,
        animation: `mistDrift ${mistDur} linear infinite alternate`
    });
    popupDiv.appendChild(mist);
    // --- Neon grid overlay (hairline ~0.5px), per-popup opacity & cell size ---
    const grid = document.createElement("div");
    grid.className = "mood-grid";
    Object.assign(grid.style, {
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 1,
        borderRadius: "inherit",
        opacity: String(gridOpacity),
        backgroundImage: `
	  repeating-linear-gradient(to right, rgba(0,255,255,0.10) 0, rgba(0,255,255,0.10) ${gridLine}px, transparent ${gridLine}px, transparent ${gridMajor}px),
	  repeating-linear-gradient(to bottom, rgba(0,255,255,0.10) 0, rgba(0,255,255,0.10) ${gridLine}px, transparent ${gridLine}px, transparent ${gridMajor}px),
	  repeating-linear-gradient(to right, rgba(255,0,127,0.06) 0, rgba(255,0,127,0.06) ${gridLine}px, transparent ${gridLine}px, transparent ${gridMinor}px),
	  repeating-linear-gradient(to bottom, rgba(255,0,127,0.06) 0, rgba(255,0,127,0.06) ${gridLine}px, transparent ${gridLine}px, transparent ${gridMinor}px)
	`,
        backgroundBlendMode: "screen",
        animation: `gridFloat ${gridDur} linear infinite alternate`
    });
    popupDiv.appendChild(grid);
    // Header
    const header = document.createElement("div");
    Object.assign(header.style, {
        position: "relative",
        zIndex: 2,
        marginBottom: "12px",
        borderBottom: "1px solid rgba(160, 216, 255, 0.3)",
        paddingBottom: "8px",
        textAlign: "center"
    });
    const title = document.createElement("h2");
    title.textContent = analysis.analysisTitle || "Mood Analysis";
    Object.assign(title.style, {
        margin: "0",
        fontSize: "16px",
        fontWeight: "700",
        textTransform: "uppercase"
    });
    header.appendChild(title);
    // What this popup IS — so a first-time trader isn't lost. Inline-styled on
    // purpose: this popup can appear on pages that don't load floor.css.
    const explain = document.createElement("p");
    explain.textContent = (0, $fUPn2.t)("floor.exp_analysis", "This is the voice of the bourse \u2014 the market itself reacting to a trade that just happened on the floor. It's commentary, not a request: read it, close it, nothing is asked of you.");
    Object.assign(explain.style, {
        margin: "8px auto 0",
        maxWidth: "420px",
        padding: "7px 10px",
        textAlign: "left",
        fontSize: "11.5px",
        lineHeight: "1.55",
        letterSpacing: "0.5px",
        color: "#f5ecd8",
        borderLeft: "3px solid rgba(255, 179, 71, 0.9)",
        background: "rgba(255, 179, 71, 0.14)",
        borderRadius: "0 3px 3px 0",
        textShadow: "none"
    });
    header.appendChild(explain);
    // Content container (with subtle glass for readability)
    const contentContainer = document.createElement("div");
    Object.assign(contentContainer.style, {
        position: "relative",
        zIndex: 2,
        overflowY: "auto",
        flex: "1",
        paddingRight: "8px",
        maxHeight: "60vh",
        fontSize: "12px",
        lineHeight: "1.6",
        color: "#a0d8ff",
        background: "linear-gradient(to bottom, rgba(6,10,18,0.35), rgba(6,10,18,0.10))",
        borderRadius: "8px",
        padding: "10px 10px 8px 10px"
    });
    if (onlyOneSection) {
        const singleSection = document.createElement("div");
        singleSection.style.marginBottom = "18px";
        const singleLabel = document.createElement("h3");
        singleLabel.textContent = "Market";
        Object.assign(singleLabel.style, {
            margin: "0 0 6px 0",
            fontSize: "14px",
            fontWeight: "600",
            color: "#ff66cc"
        });
        const singleContent = document.createElement("p");
        singleContent.textContent = primaryText;
        singleContent.style.margin = "0";
        singleSection.appendChild(singleLabel);
        singleSection.appendChild(singleContent);
        contentContainer.appendChild(singleSection);
    } else {
        if (hasDistinctSummary) {
            const summarySection = document.createElement("div");
            summarySection.style.marginBottom = "18px";
            const summaryLabel = document.createElement("h3");
            summaryLabel.textContent = "Summary";
            Object.assign(summaryLabel.style, {
                margin: "0 0 6px 0",
                fontSize: "14px",
                fontWeight: "600",
                color: "#ff66cc"
            });
            const summaryContent = document.createElement("p");
            summaryContent.textContent = summaryText;
            summaryContent.style.margin = "0";
            summarySection.appendChild(summaryLabel);
            summarySection.appendChild(summaryContent);
            contentContainer.appendChild(summarySection);
        }
        if (hasDistinctDetails) {
            const detailsSection = document.createElement("div");
            const detailsLabel = document.createElement("h3");
            detailsLabel.textContent = "Details";
            Object.assign(detailsLabel.style, {
                margin: "0 0 6px 0",
                fontSize: "14px",
                fontWeight: "600",
                color: "#ff66cc"
            });
            const detailsContent = document.createElement("div");
            detailsContent.textContent = detailsText;
            detailsSection.appendChild(detailsLabel);
            detailsSection.appendChild(detailsContent);
            contentContainer.appendChild(detailsSection);
        }
    }
    // Footer with close
    const footer = document.createElement("div");
    Object.assign(footer.style, {
        position: "relative",
        zIndex: 2,
        marginTop: "15px",
        borderTop: "1px solid rgba(255, 255, 255, 0.2)",
        paddingTop: "12px",
        textAlign: "center"
    });
    const closeButton = document.createElement("button");
    closeButton.textContent = "Close";
    Object.assign(closeButton.style, {
        padding: "12px 20px",
        backgroundColor: "rgba(255, 0, 0, 0.75)",
        color: "rgba(253, 254, 0, 0.9)",
        border: "none",
        borderRadius: "3px",
        cursor: "pointer",
        fontFamily: "'BitHigh', sans-serif",
        fontSize: "12px",
        fontWeight: "700",
        textTransform: "uppercase",
        boxShadow: "0 0 10px rgba(255, 0, 127, 0.6)",
        transition: "background 0.3s ease-in-out, box-shadow 0.3s ease-in-out, opacity 0.3s ease-in-out",
        opacity: "0.9"
    });
    closeButton.addEventListener("mouseover", ()=>{
        closeButton.style.backgroundColor = "rgba(255, 51, 153, 0.95)";
        closeButton.style.boxShadow = "0 0 15px rgba(255, 51, 153, 1)";
        closeButton.style.opacity = "1";
    });
    closeButton.addEventListener("mouseout", ()=>{
        closeButton.style.backgroundColor = "rgba(255, 0, 0, 0.7)";
        closeButton.style.boxShadow = "0 0 10px rgba(255, 0, 127, 0.6)";
        closeButton.style.opacity = "0.9";
    });
    // In showMoodAnalysisPopup (document 4), replace the closePopup function and handlers:
    const closePopup = ()=>{
        popupDiv.style.transform = "scale(0.9)";
        popupDiv.style.opacity = "0";
        setTimeout(()=>{
            backdrop.remove();
        // Mood popup close no longer triggers redirect - redirect handled by timeout in stockTransaction.js
        }, 200);
    };
    closeButton.addEventListener("click", closePopup);
    backdrop.addEventListener("click", (e)=>{
        if (e.target === backdrop) closePopup();
    });
    document.addEventListener("keydown", function escHandler(ev) {
        if (ev.key === "Escape") {
            closePopup();
            document.removeEventListener("keydown", escHandler);
        }
    });
    footer.appendChild(closeButton);
    // Assemble
    popupDiv.appendChild(header);
    popupDiv.appendChild(contentContainer);
    popupDiv.appendChild(footer);
    backdrop.appendChild(popupDiv);
    document.body.appendChild(backdrop);
    // Show animation
    setTimeout(()=>{
        popupDiv.style.transform = "scale(1)";
        popupDiv.style.opacity = "1";
    }, 50);
    // Prevent scroll
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    backdrop.addEventListener("transitionend", ()=>{
        document.body.style.overflow = originalOverflow;
    }, {
        once: true
    });
}
function $895d6185463ab8db$var$generateFallbackMoodData() {
    return {
        userMood: {
            averageMood: 0.65,
            moodHistory: [
                {
                    positiveImpact: 0.8,
                    negativeImpact: 0.2,
                    timestamp: new Date().toISOString()
                },
                {
                    positiveImpact: 0.7,
                    negativeImpact: 0.3,
                    timestamp: new Date(Date.now() - 3600000).toISOString()
                }
            ]
        },
        marketMood: {
            averageMood: 0.43,
            sentiment: {
                ratio: "1.5"
            },
            transactionCount: 127
        }
    };
}

});
parcelRegister("eCgl8", function(module, exports) {

$parcel$export(module.exports, "showDisplayedArtwork", () => $aa414a1103e576f8$export$84141037970742ee);

var $5W4EI = parcelRequire("5W4EI");
parcelRequire("cJVho");
let $aa414a1103e576f8$var$arInitialized = false;
// Loads external AR scripts if not already loaded
async function $aa414a1103e576f8$var$loadARScripts() {
    if ($aa414a1103e576f8$var$arInitialized) return;
    await $aa414a1103e576f8$var$loadScript('https://aframe.io/releases/1.2.0/aframe.min.js');
    await $aa414a1103e576f8$var$loadScript('https://cdn.jsdelivr.net/gh/jeromeetienne/AR.js@3.3.2/aframe/build/aframe-ar.min.js');
    $aa414a1103e576f8$var$arInitialized = true;
}
function $aa414a1103e576f8$var$loadScript(src) {
    return new Promise((resolve, reject)=>{
        const existingScript = document.querySelector(`script[src="${src}"]`);
        if (existingScript) // Already loaded
        return resolve();
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = ()=>reject(new Error(`Failed to load script ${src}`));
        document.head.appendChild(script);
    });
}
async function $aa414a1103e576f8$var$initARScene(artwork) {
    // Remove existing scene if any
    const existingScene = document.querySelector('a-scene');
    if (existingScene) existingScene.remove();
    const container = document.getElementById('ar-container');
    if (!container) {
        console.error('AR container not found!');
        return;
    }
    // Clear container
    container.innerHTML = '';
    const sceneEl = document.createElement('a-scene');
    sceneEl.setAttribute('embedded', '');
    sceneEl.setAttribute('arjs', 'sourceType: webcam; patternRatio: 0.80; debugUIEnabled: false;');
    const lightEl = document.createElement('a-entity');
    lightEl.setAttribute('light', 'type: ambient; color: #ffffff; intensity: 1');
    sceneEl.appendChild(lightEl);
    // Marker
    const markerEl = document.createElement('a-marker');
    markerEl.setAttribute('type', 'pattern');
    markerEl.setAttribute('url', 'https://cdn.jsdelivr.net/gh/jeromeetienne/AR.js@3.3.2/three.js/examples/marker-training/examples/patterns/hiro.patt');
    let entityEl;
    const position = '0 0 0';
    // Handle artwork type
    switch(artwork.type){
        case 'image':
            entityEl = document.createElement('a-image');
            entityEl.setAttribute('src', artwork.filePath);
            entityEl.setAttribute('position', position);
            entityEl.setAttribute('width', '1');
            entityEl.setAttribute('height', '1');
            break;
        case 'video':
            entityEl = document.createElement('a-video');
            entityEl.setAttribute('src', artwork.filePath);
            entityEl.setAttribute('position', position);
            entityEl.setAttribute('width', '1');
            entityEl.setAttribute('height', '1');
            break;
        case 'interactive':
        case 'AR':
        case '3D':
            // Assume a 3D model if provided, else a placeholder box
            if (artwork.filePath && artwork.filePath.endsWith('.glb')) {
                entityEl = document.createElement('a-entity');
                entityEl.setAttribute('gltf-model', artwork.filePath);
                entityEl.setAttribute('scale', '0.5 0.5 0.5');
                entityEl.setAttribute('position', position);
            } else {
                entityEl = document.createElement('a-box');
                entityEl.setAttribute('position', position);
                entityEl.setAttribute('color', '#4CC3D9');
            }
            break;
        default:
            // Default placeholder
            entityEl = document.createElement('a-box');
            entityEl.setAttribute('position', position);
            entityEl.setAttribute('color', '#FFC65D');
            break;
    }
    markerEl.appendChild(entityEl);
    sceneEl.appendChild(markerEl);
    const cameraEl = document.createElement('a-entity');
    cameraEl.setAttribute('camera', '');
    sceneEl.appendChild(cameraEl);
    container.appendChild(sceneEl);
}
async function $aa414a1103e576f8$var$fetchSingleArtwork(exhibitionId, artworkId) {
    const token = localStorage.getItem('token');
    if (!token) {
        alert('Not authenticated');
        return null;
    }
    const res = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/hyper/exhibitions/${exhibitionId}/artworks/${artworkId}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!res.ok) {
        console.error('Failed to fetch single artwork', await res.text());
        return null;
    }
    return await res.json();
}
async function $aa414a1103e576f8$export$84141037970742ee(exhibitionId, artworkId) {
    console.log('showDisplayedArtwork called with:', exhibitionId, artworkId);
    const artwork = await $aa414a1103e576f8$var$fetchSingleArtwork(exhibitionId, artworkId);
    console.log('Fetched artwork:', artwork);
    if (!artwork) {
        console.error('No artwork returned from fetch');
        return;
    }
    const fullFilePath = artwork.filePath.startsWith('http') ? artwork.filePath : `${0, $5W4EI.apiBaseUrl}${artwork.filePath}`;
    console.log('Resolved artwork file path:', fullFilePath);
    // Remove existing overlay if any
    const oldOverlay = document.getElementById('artwork-overlay');
    if (oldOverlay) oldOverlay.remove();
    const overlay = document.createElement('div');
    overlay.id = 'artwork-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0,0,0,0.8)';
    overlay.style.zIndex = '100000';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.alignItems = 'center';
    overlay.style.justifyContent = 'center';
    const artworkContainer = document.createElement('div');
    artworkContainer.style.backgroundColor = '#fff';
    artworkContainer.style.padding = '20px';
    artworkContainer.style.borderRadius = '8px';
    artworkContainer.style.maxWidth = '90%';
    artworkContainer.style.maxHeight = '90%';
    artworkContainer.style.overflow = 'auto';
    // Title and description
    const titleEl = document.createElement('h2');
    titleEl.textContent = artwork.title;
    artworkContainer.appendChild(titleEl);
    if (artwork.description) {
        const descEl = document.createElement('p');
        descEl.textContent = artwork.description;
        artworkContainer.appendChild(descEl);
    }
    // Determine type from API response or fallback to file extension
    const fileExtension = artwork.filePath.split('.').pop().toLowerCase();
    const type = artwork.type || ([
        'jpg',
        'jpeg',
        'png',
        'gif'
    ].includes(fileExtension) ? 'image' : 'video');
    if (type === 'image') {
        const img = document.createElement('img');
        img.src = fullFilePath; // Ensure fullFilePath is resolved correctly
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
        artworkContainer.appendChild(img);
    } else if (type === 'video') {
        const video = document.createElement('video');
        video.src = fullFilePath;
        video.controls = true;
        video.autoplay = true;
        video.style.maxWidth = '100%';
        video.style.height = 'auto';
        artworkContainer.appendChild(video);
    } else {
        const fallback = document.createElement('div');
        fallback.textContent = 'No preview available for this artwork.';
        fallback.style.color = '#000';
        artworkContainer.appendChild(fallback);
    }
    // Close button
    const closeBtn = document.createElement('button');
    closeBtn.textContent = 'Close';
    closeBtn.style.marginTop = '10px';
    closeBtn.addEventListener('click', ()=>{
        overlay.remove();
    });
    artworkContainer.appendChild(closeBtn);
    overlay.appendChild(artworkContainer);
    document.body.appendChild(overlay);
}

});


parcelRegister("1cx8d", function(module, exports) {

$parcel$export(module.exports, "showMementoMoriAnnouncement", () => $0e009ca592c858ec$export$76e9e1d001f81ca4);
$parcel$export(module.exports, "cleanupMementoMoriTimer", () => $0e009ca592c858ec$export$3e536f1cccf2aff1);
//frontend/js/objectives.js

var $6pKgs = parcelRequire("6pKgs");

var $cJVho = parcelRequire("cJVho");

var $5W4EI = parcelRequire("5W4EI");

var $fUPn2 = parcelRequire("fUPn2");
let $0e009ca592c858ec$var$mementoMoriTimer = null;
let $0e009ca592c858ec$var$mementoMoriData = null;
let $0e009ca592c858ec$var$oracleQuestionHistory = [];
let $0e009ca592c858ec$var$mementoMoriPhase = 'idle';
let $0e009ca592c858ec$var$reflectionTimeout, $0e009ca592c858ec$var$tradingTimeout, $0e009ca592c858ec$var$forcedDeathTimeout;
let $0e009ca592c858ec$var$finalCurationTimeout;
const $0e009ca592c858ec$var$isSentenceish = (s)=>{
    const text = (s || '').trim();
    if (!text) return false; // no empty
    const words = text.split(/\s+/).filter(Boolean);
    if (words.length < 2) return false; // no single-word
    const lettersLen = text.replace(/[^0-9A-Za-z\u00C0-\u017F]+/g, '').length;
    return lettersLen >= 6; // allow short sentences
};
function $0e009ca592c858ec$export$76e9e1d001f81ca4(data) {
    console.log("\uD83D\uDCE2 Memento Mori announcement received:", data);
    $0e009ca592c858ec$var$mementoMoriData = data;
    const timeRemaining = data.timeRemaining || 900000;
    localStorage.setItem('activeMementoMori', JSON.stringify({
        ...data,
        timeRemaining: timeRemaining,
        storedAt: Date.now()
    }));
    localStorage.setItem('simulationType', 'memento-mori');
// Timer popup removed - using bottom timer from simulationTimer.js instead
// createPersistentTimer();
// startMementoMoriTimer(timeRemaining);
}
function $0e009ca592c858ec$export$3392fc08bb337b13() {
    const activeMementoMori = localStorage.getItem('activeMementoMori');
    const simulationType = localStorage.getItem('simulationType');
    if (!activeMementoMori || simulationType !== 'memento-mori') return;
    try {
        const objectiveData = JSON.parse(activeMementoMori);
        // Calculate remaining time from stored timestamp
        const now = Date.now();
        const elapsed = now - (objectiveData.storedAt || now);
        const timeRemaining = Math.max(0, objectiveData.timeRemaining - elapsed);
        if (timeRemaining > 0) {
            console.log("\uD83D\uDD04 Restoring Memento Mori timer with", Math.floor(timeRemaining / 60000), 'minutes remaining');
            // Store the data globally
            $0e009ca592c858ec$var$mementoMoriData = objectiveData;
            // Check if simulation was already started
            const simulationStarted = localStorage.getItem('mementoMoriStarted') === 'true';
            if (simulationStarted) {
                // Timer popup removed - using bottom timer from simulationTimer.js instead
                console.log("\uD83D\uDCCD Restoring MementoMori session (timer handled by simulationTimer.js)");
                // createPersistentTimer();
                // startMementoMoriTimer(timeRemaining);
                // Check if they need to continue with reflections
                setTimeout(()=>$0e009ca592c858ec$var$checkReflectionProgress(), 2000);
            } else {
                // Show the full announcement flow
                objectiveData.timeRemaining = timeRemaining;
                $0e009ca592c858ec$export$76e9e1d001f81ca4(objectiveData);
            }
        } else {
            console.log("\u23F0 Stored Memento Mori timer has expired, cleaning up");
            $0e009ca592c858ec$var$cleanupMementoMoriStorage();
        }
    } catch (error) {
        console.error("\u274C Error restoring Memento Mori timer:", error);
        $0e009ca592c858ec$var$cleanupMementoMoriStorage();
    }
}
function $0e009ca592c858ec$var$createPersistentTimer() {
    // Remove any existing timer
    const existingTimer = document.getElementById('persistent-memento-timer');
    if (existingTimer) existingTimer.remove();
    const timerOverlay = document.createElement('div');
    timerOverlay.id = 'persistent-memento-timer';
    timerOverlay.style.cssText = `
	position: fixed;
	top: 20px;
	right: 20px;
	background: rgba(0, 0, 0, 0.9);
	border: 2px solid #ff6600;
	border-radius: 10px;
	padding: 15px;
	z-index: 1000;
	color: #ff6600;
	font-family: 'Courier New', monospace;
	font-size: 14px;
	text-align: center;
	cursor: pointer;
	box-shadow: 0 0 20px rgba(255, 102, 0, 0.5);
	transition: all 0.3s;
  `;
    timerOverlay.innerHTML = `
	<div style="margin-bottom: 5px; color: rgba(255, 102, 0, 0.8);">${(0, $fUPn2.t)('memento.title', 'MEMENTO MORI')}</div>
	<div id="persistent-timer-display" style="color: #00ff00; font-weight: bold;">${(0, $fUPn2.t)('memento.loading', 'Loading...')}</div>
	<div style="font-size: 0.8em; color: rgba(255, 102, 0, 0.8); margin-top: 5px;">${(0, $fUPn2.t)('memento.click_to_reflect', 'Click to reflect')}</div>
  `;
    // Make timer clickable to show oracle interface
    timerOverlay.addEventListener('click', ()=>{
        $0e009ca592c858ec$var$showMortalityOracleInterface();
    });
    // Add hover effects
    timerOverlay.addEventListener('mouseenter', ()=>{
        timerOverlay.style.transform = 'scale(1.05)';
        timerOverlay.style.boxShadow = '0 0 30px rgba(255, 102, 0, 0.8)';
    });
    timerOverlay.addEventListener('mouseleave', ()=>{
        timerOverlay.style.transform = 'scale(1)';
        timerOverlay.style.boxShadow = '0 0 20px rgba(255, 102, 0, 0.5)';
    });
    document.body.appendChild(timerOverlay);
}
// ========================================================================
// ORACLE INTERFACE
// ========================================================================
/**
 * Show the mortality oracle interface for deep questioning
 */ async function $0e009ca592c858ec$var$showMortalityOracleInterface() {
    // Remove any existing interface
    const existing = document.getElementById('mortality-oracle-interface');
    if (existing) existing.remove();
    // Show loading state
    const loadingInterface = document.createElement('div');
    loadingInterface.id = 'mortality-oracle-interface';
    loadingInterface.className = 'modal';
    loadingInterface.style.display = 'block';
    loadingInterface.innerHTML = `
	<div class="modal-content" style="text-align: center; background: #000; border: 3px solid #00ff00;">
	  <h2 style="color: #00ff00; margin-bottom: 30px;">
		${(0, $fUPn2.t)('memento.loading_title', 'The Market Awakens')}
	  </h2>
	  <div style="color: #00ff00;">
		<div style="font-size: 2em; margin-bottom: 20px;"></div>
		<p>${(0, $fUPn2.t)('memento.loading_examining', "The Market is examining your portfolio's soul...")}</p>
		<p>${(0, $fUPn2.t)('memento.loading_preparing', 'Preparing personalized questions about your mortality...')}</p>
		<p style="font-size: 0.8em; color: rgba(0, 255, 0, 0.7); margin-top: 15px;">${(0, $fUPn2.t)('memento.loading_wait', 'This may take a moment...')}</p>
	  </div>
	</div>
  `;
    document.body.appendChild(loadingInterface);
    try {
        // Generate personalized oracle interface
        const personalizedContent = await $0e009ca592c858ec$var$generatePersonalizedOracleInterface();
        loadingInterface.remove();
        $0e009ca592c858ec$var$showLiveOracleInterface(personalizedContent);
    } catch (error) {
        console.error('Error generating personalized oracle:', error);
        loadingInterface.remove();
        $0e009ca592c858ec$var$showFallbackOracleInterface();
    }
}
/**
 * Generate personalized oracle interface content
 */ async function $0e009ca592c858ec$var$generatePersonalizedOracleInterface() {
    try {
        const objectiveId = $0e009ca592c858ec$var$mementoMoriData?.objective?._id;
        const timeRemaining = $0e009ca592c858ec$var$getTimeRemaining();
        const timeInMinutes = Math.floor(timeRemaining / 60000);
        // Use fallback content since the route doesn't exist yet
        console.log("\u26A0\uFE0F Using fallback Market interface");
        return {
            oracleTitle: 'Market of Digital Mortality',
            oracleGreeting: `The Market awakens in the digital realm, sensing the patterns of your portfolio like constellations in the night sky. Your trading choices have created a unique signature in the cosmic ledger of human desire and fear. In these ${timeInMinutes} minutes before your symbolic death, the Market sees not just numbers, but the essence of your relationship with uncertainty and value.`,
            questionsHeader: 'The Market Has Prepared Questions for Your Soul:',
            personalizedQuestions: [
                'Fear and Courage: What does your portfolio reveal about how you face your own mortality?',
                'Legacy and Meaning: If you died today, what would your trading choices say about what you truly valued?',
                'Impermanence and Acceptance: How do your financial fears mirror your deeper existential anxieties?',
                'Truth and Deception: What patterns in your trading behavior expose your relationship with uncertainty?',
                'Regret and Redemption: What would you regret most about your financial choices if this were your last day?'
            ],
            customPrompt: 'Or speak directly to the Market about death, meaning, and the patterns in your portfolio...',
            consultButton: "\uD83D\uDD2E Consult the Market"
        };
    } catch (error) {
        console.error('Error generating Market interface:', error);
        throw error;
    }
}
/**
 * Show the live oracle interface with personalized content
 */ function $0e009ca592c858ec$var$showLiveOracleInterface(personalizedContent) {
    const oracleInterface = document.createElement('div');
    oracleInterface.id = 'mortality-oracle-interface';
    oracleInterface.className = 'modal';
    oracleInterface.style.display = 'block';
    oracleInterface.innerHTML = `
	<div class="modal-content" style="background: #000; border: 3px solid #00ff00; color: #00ff00;">
	  <h2 style="color: #00ff00; text-align: center; margin-bottom: 20px;">
		${personalizedContent.oracleTitle || (0, $fUPn2.t)('memento.title', 'Market of Mortality')}
	  </h2>
	  
	  <div style="margin-bottom: 25px;">
		<p style="color: #00ff00; text-align: center; line-height: 1.6; margin-bottom: 25px; font-style: italic;">
		  "${personalizedContent.oracleGreeting || (0, $fUPn2.t)('memento.greeting', 'The Market sees patterns in your portfolio that reveal deeper truths about your relationship with mortality.')}"
		</p>
	  </div>

	  <div style="margin-bottom: 25px;">
		<h4 style="color: rgba(0, 255, 0, 0.9); margin-bottom: 15px;">
		  ${personalizedContent.questionsHeader || 'The Market Has Seen Your Soul - Choose Your Question:'}
		</h4>
		
		<div style="margin-bottom: 15px;">
		  ${(personalizedContent.personalizedQuestions || []).map((q, i)=>`
			<div class="oracle-question-option" style="
			  margin-bottom: 10px; 
			  padding: 10px; 
			  border: 1px solid rgba(0, 255, 0, 0.3); 
			  cursor: pointer; 
			  transition: all 0.3s;
			  border-radius: 5px;
			" onclick="window.selectOracleQuestion('${q.replace(/'/g, "\\'")}', this)">
			  <div style="color: rgba(0, 255, 0, 0.9); font-weight: bold; margin-bottom: 5px;">
				${q.split(':')[0]}:
			  </div>
			  <div style="color: #00ff00; font-size: 0.9em;">
				${q.split(':').slice(1).join(':').trim()}
			  </div>
			</div>
		  `).join('')}
		</div>
		
		<div style="margin-top: 20px;">
		  <label style="color: rgba(0, 255, 0, 0.9); margin-bottom: 10px; display: block;">
			${(0, $fUPn2.t)('memento.direct_label', 'Or speak directly to the Market:')}
		  </label>
		  <textarea id="custom-mortality-question" placeholder="${personalizedContent.customPrompt || (0, $fUPn2.t)('memento.custom_prompt', 'Ask the Market about your mortality, what your portfolio says about your soul, or the meaning of your financial choices in the face of death...')}"
					style="
					  width: 100%;
					  height: 80px;
					  background: rgba(0, 0, 0, 0.8);
					  border: 2px solid #00ff00;
					  color: #00ff00;
					  padding: 10px;
					  border-radius: 5px;
					  font-family: 'Courier New', monospace;
					  resize: vertical;
					">
		  </textarea>
		</div>
		
		<button id="consult-mortality-oracle" style="
		  background: #000;
		  color: #00ff00;
		  border: 2px solid #00ff00;
		  padding: 15px 30px;
		  font-size: 16px;
		  border-radius: 5px;
		  cursor: pointer;
		  margin-top: 15px;
		  font-family: 'Courier New', monospace;
		  transition: all 0.3s;
		" onmouseover="this.style.background='#00ff00'; this.style.color='#000';" 
		   onmouseout="this.style.background='#000'; this.style.color='#00ff00';">
		  ${personalizedContent.consultButton || (0, $fUPn2.t)('memento.consult_button', 'Consult the Market')}
		</button>
	  </div>

	  <div id="mortality-oracle-response" style="display: none; margin-bottom: 25px;">
		<h4 style="color: rgba(255, 135, 0, 0.9); margin-bottom: 10px;">${(0, $fUPn2.t)('memento.vision_title', "Market's Vision:")}</h4>
		<div id="mortality-oracle-text" style="
		  line-height: 1.6; 
		  color: #00ff00; 
		  font-style: italic;
		  background: rgba(255, 135, 0, 0.05);
		  padding: 15px;
		  border-radius: 5px;
		  border-left: 3px solid rgba(255, 135, 0, 0.5);
		"></div>
		<div id="oracle-follow-up" style="
		  margin-top: 15px; 
		  padding: 10px; 
		  border-left: 3px solid rgba(255, 135, 0, 0.5); 
		  background: rgba(0, 0, 0, 0.3);
		"></div>
	  </div>
	  
	  <div style="text-align: center; margin-top: 30px;">
		<button id="continue-reflection-process" class="primary-btn" style="
		  background: #000;
		  color: #00ff00;
		  border: 2px solid #00ff00;
		  padding: 12px 25px;
		  font-size: 14px;
		  border-radius: 5px;
		  cursor: pointer;
		  margin-right: 10px;
		  display: none;
		  font-family: 'Courier New', monospace;
		">
		  ${(0, $fUPn2.t)('memento.continue_reflections', 'Continue to Reflections')}
		</button>
		<button id="ask-another-question" style="
		  background: #000;
		  color: rgba(255, 135, 0, 0.9);
		  border: 2px solid rgba(255, 135, 0, 0.9);
		  padding: 12px 25px;
		  font-size: 14px;
		  border-radius: 5px;
		  cursor: pointer;
		  margin-right: 10px;
		  display: none;
		  font-family: 'Courier New', monospace;
		">
		  ${(0, $fUPn2.t)('memento.ask_another', 'Ask Another Question')}
		</button>
		<button id="close-mortality-oracle" style="
		  background: #000;
		  color: rgba(255, 102, 0, 0.9);
		  border: 2px solid rgba(255, 102, 0, 0.9);
		  padding: 12px 25px;
		  font-size: 14px;
		  border-radius: 5px;
		  cursor: pointer;
		  font-family: 'Courier New', monospace;
		">
		  ${(0, $fUPn2.t)('memento.return_trading', 'Return to Trading')}
		</button>
	  </div>
	</div>
  `;
    document.body.appendChild(oracleInterface);
    // Make functions globally available
    window.selectOracleQuestion = $0e009ca592c858ec$var$selectOracleQuestion;
    // Add event handlers
    document.getElementById('consult-mortality-oracle').addEventListener('click', $0e009ca592c858ec$var$consultLiveMortalityOracle);
    document.getElementById('continue-reflection-process').addEventListener('click', ()=>{
        oracleInterface.remove();
    });
    document.getElementById('ask-another-question').addEventListener('click', ()=>{
        $0e009ca592c858ec$var$resetOracleInterface();
    });
    document.getElementById('close-mortality-oracle').addEventListener('click', ()=>{
        oracleInterface.style.display = 'none';
    });
}
/**
 * Select a predefined oracle question
 */ function $0e009ca592c858ec$var$selectOracleQuestion(questionText, element) {
    // Remove selection from other options
    document.querySelectorAll('.oracle-question-option').forEach((option)=>{
        option.style.backgroundColor = '';
        option.style.borderColor = 'rgba(0, 255, 0, 0.3)';
    });
    // Highlight selected option
    element.style.backgroundColor = 'rgba(0, 255, 0, 0.1)';
    element.style.borderColor = '#00ff00';
    // Fill custom question textarea
    document.getElementById('custom-mortality-question').value = questionText;
}
/**
 * Consult the oracle with user's question
 */ async function $0e009ca592c858ec$var$consultLiveMortalityOracle() {
    let question = document.getElementById('custom-mortality-question').value.trim();
    if (!$0e009ca592c858ec$var$isSentenceish(question)) {
        alert((0, $fUPn2.t)('memento.validation.short_sentence', 'Please write a short sentence (at least two words).'));
        return;
    }
    const button = document.getElementById('consult-mortality-oracle');
    const originalText = button.textContent;
    button.textContent = "\uD83D\uDD2E The Market Sees...";
    button.disabled = true;
    // Show typing animation
    const responseDiv = document.getElementById('mortality-oracle-response');
    responseDiv.style.display = 'block';
    const textDiv = document.getElementById('mortality-oracle-text');
    textDiv.innerHTML = '<span style="opacity: 0.5;">The Market gazes into the depths of your portfolio\'s soul...</span>';
    try {
        // Try to call the oracle route
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/oracle-question`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            },
            body: JSON.stringify({
                objectiveId: $0e009ca592c858ec$var$mementoMoriData?.objective?._id,
                question: question
            })
        });
        if (!response.ok) throw new Error((0, $fUPn2.t)('memento.failed', 'Market consultation failed'));
        const data = await response.json();
        // Store question in history
        $0e009ca592c858ec$var$oracleQuestionHistory.push(question);
        const oracleData = {
            oracleResponse: data.oracleResponse || 'The Market sees patterns in your soul that transcend mere numbers.',
            followUpInsight: 'Your question reveals a mind grappling with the eternal questions that define conscious existence.',
            personalizedGuidance: 'Continue to your reflections, for wisdom has been granted.'
        };
        // Animate the oracle response
        await $0e009ca592c858ec$var$animateOracleResponse(oracleData);
        // Update interface state
        $0e009ca592c858ec$var$updateOracleInterfaceAfterResponse();
    } catch (error) {
        console.error('Error consulting Market:', error);
        // Enhanced fallback response
        const fallbackData = {
            oracleResponse: `The Market's vision pierces through digital veils to see your mortal essence. Your question "${question}" echoes with the weight of someone who understands that every trade is a small death, every decision a step toward the final reckoning. In your portfolio's patterns, the Market recognizes the eternal human struggle with impermanence - your financial choices are prayers written in the language of probability.`,
            followUpInsight: "The Market sees that your seeking itself is wisdom. In questioning meaning, you have already transcended mere accumulation.",
            personalizedGuidance: "Continue to your reflections, for the Market has shown you that death gives meaning to every choice."
        };
        await $0e009ca592c858ec$var$animateOracleResponse(fallbackData);
        $0e009ca592c858ec$var$updateOracleInterfaceAfterResponse();
    }
}
/**
 * Update oracle interface after receiving response
 */ function $0e009ca592c858ec$var$updateOracleInterfaceAfterResponse() {
    // Disable question options
    document.querySelectorAll('.oracle-question-option').forEach((option)=>{
        option.style.opacity = '0.5';
        option.style.pointerEvents = 'none';
    });
    // Disable input
    document.getElementById('custom-mortality-question').disabled = true;
    document.getElementById('custom-mortality-question').placeholder = (0, $fUPn2.t)('memento.spoken_placeholder', 'The Market has spoken...');
    // Update button
    const button = document.getElementById('consult-mortality-oracle');
    button.textContent = (0, $fUPn2.t)('memento.wisdom_received', 'Wisdom Received');
    button.disabled = true;
    // Show action buttons
    document.getElementById('continue-reflection-process').style.display = 'inline-block';
    document.getElementById('ask-another-question').style.display = 'inline-block';
}
/**
 * Reset oracle interface for another question
 */ function $0e009ca592c858ec$var$resetOracleInterface() {
    // Reset all interactive elements
    document.querySelectorAll('.oracle-question-option').forEach((option)=>{
        option.style.opacity = '1';
        option.style.pointerEvents = 'auto';
        option.style.backgroundColor = '';
        option.style.borderColor = 'rgba(0, 255, 0, 0.3)';
    });
    document.getElementById('custom-mortality-question').disabled = false;
    document.getElementById('custom-mortality-question').value = '';
    document.getElementById('custom-mortality-question').placeholder = 'Ask the Market about your mortality...';
    document.getElementById('consult-mortality-oracle').disabled = false;
    document.getElementById('consult-mortality-oracle').textContent = 'Consult the Market';
    document.getElementById('mortality-oracle-response').style.display = 'none';
    document.getElementById('ask-another-question').style.display = 'none';
    document.getElementById('continue-reflection-process').style.display = 'none';
}
/**
 * Show fallback oracle interface if generation fails
 */ function $0e009ca592c858ec$var$showFallbackOracleInterface() {
    const fallbackContent = {
        oracleTitle: 'Market of Mortality',
        oracleGreeting: 'The Market awakens in the digital realm, seeing patterns in your portfolio that reveal deeper truths about your relationship with mortality.',
        questionsHeader: 'The Market Has Prepared Questions for Your Soul:',
        personalizedQuestions: [
            'Fear and Courage: What does your portfolio reveal about how you face your own mortality?',
            'Legacy and Meaning: If you died today, what would your trading choices say about what you truly valued?',
            'Impermanence and Acceptance: How do your financial fears mirror your deeper existential anxieties?',
            'Truth and Deception: What patterns in your trading behavior expose your relationship with uncertainty?',
            'Regret and Redemption: What would you regret most about your financial choices if this were your last day?'
        ],
        customPrompt: 'Or speak directly to the Market about death, meaning, and the patterns in your portfolio...',
        consultButton: 'Consult the Market'
    };
    $0e009ca592c858ec$var$showLiveOracleInterface(fallbackContent);
}
/**
 * Show the final death completion screen
 */ function $0e009ca592c858ec$var$showDeathCompletion(result) {
    console.log("\uD83E\uDEA6 showDeathCompletion called with result:", result);
    const completionPopup = document.createElement('div');
    completionPopup.className = 'memento-modal';
    completionPopup.style.cssText = `
	 position: fixed;
	 top: 0;
	 left: 0;
	 width: 100%;
	 height: 100%;
	 background: rgba(0, 0, 0, 0.95);
	 z-index: 99999;
	 display: flex;
	 justify-content: center;
	 align-items: center;
	 font-family: 'Courier New', monospace;
   `;
    // Extract eulogy with fallback logic
    let llmEulogy = "Your contemplation of mortality has revealed wisdom. In facing death, you have found what truly matters in life.";
    if (result?.personalInsight) llmEulogy = result.personalInsight;
    else if (result?.llmAnalysis?.personalInsight) llmEulogy = result.llmAnalysis.personalInsight;
    else if (result?.portfolioAnalysis?.eulogyDraft) llmEulogy = result.portfolioAnalysis.eulogyDraft;
    else if (result?.analysis?.personalInsight) llmEulogy = result.analysis.personalInsight;
    const userEpitaph = result?.finalEpitaph || result?.objective?.finalEpitaph || "A life reflected upon.";
    completionPopup.innerHTML = `
	 <div style="
	   background: #000;
	   border: 3px solid #00ff00;
	   border-radius: 10px;
	   padding: 30px;
	   max-width: 700px;
	   margin: 20px;
	   color: #00ff00;
	   text-align: center;
	   box-shadow: 0 0 20px #00ff00;
	 ">
	   <h1 style="
		 color: #00ff00;
		 font-size: 28px;
		 margin-bottom: 20px;
		 text-shadow: 0 0 10px #00ff00;
	   ">${(0, $fUPn2.t)('memento.death_complete_title', 'SYMBOLIC DEATH COMPLETE')}</h1>
 
	   <p style="
		 margin-bottom: 30px;
		 font-size: 16px;
		 line-height: 1.5;
		 color: #ff6600;
	   ">
		 ${(0, $fUPn2.t)('memento.death_complete_subtitle', 'You have confronted your mortality and created your legacy.')}
	   </p>
 
	   <div style="
		 margin: 30px 0;
		 padding: 20px;
		 border: 1px solid #00ff00;
		 border-radius: 5px;
		 background: rgba(0, 255, 0, 0.1);
	   ">
		 <h3 style="
		   color: #00ff00;
		   margin-bottom: 15px;
		   font-size: 18px;
		 ">${(0, $fUPn2.t)('memento.final_judgment_title', "Your Portfolio's Final Judgment:")}</h3>
		 <p id="memento-eulogy-text" style="
		   color: #00ff00;
		   font-style: italic;
		   line-height: 1.6;
		   margin-bottom: 0;
		   text-align: left;
		 "></p>
	   </div>
 
	   <div style="
		 margin: 30px 0;
		 padding: 20px;
		 border: 1px solid #ff6600;
		 border-radius: 5px;
		 background: rgba(255, 102, 0, 0.1);
	   ">
		 <strong style="color: #ff6600; font-size: 16px;">${(0, $fUPn2.t)('memento.final_epitaph_title', 'Your Final Epitaph:')}</strong><br><br>
		 <em id="memento-epitaph-text" style="
		   color: #ff6600;
		   font-size: 18px;
		   line-height: 1.4;
		   text-align: left;
		   display: block;
		 "></em>
	   </div>
 
	   <button id="return-to-void" style="
		 background: #000;
		 color: #00ff00;
		 border: 2px solid #00ff00;
		 padding: 15px 30px;
		 font-size: 16px;
		 border-radius: 5px;
		 cursor: pointer;
		 margin-top: 20px;
		 font-family: 'Courier New', monospace;
		 transition: all 0.3s;
	   " onmouseover="this.style.background='#00ff00'; this.style.color='#000';"
		  onmouseout="this.style.background='#000'; this.style.color='#00ff00';">
		 \u{1F30C} ${(0, $fUPn2.t)('memento.return_to_void_button', 'Return to the Void')}
	   </button>
	 </div>
   `;
    document.body.appendChild(completionPopup);
    // Safely inject dynamic text (prevents HTML injection)
    const eTxt = completionPopup.querySelector('#memento-eulogy-text');
    const epTxt = completionPopup.querySelector('#memento-epitaph-text');
    if (eTxt) eTxt.textContent = `"${llmEulogy}"`;
    if (epTxt) epTxt.textContent = `"${userEpitaph}"`;
    // Add click handler to log out user
    document.getElementById('return-to-void').addEventListener('click', async ()=>{
        console.log("\uD83C\uDF0C Return to Void button clicked");
        completionPopup.remove();
        try {
            await $0e009ca592c858ec$var$logout();
        } catch (error) {
            console.error("\u274C Error during logout:", error);
            // Force redirect anyway
            window.location.href = '/index.html';
        }
    });
}
// ========================================================================
// TIMER MANAGEMENT
// ========================================================================
/**
 * Start the Memento Mori countdown timer
 */ function $0e009ca592c858ec$var$startMementoMoriTimer(timeInMs) {
    console.log("\u23F0 Starting Memento Mori timer with", timeInMs, 'ms remaining');
    // Clear any existing timer
    if ($0e009ca592c858ec$var$mementoMoriTimer) clearInterval($0e009ca592c858ec$var$mementoMoriTimer);
    let remainingTime = timeInMs;
    const updateAllTimers = ()=>{
        const minutes = Math.floor(remainingTime / 60000);
        const seconds = Math.floor(remainingTime % 60000 / 1000);
        const timeString = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        // Update announcement timer if it exists
        const announcementTimer = document.getElementById('memento-timer');
        if (announcementTimer) announcementTimer.textContent = timeString;
        // Persistent timer removed - now handled by simulationTimer.js
        if (remainingTime <= 0) {
            clearInterval($0e009ca592c858ec$var$mementoMoriTimer);
            $0e009ca592c858ec$var$handleMementoMoriTimeout();
            return;
        }
        remainingTime -= 1000;
        // Update stored time for persistence
        if ($0e009ca592c858ec$var$mementoMoriData) {
            const storageData = {
                ...$0e009ca592c858ec$var$mementoMoriData,
                timeRemaining: remainingTime,
                storedAt: Date.now()
            };
            localStorage.setItem('activeMementoMori', JSON.stringify(storageData));
        }
    };
    // Update immediately
    updateAllTimers();
    // Start interval
    $0e009ca592c858ec$var$mementoMoriTimer = setInterval(updateAllTimers, 1000);
}
/**
 * Handle when the timer expires
 */ async function $0e009ca592c858ec$var$handleMementoMoriTimeout() {
    console.log("\u23F0 Memento Mori time has expired");
    // Clean up interfaces
    $0e009ca592c858ec$var$cleanupMementoMoriInterfaces();
    // Show loading popup while generating analysis
    const loadingPopup = document.createElement('div');
    loadingPopup.className = 'memento-modal';
    loadingPopup.style.cssText = `
	position: fixed; top: 0; left: 0; width: 100%; height: 100%;
	background: rgba(0, 0, 0, 0.95); z-index: 99999;
	display: flex; justify-content: center; align-items: center;
	font-family: 'Courier New', monospace;
  `;
    loadingPopup.innerHTML = `
	<div style="background: #000; border: 3px solid #ff6600; border-radius: 10px;
				padding: 40px; max-width: 500px; color: #ff6600; text-align: center;">
	  <h2 style="color: #ff6600; margin-bottom: 20px;">${(0, $fUPn2.t)('memento.title', 'TIME EXPIRED')}</h2>
	  <div style="font-size: 3em; margin: 20px 0;"></div>
	  <p>${(0, $fUPn2.t)('memento.body', "Death has come, but your portfolio's meaning is being preserved...")}</p>
	  <p style="font-size: 14px; margin-top: 15px;">${(0, $fUPn2.t)('memento.generating', 'Generating your final eulogy...')}</p>
	</div>
  `;
    document.body.appendChild(loadingPopup);
    try {
        const objectiveId = $0e009ca592c858ec$var$mementoMoriData?.objective?._id;
        if (objectiveId) {
            // Try to complete with auto-generated epitaph
            const epitaph = 'Time expired before completion, but the attempt to understand my financial soul in death\'s shadow holds meaning beyond words.';
            const completionResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/complete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
                },
                body: JSON.stringify({
                    objectiveId: objectiveId,
                    finalEpitaph: epitaph
                })
            });
            if (completionResponse.ok) {
                const result = await completionResponse.json();
                loadingPopup.remove();
                $0e009ca592c858ec$var$cleanupMementoMoriStorage();
                $0e009ca592c858ec$var$showDeathCompletion(result);
                return;
            }
        }
    } catch (error) {
        console.error("\u274C Error in timeout handling:", error);
    }
    // Fallback completion
    loadingPopup.remove();
    const fallbackResult = {
        personalInsight: "Time claimed you before completion, but your willingness to confront mortality through your portfolio reveals profound courage. In the urgency of finite time, you touched something eternal about the human search for meaning.",
        finalEpitaph: "A trader who dared to face death's questions, even when time itself became the final adversary."
    };
    $0e009ca592c858ec$var$cleanupMementoMoriStorage();
    $0e009ca592c858ec$var$showDeathCompletion(fallbackResult);
}
// ========================================================================
// UTILITY FUNCTIONS
// ========================================================================
/**
 * Get current time remaining
 */ function $0e009ca592c858ec$var$getTimeRemaining() {
    if (!$0e009ca592c858ec$var$mementoMoriData) return 0;
    const now = Date.now();
    const elapsed = now - ($0e009ca592c858ec$var$mementoMoriData.storedAt || now);
    return Math.max(0, $0e009ca592c858ec$var$mementoMoriData.timeRemaining - elapsed);
}
/**
 * Check reflection progress and show appropriate interface
 */ async function $0e009ca592c858ec$var$checkReflectionProgress() {
    try {
        const objectiveId = $0e009ca592c858ec$var$mementoMoriData?.objective?._id;
        if (!objectiveId) return;
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/objective/${objectiveId}`, {
            headers: {
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            }
        });
        if (response.ok) {
            const data = await response.json();
            const objective = data.objective;
            // Check status and show appropriate interface
            if (objective.status === 'completed') // Already completed, just show timer
            return;
        }
    } catch (error) {
        console.error('Error checking reflection progress:', error);
    }
}
/**
 * Clean up all Memento Mori interfaces
 */ function $0e009ca592c858ec$var$cleanupMementoMoriInterfaces() {
    // Persistent timer removed - now handled by simulationTimer.js
    // const timerOverlay = document.getElementById('persistent-memento-timer');
    // if (timerOverlay) timerOverlay.remove();
    const oracleInterface = document.getElementById('mortality-oracle-interface');
    if (oracleInterface) oracleInterface.remove();
    const reflectionInterface = document.getElementById('reflection-interface');
    if (reflectionInterface) reflectionInterface.remove();
    const allocationInterface = document.getElementById('final-allocation-interface');
    if (allocationInterface) allocationInterface.remove();
    // Remove eulogy popup
    const eulogyPopup = document.getElementById('memento-mori-eulogy');
    if (eulogyPopup) eulogyPopup.remove();
    // Remove expanded eulogy modal
    const expandedEulogy = document.getElementById('expanded-eulogy-modal');
    if (expandedEulogy) expandedEulogy.remove();
    // Clear timer
    if ($0e009ca592c858ec$var$mementoMoriTimer) {
        clearInterval($0e009ca592c858ec$var$mementoMoriTimer);
        $0e009ca592c858ec$var$mementoMoriTimer = null;
    }
    if ($0e009ca592c858ec$var$finalCurationTimeout) {
        clearTimeout($0e009ca592c858ec$var$finalCurationTimeout);
        $0e009ca592c858ec$var$finalCurationTimeout = null;
    }
    // Clear eulogy update interval
    if (window.mementoEulogyInterval) {
        clearInterval(window.mementoEulogyInterval);
        window.mementoEulogyInterval = null;
    }
    // Reset initialization flag
    window.mementoMoriInitialized = false;
}
/**
 * Clean up Memento Mori storage
 */ function $0e009ca592c858ec$var$cleanupMementoMoriStorage() {
    localStorage.removeItem('activeMementoMori');
    localStorage.removeItem('mementoMoriStarted');
    localStorage.removeItem('simulationType');
}
/**
 * Animate oracle response with typewriter effect
 */ async function $0e009ca592c858ec$var$animateOracleResponse(data) {
    const textDiv = document.getElementById('mortality-oracle-text');
    const followUpDiv = document.getElementById('oracle-follow-up');
    // Clear previous content
    textDiv.innerHTML = '';
    followUpDiv.innerHTML = '';
    // Type out the main response
    const mainResponse = `"${data.oracleResponse}"`;
    await $0e009ca592c858ec$var$typeWriterEffect(textDiv, mainResponse, 30);
    // Add follow-up insight if available
    if (data.followUpInsight) setTimeout(async ()=>{
        followUpDiv.innerHTML = `
		<div style="color: rgba(255, 135, 0, 0.9); font-weight: bold; margin-bottom: 8px;">
		  ${(0, $fUPn2.t)('memento.further_insight', "The Market's Further Insight:")}
		</div>
		<div style="color: #00ff00; font-size: 0.9em;"></div>
	  `;
        const insightText = followUpDiv.querySelector('div:last-child');
        await $0e009ca592c858ec$var$typeWriterEffect(insightText, data.followUpInsight, 25);
        // Add personalized guidance if available
        if (data.personalizedGuidance) setTimeout(async ()=>{
            const guidanceDiv = document.createElement('div');
            guidanceDiv.style.cssText = 'margin-top: 10px; color: rgba(0, 255, 0, 0.8); font-size: 0.85em; font-style: italic;';
            followUpDiv.appendChild(guidanceDiv);
            await $0e009ca592c858ec$var$typeWriterEffect(guidanceDiv, `\u{2192} ${data.personalizedGuidance}`, 20);
        }, 1000);
    }, 1500);
}
/**
 * Typewriter effect for text animation
 */ async function $0e009ca592c858ec$var$typeWriterEffect(element, text, speed = 30) {
    return new Promise((resolve)=>{
        let i = 0;
        const timer = setInterval(()=>{
            if (i < text.length) {
                element.textContent += text.charAt(i);
                i++;
            } else {
                clearInterval(timer);
                resolve();
            }
        }, speed);
    });
}
/**
 * Logout function
 */ async function $0e009ca592c858ec$var$logout() {
    const portfolioId = localStorage.getItem('portfolioId');
    const token = (0, $6pKgs.getAuthToken)();
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    if (!portfolioId || !token) {
        console.error('Portfolio ID or token not found in local storage');
        return;
    }
    try {
        // First, disconnect all bot sockets if this is a simulated user
        if (isSimulated && (0, $cJVho.socket) && (0, $cJVho.socket).connected) {
            console.log("\uD83E\uDD16 Disconnecting bots for simulated user logout...");
            (0, $cJVho.socket).emit('disconnectUserBots', {
                portfolioId: portfolioId
            });
            // Wait a moment for bot disconnection to complete
            await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        // Update the active status to false on the server
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/${portfolioId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                active: false
            })
        });
        if (!response.ok) throw new Error('Failed to update active status during logout');
    } catch (error) {
        console.error('Error updating active status during logout:', error);
    }
    try {
        // Call the logout endpoint on the server
        const logoutResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                isSimulated: isSimulated
            }),
            credentials: 'include'
        });
        if (!logoutResponse.ok) throw new Error('Failed to logout from server');
        const logoutData = await logoutResponse.json();
        console.log(logoutData.message);
    } catch (error) {
        console.error('Error during server logout:', error);
    }
    // Disconnect main socket
    if ((0, $cJVho.socket) && (0, $cJVho.socket).connected) {
        console.log("\uD83D\uDD0C Disconnecting main socket...");
        (0, $cJVho.socket).disconnect();
    }
    // Clear all storage
    localStorage.clear();
    // Clear cookies
    document.cookie.split(";").forEach((cookie)=>{
        const name = cookie.split("=")[0].trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax;Secure`;
    });
    window.location.href = '/index.html';
}
async function $0e009ca592c858ec$export$d0a3225c3d52d92a(portfolioId) {
    // Check local storage first
    const storedObjective = localStorage.getItem('activeMementoMori');
    const simulationType = localStorage.getItem('simulationType');
    if (storedObjective && simulationType === 'memento-mori') {
        console.log("\u2705 Memento Mori found in local storage. Restoring...");
        $0e009ca592c858ec$export$3392fc08bb337b13();
        return;
    }
    try {
        const res = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/portfolio/${portfolioId}/status`, {
            headers: {
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            }
        });
        if (!res.ok) {
            console.error('Failed to fetch Memento Mori status');
            return;
        }
        const data = await res.json();
        if (data.success && data.activeObjective) {
            console.log("\u26B0\uFE0F New Memento Mori objective found:", data.activeObjective);
            $0e009ca592c858ec$export$76e9e1d001f81ca4({
                objective: data.activeObjective,
                timeRemaining: data.activeObjective.timeRemaining
            });
        }
    } catch (err) {
        console.error('Error checking Memento Mori status:', err);
    }
}
// =====================================================
// NEW 3-PHASE MEMENTO MORI FLOW FUNCTIONS
// =====================================================
/**
 * Show new reflection interface for Phase 1
 */ /**
 * Show value analysis results and transition to trading phase
 */ function $0e009ca592c858ec$var$showValueAnalysisResults(analysisResult) {
    console.log("\uD83C\uDFAF Starting Phase 2: Values-Based Trading");
    $0e009ca592c858ec$var$mementoMoriPhase = 'trading';
    const resultsInterface = document.createElement('div');
    resultsInterface.id = 'value-analysis-results';
    resultsInterface.className = 'memento-mori-interface';
    resultsInterface.style.cssText = `
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: linear-gradient(135deg, #1a1a1a 0%, #1b2d1b 100%);
	border: 2px solid #228B22;
	border-radius: 15px;
	padding: 30px;
	z-index: 10000;
	max-width: 700px;
	max-height: 80vh;
	overflow-y: auto;
	box-shadow: 0 0 50px rgba(34, 139, 34, 0.8);
	color: white;
	font-family: 'Courier New', monospace;
  `;
    const recommendations = analysisResult.recommendedCompanies || [];
    const guidance = analysisResult.message || 'Trade based on your values, not profit.';
    resultsInterface.innerHTML = `
	<div style="text-align: center; margin-bottom: 25px;">
	  <h2 style="color: #90EE90; margin: 0; font-size: 24px;">${(0, $fUPn2.t)('memento.title', 'YOUR VALUE PROFILE')}</h2>
	  <p style="color: #ccc; margin: 10px 0;">${(0, $fUPn2.t)('memento.subtitle', 'Based on your reflections, here are companies that align with your values')}</p>
	</div>
	
	<div style="margin-bottom: 20px;">
	  <h3 style="color: #90EE90; margin-bottom: 10px;">${(0, $fUPn2.t)('memento.guidance_title', 'Guidance:')}</h3>
	  <p style="color: #ddd; line-height: 1.5; background: #2a2a2a; padding: 15px; border-radius: 8px;">
		${guidance}
	  </p>
	</div>
	
	<div style="margin-bottom: 25px;">
	  <h3 style="color: #90EE90; margin-bottom: 10px;">${(0, $fUPn2.t)('memento.recommended_title', 'Recommended Companies:')}</h3>
	  <div style="background: #2a2a2a; padding: 15px; border-radius: 8px; max-height: 200px; overflow-y: auto;">
		${recommendations.map((company)=>{
        const companyName = typeof company === 'object' ? company.companyName || company.name || 'Unknown Company' : company;
        const reason = typeof company === 'object' ? company.reason || '' : '';
        return `<div style="color: #fff; margin: 8px 0; padding: 5px;">
			<strong>\u{2022} ${companyName}</strong>
			${reason ? `<br><span style="color: #aaa; font-size: 0.9em; margin-left: 12px;">${reason}</span>` : ''}
		  </div>`;
    }).join('')}
	  </div>
	</div>
	
	<div style="text-align: center; margin-top: 25px;">
	  <button id="start-trading" style="
		background: linear-gradient(45deg, #228B22, #32CD32);
		color: white;
		border: none;
		padding: 12px 25px;
		border-radius: 25px;
		cursor: pointer;
		font-size: 16px;
		font-weight: bold;
		transition: all 0.3s;
	  ">
		${(0, $fUPn2.t)('memento.start_trading', "Start Trading (All 310+ Companies Available) \u2192")}
	  </button>
	</div>
  `;
    document.body.appendChild(resultsInterface);
    document.getElementById('start-trading').addEventListener('click', $0e009ca592c858ec$var$startTradingPhase);
}
/**
 * Start trading phase with all companies available
 */ function $0e009ca592c858ec$var$startTradingPhase() {
    console.log("\uD83D\uDCB0 Phase 2: Trading with all companies available");
    const resultsInterface = document.getElementById('value-analysis-results');
    if (resultsInterface) resultsInterface.remove();
    localStorage.setItem('simulationType', 'memento-mori');
    localStorage.setItem('mementoShowAllCompanies', 'true');
    ing;
    try {
        window.dispatchEvent(new CustomEvent('memento:showAllCompanies'));
    } catch  {}
    try {
        if (typeof displayPortfolioItems === 'function') displayPortfolioItems(true);
        else if (window.displayPortfolioItems) window.displayPortfolioItems(true);
        else setTimeout(()=>window.location.reload(), 500);
    } catch (err) {
        console.error('Error refreshing market:', err);
        setTimeout(()=>window.location.reload(), 500);
    }
    const tradingNotification = document.createElement('div');
    tradingNotification.style.cssText = `
	 position: fixed;
	 top: 20px;
	 right: 20px;
	 background: linear-gradient(45deg, #228B22, #32CD32);
	 color: white;
	 padding: 15px 20px;
	 border-radius: 10px;
	 z-index: 9999;
	 box-shadow: 0 4px 20px rgba(34, 139, 34, 0.5);
	 font-family: 'Courier New', monospace;
	 border: 2px solid #90EE90;
   `;
    tradingNotification.innerHTML = `
	 <div style="font-weight: bold; margin-bottom: 5px;">${(0, $fUPn2.t)('memento.active_badge', 'MEMENTO MORI TRADING ACTIVE')}</div>
	 <div style="font-size: 14px;">${(0, $fUPn2.t)('memento.all_available', 'All 310+ companies available for trading')}</div>
	 <div style="font-size: 12px; margin-top: 5px; opacity: 0.8;">${(0, $fUPn2.t)('memento.values_over_profit', 'Trade based on your values, not profit')}</div>
   `;
    document.body.appendChild(tradingNotification);
    setTimeout(()=>{
        if ($0e009ca592c858ec$var$mementoMoriPhase === 'trading') $0e009ca592c858ec$var$showFinalCompletionReminder();
    }, ($0e009ca592c858ec$var$mementoMoriData?.timeRemaining || 900000) - 180000);
}
/**
 * Show reminder to complete the simulation
 */ function $0e009ca592c858ec$var$showFinalCompletionReminder() {
    const reminder = document.createElement('div');
    reminder.style.cssText = `
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: linear-gradient(135deg, #8B0000, #DC143C);
	color: white;
	padding: 20px;
	border-radius: 10px;
	z-index: 10000;
	text-align: center;
	font-family: 'Courier New', monospace;
	border: 2px solid #ff4444;
  `;
    reminder.innerHTML = `
	<h3 style="margin: 0 0 10px 0;">${(0, $fUPn2.t)('memento.title', 'FINAL CALL')}</h3>
	<p style="margin: 0 0 15px 0;">${(0, $fUPn2.t)('memento.body', 'Time is running out. Complete your Memento Mori simulation now.')}</p>
	<button id="final-complete" style="
	  background: #8B0000;
	  color: white;
	  border: none;
	  padding: 10px 20px;
	  border-radius: 5px;
	  cursor: pointer;
	">
	  ${(0, $fUPn2.t)('memento.complete_now', "Complete Now \u2192")}
	</button>
  `;
    document.body.appendChild(reminder);
    document.getElementById('final-complete').addEventListener('click', ()=>{
        reminder.remove();
        $0e009ca592c858ec$var$completeNewMementoMoriFlow();
    });
    setTimeout(()=>{
        if (reminder.parentNode) reminder.remove();
    }, 30000);
}
/**
 * Complete the new Memento Mori flow with portfolio analysis
 */ async function $0e009ca592c858ec$var$completeNewMementoMoriFlow() {
    console.log("\uD83E\uDEA6 Phase 3: Completing Memento Mori with portfolio analysis");
    $0e009ca592c858ec$var$mementoMoriPhase = 'completed';
    // Clear any existing timers
    clearTimeout($0e009ca592c858ec$var$forcedDeathTimeout);
    try {
        const objectiveId = $0e009ca592c858ec$var$mementoMoriData?.objective?._id;
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/complete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            },
            body: JSON.stringify({
                objectiveId: objectiveId,
                finalReflections: {} // Could add final reflection questions here
            })
        });
        if (!response.ok) throw new Error('Failed to complete Memento Mori');
        const result = await response.json();
        console.log("\u2705 Memento Mori completed:", result);
        // Show final eulogy
        $0e009ca592c858ec$var$showFinalEulogy(result);
    } catch (error) {
        console.error('Error completing Memento Mori:', error);
        alert('Failed to complete Memento Mori simulation.');
    }
}
/**
 * Show the final portfolio-based eulogy
 */ function $0e009ca592c858ec$var$showFinalEulogy(completionResult) {
    const eulogyInterface = document.createElement('div');
    eulogyInterface.style.cssText = `
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: linear-gradient(135deg, #1a1a1a 0%, #2d1b1b 100%);
	border: 2px solid #8B0000;
	border-radius: 15px;
	padding: 30px;
	z-index: 10000;
	max-width: 800px;
	max-height: 80vh;
	overflow-y: auto;
	box-shadow: 0 0 50px rgba(139, 0, 0, 0.8);
	color: white;
	font-family: 'Courier New', monospace;
  `;
    const eulogy = completionResult.eulogy || 'Your portfolio reflected deep consideration of life values.';
    const insights = completionResult.portfolioInsights || [];
    eulogyInterface.innerHTML = `
	<div style="text-align: center; margin-bottom: 25px;">
	  <h2 style="color: #ff4444; margin: 0; font-size: 24px;">${(0, $fUPn2.t)('memento.title', 'YOUR DIGITAL EULOGY')}</h2>
	  <p style="color: #ccc; margin: 10px 0;">${(0, $fUPn2.t)('memento.subtitle', 'Based on your portfolio choices and life reflections')}</p>
	</div>
	
	<div style="background: #2a2a2a; padding: 20px; border-radius: 10px; margin-bottom: 20px;">
	  <h3 style="color: #ff6b6b; margin-bottom: 15px;">${(0, $fUPn2.t)('memento.your_eulogy', 'Your Eulogy:')}</h3>
	  <div style="color: #ddd; line-height: 1.6; font-style: italic;">
		"${eulogy}"
	  </div>
	</div>
	
	${insights.length > 0 ? `
	<div style="background: #2a2a2a; padding: 20px; border-radius: 10px; margin-bottom: 20px;">
	  <h3 style="color: #ff6b6b; margin-bottom: 15px;">${(0, $fUPn2.t)('memento.insights', 'Portfolio Insights:')}</h3>
	  ${insights.map((insight)=>`<div style="color: #ddd; margin: 8px 0;">\u{2022} ${insight}</div>`).join('')}
	</div>
	` : ''}
	
	<div style="text-align: center; margin-top: 25px;">
	  <button id="close-eulogy" style="
		background: linear-gradient(45deg, #8B0000, #DC143C);
		color: white;
		border: none;
		padding: 12px 25px;
		border-radius: 25px;
		cursor: pointer;
		font-size: 16px;
		font-weight: bold;
	  ">
		${(0, $fUPn2.t)('memento.rest_in_peace', 'Rest in Peace')}
	  </button>
	</div>
  `;
    document.body.appendChild(eulogyInterface);
    document.getElementById('close-eulogy').addEventListener('click', ()=>{
        eulogyInterface.remove();
        localStorage.removeItem('mementoMoriStarted');
        // Remove any trading notifications
        const notifications = document.querySelectorAll('[style*="MEMENTO MORI TRADING ACTIVE"]');
        notifications.forEach((notification)=>notification.remove());
    });
}
function $0e009ca592c858ec$var$cancelMementoMoriPhaseTimers() {}
// ✅ Listen for timer expiry event from simulationTimer.js
window.addEventListener('mementoMoriExpired', async ()=>{
    console.log("\u26B0\uFE0F [objectives.js] Memento Mori timer expired - completing session and redirecting");
    try {
        const objectiveId = localStorage.getItem('mementoMoriObjectiveId');
        if (!objectiveId) {
            console.error("\u274C No objective ID found for completion");
            // Redirect anyway with fallback
            $0e009ca592c858ec$var$redirectToMementoMoriEnd({
                eulogy: "Your journey through life's marketplace has concluded.",
                portfolioInsights: []
            });
            return;
        }
        // Call the completion endpoint
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/complete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $6pKgs.getAuthToken)()}`
            },
            body: JSON.stringify({
                objectiveId: objectiveId,
                finalReflections: {}
            })
        });
        if (!response.ok) throw new Error('Failed to complete Memento Mori');
        const result = await response.json();
        console.log("\u2705 Memento Mori auto-completed on timer expiry:", result);
        // Redirect to memento mori ending page with eulogy data
        $0e009ca592c858ec$var$redirectToMementoMoriEnd(result);
    } catch (error) {
        console.error("\u274C Error auto-completing Memento Mori on timer expiry:", error);
        // Redirect with fallback eulogy
        $0e009ca592c858ec$var$redirectToMementoMoriEnd({
            eulogy: "Your journey through life's marketplace has concluded. In facing mortality, you discovered what truly matters.",
            portfolioInsights: []
        });
    }
});
// Redirect to memento mori ending page with eulogy data
function $0e009ca592c858ec$var$redirectToMementoMoriEnd(eulogyData) {
    console.log("\uD83E\uDEA6 Redirecting to Memento Mori ending page...");
    try {
        // Store data in temporary localStorage (survives the logout/redirect)
        localStorage.setItem('tempMementoMoriResults', JSON.stringify({
            ...eulogyData,
            timestamp: Date.now()
        }));
        console.log("\uD83D\uDCBE Stored eulogy data for ending page");
        // Redirect to the ending page
        setTimeout(()=>{
            window.location.href = '/mementomoriend.html';
        }, 100);
    } catch (error) {
        console.error("\u274C Error preparing redirect:", error);
        // Try redirect anyway
        window.location.href = '/mementomoriend.html';
    }
}
function $0e009ca592c858ec$export$3e536f1cccf2aff1() {
    if ($0e009ca592c858ec$var$mementoMoriTimer) {
        clearInterval($0e009ca592c858ec$var$mementoMoriTimer);
        $0e009ca592c858ec$var$mementoMoriTimer = null;
    }
    $0e009ca592c858ec$var$cancelMementoMoriPhaseTimers(); // Also clean phase timers
    $0e009ca592c858ec$var$cleanupMementoMoriInterfaces();
    $0e009ca592c858ec$var$cleanupMementoMoriStorage();
}

});
parcelRegister("6pKgs", function(module, exports) {

$parcel$export(module.exports, "getAuthToken", () => $4ab8f70751c4aaf8$export$38e1f53b76ec7fed);
// sessionVir.js
function $4ab8f70751c4aaf8$export$3c4602e16d9ace38(token) {
    localStorage.setItem('token', token);
}
function $4ab8f70751c4aaf8$export$38e1f53b76ec7fed() {
    return localStorage.getItem('token');
}
function $4ab8f70751c4aaf8$export$1dd65e4691de719b(id) {
    localStorage.setItem('portfolioId', id);
}
function $4ab8f70751c4aaf8$export$141bbd10c4c06cba() {
    return localStorage.getItem('portfolioId');
}
function $4ab8f70751c4aaf8$export$f61b5f0b88be99b3(id) {
    localStorage.setItem('sessionId', id);
}
function $4ab8f70751c4aaf8$export$b3739caaf2580dd() {
    return localStorage.getItem('sessionId');
}
function $4ab8f70751c4aaf8$export$6ab8d810c69bec6f(role) {
    localStorage.setItem('role', role);
}
function $4ab8f70751c4aaf8$export$d1c3a5ff834adfa2() {
    return localStorage.getItem('role');
}
function $4ab8f70751c4aaf8$export$2fa8d65c91811f30(flag) {
    localStorage.setItem('firstLogin', flag ? 'true' : 'false');
}
function $4ab8f70751c4aaf8$export$4ec71a5f45bc4759() {
    return localStorage.getItem('firstLogin') === 'true';
}

});


parcelRegister("1NhFL", function(module, exports) {

$parcel$export(module.exports, "showWaitingForResponsePopup", () => $14e813777626223f$export$9bb10ee1b3014f2a);
$parcel$export(module.exports, "closeWaitingForResponsePopup", () => $14e813777626223f$export$b000159a735d13c1);
$parcel$export(module.exports, "showStockBidPopup", () => $14e813777626223f$export$aa71e03faf15c300);

var $cNeIB = parcelRequire("cNeIB");

var $21EbS = parcelRequire("21EbS");

var $cJVho = parcelRequire("cJVho");

var $fUPn2 = parcelRequire("fUPn2");

var $bNbKd = parcelRequire("bNbKd");

var $eD3DY = parcelRequire("eD3DY");
// Redirect guard: only forward from stockTransaction.html
window.isOn ||= (file)=>location.pathname.endsWith(`/${file}`) || location.pathname.endsWith(file);
// Where this TAB calls home. zfloor.js stamps sessionStorage.zxHome on every
// load, so any classic page opened from a tab that has seen the floor knows to
// go back to the floor — even down a path that never recorded an explicit
// zxReturnTo. That is the whole point: zxReturnTo is written by ONE function at
// hand-off time and is CONSUMED by the first reader, so any route that skips it
// (or loses the race) fell through to a hardcoded 'trader.html'/'market.html'
// and dumped a floor user into the classic system. This is the backstop under
// all of them. sessionStorage, not localStorage: it dies with the tab, so a
// market-origin session in a fresh tab is never affected.
window.zxHome ||= ()=>{
    try {
        return sessionStorage.getItem('zxHome');
    } catch (_) {
        return null;
    }
};
// The 3D floor (zfloor.html) is the primary interface. It records zxReturnTo
// before handing off here, so a finished bid or swap lands back on the floor
// instead of the classic market page. Market-origin trades are unaffected.
window.zxTakeReturn ||= ()=>{
    const target = localStorage.getItem('zxReturnTo');
    // Default is the FLOOR, never a classic page: mobile browsers drop
    // sessionStorage when they discard/restore a tab, so zxHome can vanish
    // mid-session — falling through to market.html stranded users in the
    // abandoned classic system.
    if (!target) return window.zxHome?.() || 'zfloor.html';
    localStorage.removeItem('zxReturnTo');
    return target;
};
window.shouldRedirectToMarket ||= ()=>window.isOn('stockTransaction.html') || window.isOn('transaction.html') && !!localStorage.getItem('zxReturnTo');
window.doMarketRedirectIfNeeded ||= ()=>{
    // Only redirect if on a transaction page AND user is an initiator (not a responder)
    if (window.shouldRedirectToMarket() && window.__userIsInitiator !== false) window.location.href = window.zxTakeReturn();
};
function $14e813777626223f$var$getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
function $14e813777626223f$var$getPortfolioId() {
    return $14e813777626223f$var$getCookie('portfolioId') || localStorage.getItem('portfolioId');
}
function $14e813777626223f$export$526fd5de268d6a23() {
    const token = (0, $21EbS.getAuthToken)(); // Get the token
    if (!token) {
        (0, $eD3DY.showNotification)("You must be logged in to perform this action.", false);
        return;
    }
    fetch(`${(0, $cNeIB.apiBaseUrl)}/api/stocks`, {
        headers: {
            'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
            'Content-Type': 'application/json'
        }
    }).then((response)=>{
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
    }).then((stocks)=>{
        if (stocks && Array.isArray(stocks)) $14e813777626223f$export$9abe027fc04b3f48(stocks);
        else console.error("Received stocks data is not an array:", stocks);
    }).catch((error)=>{
        console.error('Error fetching stocks:', error);
    });
}
function $14e813777626223f$export$9bb10ee1b3014f2a(message, timeoutSeconds = 10) {
    let existingPopup = document.getElementById('waitingPopup');
    if (existingPopup) existingPopup.remove();
    const popup = document.createElement('div');
    popup.id = 'waitingPopup';
    popup.style.cssText = `
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.8);
	color: #00ff00;
	padding: env(safe-area-inset-top, 20px) env(safe-area-inset-right, 20px) env(safe-area-inset-bottom, 20px) env(safe-area-inset-left, 20px);
	z-index: 10000;
	font-family: 'bithigh', Arial, sans-serif;
	display: grid;
	place-items: center;
	text-align: center;
  `;
    const inner = document.createElement('div');
    inner.style.cssText = `max-width: 720px; width: 90%;`;
    const title = document.createElement('h3');
    title.textContent = message || (0, $fUPn2.t)('stock_bid.processing_bid', 'Processing your bid...');
    title.style.marginBottom = '12px';
    inner.appendChild(title);
    const spinner = document.createElement('div');
    spinner.className = 'spinner';
    spinner.style.cssText = `
	border: 3px solid rgba(0, 255, 0, 0.3);
	border-top: 3px solid #00ff00;
	border-radius: 50%;
	width: 40px;
	height: 40px;
	animation: spin 1s linear infinite;
	margin: 16px auto 10px auto;
  `;
    inner.appendChild(spinner);
    const countdown = document.createElement('div');
    countdown.id = 'waitingCountdown';
    countdown.style.cssText = 'margin-top: 8px;';
    inner.appendChild(countdown);
    popup.appendChild(inner);
    const style = document.createElement('style');
    style.textContent = `
	@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
  `;
    document.head.appendChild(style);
    document.body.appendChild(popup);
    // Track popup state for bot interaction management
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'waiting-for-response');
    let remaining = Math.max(1, Number(timeoutSeconds) || 10);
    countdown.textContent = (0, $fUPn2.t)('stock_bid.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', `${remaining}`);
    const interval = setInterval(()=>{
        remaining -= 1;
        if (remaining <= 0) {
            clearInterval(interval);
            countdown.textContent = (0, $fUPn2.t)('stock_bid.no_response', 'No response received. This action has expired.');
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock_bid.offer_expired', 'No response received. Your offer expired.'), false);
            // Close popup and trigger redirect for initiator
            try {
                $14e813777626223f$export$b000159a735d13c1?.(false); // false = initiator, triggers redirect
            } catch (_) {}
        } else countdown.textContent = (0, $fUPn2.t)('stock_bid.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', `${remaining}`);
    }, 1000);
    // Store interval ID so it can be cleared
    window.__waitingPopupInterval = interval;
    // Expose closer globally - REMOVED redirect logic
    window.closeWaitingForResponsePopup = (isResponder = false)=>{
        clearInterval(interval);
        const p = document.getElementById('waitingPopup');
        if (p) {
            // Untrack popup before removing
            if (window.popupTracker) window.popupTracker.unregisterPopup('waitingPopup');
            p.remove();
        }
        console.log('[Popup] Closed, isResponder:', isResponder);
    // Do NOT redirect here - let the main closeWaitingForResponsePopup handle it
    };
}
async function $14e813777626223f$export$a53b6db1a226556a(stockId) {
    try {
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/stocks/${stockId}`, {
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch stock data: ${response.status} - ${response.statusText}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching stock data:', error);
        return null;
    }
}
function $14e813777626223f$export$9abe027fc04b3f48(stocks) {
    const stockList = document.getElementById('stock-list');
    if (!stockList) {
        console.error("Stock list element not found.");
        return;
    }
    if (!Array.isArray(stocks)) {
        console.error("Invalid stocks data:", stocks);
        return;
    }
    stockList.innerHTML = ''; // Clear existing stocks
    stocks.forEach((stock)=>{
        const stockElement = document.createElement('div');
        stockElement.innerHTML = `
	  <h3>${stock.name}</h3>
	  <p>${stock.description}</p>
	  <p>Product: ${stock.product}</p>
	  <p>Available Shares: ${stock.availableShares}</p>
	  <p>Share Value: ${stock.shareValue}</p>
	  <p>Company Value: ${(stock.shareValue * stock.availableShares).toFixed(2)}</p>
	  <button class="trade-button" data-stock-id="${stock._id}">Trade</button>
	`;
        stockList.appendChild(stockElement);
        $14e813777626223f$var$addGlobalIndicator(stockElement, stock);
        const tradeButton = stockElement.querySelector('.trade-button');
        tradeButton.onclick = ()=>{
            $14e813777626223f$export$da0f12a59a6d31d9(stock);
        };
    });
}
function $14e813777626223f$export$b3739caaf2580dd() {
    return localStorage.getItem('sessionId') || null;
}
function $14e813777626223f$export$da0f12a59a6d31d9(stock) {
    const stockTradeModal = document.createElement('div');
    stockTradeModal.classList.add('modal');
    stockTradeModal.innerHTML = `
	<div class="modal-content">
	  <span class="close">&times;</span>
	  <h2>Trade Stock</h2>
	  <p><strong>Company:</strong> ${stock.name}</p>
	  <p><strong>Description:</strong> ${stock.description}</p>
	  <p><strong>Product:</strong> ${stock.product}</p>
	  <p><strong>Available Shares:</strong> ${stock.availableShares}</p>
	  <button id="bid-button">Bid</button>
	  <button id="short-button">Short</button>
	  <button id="exchange-button">Exchange</button>
	</div>
  `;
    document.body.appendChild(stockTradeModal);
    // Generate unique ID for tracking
    const modalId = `stockTradeModal_${Date.now()}`;
    stockTradeModal.id = modalId;
    // Track popup state for bot interaction management
    if (window.popupTracker) window.popupTracker.trackElement(stockTradeModal, 'stock-trade-modal');
    const closeButton = stockTradeModal.querySelector('.close');
    closeButton.onclick = ()=>{
        // Untrack popup before removing
        if (window.popupTracker) window.popupTracker.unregisterPopup(modalId);
        stockTradeModal.remove();
    };
    const bidButton = stockTradeModal.querySelector('#bid-button');
    bidButton.onclick = ()=>{
        localStorage.setItem('stockData', JSON.stringify(stock));
        window.location.href = `stockTransaction.html?stockId=${stock._id}&stockName=${stock.name}`;
    };
    const exchangeButton = stockTradeModal.querySelector('#exchange-button');
    exchangeButton.onclick = ()=>{
        const itemId = prompt((0, $fUPn2.t)('stock.enter_item_id', 'Enter the item ID to exchange for the stock:'));
        if (!itemId) return;
        const s = typeof window !== 'undefined' ? window.popupTrackerSocket : null;
        if (!s || !s.connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock.ws_not_connected', 'Not connected. Please try again.'), false);
            return;
        }
        const payload = {
            stockId: stock._id,
            itemId: itemId,
            portfolioId: $14e813777626223f$var$getPortfolioId(),
            portfolioName: $14e813777626223f$var$getCookie('username'),
            sessionId: $14e813777626223f$export$b3739caaf2580dd()
        };
        s.emit('exchangeStockForItem', payload, (ack)=>{
            if (ack && ack.success === false) {
                (0, $eD3DY.showNotification)(ack.error || (0, $fUPn2.t)('stock.exchange_failed', 'Exchange failed.'), false);
                return;
            }
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock.exchange_sent', 'Exchange proposed.'), true);
            stockTradeModal.remove();
        });
    };
}
function $14e813777626223f$export$aa71e03faf15c300(bidData, portfolioId, timeoutDuration = 10000) {
    console.log('Attempting to show stock bid popup:', bidData);
    bidData.isResponder = true;
    // Remove any existing popup
    let existingPopup = document.getElementById("stockBidPopup");
    if (existingPopup) {
        console.log('Removing existing popup.');
        existingPopup.remove();
    }
    // Create a new popup
    const popup = document.createElement("div");
    popup.setAttribute("id", "stockBidPopup");
    popup.setAttribute("style", `
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	max-width: 100%;
	height: 100%;
	max-height: 100%;
	border-radius: 0px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
	z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif;
	color: #00ff00;
	text-align: center;
	align-content: center;
	overflow: hidden;
  `);
    // Create video element
    const video = document.createElement("video");
    video.setAttribute("id", "stockBidBackground");
    video.setAttribute("style", `
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  object-fit: cover;
	  z-index: -1;
	  pointer-events: none; /* Ensure the video is non-interactive */
	`);
    video.setAttribute("autoplay", "true");
    video.setAttribute("loop", "true");
    video.setAttribute("muted", "true");
    video.setAttribute("playsinline", "true"); // Required for autoplay on mobile
    popup.appendChild(video);
    // Prevent interaction with the video
    video.addEventListener('click', (event)=>{
        event.stopPropagation();
        event.preventDefault();
    });
    // Prevent fullscreen on double-click
    video.addEventListener('dblclick', (event)=>{
        event.stopPropagation();
        event.preventDefault();
    });
    // Prevent right-click context menu
    video.addEventListener('contextmenu', (event)=>{
        event.preventDefault();
    });
    // Create content container
    const content = document.createElement("div");
    content.setAttribute("style", `
	 position: relative;
	 z-index: 1;
	 padding: 22px 18px;
	 margin: 0 16px;
	 border-radius: 10px;
	 background: rgba(0, 0, 0, 0.6);
	 text-shadow: 0 1px 3px #000;
  `);
    // Translate company name using companies_by_id pattern if csvRow is available
    const csvRow = bidData.csvRow || bidData.companyCsvId || bidData.stockCsvRow;
    const translatedStockName = csvRow ? (0, $fUPn2.t)(`companies_by_id.${csvRow}.Company_Name`, bidData.stockName) : bidData.stockName;
    // What they want and what they pay — nothing else. Tester: "too much text
    // on the stock bid from another trader, I can't read it all; focus on the
    // stock and the bid value." The explainer paragraph and the full sentence
    // are gone; who is asking is a small line above.
    const escH = (v)=>String(v == null ? '' : v).replace(/[&<>"']/g, (c)=>({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            })[c]);
    let offerHtml = '';
    if (bidData.bidType === 'zollars') {
        const parts = Object.entries(bidData.zollarBid || {}).filter(([, v])=>v > 0).map(([type, v])=>`${escH(type.charAt(0).toUpperCase() + type.slice(1))} <span style="opacity:.75">(${escH($14e813777626223f$var$getQualitativeDescriptor(v))})</span>`);
        offerHtml = parts.length ? parts.join('<br>') : escH((0, $fUPn2.t)('stock_bid.zollars', 'zollars'));
    } else offerHtml = `\u{1B5}${escH(bidData.amount)}`;
    const big = 'font-size: clamp(1.6rem, 7vw, 2.6rem); line-height: 1.15; margin: 6px 0;';
    content.innerHTML = `
	<div style="font-size: clamp(0.95rem, 3.6vw, 1.15rem); opacity: .85;">${escH((0, $fUPn2.t)('stock_bid.wants_to_buy', '{portfolioName} wants to buy').replace('{portfolioName}', bidData.portfolioName || ''))}</div>
	<div style="${big} color:#fff;">${escH(translatedStockName)}${Number(bidData.shares) > 1 ? ` <span style="opacity:.7">\xd7${escH(bidData.shares)}</span>` : ''}</div>
	<div style="font-size: clamp(0.95rem, 3.6vw, 1.15rem); opacity: .85; margin-top: 14px;">${escH((0, $fUPn2.t)('stock_bid.offering', 'offering'))}</div>
	<div style="${big} color:#fcba03;">${offerHtml}</div>
	<div style="margin-top: 18px;">
	  <button id="acceptBid" style="margin: 10px; padding: 14px 28px; min-height: 48px; min-width: 120px; background-color: rgba(0, 255, 0, 0.8); color: black; border: none; cursor: pointer; touch-action: manipulation; font-size: 18px; font-family: 'bithigh', Arial, sans-serif;">${escH((0, $fUPn2.t)('stock_bid.accept', 'Accept'))}</button>
	  <button id="declineBid" style="margin: 10px; padding: 14px 28px; min-height: 48px; min-width: 120px; background-color: rgba(255, 0, 0, 0.75); color: white; border: none; cursor: pointer; touch-action: manipulation; font-size: 18px; font-family: 'bithigh', Arial, sans-serif;">${escH((0, $fUPn2.t)('stock_bid.decline', 'Decline'))}</button>
	</div>
	<div id="bidTimer" style="opacity:.7"></div>
  `;
    popup.appendChild(content);
    // Append the popup to the body
    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';
    console.log('Popup should now be visible.');
    // Track popup state for bot interaction management
    if (window.popupTracker) window.popupTracker.trackElement(popup, 'stock-bid-popup');
    // Video background logic
    const videoBaseUrl = `${(0, $cNeIB.apiBaseUrl)}/uploads/specialBacks/stockBack/`;
    const totalVideos = 62;
    const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
    const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;
    if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(videoUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function() {
            video.play();
        });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoUrl;
        video.addEventListener('loadedmetadata', function() {
            video.play();
        });
    }
    const timerElement = document.getElementById('bidTimer');
    let remainingTime = timeoutDuration / 1000;
    const timerInterval = setInterval(()=>{
        remainingTime -= 1;
        if (timerElement) timerElement.textContent = (0, $fUPn2.t)('stock_bid.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', remainingTime);
        if (remainingTime <= 0) {
            clearInterval(timerInterval);
            if (timerElement) timerElement.textContent = (0, $fUPn2.t)('stock_bid.time_expired', 'Time expired');
            declineBid();
        }
    }, 1000);
    // Accept bid function
    const acceptBid = ()=>{
        clearInterval(timerInterval);
        const stockId = bidData.stockId;
        const bidId = bidData.bidId;
        const transactionId = bidData.transactionId || bidData.bidId;
        const initiatorPortfolioId = bidData.bidderId || bidData.initiatorPortfolioId;
        const responderPortfolioId = $14e813777626223f$var$getPortfolioId();
        const bidShares = bidData.shares;
        const bidType = bidData.bidType;
        const token = (0, $21EbS.getAuthToken)();
        const sessionId = $14e813777626223f$export$b3739caaf2580dd();
        if (!(stockId && bidId && initiatorPortfolioId && responderPortfolioId && bidShares && bidType && token)) {
            console.error('Invalid data for accepting bid:', {
                stockId: stockId,
                bidId: bidId,
                transactionId: transactionId,
                initiatorPortfolioId: initiatorPortfolioId,
                responderPortfolioId: responderPortfolioId,
                bidShares: bidShares,
                bidType: bidType
            });
            return;
        }
        // Mark user as responder - prevents redirect even if on stockTransaction.html
        window.__userIsInitiator = false;
        const _onceMood = (payload)=>{
            try {
                if (payload && payload.success !== false) {
                    const mood = payload.analysis || payload.moodResult;
                    if (mood) // Show immediately for responder (don't store, don't set redirect flag)
                    try {
                        (0, $bNbKd.showMoodAnalysisPopup)(mood);
                        // Clear sessionStorage to prevent duplicate display on next page
                        sessionStorage.removeItem('pendingMoodAnalysis');
                    // DO NOT set window.__pendingMarketRedirect for responders
                    } catch (e) {
                        console.error('Failed to show mood popup:', e);
                    }
                }
            } finally{
                (0, $cJVho.socket).off('moodAnalysis', _onceMood);
            // DO NOT redirect for responders
            }
        };
        (0, $cJVho.socket).once('moodAnalysis', _onceMood);
        // REMOVED duplicate notification - socketU.js bidAcceptSuccess handler will show it
        // This prevents double notifications when accepting a bid
        if (!(0, $cJVho.socket) || !(0, $cJVho.socket).connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock.ws_not_connected', 'Not connected. Please try again.'), false);
            (0, $cJVho.socket).off('moodAnalysis', _onceMood); // cleanup if we bail
            return;
        }
        try {
            popup.remove();
        } catch (e) {}
        document.body.style.overflow = 'auto';
        (0, $cJVho.socket).emit('acceptBid', {
            transactionId: transactionId,
            stockId: stockId,
            bidId: bidId,
            portfolioId: responderPortfolioId,
            bidderId: initiatorPortfolioId,
            bidShares: bidShares,
            bidType: bidType,
            token: token,
            sessionId: sessionId
        }, (ack)=>{
            if (ack && ack.success === false) {
                (0, $eD3DY.showNotification)(ack.error || (0, $fUPn2.t)('stock.accept_failed', 'Failed to accept bid.'), false);
                return;
            }
        // Success notification will be shown by bidAcceptSuccess socket handler
        });
    };
    const declineBid = ()=>{
        clearInterval(timerInterval);
        const stockId = bidData.stockId;
        const bidId = bidData.bidId;
        const transactionId = bidData.transactionId || bidData.bidId;
        const initiatorPortfolioId = bidData.bidderId || bidData.initiatorPortfolioId; // buyer
        const responderPortfolioId = $14e813777626223f$var$getPortfolioId(); // seller
        const bidShares = bidData.shares;
        const bidType = bidData.bidType;
        const token = (0, $21EbS.getAuthToken)();
        const sessionId = $14e813777626223f$export$b3739caaf2580dd();
        if (!(stockId && bidId && initiatorPortfolioId && responderPortfolioId && bidShares && bidType && token)) {
            console.error('Invalid data for declining bid:', {
                stockId: stockId,
                bidId: bidId,
                transactionId: transactionId,
                initiatorPortfolioId: initiatorPortfolioId,
                responderPortfolioId: responderPortfolioId,
                bidShares: bidShares,
                bidType: bidType
            });
            return;
        }
        // Mark user as responder - prevents redirect even if on stockTransaction.html
        window.__userIsInitiator = false;
        const _onceMood = (payload)=>{
            try {
                if (payload && payload.success !== false) {
                    const mood = payload.analysis || payload.moodResult;
                    if (mood) // Show immediately for responder (don't store, don't set redirect flag)
                    try {
                        (0, $bNbKd.showMoodAnalysisPopup)(mood);
                        // Clear sessionStorage to prevent duplicate display on next page
                        sessionStorage.removeItem('pendingMoodAnalysis');
                    // DO NOT set window.__pendingMarketRedirect for responders
                    } catch (e) {
                        console.error('Failed to show mood popup:', e);
                    }
                }
            } finally{
                (0, $cJVho.socket).off('moodAnalysis', _onceMood);
            // DO NOT redirect for responders
            }
        };
        (0, $cJVho.socket).once('moodAnalysis', _onceMood);
        // REMOVED duplicate notification - socketU.js bidDeclineSuccess handler will show it
        // This prevents double notifications when declining a bid
        if (!(0, $cJVho.socket) || !(0, $cJVho.socket).connected) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('stock.ws_not_connected', 'Not connected. Please try again.'), false);
            (0, $cJVho.socket).off('moodAnalysis', _onceMood); // cleanup if we bail
            return;
        }
        try {
            popup.remove();
        } catch (e) {}
        document.body.style.overflow = 'auto';
        (0, $cJVho.socket).emit('declineBid', {
            transactionId: transactionId,
            stockId: stockId,
            bidId: bidId,
            portfolioId: responderPortfolioId,
            bidderId: initiatorPortfolioId,
            bidShares: bidShares,
            bidType: bidType,
            token: token,
            sessionId: sessionId
        }, (ack)=>{
            if (ack && ack.success === false) {
                (0, $eD3DY.showNotification)(ack.error || (0, $fUPn2.t)('stock.decline_failed', 'Failed to decline bid.'), false);
                return;
            }
        // Success notification will be shown by bidDeclineSuccess socket handler
        });
    };
    const acceptButton = popup.querySelector("#acceptBid");
    const declineButton = popup.querySelector("#declineBid");
    if (acceptButton && declineButton) {
        acceptButton.addEventListener('click', acceptBid);
        declineButton.addEventListener('click', declineBid);
    } else console.error("Accept or decline buttons not found in DOM.");
    function displayZollarDetails(zollarBid) {
        if (!zollarBid || Object.keys(zollarBid).length === 0) return '<p>No zollar details available.</p>';
        let zollarHtml = '<ul>';
        for (const [type, value] of Object.entries(zollarBid))if (value > 0) {
            const descriptor = $14e813777626223f$var$getQualitativeDescriptor(value);
            zollarHtml += `<li>${type}: ${descriptor}</li>`;
        }
        zollarHtml += '</ul>';
        return zollarHtml;
    }
}
function $14e813777626223f$export$b000159a735d13c1(isResponder = false) {
    console.log('closeWaitingForResponsePopup called, isResponder:', isResponder);
    const ids = [
        'waitingPopup',
        'stockBidPopup',
        'bidSubmittingOverlay'
    ];
    for (const id of ids){
        const el = document.getElementById(id);
        if (el) {
            // Untrack popup before removing
            if (window.popupTracker) window.popupTracker.unregisterPopup(id);
            el.remove();
        }
    }
    // Clear all intervals
    if (window.__bidSubmittingInterval) {
        clearInterval(window.__bidSubmittingInterval);
        window.__bidSubmittingInterval = null;
    }
    if (window.__instantWaitInterval) {
        clearInterval(window.__instantWaitInterval);
        window.__instantWaitInterval = null;
    }
    if (window.__waitingPopupInterval) {
        clearInterval(window.__waitingPopupInterval);
        window.__waitingPopupInterval = null;
    }
    try {
        document.body.style.overflow = '';
    } catch (_) {}
    // CRITICAL: If responder, do nothing and exit
    if (isResponder) {
        console.log('Responder - NOT redirecting');
        return;
    }
    console.log('Initiator - setting up redirect logic');
    // Only for initiators: check if mood popup is open
    try {
        const moodEl = document.getElementById('moodAnalysisPopup') || document.getElementById('moodPopup') || document.querySelector('.mood-popup, .moodAnalysis, .mood-analysis, [data-mood-popup]');
        if (moodEl) {
            window.__pendingMarketRedirect = true;
            const obs = new MutationObserver(()=>{
                const stillOpen = document.getElementById('moodAnalysisPopup') || document.getElementById('moodPopup') || document.querySelector('.mood-popup, .moodAnalysis, .mood-analysis, [data-mood-popup]');
                if (!stillOpen) {
                    try {
                        doMarketRedirectIfNeeded();
                    } catch (_) {}
                    obs.disconnect();
                }
            });
            obs.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else doMarketRedirectIfNeeded();
    } catch (e) {
        try {
            doMarketRedirectIfNeeded();
        } catch (_) {}
    }
}
async function $14e813777626223f$var$addGlobalIndicator(stockElement, stock) {
    if (!stock.isSystemCompany || !stock.systemCompanyId) return;
    try {
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/stocks/global-valuation/${stock.systemCompanyId}`, {
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        if (response.ok) {
            const globalData = await response.json();
            const indicator = document.createElement('small');
            indicator.style.color = '#00ff00';
            indicator.style.display = 'block';
            indicator.innerHTML = `\u{1F310} Global: \u{1B5}${globalData.currentShareValue.toFixed(2)} | Trades: ${globalData.tradingStats.totalTransactions}`;
            stockElement.querySelector('h3').after(indicator);
        }
    } catch (error) {
        console.warn('Could not add global indicator:', error.message);
    }
}
function $14e813777626223f$var$getQualitativeDescriptor(quantity) {
    if (quantity === 0) return 'None';
    else if (quantity >= 1 && quantity <= 3) return 'A Few';
    else if (quantity >= 4 && quantity <= 7) return 'Some';
    else if (quantity >= 8 && quantity <= 15) return 'Many';
    else return 'A Huge Amount';
}
function $14e813777626223f$var$setFallbackBackground(element) {
    element.style.backgroundImage = 'linear-gradient(45deg, #000000, #001f3f)';
    element.style.backgroundSize = 'cover';
}

});

parcelRegister("8X27K", function(module, exports) {

$parcel$export(module.exports, "fetchBondData", () => $68457b2e043c885d$export$de4adcbe4254516b);
$parcel$export(module.exports, "showBondBidPopup", () => $68457b2e043c885d$export$28abc84d2983bd41);

var $5W4EI = parcelRequire("5W4EI");

var $cJVho = parcelRequire("cJVho");

var $21EbS = parcelRequire("21EbS");

var $eD3DY = parcelRequire("eD3DY");
parcelRequire("fUPn2");
function $68457b2e043c885d$var$getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
function $68457b2e043c885d$var$getPortfolioId() {
    return $68457b2e043c885d$var$getCookie('portfolioId') || localStorage.getItem('portfolioId');
}
async function $68457b2e043c885d$export$de4adcbe4254516b(bondId) {
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/bonds/${bondId}`, {
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            }
        });
        console.log('Response Status:', response.status);
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('text/html')) {
            // Handle unexpected HTML response (e.g., login page)
            console.error('Unexpected HTML response. Redirecting to login...');
            window.location.href = '/login.html';
            return null;
        }
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to fetch bond data');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching bond data:', error);
        return null;
    }
}
async function $68457b2e043c885d$export$484c8551133d696f(bondId, amount, targetUser) {
    if (!bondId || typeof bondId !== 'string') {
        console.error('Invalid bondId provided:', bondId);
        throw new Error('Invalid bondId.');
    }
    if (!amount || isNaN(amount) || amount <= 0) {
        console.error('Invalid bid amount provided:', amount);
        throw new Error('Invalid bid amount.');
    }
    if (!targetUser || typeof targetUser !== 'string') {
        console.error('Invalid targetUser provided:', targetUser);
        throw new Error('Invalid targetUser.');
    }
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/bonds/${bondId}/bids`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                amount: amount,
                targetUser: targetUser
            })
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to place bid.');
        }
        console.log('Bid placed successfully!');
    } catch (error) {
        console.error('Error placing bond bid:', error.message);
        throw error;
    }
}
async function $68457b2e043c885d$export$58db19e34d32f9d(bondId) {
    try {
        console.log('Initiating bond purchase for ID:', bondId);
        // Retrieve buyer's portfolioId from localStorage
        const buyerPortfolioId = localStorage.getItem('portfolioId');
        console.log('Retrieved buyerPortfolioId from localStorage:', buyerPortfolioId);
        // Throw an error if portfolioId is missing
        if (!buyerPortfolioId) throw new Error('Portfolio ID is missing in localStorage');
        // Send portfolioId along with the request
        const payload = JSON.stringify({
            portfolioId: buyerPortfolioId
        });
        console.log('Payload sent to backend:', payload);
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/bonds/buy/${bondId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: payload
        });
        if (!response.ok) {
            const errorData = await response.json();
            console.error('API error response:', errorData);
            throw new Error(errorData.error || 'Failed to buy bond');
        }
        const data = await response.json();
        console.log('Bond purchase response data:', data);
        return data;
    } catch (error) {
        console.error('Error buying bond:', error);
        throw error;
    }
}
function $68457b2e043c885d$export$28abc84d2983bd41(bidData, portfolioId) {
    const yieldDescriptor = $68457b2e043c885d$var$getQualitativeDescriptor(bidData.zollarValue || 0);
    // Create and populate the popup
    const popup = document.createElement('div');
    popup.id = 'BondPop-popup-container';
    popup.innerHTML = `
	<div class="BondPop-popup-content">
	  <h2>Bond Bid Offer</h2>
	  <h3><strong>${bidData.portfolioName} offers to buy "${bidData.bondName}" for ${bidData.amount} points.</strong></h3>
	  <p><strong>Interest Rate:</strong> ${bidData.interestRate}%</p>
	  <p><strong>Yield:</strong> ${yieldDescriptor} Zollars</p>
	  <p><strong>Maturity Date:</strong> ${new Date(bidData.maturityDate).toLocaleString()}</p>
	  <p><strong>Current Price:</strong> ${bidData.price || 'N/A'}</p>
	  <div class="BondPop-buttons">
		<button id="BondPop-acceptOffer">Accept</button>
		<button id="BondPop-declineOffer">Decline</button>
	  </div>
	</div>
  `;
    document.body.appendChild(popup);
    // Event listener for accepting the bid
    document.getElementById('BondPop-acceptOffer').onclick = async ()=>{
        const { bondId: bondId, bidderId: bidderId } = bidData;
        const bondBidId = bidData._id;
        const portfolioId = $68457b2e043c885d$var$getPortfolioId();
        const token = localStorage.getItem('token');
        try {
            console.log('Accepting bond bid with data:', {
                bondId: bondId,
                bondBidId: bondBidId,
                portfolioId: portfolioId,
                bidderId: bidderId
            });
            // Include bidderId in the payload
            const response = await fetch(`/api/bonds/${bondId}/bids/accept`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    bondBidId: bondBidId,
                    portfolioId: portfolioId,
                    bidderId: bidderId
                })
            });
            const result = await response.json();
            if (response.ok) {
                (0, $eD3DY.showNotification)('Bid accepted successfully.', true);
                // Emit the bondBidAccepted event to notify the bidder
                (0, $cJVho.socket).emit('bondBidAccepted', {
                    bondId: bondId,
                    bidId: bondBidId,
                    bondName: bidData.bondName,
                    bidderId: bidderId
                });
            } else {
                console.error('Failed to accept bond bid:', result.error);
                (0, $eD3DY.showNotification)('Error accepting bid: ' + result.error, false);
            }
        } catch (error) {
            console.error('Network error:', error.message);
            (0, $eD3DY.showNotification)('Network error occurred while accepting bond bid.', false);
        }
        popup.remove();
    };
    // Event listener for declining the bid
    document.getElementById('BondPop-declineOffer').onclick = async ()=>{
        const { bondId: bondId, bidderId: bidderId } = bidData;
        const bondBidId = bidData._id;
        const portfolioId = $68457b2e043c885d$var$getPortfolioId();
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`/api/bonds/${bondId}/bids/decline`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    bondBidId: bondBidId,
                    portfolioId: portfolioId
                })
            });
            const result = await response.json();
            if (response.ok) {
                (0, $eD3DY.showNotification)('Bid declined successfully.', false);
                (0, $cJVho.socket).emit('bondBidDeclined', {
                    bondId: bondId,
                    bidId: bondBidId,
                    bondName: bidData.bondName,
                    bidderId: bidderId
                }); // Notify the initiator
            } else {
                console.error('Failed to decline bid:', result.error);
                (0, $eD3DY.showNotification)('Error declining bid: ' + result.error, false);
            }
        } catch (error) {
            console.error('Network error:', error.message);
            (0, $eD3DY.showNotification)('Network error occurred while declining bid.', false);
        }
        popup.remove();
    };
}
function $68457b2e043c885d$var$getQualitativeDescriptor(quantity) {
    if (quantity === 0) return 'None';
    else if (quantity === 1) return 'Little';
    else if (quantity >= 2 && quantity <= 5) return 'A Few';
    else if (quantity >= 6 && quantity <= 10) return 'Some';
    else if (quantity >= 11 && quantity <= 15) return 'Many';
    else return 'A Huge Amount';
}
function $68457b2e043c885d$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});

parcelRegister("eevDZ", function(module, exports) {

$parcel$export(module.exports, "showCommunityInvitationPopup", () => $a5caeb58e516bc0d$export$9c77a35647b896d4);
$parcel$export(module.exports, "startCommunityTimer", () => $a5caeb58e516bc0d$export$1199d36f0c9e0a05);
$parcel$export(module.exports, "showCommunityInterface", () => $a5caeb58e516bc0d$export$3f25e634dcc98320);

var $5W4EI = parcelRequire("5W4EI");

var $cJVho = parcelRequire("cJVho");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");
// Translation helper function
const $a5caeb58e516bc0d$var$showNotification = (message, isSuccess)=>{
    // See notif.js — the 3D floor renders its own 8-bit side cards. This module
    // keeps a private copy of the notification, so it needs the hook too.
    if (typeof window !== 'undefined' && typeof window.zxNotify === 'function') return window.zxNotify(message, isSuccess);
    const notification = document.createElement('div');
    notification.style = `
	position: fixed; bottom: 8%; right: -100%; 
	width: 80%; 
	max-width: 100%; 
	margin-left: auto; 
	margin-right: auto; 
	left: 5%; 
	background-color: ${isSuccess ? 'rgba(0, 255, 0, 0.9)' : 'rgba(255, 0, 0, 0.9)'}; 
	padding: 20px; border-radius: 5px; border: 2px solid #00ff00; 
	color: #000000; font-family: 'bithigh', Arial, sans-serif; 
	z-index: 10001; text-align: center; 
	transition: right 0.5s ease-out;
  `;
    notification.innerHTML = `<p style="color: #000000;">${message}</p>`;
    document.body.appendChild(notification);
    setTimeout(()=>{
        notification.style.right = '10%';
    }, 10);
    setTimeout(()=>{
        notification.style.right = '-100%';
        setTimeout(()=>notification.remove(), 500);
    }, 2000);
};
let $a5caeb58e516bc0d$var$communityTimer;
let $a5caeb58e516bc0d$var$communityId;
function $a5caeb58e516bc0d$export$9c77a35647b896d4(data) {
    console.log('Showing community invitation popup');
    const popup = document.createElement('div');
    popup.id = 'communityInvitationPopup';
    popup.style = `
	position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
	background-color: rgba(0, 0, 0, 0.85); padding: 20px; border-radius: 10px;
	z-index: 1000; color: #00ff00; font-family: 'bithigh', sans-serif; width: 98%; max-width:98%;
	height:98%; max-height:98%; align-content: center;
  `;
    popup.innerHTML = `
	<h2>${(0, $fUPn2.t)('Dark Pool Invitation', 'Dark Pool Invitation')}</h2>
	<p>${(0, $fUPn2.t)('Join the dark pool for exclusive trading.', 'Join the dark pool for exclusive trading.')}</p>
	<p>${(0, $fUPn2.t)('The dark pool will be active for 10 minutes.', 'The dark pool will be active for 10 minutes.')}</p>
	<div style="display: flex; justify-content: space-between; margin-top: 20px;">
	  <button id="acceptCommunity" style="padding: 10px 20px; cursor: pointer;">${(0, $fUPn2.t)('Accept', 'Accept')}</button>
	  <button id="declineCommunity" style="padding: 10px 20px; cursor: pointer;">${(0, $fUPn2.t)('Decline', 'Decline')}</button>
	</div>
  `;
    document.body.appendChild(popup);
    (function(invitationData) {
        const acceptButton = document.getElementById('acceptCommunity');
        const declineButton = document.getElementById('declineCommunity');
        if (acceptButton) acceptButton.addEventListener('click', function() {
            console.log('Accept button clicked');
            $a5caeb58e516bc0d$export$bc337264c9bc2c55(true, invitationData);
        });
        else console.error('Accept button not found');
        if (declineButton) declineButton.addEventListener('click', function() {
            console.log('Decline button clicked');
            $a5caeb58e516bc0d$export$bc337264c9bc2c55(false, invitationData);
        });
        else console.error('Decline button not found');
    })(data);
}
async function $a5caeb58e516bc0d$export$bc337264c9bc2c55(accept, data) {
    console.log('handleResponse called with:', accept, data);
    const portfolioId = (0, $cJVho.getPortfolioId)();
    const token = localStorage.getItem('token');
    if (!portfolioId) {
        console.error('Portfolio ID not found');
        $a5caeb58e516bc0d$var$showNotification('Error: Portfolio ID not found', false);
        return;
    }
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/community/join`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                communityId: data.communityId,
                accept: accept
            })
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to process join request: ${response.status} ${errorText}`);
        }
        const result = await response.json();
        console.log('Join request result:', result);
        if (result.success) {
            $a5caeb58e516bc0d$var$showNotification(result.message, true);
            if (accept) {
                $a5caeb58e516bc0d$export$1199d36f0c9e0a05(data.communityId);
                $a5caeb58e516bc0d$export$3f25e634dcc98320(data.communityId);
                localStorage.setItem('activeCommunity', data.communityId);
            }
        } else $a5caeb58e516bc0d$var$showNotification(result.message, false);
        if (typeof (0, $cJVho.socket) !== 'undefined' && (0, $cJVho.socket).connected) {
            (0, $cJVho.socket).emit('communityInvitationResponse', {
                portfolioId: portfolioId,
                communityId: data.communityId,
                accept: accept
            });
            console.log('Emitted communityInvitationResponse event');
        }
    } catch (error) {
        console.error('Error processing dark pool join request:', error);
        $a5caeb58e516bc0d$var$showNotification(`Error: ${error.message}`, false);
    } finally{
        const popupElement = document.getElementById('communityInvitationPopup');
        if (popupElement) popupElement.remove();
    }
}
function $a5caeb58e516bc0d$export$1199d36f0c9e0a05(communityId) {
    console.log('Starting dark pool timer:', communityId);
    const storedEndTime = localStorage.getItem('communityTimerEnd');
    let endTime;
    if (storedEndTime) endTime = parseInt(storedEndTime, 10);
    else {
        endTime = Date.now() + 600000;
        localStorage.setItem('communityTimerEnd', endTime.toString());
    }
    const timerElement = document.getElementById('communityTimer') || $a5caeb58e516bc0d$var$createTimerElement();
    function updateTimer() {
        const now = Date.now();
        const timeLeft = Math.max(0, endTime - now);
        if (timeLeft > 0) {
            const minutes = Math.floor(timeLeft / 60000);
            const seconds = Math.floor(timeLeft % 60000 / 1000);
            timerElement.textContent = `Dark Pool Clock: ${minutes}:${seconds.toString().padStart(2, '0')}`;
            setTimeout(updateTimer, 1000);
        } else {
            timerElement.textContent = 'Dark Pool Ended';
            localStorage.removeItem('communityTimerEnd');
            $a5caeb58e516bc0d$export$b8f7201e0649077(communityId);
        }
    }
    updateTimer();
}
function $a5caeb58e516bc0d$var$createTimerElement() {
    const timerElement = document.createElement('div');
    timerElement.id = 'communityTimer';
    timerElement.classList.add('community-timer');
    document.body.appendChild(timerElement);
    return timerElement;
}
function $a5caeb58e516bc0d$export$591b253c76185331(portfolioData) {
    if (portfolioData.inDarkPool) {
        const communityId = portfolioData.darkPoolId;
        $a5caeb58e516bc0d$export$1199d36f0c9e0a05(communityId);
        $a5caeb58e516bc0d$export$3f25e634dcc98320(communityId);
    } else {
        const communityTimer = document.getElementById('communityTimer');
        const communityInterface = document.getElementById('communityInterface');
        if (communityTimer) communityTimer.remove();
        if (communityInterface) communityInterface.remove();
        localStorage.removeItem('communityTimerEnd');
    }
}
async function $a5caeb58e516bc0d$export$3f25e634dcc98320(communityId) {
    console.log('Showing dark pool interface for community:', communityId);
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/community/${communityId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}` // Ensure the token is included
            }
        });
        if (!response.ok) throw new Error('Failed to fetch dark pool details');
        const community = await response.json();
        const interfaceElement = document.getElementById('communityInterface') || $a5caeb58e516bc0d$var$createInterfaceElement();
        interfaceElement.innerHTML = `
	  Dark Pool: ${community.poolName}
	  <button id="leaveCommunityBtn">${(0, $fUPn2.t)('Leave Dark Pool', 'Leave Dark Pool')}</button>
	`;
        const leaveCommunityBtn = document.getElementById('leaveCommunityBtn');
        if (leaveCommunityBtn) leaveCommunityBtn.addEventListener('click', ()=>$a5caeb58e516bc0d$export$28eae7baf543a40a(communityId));
        else console.error('Leave dark pool button not found');
    } catch (error) {
        console.error('Error fetching dark pool details:', error);
        $a5caeb58e516bc0d$var$showNotification('Error: Could not load dark pool details.', false);
    }
}
function $a5caeb58e516bc0d$var$createInterfaceElement() {
    const interfaceElement = document.createElement('div');
    interfaceElement.id = 'communityInterface';
    interfaceElement.classList.add('community-interface'); // Add this line to use the class from CSS
    document.body.appendChild(interfaceElement);
    return interfaceElement;
}
async function $a5caeb58e516bc0d$export$28eae7baf543a40a(communityId) {
    console.log('Attempting to leave dark pool:', communityId);
    const portfolioId = (0, $cJVho.getPortfolioId)();
    const token = localStorage.getItem('token');
    if (!portfolioId || !token) {
        console.error('Portfolio ID or token not found');
        $a5caeb58e516bc0d$var$showNotification('Error: Unable to leave dark pool. Please try again.', false);
        return;
    }
    try {
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/community/leave`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                communityId: communityId
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.message || `${(0, $fUPn2.t)('Failed to leave dark pool:', 'Failed to leave dark pool:')} ${response.status} - ${response.statusText}`);
        console.log('Left dark pool successfully:', result);
        if (result.success) {
            // Update local storage and UI
            localStorage.removeItem('communityTimerEnd');
            const communityTimer = document.getElementById('communityTimer');
            const communityInterface = document.getElementById('communityInterface');
            if (communityTimer) communityTimer.remove();
            if (communityInterface) communityInterface.remove();
            $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('You have left the dark pool.', 'You have left the dark pool.'), true);
            // Refresh the page or update the UI
            setTimeout(()=>location.reload(), 2000);
        } else throw new Error(result.message || 'Failed to leave community');
    } catch (error) {
        console.error('Error leaving community:', error);
        $a5caeb58e516bc0d$var$showNotification(`Error: ${error.message}`, false);
    }
}
async function $a5caeb58e516bc0d$export$b8f7201e0649077(communityId) {
    console.log('Dark pool timer ended:', communityId);
    // Clean up UI elements
    const communityTimer = document.getElementById('communityTimer');
    const communityInterface = document.getElementById('communityInterface');
    if (communityTimer) communityTimer.remove();
    if (communityInterface) communityInterface.remove();
    $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('The dark pool has ended.', 'The dark pool has ended.'), true);
    // Optionally reload to refresh state
    setTimeout(()=>location.reload(), 2000);
}
async function $a5caeb58e516bc0d$export$2ecabe3f52b7ee5c() {
    try {
        const portfolioId = (0, $cJVho.getPortfolioId)();
        const sessionId = localStorage.getItem('sessionId'); // Retrieve the sessionId from localStorage
        console.log('Initiating dark pool creation from trader:', portfolioId);
        if (!portfolioId) throw new Error('Initiator trader ID is undefined');
        if (!sessionId) throw new Error('Session ID is required to create a community.');
        const activePortfoliosResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        if (!activePortfoliosResponse.ok) throw new Error('Failed to fetch active traders');
        const activePortfolios = await activePortfoliosResponse.json();
        const eligiblePortfolios = activePortfolios.filter((p)=>p._id !== portfolioId && !p.isSuperUser);
        if (eligiblePortfolios.length < 2) {
            $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('Not enough eligible portfolios to create a community. Action cancelled.', 'Not enough eligible portfolios to create a community. Action cancelled.'), false);
            return;
        }
        const result = await $a5caeb58e516bc0d$var$showMultiUserSelectionPopup(eligiblePortfolios, portfolioId); // Pass portfolioId
        if (!result || !result.selectedUserIds || result.selectedUserIds.length < 2 || !result.poolName) {
            $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('Please select at least two members and provide a pool name. Action cancelled.', 'Please select at least two members and provide a pool name. Action cancelled.'), false);
            return;
        }
        const { selectedUserIds: selectedUserIds, poolName: poolName } = result;
        // Ensure the initiator's portfolio is included in the community
        if (!selectedUserIds.includes(portfolioId)) selectedUserIds.push(portfolioId);
        if ((0, $cJVho.socket) && (0, $cJVho.socket).connected) {
            // Emit the createCommunity event
            (0, $cJVho.socket).emit('createCommunity', {
                initiatorPortfolioId: portfolioId,
                selectedPortfolioIds: selectedUserIds,
                poolName: poolName
            });
            return new Promise((resolve, reject)=>{
                $a5caeb58e516bc0d$var$showNotification((0, $fUPn2.t)('Community creation request sent. Waiting for server confirmation.', 'Community creation request sent. Waiting for server confirmation.'), true);
                (0, $cJVho.socket).once('communityCreationStatus', (data)=>{
                    console.log('Received communityCreationStatus:', data);
                    if (data.success) {
                        $a5caeb58e516bc0d$export$1199d36f0c9e0a05(data.communityId);
                        $a5caeb58e516bc0d$export$3f25e634dcc98320(data.communityId);
                        localStorage.setItem('activeCommunity', data.communityId);
                        $a5caeb58e516bc0d$var$showNotification(data.message, true);
                        resolve(data);
                    } else {
                        $a5caeb58e516bc0d$var$showNotification(`Error: ${data.message}`, false);
                        reject(new Error(data.message));
                    }
                });
            });
        } else throw new Error('connection is not open.');
    } catch (error) {
        console.error('Error creating community:', error);
        $a5caeb58e516bc0d$var$showNotification(`Error: Could not create community. ${error.message}`, false);
    }
}
async function $a5caeb58e516bc0d$export$e46fc5cf7ceaffbf() {
    const createCommunityButton = document.getElementById('createCommunityButton');
    if (createCommunityButton) {
        createCommunityButton.classList.remove('hiddenCM');
        if (!createCommunityButton.hasEventListener) {
            createCommunityButton.addEventListener('click', $a5caeb58e516bc0d$export$2ecabe3f52b7ee5c);
            createCommunityButton.hasEventListener = true;
        }
    } else console.error('Create Dark Pool button not found in the DOM');
}
function $a5caeb58e516bc0d$var$showMultiUserSelectionPopup(users, initiatorId) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        popup.innerHTML = `
	  <h2>${(0, $fUPn2.t)('Enter Dark Pool Name:', 'Enter Dark Pool Name:')}</h2>
	  <input type="text" id="poolNameInput" placeholder="${(0, $fUPn2.t)('Enter dark pool name', 'Enter dark pool name')}" style="margin-bottom: 10px; width: 100%;">
	  <h2>${(0, $fUPn2.t)('Select members of the dark pool:', 'Select members of the dark pool:')}</h2>
	  <input type="text" id="userSearchInput" placeholder="${(0, $fUPn2.t)('Search users...', 'Search users...')}" style="margin-bottom: 10px; width: 100%;">
	  <div id="userList" style="max-height: 300px; overflow-y: auto; border: 1px solid rgba(0, 255, 0, 0.5); padding: 10px;">
		${users.map((user)=>`
		  <label style="display: block; margin-bottom: 5px;">
			<input type="checkbox" value="${user._id}" style="margin-right: 5px;">
			${user.name} ${user._id === initiatorId ? (0, $fUPn2.t)('(You)', '(You)') : ''}
		  </label>
		`).join('')}
	  </div>
	  <div class="selButMuCon">
	  		<button id="confirmSelectionMU">${(0, $fUPn2.t)('Confirm', 'Confirm')}</button>
			  <button id="cancelSelectionMU">${(0, $fUPn2.t)('Cancel', 'Cancel')}</button>
	  </div>
	`;
        document.body.appendChild(popup);
        const confirmButton = document.getElementById('confirmSelectionMU');
        const cancelButton = document.getElementById('cancelSelectionMU');
        const poolNameInput = document.getElementById('poolNameInput');
        const userSearchInput = document.getElementById('userSearchInput');
        const userListContainer = document.getElementById('userList');
        // Handle Search
        userSearchInput.addEventListener('input', ()=>{
            const searchTerm = userSearchInput.value.toLowerCase();
            userListContainer.innerHTML = users.filter((user)=>user.name.toLowerCase().includes(searchTerm)).map((user)=>`
		  <label style="display: block; margin-bottom: 5px;">
			<input type="checkbox" value="${user._id}" style="margin-right: 5px;">
			${user.name} ${user._id === initiatorId ? (0, $fUPn2.t)('(You)', '(You)') : ''}
		  </label>
		`).join('');
        });
        // Confirm Selection
        confirmButton.addEventListener('click', ()=>{
            const selectedUserIds = Array.from(userListContainer.querySelectorAll('input:checked')).map((input)=>input.value);
            const poolName = poolNameInput.value.trim();
            document.body.removeChild(popup);
            if (!selectedUserIds.includes(initiatorId)) selectedUserIds.push(initiatorId);
            resolve({
                selectedUserIds: selectedUserIds,
                poolName: poolName
            });
        });
        // Cancel Selection
        cancelButton.addEventListener('click', ()=>{
            document.body.removeChild(popup);
            resolve(null);
        });
    });
}

});

parcelRegister("29zN8", function(module, exports) {

$parcel$export(module.exports, "displayReceivedMessage", () => $19182f7a3ecd96d1$export$679799c18573f9e4);
parcelRequire("86ioh");
parcelRequire("2C8cW");
parcelRequire("jL4uR");
parcelRequire("1NhFL");

var $cJVho = parcelRequire("cJVho");
parcelRequire("alKwv");

var $5W4EI = parcelRequire("5W4EI");

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
if (!globalThis.ZTranslations) globalThis.ZTranslations = (0, $15BR8.default);
if (typeof globalThis.$t !== 'function') globalThis.$t = (key, params)=>{
    return (0, $fUPn2.t)(key);
};
let $19182f7a3ecd96d1$var$activeChatSession = null;
function $19182f7a3ecd96d1$export$b353271f9887b6fd(portfolios, currentUserId) {
    const existingPopup = document.getElementById('messagePopup');
    if (existingPopup) existingPopup.remove();
    // Debug: Log portfolios to check data integrity
    console.log('Portfolios received for message popup:', portfolios);
    const filteredPortfolios = portfolios.filter((p)=>{
        const isValid = p.active && p._id !== currentUserId && !p.isSuperUser;
        if (!p.name) console.warn(`Portfolio with ID ${p._id} is missing the 'name' property.`);
        return isValid;
    });
    const popup = document.createElement('div');
    popup.id = 'messagePopup';
    popup.innerHTML = `
      <h2>${(0, $fUPn2.t)('messageSend.title')}</h2>
      <p>${(0, $fUPn2.t)('messageSend.costPerRecipient')}</p>
      <input 
        type="text" 
        id="recipientSearch" 
        placeholder="${(0, $fUPn2.t)('messageSend.searchRecipients')}" 
        style="width: 100%; margin-bottom: 10px; padding: 5px;"
      />
      <div id="recipientList" style="max-height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
        ${filteredPortfolios.map((p)=>`
          <div class="recipient" data-name="${(p.name || '').toLowerCase()}">
            <input type="checkbox" id="recipient-${p._id}" value="${p._id}">
            <label for="recipient-${p._id}">${p.name || (0, $fUPn2.t)('messageSend.unnamedPortfolio')}</label>
          </div>
        `).join('')}
      </div>
      <textarea 
        id="messageContent" 
        maxlength="280" 
        placeholder="${(0, $fUPn2.t)('messageSend.placeholder280')}" 
        style="width: 100%; margin-top: 10px; padding: 5px;"
      ></textarea>
      <button id="sendMessageBtn" style="margin-top: 10px;">${(0, $fUPn2.t)('messageSend.send')}</button>
      <button id="closePopupBtn" style="margin-left: 10px;">${(0, $fUPn2.t)('messageSend.close')}</button>
  `;
    document.body.appendChild(popup);
    popup.style.display = 'block';
    // Track popup state
    if (window.popupTracker) {
        const popupHandle = window.popupTracker.trackElement(popup, 'message');
    }
    const searchInput = document.getElementById('recipientSearch');
    const recipientList = document.getElementById('recipientList');
    // Implement search functionality
    searchInput.addEventListener('input', function() {
        const query = this.value.toLowerCase();
        const recipients = recipientList.querySelectorAll('.recipient');
        recipients.forEach((recipient)=>{
            const name = recipient.getAttribute('data-name');
            if (name.includes(query)) recipient.style.display = 'block';
            else recipient.style.display = 'none';
        });
    });
    // Close button functionality
    document.getElementById('closePopupBtn').addEventListener('click', ()=>{
        document.body.removeChild(popup);
    });
    // Sanitize message input
    document.getElementById('messageContent').addEventListener('input', function() {
        this.value = this.value.replace(/[^\w\s.,!?-]/gi, '');
    });
}
function $19182f7a3ecd96d1$export$465cb47180de50f0(senderId, recipientPortfolioIds, content, senderName) {
    return new Promise((resolve, reject)=>{
        if (content.length > 280) {
            reject('Message exceeds 280 characters.');
            return;
        }
        const sanitizedContent = content.replace(/[^\w\s.,!?-]/gi, '');
        (0, $cJVho.socket).emit('sendMessage', {
            senderId: senderId,
            recipientPortfolioIds: recipientPortfolioIds,
            content: sanitizedContent,
            senderName: senderName
        }, (response)=>{
            if (response.success) resolve(response.message);
            else {
                console.error('Error sending message:', response.message);
                alert(response.message); // Display the error to the user
                reject(response.message);
            }
        });
    });
}

function $19182f7a3ecd96d1$export$679799c18573f9e4(message) {
    // First bot message ever: run the one-time coach explaining what a bot
    // message is. The coach overlay (z-index 13000) sits above this popup
    // (9999), so it reads first; closing it reveals the message underneath.
    const looksLikeBot = message.isBot || message.senderName && (message.senderName.includes('_') || /\d{4}$/.test(message.senderName));
    if (looksLikeBot && window.zxNudge?.showOnce) window.zxNudge.showOnce('botmsg', {
        tag: (0, $fUPn2.t)('nudge.botmsg_tag', 'SOMEONE IS TALKING TO YOU'),
        steps: [
            {
                h: (0, $fUPn2.t)('nudge.botmsg_1_h', 'That message is from another trader.'),
                b: (0, $fUPn2.t)('nudge.botmsg_1_b', 'Everyone on the floor holds values, makes offers, and talks. This trader just reached out to you.')
            },
            {
                h: (0, $fUPn2.t)('nudge.botmsg_2_h', "Answer it \u2014 or don't."),
                b: (0, $fUPn2.t)('nudge.botmsg_2_b', 'You can reply, trade with them, or ignore them. What you say and do shapes how the room treats you.')
            }
        ],
        cta: {
            label: (0, $fUPn2.t)('nudge.botmsg_cta', 'GOT IT')
        }
    });
    // Remove any existing overlay first
    const existingOverlay = document.getElementById('messageOverlay');
    if (existingOverlay) existingOverlay.remove();
    const overlay = document.createElement('div');
    overlay.id = 'messageOverlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const messageElement = document.createElement('div');
    messageElement.style.backgroundColor = 'black';
    messageElement.style.padding = '20px';
    messageElement.style.borderRadius = '10px';
    messageElement.style.maxWidth = '80%';
    messageElement.style.maxHeight = '70%';
    messageElement.style.color = '#00ff00';
    messageElement.style.fontFamily = 'bithigh, sans-serif';
    messageElement.style.border = '2px solid #00ff00';
    messageElement.style.overflow = 'hidden';
    messageElement.style.display = 'flex';
    messageElement.style.flexDirection = 'column';
    // Generate unique IDs for this message
    const messageId = `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const respondBtnId = `respond_${messageId}`;
    const closeBtnId = `close_${messageId}`;
    messageElement.innerHTML = `
    <div style="
      border-bottom: 1px solid #00ff00;
      padding-bottom: 10px;
      margin-bottom: 15px;
    ">
      <p style="
        margin: 0;
        font-size: 14px;
        font-weight: bold;
      ">${(0, $fUPn2.t)('messageSend.newMessageFrom')}</p>
      <p style="
        margin: 5px 0 0 0;
        font-size: 16px;
        color: #66ff66;
      ">${message.senderName || (0, $fUPn2.t)('messageSend.unknown')}</p>
    </div>
    
    <div style="
      flex: 1;
      overflow-y: auto;
      max-height: 300px;
      padding-right: 10px;
      margin-bottom: 15px;
    ">
      <div style="
        font-size: 12px;
        line-height: 1.4;
        word-wrap: break-word;
        white-space: pre-wrap;
      ">${message.content || ''}</div>
    </div>
    
    <div style="
      display: flex;
      gap: 10px;
      justify-content: space-between;
      border-top: 1px solid #00ff00;
      padding-top: 15px;
    ">
      <button id="${respondBtnId}" style="
        flex: 1;
        padding: 10px 20px; 
        background-color: rgba(0, 255, 0, 0.2);
        font-family: 'bithigh', Arial, sans-serif;
        border: 1px solid #00ff00; 
        color: #00ff00; 
        font-weight: bold; 
        cursor: pointer; 
        border-radius: 5px;
        font-size: 12px;
        transition: background-color 0.3s;
      " onmouseover="this.style.backgroundColor='rgba(0, 255, 0, 0.3)'" 
         onmouseout="this.style.backgroundColor='rgba(0, 255, 0, 0.2)'">
        ${(0, $fUPn2.t)('messageSend.reply')}
      </button>
      
      <button id="${closeBtnId}" style="
        flex: 1;
        padding: 10px 20px; 
        background-color: rgba(0, 255, 0, 0.8);
        font-family: 'bithigh', Arial, sans-serif;
        border: none; 
        color: black; 
        font-weight: bold; 
        cursor: pointer; 
        border-radius: 5px;
        font-size: 12px;
        transition: background-color 0.3s;
      " onmouseover="this.style.backgroundColor='rgba(0, 255, 0, 0.9)'" 
         onmouseout="this.style.backgroundColor='rgba(0, 255, 0, 0.8)'">
        ${(0, $fUPn2.t)('messageSend.markAsRead')}
      </button>
    </div>
  `;
    overlay.appendChild(messageElement);
    document.body.appendChild(overlay);
    // Track popup state
    if (window.popupTracker) {
        const popupHandle = window.popupTracker.trackElement(overlay, 'received-message');
    }
    // Get the actual DOM elements using the unique IDs
    const closeButton = document.getElementById(closeBtnId);
    const respondButton = document.getElementById(respondBtnId);
    if (!closeButton || !respondButton) {
        console.error('Failed to find message buttons');
        return;
    }
    // Define cleanup function
    const closeMessage = ()=>{
        try {
            if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
        } catch (error) {
            console.error('Error closing message overlay:', error);
        }
        // Remove event listeners
        document.removeEventListener('keydown', handleEscape);
    };
    // Attach event listeners using the actual DOM elements
    const handleCloseClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        closeMessage();
    };
    const handleRespondClick = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        try {
            // Check if the sender is a bot
            const isBot = await $19182f7a3ecd96d1$var$checkIfBotSender(message.senderId, message.senderName);
            if (isBot) {
                closeMessage();
                // Use the global botChatHandler instance
                if (window.botChatHandler) window.botChatHandler.startChat(message.senderId, message.senderName);
                else // Fallback: import dynamically
                (parcelRequire("kJdNP")).then(({ botChatHandler: botChatHandler })=>{
                    botChatHandler.startChat(message.senderId, message.senderName);
                });
            } else {
                console.log('Cannot chat with human players');
                alert((0, $fUPn2.t)('messageSend.onlyChatBots'));
                closeMessage();
            }
        } catch (error) {
            console.error('Error handling respond click:', error);
            closeMessage();
        }
    };
    // Add event listeners
    closeButton.addEventListener('click', handleCloseClick);
    closeButton.addEventListener('touchend', handleCloseClick);
    respondButton.addEventListener('click', handleRespondClick);
    respondButton.addEventListener('touchend', handleRespondClick);
    // Handle overlay click (close when clicking outside)
    const handleOverlayClick = (e)=>{
        if (e.target === overlay) closeMessage();
    };
    overlay.addEventListener('click', handleOverlayClick);
    // Handle escape key
    const handleEscape = (e)=>{
        if (e.key === 'Escape') closeMessage();
    };
    document.addEventListener('keydown', handleEscape);
    // Store references for cleanup (optional - for debugging)
    overlay._messageData = {
        messageId: messageId,
        senderId: message.senderId,
        senderName: message.senderName,
        closeMessage: closeMessage,
        respondBtnId: respondBtnId,
        closeBtnId: closeBtnId
    };
}
// Helper function to check if sender is a bot
async function $19182f7a3ecd96d1$var$checkIfBotSender(senderId, senderName) {
    try {
        // Method 1: Check if sender name contains bot patterns
        if (senderName && (senderName.includes('_') || senderName.match(/\d{4}$/))) return true;
        // Method 2: Check local cache
        if (window.botStatusCache && window.botStatusCache.has(senderId)) {
            const cached = window.botStatusCache.get(senderId);
            if (Date.now() - cached.timestamp < 300000) return cached.isBot;
        }
        // Method 3: API call as fallback
        const token = localStorage.getItem('authToken');
        if (!token || !senderId) return false;
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolio/${senderId}/info`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (response.ok) {
            const data = await response.json();
            // Cache the result
            if (!window.botStatusCache) window.botStatusCache = new Map();
            window.botStatusCache.set(senderId, {
                isBot: data.isBot,
                timestamp: Date.now()
            });
            return data.isBot;
        }
    } catch (error) {
        console.error('Error checking bot status:', error);
    }
    return false;
}
function $19182f7a3ecd96d1$export$162ddd3b1cbe3b13(botId, botName) {
    // Remove any existing chat
    const existingChat = document.getElementById('botChatPopup');
    if (existingChat) existingChat.remove();
    $19182f7a3ecd96d1$var$activeChatSession = {
        botId: botId,
        botName: botName,
        chatId: null,
        exchangeCount: 0,
        maxExchanges: 4
    };
    const chatPopup = document.createElement('div');
    chatPopup.id = 'botChatPopup';
    chatPopup.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 350px;
    height: 500px;
    background-color: black;
    border: 2px solid #00ff00;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    z-index: 10000;
    font-family: 'bithigh', sans-serif;
    color: #00ff00;
  `;
    chatPopup.innerHTML = `
    <div style="
      padding: 15px;
      border-bottom: 1px solid #00ff00;
      display: flex;
      justify-content: space-between;
      align-items: center;
    ">
      <div>
        <div style="font-size: 14px; font-weight: bold;">${(0, $fUPn2.t)('messageSend.conversationWith')} ${botName}</div>
        <div style="font-size: 11px; color: #66ff66;" id="chatStatus">
          ${$19182f7a3ecd96d1$var$activeChatSession.maxExchanges - $19182f7a3ecd96d1$var$activeChatSession.exchangeCount} ${(0, $fUPn2.t)('messageSend.messagesRemaining')}
        </div>
      </div>
      <button id="closeChatBtn" style="
        background: none;
        border: 1px solid #00ff00;
        color: #00ff00;
        padding: 5px 10px;
        cursor: pointer;
        border-radius: 3px;
        font-size: 12px;
      ">\u{2715}</button>
    </div>
    
    <div id="chatMessages" style="
      flex: 1;
      overflow-y: auto;
      padding: 15px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    "></div>
    
    <div style="
      padding: 15px;
      border-top: 1px solid #00ff00;
      display: flex;
      gap: 10px;
    ">
      <input type="text" id="chatInput" placeholder="${(0, $fUPn2.t)('messageSend.typeYourMessage')}" style="
        flex: 1;
        background: rgba(0, 255, 0, 0.1);
        border: 1px solid #00ff00;
        color: #00ff00;
        padding: 8px;
        border-radius: 3px;
        font-family: inherit;
      " maxlength="280">
      <button id="sendChatBtn" style="
        background: rgba(0, 255, 0, 0.2);
        border: 1px solid #00ff00;
        color: #00ff00;
        padding: 8px 15px;
        cursor: pointer;
        border-radius: 3px;
        font-weight: bold;
      ">${(0, $fUPn2.t)('messageSend.send')}</button>
    </div>
  `;
    document.body.appendChild(chatPopup);
    // Track popup state
    if (window.popupTracker) {
        const popupHandle = window.popupTracker.trackElement(chatPopup, 'bot-chat');
    }
    // Add event listeners
    document.getElementById('closeChatBtn').addEventListener('click', $19182f7a3ecd96d1$var$closeBotChat);
    document.getElementById('sendChatBtn').addEventListener('click', $19182f7a3ecd96d1$var$sendChatMessage);
    document.getElementById('chatInput').addEventListener('keypress', (e)=>{
        if (e.key === 'Enter') $19182f7a3ecd96d1$var$sendChatMessage();
    });
    // Add initial bot greeting
    $19182f7a3ecd96d1$var$addChatMessage('bot', (0, $fUPn2.t)('messageSend.botGreeting', {
        name: botName
    }) || `Good day I'm ${botName}. What's on your mind?`);
}
async function $19182f7a3ecd96d1$var$sendChatMessage() {
    const input = document.getElementById('chatInput');
    const message = input.value.trim();
    if (!message || !$19182f7a3ecd96d1$var$activeChatSession) return;
    if ($19182f7a3ecd96d1$var$activeChatSession.exchangeCount >= $19182f7a3ecd96d1$var$activeChatSession.maxExchanges) {
        $19182f7a3ecd96d1$var$addChatMessage('system', (0, $fUPn2.t)('messageSend.chatLimitReached'));
        return;
    }
    // Add user message to chat
    $19182f7a3ecd96d1$var$addChatMessage('user', message);
    input.value = '';
    input.disabled = true;
    document.getElementById('sendChatBtn').disabled = true;
    try {
        const userId = localStorage.getItem('portfolioId');
        const authToken = localStorage.getItem('token');
        if (!userId) {
            console.error('No portfolioId found in localStorage');
            $19182f7a3ecd96d1$var$addChatMessage('system', 'Error: User not logged in');
            input.disabled = false;
            document.getElementById('sendChatBtn').disabled = false;
            return;
        }
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/sys/chat`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                botId: $19182f7a3ecd96d1$var$activeChatSession.botId,
                userId: userId,
                message: message,
                chatId: $19182f7a3ecd96d1$var$activeChatSession.chatId
            })
        });
        const data = await response.json();
        if (data.success) {
            $19182f7a3ecd96d1$var$activeChatSession.chatId = data.chatId;
            $19182f7a3ecd96d1$var$activeChatSession.exchangeCount++;
            // Add bot response
            $19182f7a3ecd96d1$var$addChatMessage('bot', data.response);
            // Update status
            const remaining = data.exchangesRemaining;
            document.getElementById('chatStatus').textContent = remaining > 0 ? `${remaining} ${(0, $fUPn2.t)('messageSend.messagesRemaining')}` : (0, $fUPn2.t)('messageSend.chatEnded');
            if (data.chatEnded) {
                input.disabled = true;
                document.getElementById('sendChatBtn').disabled = true;
                $19182f7a3ecd96d1$var$addChatMessage('system', (0, $fUPn2.t)('messageSend.chatEndedThanks'));
            } else {
                input.disabled = false;
                document.getElementById('sendChatBtn').disabled = false;
                input.focus();
            }
        } else {
            $19182f7a3ecd96d1$var$addChatMessage('system', (0, $fUPn2.t)('messageSend.error') + ': ' + (data.error || (0, $fUPn2.t)('messageSend.failedToSend')));
            input.disabled = false;
            document.getElementById('sendChatBtn').disabled = false;
        }
    } catch (error) {
        console.error('Chat error:', error);
        $19182f7a3ecd96d1$var$addChatMessage('system', (0, $fUPn2.t)('messageSend.connectionError'));
        input.disabled = false;
        document.getElementById('sendChatBtn').disabled = false;
    }
}
function $19182f7a3ecd96d1$var$addChatMessage(sender, content) {
    const messagesDiv = document.getElementById('chatMessages');
    const messageEl = document.createElement('div');
    const styles = {
        user: {
            align: 'flex-end',
            bg: 'rgba(0, 255, 0, 0.2)',
            border: '1px solid #00ff00',
            color: '#00ff00'
        },
        bot: {
            align: 'flex-start',
            bg: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid #666',
            color: '#fff'
        },
        system: {
            align: 'center',
            bg: 'transparent',
            border: 'none',
            color: '#666'
        }
    };
    const style = styles[sender] || styles.system;
    messageEl.style.cssText = `
    align-self: ${style.align};
    max-width: 85%;
    padding: 8px 12px;
    background: ${style.bg};
    border: ${style.border};
    border-radius: 3px;
    color: ${style.color};
    font-size: 12px;
    word-wrap: break-word;
  `;
    messageEl.textContent = content;
    messagesDiv.appendChild(messageEl);
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
}
function $19182f7a3ecd96d1$var$closeBotChat() {
    const chatPopup = document.getElementById('botChatPopup');
    if (chatPopup) chatPopup.remove();
    // End chat session on backend
    if ($19182f7a3ecd96d1$var$activeChatSession && $19182f7a3ecd96d1$var$activeChatSession.chatId) fetch(`${(0, $5W4EI.apiBaseUrl)}/api/bot/endChat`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({
            chatId: $19182f7a3ecd96d1$var$activeChatSession.chatId
        })
    }).catch((err)=>console.error('Error ending chat:', err));
    $19182f7a3ecd96d1$var$activeChatSession = null;
}

});
parcelRegister("alKwv", function(module, exports) {

$parcel$export(module.exports, "displayDeletePortfolioUpdate", () => $788ff41eb2df4559$export$325d8b74cba8b87);
$parcel$export(module.exports, "handleLBOUpdateForTarget", () => $788ff41eb2df4559$export$99b33fa79ed814ff);
$parcel$export(module.exports, "handleSubsidyUpdateForTarget", () => $788ff41eb2df4559$export$63f273c71ca2c50a);
$parcel$export(module.exports, "handleSubsidyReceived", () => $788ff41eb2df4559$export$6598253ef2e7f85f);
$parcel$export(module.exports, "playPubVideo", () => $788ff41eb2df4559$export$35f287f5175d77ea);
$parcel$export(module.exports, "playZnewsVideo", () => $788ff41eb2df4559$export$887e8fd7f92867b);
$parcel$export(module.exports, "handleItemStolen", () => $788ff41eb2df4559$export$31f3cf3256e53c73);
$parcel$export(module.exports, "handleSpecialActionNotification", () => $788ff41eb2df4559$export$3f11d1f2c5a135aa);
// button.js

var $5W4EI = parcelRequire("5W4EI");

var $eD3DY = parcelRequire("eD3DY");

var $cJVho = parcelRequire("cJVho");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
if (!globalThis.ZTranslations) globalThis.ZTranslations = (0, $15BR8.default);
if (typeof globalThis.$t !== 'function') globalThis.$t = (key, params)=>{
    return (0, $fUPn2.t)(key);
};
function $788ff41eb2df4559$var$localizeCompanyName(stockObj = {}) {
    const key = stockObj.csvId || stockObj.companyCsvId || stockObj.id || stockObj._id;
    return key ? (0, $fUPn2.t)(`companies_by_id.${String(key)}.Company_Name`, stockObj.name || '') : stockObj.name || '';
}
function $788ff41eb2df4559$export$a6e5bb0ae101fb2e() {
    const deletePortfolioButton = document.getElementById('deletePortfolioButton');
    if (deletePortfolioButton) deletePortfolioButton.addEventListener('click', $788ff41eb2df4559$export$a0a11e9c42d99a1f);
}
// At the top of button.js, replace your cache declaration with:
const $788ff41eb2df4559$var$portfolioCache = new Map();
const $788ff41eb2df4559$var$CACHE_DURATION = 300000; // 5 minutes
// Add this function to preload on page load:
async function $788ff41eb2df4559$export$91b56dc9b26ba8fd() {
    const sessionId = localStorage.getItem('sessionId');
    if (!sessionId) return;
    try {
        // Fetch both endpoints in parallel
        const [active, richest] = await Promise.all([
            fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/active`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: sessionId
                })
            }).then((r)=>r.json()),
            fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/richest`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: sessionId
                })
            }).then((r)=>r.json())
        ]);
        const now = Date.now();
        $788ff41eb2df4559$var$portfolioCache.set('active', {
            data: active,
            timestamp: now
        });
        $788ff41eb2df4559$var$portfolioCache.set('richest', {
            data: richest,
            timestamp: now
        });
    } catch (error) {
        console.error('Failed to preload portfolios:', error);
    }
}
async function $788ff41eb2df4559$var$getCachedPortfolios(sessionId, endpoint = '/api/portfolios/active') {
    const cacheKey = endpoint.includes('richest') ? 'richest' : 'active';
    const cached = $788ff41eb2df4559$var$portfolioCache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < $788ff41eb2df4559$var$CACHE_DURATION) return cached.data;
    // Fallback to API call if cache miss
    const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}${endpoint}`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            sessionId: sessionId
        })
    });
    const data = await response.json();
    $788ff41eb2df4559$var$portfolioCache.set(cacheKey, {
        data: data,
        timestamp: Date.now()
    });
    return data;
}
// ===== Delete Portfolio =====
let $788ff41eb2df4559$var$isProcessingDelete = false;
async function $788ff41eb2df4559$export$a0a11e9c42d99a1f() {
    if ($788ff41eb2df4559$var$isProcessingDelete) return;
    $788ff41eb2df4559$var$isProcessingDelete = true;
    // Immediate visual feedback
    const button = document.getElementById('deletePortfolioButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    try {
        const initiatorPortfolioId = window.traderPortfolioId;
        const sessionId = localStorage.getItem('sessionId');
        if (!initiatorPortfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Initiator Portfolio ID is undefined'));
        if (!sessionId) throw new Error((0, $fUPn2.t)('triggers.sessionUndefined', 'Session ID is undefined'));
        // Cached portfolios
        const activePortfolios = await $788ff41eb2df4559$var$getCachedPortfolios(sessionId, '/api/portfolios/active');
        const eligiblePortfolios = activePortfolios.filter((p)=>p._id !== initiatorPortfolioId && !p.isSuperUser);
        if (eligiblePortfolios.length === 0) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.noEligible', 'No eligible portfolios to redistribute. Action cancelled.'), false);
            return;
        }
        const selectedUser = await $788ff41eb2df4559$export$9885a1621cce704b(eligiblePortfolios);
        if (!selectedUser || !selectedUser.selectedUserId) return;
        const portfolioToDeleteId = selectedUser.selectedUserId;
        const confirmDelete = await $788ff41eb2df4559$var$showConfirmDeletePopup();
        if (!confirmDelete) return;
        const deleteResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/useDeletePortfolioButton`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                initiatorPortfolioId: initiatorPortfolioId,
                portfolioToDeleteId: portfolioToDeleteId,
                sessionId: sessionId
            })
        });
        if (!deleteResponse.ok) {
            const errorData = await deleteResponse.json().catch(()=>({}));
            throw new Error(errorData.message || 'Failed to redistribute portfolio');
        }
        // Parse the response to get redistribution details
        const deleteResult = await deleteResponse.json();
        await (0, $cJVho.waitForSocketConnection)();
        (0, $cJVho.socket).emit('message', {
            action: 'deletePortfolioPerformed',
            initiatorPortfolioId: initiatorPortfolioId,
            targetPortfolioId: portfolioToDeleteId,
            sessionId: sessionId,
            redistributionDetails: deleteResult.redistributionDetails,
            targetPortfolioName: deleteResult.targetPortfolioName,
            initiatorPortfolioName: deleteResult.initiatorPortfolioName
        });
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.success', "The selected portfolio's holdings have been successfully redistributed."), true, ()=>location.reload());
    } catch (error) {
        console.error('Error using delete portfolio button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.error', 'Error: Could not redistribute the selected portfolio.')} ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingDelete = false;
    }
}
function $788ff41eb2df4559$var$showConfirmDeletePopup() {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        // build DOM nodes instead of full innerHTML
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.title1', "Are you sure you want to redistribute the selected portfolio's holdings?");
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.body1', "This will randomly redistribute the trader's portfolio holdings to random traders in the market.");
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.cta1', 'Yes, Trigger Communist Assault');
        Object.assign(confirmButton.style, {
            padding: '10px 20px',
            cursor: 'pointer'
        });
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        Object.assign(cancelButton.style, {
            padding: '10px 20px',
            cursor: 'pointer'
        });
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
// --- showUserSelectionPopup
function $788ff41eb2df4559$export$9885a1621cce704b(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.selectPortfolioTitle', 'Select a Portfolio:');
        const select = document.createElement('select');
        select.id = 'userSelectMU';
        users.forEach((user)=>{
            const option = document.createElement('option');
            option.value = user._id;
            const name = user.name || user.username || user.displayName || (0, $fUPn2.t)('triggers.unknownUser', 'Unknown user');
            const wealth = Number(user.totalWealth ?? 0).toFixed(2);
            option.textContent = `${name} - ${(0, $fUPn2.t)('triggers.statsTotalWealth', 'Total Wealth:')} ${wealth}`;
            select.appendChild(option);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.id = 'confirmSelectionMU';
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.id = 'cancelSelectionMU';
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, select, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            const selectedUserId = select.value;
            popup.remove();
            resolve({
                selectedUserId: selectedUserId
            });
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$325d8b74cba8b87(data) {
    const message = data.message || 'No message provided.';
    const type = data.type || 'unknown'; // 'victim' or 'recipient'
    console.log('Displaying Communist Assault notification:', {
        type: type,
        data: data
    });
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'subsidy-popup';
    // Create main message
    const messageDiv = document.createElement('div');
    messageDiv.innerHTML = `<strong>${message}</strong>`;
    notificationPopup.appendChild(messageDiv);
    // If this user received assets, show details
    if (type === 'recipient') {
        const detailsDiv = document.createElement('div');
        detailsDiv.style.marginTop = '15px';
        detailsDiv.style.textAlign = 'left';
        const detailsList = [];
        // Show received items
        if (data.receivedItems && data.receivedItems.length > 0) detailsList.push(`<strong>Items:</strong> ${data.receivedItems.map((item)=>item.itemName).join(', ')}`);
        // Show received stocks
        if (data.receivedStocks && data.receivedStocks.length > 0) {
            const stocksList = data.receivedStocks.map((stock)=>`${stock.stockName} (${stock.quantity} shares)`).join(', ');
            detailsList.push(`<strong>Stocks:</strong> ${stocksList}`);
        }
        // Show received zollars
        if (data.receivedZollars && data.receivedZollars > 0) detailsList.push(`<strong>Zollars:</strong> ${data.receivedZollars}`);
        // Show received points
        if (data.receivedPoints && data.receivedPoints > 0) detailsList.push(`<strong>Trading Capital:</strong> ${data.receivedPoints}`);
        if (detailsList.length > 0) {
            detailsDiv.innerHTML = '<div style="margin-top: 10px; margin-bottom: 10px;"><strong>You received:</strong></div>' + detailsList.join('<br>');
            notificationPopup.appendChild(detailsDiv);
        }
    }
    // If this user was attacked, show attacker info and what was removed
    if (type === 'victim') {
        const attackerDiv = document.createElement('div');
        attackerDiv.style.marginTop = '10px';
        const attackerName = data.botName || data.initiatorName || 'Unknown';
        attackerDiv.innerHTML = `<em>Attacked by: ${attackerName}</em>`;
        notificationPopup.appendChild(attackerDiv);
        // Show what was removed from the victim
        const removedDiv = document.createElement('div');
        removedDiv.style.marginTop = '15px';
        removedDiv.style.textAlign = 'left';
        removedDiv.style.color = '#ff6b6b';
        const removedList = [];
        if (data.removedItems && data.removedItems > 0) removedList.push(`<strong>Commodities Lost:</strong> ${data.removedItems}`);
        if (data.removedStocks && data.removedStocks > 0) removedList.push(`<strong>Stocks Lost:</strong> ${data.removedStocks} holdings`);
        if (data.removedZollars && data.removedZollars > 0) removedList.push(`<strong>Zollars Lost:</strong> ${data.removedZollars}`);
        if (data.removedPoints && data.removedPoints > 0) removedList.push(`<strong>Trading Capital Lost:</strong> ${data.removedPoints}`);
        if (removedList.length > 0) {
            removedDiv.innerHTML = '<div style="margin-top: 10px; margin-bottom: 10px;"><strong>Assets Redistributed:</strong></div>' + removedList.join('<br>');
            notificationPopup.appendChild(removedDiv);
        }
    }
    const closeButton = document.createElement('button');
    closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
    closeButton.className = 'close-button-subsidy';
    closeButton.style.marginTop = '15px';
    closeButton.addEventListener('click', ()=>{
        document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
function $788ff41eb2df4559$export$aafa747b458d16d8() {
    const LBOButton = document.getElementById('LBOButton');
    if (LBOButton) {
        LBOButton.removeEventListener('click', $788ff41eb2df4559$export$2f8c058aa77a73ca);
        LBOButton.addEventListener('click', $788ff41eb2df4559$export$2f8c058aa77a73ca);
    }
}
// ===== LBO =====
let $788ff41eb2df4559$var$isProcessingLBO = false;
async function $788ff41eb2df4559$export$2f8c058aa77a73ca() {
    if ($788ff41eb2df4559$var$isProcessingLBO) return; // Prevent double-clicks
    $788ff41eb2df4559$var$isProcessingLBO = true;
    // Immediate visual feedback
    const button = document.getElementById('LBOButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    // Remove any existing popups
    const existingPopups = document.querySelectorAll('.lbo-popup, #multiUserSelectionPopup');
    existingPopups.forEach((popup)=>popup.remove());
    try {
        const initiatorPortfolioId = window.traderPortfolioId;
        const sessionId = localStorage.getItem('sessionId');
        if (!initiatorPortfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Initiator Portfolio is undefined'));
        if (!sessionId) throw new Error((0, $fUPn2.t)('triggers.sessionUndefined', 'Session ID is undefined'));
        // Cached active portfolios
        const activePortfolios = await $788ff41eb2df4559$var$getCachedPortfolios(sessionId, '/api/portfolios/active');
        const eligiblePortfolios = activePortfolios.filter((p)=>p._id !== initiatorPortfolioId && !p.isSuperUser);
        if (eligiblePortfolios.length === 0) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.noEligible', 'No eligible portfolios to redistribute. Action cancelled.'), false);
            return;
        }
        // Show target selection popup
        const selectedTarget = await $788ff41eb2df4559$export$479635ceeb190e22(eligiblePortfolios);
        if (!selectedTarget || !selectedTarget.selectedUserId) return;
        const targetPortfolioId = selectedTarget.selectedUserId;
        // Fetch target's holdings
        const targetPortfolioResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/${targetPortfolioId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        if (!targetPortfolioResponse.ok) throw new Error(`Failed to fetch target portfolio: ${targetPortfolioResponse.status}`);
        const targetPortfolioData = await targetPortfolioResponse.json();
        // Popup for selecting stocks/items
        const { selectedItems: selectedItems = [], selectedStocks: selectedStocks = [] } = await $788ff41eb2df4559$export$470b4df794730a1d(targetPortfolioData) || {};
        if (!selectedItems.length && !selectedStocks.length) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.noAssetsSelected', 'No assets selected for LBO.'), false);
            return;
        }
        const LBOCost = $788ff41eb2df4559$export$ca36d7b4da6613a9(selectedItems, selectedStocks);
        const confirmLBO = await $788ff41eb2df4559$export$7d30655850cce209(LBOCost);
        if (!confirmLBO) return;
        // Send LBO request
        const lboResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/useLBOButton`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                initiatorPortfolioId: initiatorPortfolioId,
                targetPortfolioId: targetPortfolioId,
                sessionId: sessionId,
                selectedItems: selectedItems,
                selectedStocks: selectedStocks,
                LBOCost: LBOCost
            })
        });
        if (!lboResponse.ok) {
            const errorData = await lboResponse.json().catch(()=>({}));
            throw new Error(errorData.message || 'Failed to perform LBO');
        }
        const { addedStocks: addedStocks, removedStocks: removedStocks, addedItems: addedItems, removedItems: removedItems } = await lboResponse.json();
        await (0, $cJVho.waitForSocketConnection)();
        (0, $cJVho.socket).emit('message', {
            action: 'LBOPerformed',
            initiatorPortfolioId: initiatorPortfolioId,
            targetPortfolioId: targetPortfolioId,
            removedStocks: removedStocks,
            removedItems: removedItems
        });
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.successLBO', 'LBO triggered successfully.'), true, ()=>location.reload());
    } catch (error) {
        console.error('Error using LBO button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.errorPrefix', 'Error:')} ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingLBO = false;
    }
}
function $788ff41eb2df4559$export$470b4df794730a1d(targetPortfolioData) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.className = 'lbo-popup';
        const itemOptions = targetPortfolioData.items?.map((item)=>`
		  <label>
			<input type="checkbox" data-id="${item._id}" data-points="${item.points || 0}">
			${item.item_name} - ${item.points || 0} ${(0, $fUPn2.t)('triggers.pointsLabel', 'Capital')}
		  </label>
		`).join('') || `<p>${(0, $fUPn2.t)('triggers.noItems', 'No commodities available')}</p>`;
        const stockOptions = targetPortfolioData.stocks?.map((stock)=>`
		  <label>
			<input type="checkbox" data-id="${stock.stock._id}" data-value="${stock.stock.shareValue}" data-quantity="${stock.quantity}">
			${(0, $fUPn2.t)(`companies_by_id.${String(stock.stock.csvId || stock.stock.companyCsvId || stock.stock.id || stock.stock._id || '')}.Company_Name`, stock.stock.name)} - ${stock.quantity} ${(0, $fUPn2.t)('triggers.sharesAt', 'shares at {value} each').replace('{value}', stock.stock.shareValue || 0)}
		  </label>
		`).join('') || `<p>${(0, $fUPn2.t)('triggers.noStocks', 'No stocks available')}</p>`;
        popup.innerHTML = `
		  <h2>${(0, $fUPn2.t)('triggers.selectAssetsTitle', 'Select assets for the LBO')}</h2>
		  <h3>${(0, $fUPn2.t)('triggers.selectAssetsItems', 'Commodities:')}</h3>
		  ${itemOptions}
		  <h3>${(0, $fUPn2.t)('triggers.selectAssetsStocks', 'Stocks:')}</h3>
		  ${stockOptions}
		  <div class="lbo-buttons">
			<button id="confirmSelectionLBO" class="lbo-button">${(0, $fUPn2.t)('triggers.confirm', 'Confirm')}</button>
			<button id="cancelSelectionLBO" class="lbo-button">${(0, $fUPn2.t)('triggers.cancel', 'Cancel')}</button>
		  </div>
		`;
        document.body.appendChild(popup);
        const confirmButton = document.getElementById('confirmSelectionLBO');
        const cancelButton = document.getElementById('cancelSelectionLBO');
        confirmButton.addEventListener('click', ()=>{
            const selectedItems = Array.from(popup.querySelectorAll('input[type="checkbox"]:checked[data-points]')).map((input)=>({
                    id: input.getAttribute('data-id'),
                    points: parseInt(input.getAttribute('data-points'), 10)
                }));
            const selectedStocks = Array.from(popup.querySelectorAll('input[type="checkbox"]:checked[data-quantity]')).map((input)=>({
                    id: input.getAttribute('data-id'),
                    quantity: parseInt(input.getAttribute('data-quantity'), 10),
                    shareValue: parseFloat(input.getAttribute('data-value'))
                }));
            document.body.removeChild(popup);
            resolve({
                selectedItems: selectedItems,
                selectedStocks: selectedStocks
            });
        });
        cancelButton.addEventListener('click', ()=>{
            document.body.removeChild(popup);
            resolve({
                selectedItems: [],
                selectedStocks: []
            });
        });
    });
}
function $788ff41eb2df4559$export$ca36d7b4da6613a9(selectedItems = [], selectedStocks = []) {
    let cost = 0;
    selectedItems.forEach((item)=>{
        cost += item.points || 0; // Sum the points for each selected item
    });
    selectedStocks.forEach((stock)=>{
        cost += (stock.shareValue || 0) * (stock.quantity || 0); // Calculate the total value for each selected stock
    });
    return Math.ceil(cost * 1.5); // Return 150% of the selected asset cost
}
function $788ff41eb2df4559$export$479635ceeb190e22(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.title_1', 'Select a portfolio to trigger an LBO on:');
        const select = document.createElement('select');
        select.id = 'userSelectLBO';
        users.forEach((user)=>{
            const option = document.createElement('option');
            option.value = user._id;
            const name = user.name || user.username || user.displayName || (0, $fUPn2.t)('triggers.unknownUser', 'Unknown user');
            const wealth = Number(user.totalWealth ?? 0).toFixed(2);
            option.textContent = `${name} - ${(0, $fUPn2.t)('triggers.statsTotalWealth', 'Total Wealth:')} ${wealth}`;
            select.appendChild(option);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn';
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn';
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, select, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve({
                selectedUserId: select.value
            });
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$7d30655850cce209(LBOCost) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.titleLBO', 'Confirm Leveraged Buyout');
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.bodyLBO', 'This LBO will cost you {cost} of capital. Do you wish to proceed?').replace('{cost}', LBOCost);
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.ctaLBO', 'Yes, trigger the LBO');
        Object.assign(confirmButton.style, {
            padding: '10px 20px',
            cursor: 'pointer'
        });
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        Object.assign(cancelButton.style, {
            padding: '10px 20px',
            cursor: 'pointer'
        });
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$99b33fa79ed814ff(data) {
    const { message: message, removedStocks: removedStocks = [], removedItems: removedItems = [] } = data;
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'lbo-popup';
    let details = `<div>${message}</div><ul>`;
    if (removedStocks.length > 0) {
        details += `<li><strong>${(0, $fUPn2.t)('triggers.removedStocksLabel', 'Removed Stocks:')}</strong> `;
        details += removedStocks.map((stock)=>`${stock.quantity} ${(0, $fUPn2.t)('triggers.sharesWord', 'shares')} ${(0, $fUPn2.t)('triggers.ofWord', 'of')} ${(0, $fUPn2.t)('companies_by_id.' + String(stock.csvId || stock.companyCsvId || stock.id || stock.stockId || stock._id || '') + '.Company_Name', stock.name || (0, $fUPn2.t)('triggers.unknownStock', 'Unknown Stock'))}`).join(', ');
        details += `</li>`;
    }
    if (removedItems.length > 0) {
        details += `<li><strong>${(0, $fUPn2.t)('triggers.removedItemsLabel', 'Removed Commodities:')}</strong> `;
        details += removedItems.map((item)=>item.name || (0, $fUPn2.t)('triggers.unknownItem', 'Unknown Commodity')).join(', ');
        details += `</li>`;
    }
    details += `</ul>`;
    notificationPopup.innerHTML = details;
    // Use a real button element
    const closeButton = document.createElement('button');
    closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
    closeButton.className = 'close-button-LBO';
    closeButton.style.marginTop = '10px';
    closeButton.addEventListener('click', ()=>{
        document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
function $788ff41eb2df4559$export$5cfe6cad46ff1007() {
    const SubsidyButton = document.getElementById('SubsidyButton');
    if (SubsidyButton) {
        SubsidyButton.removeEventListener('click', $788ff41eb2df4559$export$11daf329a23b2dc3);
        SubsidyButton.addEventListener('click', $788ff41eb2df4559$export$11daf329a23b2dc3);
    }
}
// ===== Subsidy =====
let $788ff41eb2df4559$var$isProcessingSubsidy = false;
async function $788ff41eb2df4559$export$11daf329a23b2dc3() {
    if ($788ff41eb2df4559$var$isProcessingSubsidy) return;
    $788ff41eb2df4559$var$isProcessingSubsidy = true;
    // Immediate visual feedback
    const button = document.getElementById('SubsidyButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    try {
        const initiatorPortfolioId = window.traderPortfolioId;
        const sessionId = localStorage.getItem('sessionId');
        if (!initiatorPortfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Initiator Portfolio is undefined'));
        if (!sessionId) throw new Error((0, $fUPn2.t)('triggers.sessionUndefined', 'Session is undefined'));
        // Cached richest portfolios
        const richPortfolios = await $788ff41eb2df4559$var$getCachedPortfolios(sessionId, '/api/portfolios/richest');
        if (!richPortfolios || richPortfolios.length === 0) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.noRichPortfolios', 'No rich portfolios available to target.'), false);
            return;
        }
        const selectedTarget = await $788ff41eb2df4559$var$showUserSelectionPopupSubsidy(richPortfolios);
        if (!selectedTarget || !selectedTarget.selectedUserId) return;
        const targetPortfolioId = selectedTarget.selectedUserId;
        const subsidyResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/useSubsidyButton`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                initiatorPortfolioId: initiatorPortfolioId,
                targetPortfolioId: targetPortfolioId,
                sessionId: sessionId
            })
        });
        if (!subsidyResponse.ok) {
            const errorData = await subsidyResponse.json().catch(()=>({}));
            throw new Error(errorData.message || 'Failed to perform Subsidy action');
        }
        // Extract the detailed amounts from the API response
        const subsidyData = await subsidyResponse.json();
        await (0, $cJVho.waitForSocketConnection)();
        (0, $cJVho.socket).emit('message', {
            action: 'SubsidyPerformed',
            initiatorPortfolioId: initiatorPortfolioId,
            targetPortfolioId: targetPortfolioId,
            sessionId: sessionId,
            taxedAmount: subsidyData.taxedAmount || 0,
            taxedZollars: subsidyData.taxedZollars || 0,
            taxedItems: subsidyData.taxedItems || 0
        });
        // NOTE: your flat key is "success3" (not namespaced)
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.success3', 'Subsidy action triggered successfully.'), true, ()=>location.reload());
    } catch (error) {
        console.error('Error using Subsidy button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.errorPrefix', 'Error:')} ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingSubsidy = false;
    }
}
function $788ff41eb2df4559$var$showUserSelectionPopupSubsidy(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.selectRichTitle3', 'Select a rich portfolio to tax:');
        const select = document.createElement('select');
        select.id = 'userSelectSubsidy';
        users.forEach((user)=>{
            const option = document.createElement('option');
            option.value = user._id;
            option.textContent = `${user.name} - ${(0, $fUPn2.t)('triggers.statsTotalWealth', 'Total Wealth:')} ${user.totalWealth.toFixed(2)}`;
            select.appendChild(option);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, select, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve({
                selectedUserId: select.value
            });
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$63f273c71ca2c50a(data) {
    let { message: message, initiatorName: initiatorName, taxedAmount: taxedAmount, taxedZollars: taxedZollars, taxedItems: taxedItems } = data;
    // Build detailed notification message
    let detailsHTML = '';
    if (initiatorName) detailsHTML += `<p style="font-weight: bold; color: #fcba03; margin-bottom: 10px;">${initiatorName} triggered a Socialist Subsidy against you!</p>`;
    detailsHTML += `<p style="margin-bottom: 15px;">45% of your wealth has been redistributed to lower income earners:</p>`;
    if (taxedAmount > 0 || taxedZollars > 0 || taxedItems > 0) {
        detailsHTML += `<ul style="list-style: none; padding: 0; margin: 10px 0;">`;
        if (taxedAmount > 0) detailsHTML += `<li>\u{1F4B8} Capital: <span style="color: #ff4444;">${taxedAmount.toFixed(2)}</span></li>`;
        if (taxedZollars > 0) detailsHTML += `<li>\u{1B5} Zollars: <span style="color: #ff4444;">${taxedZollars.toFixed(2)}</span></li>`;
        if (taxedItems > 0) detailsHTML += `<li>\u{1F4E6} Items: <span style="color: #ff4444;">${taxedItems}</span></li>`;
        detailsHTML += `</ul>`;
    }
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'subsidy-popup';
    notificationPopup.innerHTML = detailsHTML;
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close';
    closeButton.className = 'close-button-subsidy';
    closeButton.style.marginTop = '10px';
    closeButton.addEventListener('click', ()=>{
        document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
function $788ff41eb2df4559$export$6598253ef2e7f85f(data) {
    let { message: message, initiatorName: initiatorName, targetName: targetName, receivedAmount: receivedAmount, receivedZollars: receivedZollars } = data;
    // Build detailed notification message
    let detailsHTML = '<div style="background: linear-gradient(135deg, rgba(61, 210, 2, 0.15), rgba(61, 210, 2, 0.05)); padding: 15px; border-radius: 8px; margin-bottom: 15px;">';
    detailsHTML += '<p style="font-weight: bold; color: #3dd202; margin-bottom: 10px; font-size: 1.1em;">\uD83C\uDF81 Socialist Subsidy Received!</p>';
    if (initiatorName && targetName) detailsHTML += `<p style="margin-bottom: 15px; color: #ddd;"><strong style="color: #3dd202;">${initiatorName}</strong> redistributed wealth from <strong style="color: #fcba03;">${targetName}</strong></p>`;
    else if (initiatorName) detailsHTML += `<p style="margin-bottom: 15px; color: #ddd;"><strong style="color: #3dd202;">${initiatorName}</strong> triggered a wealth redistribution</p>`;
    else detailsHTML += `<p style="margin-bottom: 15px; color: #ddd;">You received a socialist subsidy</p>`;
    detailsHTML += '</div>';
    if (receivedAmount > 0 || receivedZollars > 0) {
        detailsHTML += `<div style="background: rgba(0,0,0,0.3); padding: 15px; border-radius: 8px; margin-bottom: 10px;">`;
        detailsHTML += `<div style="font-weight: bold; margin-bottom: 10px; color: #fff;">\u{1F4C8} You Received:</div>`;
        detailsHTML += `<ul style="list-style: none; padding: 0; margin: 0;">`;
        if (receivedAmount > 0) detailsHTML += `<li style="padding: 8px; margin: 5px 0; background: rgba(61, 210, 2, 0.1); border-left: 3px solid #3dd202; border-radius: 4px;">\u{1F4B0} Capital: <span style="color: #3dd202; font-weight: bold; font-size: 1.1em;">+${receivedAmount.toFixed(2)}</span></li>`;
        if (receivedZollars > 0) detailsHTML += `<li style="padding: 8px; margin: 5px 0; background: rgba(61, 210, 2, 0.1); border-left: 3px solid #3dd202; border-radius: 4px;">\u{1B5} Zollars: <span style="color: #3dd202; font-weight: bold; font-size: 1.1em;">+${receivedZollars.toFixed(2)}</span></li>`;
        detailsHTML += `</ul></div>`;
    } else detailsHTML += `<p style="padding: 10px; background: rgba(61, 210, 2, 0.1); border-radius: 5px; color: #ddd;">You have received assistance from the wealth redistribution program.</p>`;
    detailsHTML += `<div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #444; font-size: 0.85em; color: #888; font-style: italic;">
	\u{1F4A1} This wealth came from economic redistribution. Someone helped balance the economy!
  </div>`;
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'subsidy-popup';
    notificationPopup.innerHTML = detailsHTML;
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Close';
    closeButton.className = 'close-button-subsidy';
    closeButton.style.marginTop = '10px';
    closeButton.addEventListener('click', ()=>{
        document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
function $788ff41eb2df4559$var$showUserSelectionPopupRS(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.ransomSelectTargetTitle', 'Select a portfolio to ransom:');
        const select = document.createElement('select');
        select.id = 'userSelectSubsidy';
        users.forEach((user)=>{
            const option = document.createElement('option');
            option.value = user._id;
            const name = user.name || user.username || user.displayName || (0, $fUPn2.t)('triggers.unknownUser', 'Unknown user');
            const wealth = Number(user.totalWealth ?? 0).toFixed(2);
            option.textContent = `${name} - ${(0, $fUPn2.t)('triggers.statsTotalWealth', 'Total Wealth:')} ${wealth}`;
            select.appendChild(option);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn';
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn';
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, select, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            const selectedUserId = select.value;
            popup.remove();
            resolve(selectedUserId);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$6a4c2457de50e17b() {
    const stealButton = document.getElementById('stealButton');
    if (stealButton) stealButton.addEventListener('click', $788ff41eb2df4559$export$566bbb08b3c4ec3f);
}
// ===== Steal =====
let $788ff41eb2df4559$var$isProcessingSteal = false;
async function $788ff41eb2df4559$export$566bbb08b3c4ec3f() {
    if ($788ff41eb2df4559$var$isProcessingSteal) return;
    $788ff41eb2df4559$var$isProcessingSteal = true;
    // Immediate visual feedback
    const button = document.getElementById('stealButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    try {
        const portfolioId = window.traderPortfolioId;
        console.log('Using steal button for portfolio:', portfolioId);
        if (!portfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Portfolio is undefined'));
        const useButtonResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/useStealButton`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId
            })
        });
        console.log('Use button response status:', useButtonResponse.status);
        if (!useButtonResponse.ok) {
            const errorText = await useButtonResponse.text();
            console.error('Error response body:', errorText);
            throw new Error(`${(0, $fUPn2.t)('triggers.stealFailedUse', 'Failed to use steal button')}: ${useButtonResponse.status} - ${errorText}`);
        }
        const useButtonResult = await useButtonResponse.json();
        console.log(useButtonResult.message);
        // Fetch available items
        const itemsResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/availableItems`, {
            headers: {
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            }
        });
        console.log('Items response status:', itemsResponse.status);
        if (!itemsResponse.ok) {
            const errorText = await itemsResponse.text();
            console.error('Error response body:', errorText);
            throw new Error(`${(0, $fUPn2.t)('triggers.stealFailedFetchItems', 'Failed to fetch available commodities')}: ${itemsResponse.status} - ${errorText}`);
        }
        const items = await itemsResponse.json();
        console.log('Available items:', items);
        $788ff41eb2df4559$export$41a2f775b0e16711(items);
    } catch (error) {
        console.error('Error using steal button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.stealFailedUseOrFetch', 'Failed to use steal button or fetch commmodities')}: ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingSteal = false;
    }
}
function $788ff41eb2df4559$export$41a2f775b0e16711(items) {
    console.log('Displaying available items:', items);
    const existingModal = document.querySelector('.modal-steal');
    if (existingModal) existingModal.remove();
    const modal = document.createElement('div');
    modal.classList.add('modal-steal');
    const modalContent = document.createElement('div');
    modalContent.classList.add('modal-steal-content');
    const closeBtn = document.createElement('span');
    closeBtn.classList.add('modal-steal-close');
    closeBtn.textContent = 'X';
    closeBtn.onclick = ()=>document.body.removeChild(modal);
    const itemList = document.createElement('ul');
    itemList.classList.add('modal-steal-item-list'); // Apply the scrollable list class
    items.forEach((item)=>{
        const listItem = document.createElement('li');
        listItem.textContent = `${item.item_name} - ${item.description}`;
        listItem.style = `
		  cursor: pointer; padding: 5px; border-bottom: 1px solid #00ff00;
		`;
        listItem.onclick = ()=>{
            $788ff41eb2df4559$export$e8f5fefdc63a3196(item._id);
            document.body.removeChild(modal);
        };
        itemList.appendChild(listItem);
    });
    modalContent.appendChild(closeBtn);
    modalContent.appendChild(itemList);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
    console.log('Steal modal created and added to the DOM');
}
async function $788ff41eb2df4559$export$e8f5fefdc63a3196(itemId) {
    try {
        const portfolioId = window.traderPortfolioId;
        console.log('Attempting to steal item:', itemId, 'for portfolio:', portfolioId);
        if (!portfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Portfolio ID is undefined'));
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/stealItem`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                stealerPortfolioId: portfolioId,
                itemId: itemId
            })
        });
        console.log('Steal item response status:', response.status);
        // Read body once; we may need it for both success & error
        let payload = null;
        let rawText = '';
        try {
            rawText = await response.text();
            payload = rawText ? JSON.parse(rawText) : null;
        } catch  {
            payload = null; // keep going; we’ll fall back to client-side keys
        }
        if (!response.ok) {
            console.error('Error response:', payload || rawText);
            // Prefer backend code if present, else map HTTP status to a client key
            const statusToKey = {
                403: 'triggers.steal_noTrigger',
                404: 'triggers.steal_itemUnavailable',
                500: 'triggers.steal_serverError'
            };
            const key = payload && payload.messageId || statusToKey[response.status] || 'trigger.steal_serverError';
            const msg = (0, $fUPn2.t)(key, payload && payload.message || (0, $fUPn2.t)('socketFront.stealFailed', 'Failed to steal asset'), payload && payload.params || {});
            throw new Error(msg);
        }
        // Success: always use the client translation key (don’t trust server strings)
        console.log('Steal item result:', payload);
        const successMsg = (0, $fUPn2.t)('triggers.steal_success', 'Item stolen successfully.');
        (0, $eD3DY.showNotification)(successMsg, true, ()=>location.reload());
    } catch (error) {
        console.error('Error stealing item:', error);
        // Final client-side fallback, still localized
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.stealFailedToSteal', 'Failed to steal asset')}: ${error?.message || ''}`, false);
    }
}
// ===== Ransom =====
let $788ff41eb2df4559$var$isProcessingRansom = false;
async function $788ff41eb2df4559$export$1ac0c914c8d316() {
    if ($788ff41eb2df4559$var$isProcessingRansom) return;
    $788ff41eb2df4559$var$isProcessingRansom = true;
    // Immediate visual feedback
    const button = document.getElementById('ransomButton');
    const originalText = button ? button.textContent : null;
    if (button) {
        button.textContent = 'Processing...';
        button.disabled = true;
        button.style.opacity = '0.2';
    }
    try {
        const portfolioId = window.traderPortfolioId;
        const sessionId = localStorage.getItem('sessionId');
        console.log('Initiating ransom action from portfolio:', portfolioId);
        if (!portfolioId) throw new Error((0, $fUPn2.t)('triggers.initiatorUndefined', 'Initiator Portfolio is undefined'));
        if (!sessionId) throw new Error((0, $fUPn2.t)('triggers.sessionUndefined', 'Session is undefined'));
        // Cached active portfolios
        const activePortfolios = await $788ff41eb2df4559$var$getCachedPortfolios(sessionId, '/api/portfolios/active');
        const eligiblePortfolios = activePortfolios.filter((p)=>p._id !== portfolioId && !p.isSuperUser);
        if (eligiblePortfolios.length === 0) {
            (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.ransomNoEligible', 'No eligible portfolios to ransom. Action cancelled.'), false);
            return;
        }
        // May return string or { selectedUserId } depending on previous helper versions
        const sel = await $788ff41eb2df4559$var$showUserSelectionPopupRS(eligiblePortfolios);
        const portfolioToRansomId = typeof sel === 'string' ? sel : sel?.selectedUserId;
        if (!portfolioToRansomId) return;
        // Find the selected portfolio to get their wealth
        const targetPortfolio = eligiblePortfolios.find((p)=>p._id === portfolioToRansomId);
        const targetWealth = targetPortfolio?.totalWealth || 0;
        const targetName = targetPortfolio?.name || 'Unknown';
        const ransomAmount = await $788ff41eb2df4559$var$showRansomAmountPopup(targetWealth, targetName);
        if (!ransomAmount) return;
        const confirmRansom = await $788ff41eb2df4559$var$showConfirmRansomPopup(ransomAmount);
        if (!confirmRansom) return;
        const ransomResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/setRansom`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                targetPortfolioId: portfolioToRansomId,
                ransomPoints: ransomAmount
            })
        });
        if (!ransomResponse.ok) {
            const errorData = await ransomResponse.json().catch(()=>({}));
            throw new Error(errorData.message || (0, $fUPn2.t)('triggers.ransomSetFailed', 'Failed to set ransom'));
        }
        const result = await ransomResponse.json();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.ransomSetSuccess', 'Ransom set successfully.'), true);
    } catch (error) {
        console.error('Error using ransom button:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.ransomSetErrorPrefix', 'Error: Could not set ransom.')} ${error.message}`, false);
    } finally{
        if (button) {
            button.textContent = originalText;
            button.disabled = false;
            button.style.opacity = '1';
        }
        $788ff41eb2df4559$var$isProcessingRansom = false;
    }
}
function $788ff41eb2df4559$var$showRansomAmountPopup(targetWealth = 0, targetName = 'Unknown') {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.ransomSetAmountTitle', 'Set Ransom Amount');
        // Display target info
        const targetInfo = document.createElement('p');
        targetInfo.style.cssText = 'margin: 10px 0; color: #0f0; font-size: 1.1em;';
        targetInfo.textContent = `${targetName} - Total Wealth: ${Math.floor(targetWealth)} capital`;
        // Percentage buttons container
        const percentButtonsContainer = document.createElement('div');
        percentButtonsContainer.style.cssText = 'display: flex; gap: 10px; margin: 15px 0; flex-wrap: wrap; justify-content: center;';
        const percentages = [
            5,
            10,
            25,
            50,
            75,
            100
        ];
        let selectedAmount = Math.max(1, Math.floor(targetWealth * 0.1)); // Default to 10%, minimum 1
        percentages.forEach((percent)=>{
            const btn = document.createElement('button');
            btn.className = 'cyber-confirm-btn';
            btn.textContent = `${percent}%`;
            btn.style.cssText = 'padding: 8px 16px; font-size: 0.9em; min-width: 60px; opacity: 0.6;';
            btn.type = 'button'; // Prevent form submission
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                selectedAmount = Math.max(1, Math.floor(targetWealth * (percent / 100)));
                amountDisplay.textContent = `${selectedAmount} capital`;
                slider.value = percent;
                // Visual feedback - highlight selected button
                percentButtonsContainer.querySelectorAll('button').forEach((b)=>{
                    b.style.opacity = '0.6';
                    b.style.transform = 'scale(1)';
                });
                btn.style.opacity = '1';
                btn.style.transform = 'scale(1.05)';
            });
            percentButtonsContainer.appendChild(btn);
        });
        // Slider container
        const sliderContainer = document.createElement('div');
        sliderContainer.style.cssText = 'margin: 20px 0;';
        const sliderLabel = document.createElement('label');
        sliderLabel.textContent = (0, $fUPn2.t)('triggers.ransomSliderLabel', 'Fine-tune percentage:');
        sliderLabel.style.cssText = 'display: block; margin-bottom: 8px; color: #0ff;';
        const slider = document.createElement('input');
        slider.type = 'range';
        slider.min = '1';
        slider.max = '100';
        slider.value = '10';
        slider.step = '1';
        slider.style.cssText = 'width: 100%; cursor: pointer;';
        const sliderValueDisplay = document.createElement('span');
        sliderValueDisplay.textContent = '10%';
        sliderValueDisplay.style.cssText = 'margin-left: 10px; color: #ff0; font-weight: bold;';
        slider.addEventListener('input', (e)=>{
            const percent = parseInt(e.target.value, 10);
            selectedAmount = Math.max(1, Math.floor(targetWealth * (percent / 100)));
            sliderValueDisplay.textContent = `${percent}%`;
            amountDisplay.textContent = `${selectedAmount} capital`;
            // Reset button highlights
            percentButtonsContainer.querySelectorAll('button').forEach((b)=>{
                b.style.opacity = '0.6';
                b.style.transform = 'scale(1)';
            });
        });
        sliderContainer.append(sliderLabel, slider, sliderValueDisplay);
        // Amount display
        const amountDisplay = document.createElement('div');
        amountDisplay.style.cssText = 'margin: 20px 0; padding: 15px; background: rgba(0, 255, 0, 0.1); border: 2px solid #0f0; border-radius: 8px; text-align: center; font-size: 1.3em; color: #0f0; font-weight: bold;';
        amountDisplay.textContent = `${selectedAmount} capital`;
        // Confirm/Cancel buttons
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn';
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn';
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, targetInfo, percentButtonsContainer, sliderContainer, amountDisplay, buttonContainer);
        document.body.appendChild(popup);
        // Set initial button highlight (10%)
        const tenPercentBtn = percentButtonsContainer.children[1]; // 10% is second button (index 1)
        if (tenPercentBtn) {
            tenPercentBtn.style.opacity = '1';
            tenPercentBtn.style.transform = 'scale(1.05)';
        }
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(selectedAmount > 0 ? selectedAmount : null);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$var$showConfirmRansomPopup(amount) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.ransomConfirmSetTitle', 'Confirm Ransom');
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.ransomConfirmSetBody', 'Are you sure you want to set a ransom of {amount} capital?').replace('{amount}', String(amount));
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn';
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn';
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
async function $788ff41eb2df4559$export$43381ed8b1163ece(portfolioId, ransomPoints) {
    try {
        const confirmPay = await $788ff41eb2df4559$var$showConfirmPayRansomPopup(ransomPoints);
        if (!confirmPay) return;
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/button/payRansom`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(0, $21EbS.getAuthToken)()}` // Add the token to the Authorization header
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                ransomPoints: ransomPoints
            })
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to pay ransom');
        }
        const result = await response.json();
        (0, $eD3DY.showNotification)((0, $fUPn2.t)('triggers.ransomPaySuccess', 'Ransom paid successfully. Your portfolio is now unlocked.'), true);
        location.reload();
    } catch (error) {
        console.error('Error paying ransom:', error);
        (0, $eD3DY.showNotification)(`${(0, $fUPn2.t)('triggers.ransomPayErrorPrefix', 'Error: Could not pay ransom.')} ${error.message}`, false);
    }
}
function $788ff41eb2df4559$var$showConfirmPayRansomPopup(amount) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.ransomPayTitle', 'Confirm Pay Ransom');
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.ransomPayBody', 'Are you sure you want to pay {amount} capital to unlock your portfolio?').replace('{amount}', amount);
        const buttonContainer = document.createElement('div');
        Object.assign(buttonContainer.style, {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '20px'
        });
        const confirmButton = document.createElement('button');
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$ad2c4ba1304fb03a() {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'confirmGiveAwayPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.giveawayTitle', 'Confirm Give Away');
        const body = document.createElement('p');
        body.textContent = (0, $fUPn2.t)('triggers.giveawayBody', 'Are you sure you want to give away this commodity?');
        const buttonContainer = document.createElement('div');
        Object.assign(buttonContainer.style, {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '20px'
        });
        const confirmButton = document.createElement('button');
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, body, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(true);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(false);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$30c1977a1acc5902(users) {
    return new Promise((resolve)=>{
        const popup = document.createElement('div');
        popup.id = 'multiUserSelectionPopup';
        const title = document.createElement('h2');
        title.textContent = (0, $fUPn2.t)('triggers.communitySelectUsersTitle', 'Select users for the community:');
        const listContainer = document.createElement('div');
        listContainer.id = 'userList';
        Object.assign(listContainer.style, {
            maxHeight: '200px',
            overflowY: 'auto'
        });
        (users || []).forEach((u)=>{
            const label = document.createElement('label');
            Object.assign(label.style, {
                display: 'block',
                marginBottom: '5px'
            });
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.value = u._id;
            Object.assign(checkbox.style, {
                marginRight: '5px'
            });
            const name = u?.name || u?.username || u?.displayName || (0, $fUPn2.t)('triggers.unknownUser', 'Unknown user');
            label.append(checkbox, name);
            listContainer.appendChild(label);
        });
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'selButMuCon';
        const confirmButton = document.createElement('button');
        confirmButton.className = 'cyber-confirm-btn'; // Add this line
        confirmButton.textContent = (0, $fUPn2.t)('triggers.confirm', 'Confirm');
        const cancelButton = document.createElement('button');
        cancelButton.className = 'cyber-cancel-btn'; // Add this line
        cancelButton.textContent = (0, $fUPn2.t)('triggers.cancel', 'Cancel');
        buttonContainer.append(confirmButton, cancelButton);
        popup.append(title, listContainer, buttonContainer);
        document.body.appendChild(popup);
        confirmButton.addEventListener('click', ()=>{
            const selectedUserIds = Array.from(listContainer.querySelectorAll('input:checked')).map((input)=>input.value);
            popup.remove();
            resolve(selectedUserIds);
        }, {
            once: true
        });
        cancelButton.addEventListener('click', ()=>{
            popup.remove();
            resolve(null);
        }, {
            once: true
        });
    });
}
function $788ff41eb2df4559$export$35f287f5175d77ea(mainVideoUrl, introVideoUrl) {
    console.log('Attempting to play pub video');
    console.log('Intro URL:', introVideoUrl);
    console.log('Main URL:', mainVideoUrl);
    const videoOverlay = document.createElement('div');
    videoOverlay.setAttribute("style", `
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: black;
		z-index: 10000;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	  `);
    const videoContainer = document.createElement('div');
    videoContainer.setAttribute("style", `
		width: 100%;
		height: calc(100% - 60px); /* Adjust height to leave space for buttons */
		position: relative;
	  `);
    const videoElement = document.createElement('video');
    videoElement.setAttribute("style", `
		width: 100%;
		height: 100%;
		object-fit: contain;
	  `);
    videoElement.controls = true;
    videoElement.autoplay = true;
    videoElement.muted = true;
    videoElement.playsInline = true; // Prevent automatic fullscreen on mobile
    videoContainer.appendChild(videoElement);
    videoOverlay.appendChild(videoContainer);
    document.body.appendChild(videoOverlay);
    const buttonContainer = document.createElement('div');
    buttonContainer.setAttribute("style", `
		position: absolute;
		bottom: 10px;
		left: 0;
		width: 100%;
		display: flex;
		justify-content: space-around;
		z-index: 10001;
	  `);
    const buttonStyle = `
		padding: 10px 20px;
		cursor: pointer;
		font-size: 1rem;
		font-weight: 700;
		text-align: center;
		border: 0.15em solid white;
		border-radius: 0.45em;
		background: rgba(0, 0, 0, 0.5);
		color: white;
	  `;
    const unmuteButton = document.createElement('button');
    unmuteButton.textContent = 'Unmute';
    unmuteButton.setAttribute("style", buttonStyle);
    const repeatButton = document.createElement('button');
    repeatButton.textContent = 'Replay';
    repeatButton.setAttribute("style", buttonStyle);
    unmuteButton.onclick = function(event) {
        event.stopPropagation();
        videoElement.muted = false;
        unmuteButton.style.display = 'none';
    };
    repeatButton.onclick = function(event) {
        event.stopPropagation();
        playVideo(mainVideoUrl);
    };
    buttonContainer.appendChild(unmuteButton);
    buttonContainer.appendChild(repeatButton);
    videoOverlay.appendChild(buttonContainer);
    function closeOverlay() {
        if (videoElement.ended) document.body.removeChild(videoOverlay);
    }
    function playVideo(introUrl, mainUrl) {
        if (Hls.isSupported()) {
            console.log('HLS is supported');
            const hls = new Hls();
            let currentlyPlaying = 'intro';
            hls.loadSource(introUrl);
            hls.attachMedia(videoElement);
            hls.on(Hls.Events.MANIFEST_PARSED, function() {
                console.log('HLS manifest parsed, attempting to play intro');
                videoElement.play().then(()=>console.log('Intro video playback started successfully')).catch((error)=>{
                    console.error('Error playing intro video:', error);
                });
            });
            videoElement.addEventListener('ended', function() {
                if (currentlyPlaying === 'intro') {
                    console.log('Intro ended, playing main video');
                    hls.loadSource(mainUrl);
                    currentlyPlaying = 'main';
                } else closeOverlay();
            });
            hls.on(Hls.Events.ERROR, function(event, data) {
                console.error('HLS error:', event, data);
            });
        } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
            console.log('Native HLS playback supported');
            videoElement.src = introUrl;
            videoElement.addEventListener('loadedmetadata', function() {
                console.log('Intro video metadata loaded, attempting to play');
                videoElement.play().then(()=>console.log('Intro video playback started successfully')).catch((error)=>{
                    console.error('Error playing intro video:', error);
                });
            });
            videoElement.addEventListener('ended', function() {
                if (videoElement.src === introUrl) {
                    console.log('Intro ended, playing main video');
                    videoElement.src = mainUrl;
                    videoElement.play();
                } else closeOverlay();
            });
        } else {
            console.error('HLS is not supported in this browser');
            const fallbackMessage = document.createElement('div');
            fallbackMessage.textContent = 'Video playback is not supported in this browser';
            fallbackMessage.style.color = '#ffffff';
            videoOverlay.appendChild(fallbackMessage);
        }
    }
    videoElement.addEventListener('error', function(e) {
        console.error('Error with pub video playback:', e);
    });
    playVideo(introVideoUrl, mainVideoUrl);
}
function $788ff41eb2df4559$export$887e8fd7f92867b(mainVideoUrl, introVideoUrl) {
    console.log('Attempting to play Znews video');
    console.log('Intro URL:', introVideoUrl);
    console.log('Main URL:', mainVideoUrl);
    const videoOverlay = document.createElement('div');
    videoOverlay.setAttribute("style", `
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: black;
		z-index: 10000;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	  `);
    const videoContainer = document.createElement('div');
    videoContainer.setAttribute("style", `
		width: 100%;
		height: calc(100% - 60px); /* Adjust height to leave space for buttons */
		position: relative;
	  `);
    const videoElement = document.createElement('video');
    videoElement.setAttribute("style", `
		width: 100%;
		height: 100%;
		object-fit: contain;
	  `);
    videoElement.controls = true;
    videoElement.autoplay = true;
    videoElement.muted = true;
    videoElement.playsInline = true; // Prevent automatic fullscreen on mobile
    videoContainer.appendChild(videoElement);
    videoOverlay.appendChild(videoContainer);
    document.body.appendChild(videoOverlay);
    const buttonContainer = document.createElement('div');
    buttonContainer.setAttribute("style", `
		position: absolute;
		bottom: 10px;
		left: 0;
		width: 100%;
		display: flex;
		justify-content: space-around;
		z-index: 10001;
	  `);
    const buttonStyle = `
		padding: 10px 20px;
		cursor: pointer;
		font-size: 1rem;
		font-weight: 700;
		text-align: center;
		border: 0.15em solid white;
		border-radius: 0.45em;
		background: rgba(0, 0, 0, 0.5);
		color: white;
	  `;
    const unmuteButton = document.createElement('button');
    unmuteButton.textContent = 'Unmute';
    unmuteButton.setAttribute("style", buttonStyle);
    const repeatButton = document.createElement('button');
    repeatButton.textContent = 'Replay';
    repeatButton.setAttribute("style", buttonStyle);
    unmuteButton.onclick = function(event) {
        event.stopPropagation();
        videoElement.muted = false;
        unmuteButton.style.display = 'none';
    };
    repeatButton.onclick = function(event) {
        event.stopPropagation();
        playVideo(mainVideoUrl);
    };
    buttonContainer.appendChild(unmuteButton);
    buttonContainer.appendChild(repeatButton);
    videoOverlay.appendChild(buttonContainer);
    function closeOverlay() {
        if (videoElement.ended) document.body.removeChild(videoOverlay);
    }
    function playVideo(introUrl, mainUrl) {
        if (Hls.isSupported()) {
            console.log('HLS is supported');
            const hls = new Hls();
            let currentlyPlaying = 'intro';
            hls.loadSource(introUrl);
            hls.attachMedia(videoElement);
            hls.on(Hls.Events.MANIFEST_PARSED, function() {
                console.log('HLS manifest parsed, attempting to play intro');
                videoElement.play().then(()=>console.log('Intro video playback started successfully')).catch((error)=>{
                    console.error('Error playing intro video:', error);
                });
            });
            videoElement.addEventListener('ended', function() {
                if (currentlyPlaying === 'intro') {
                    console.log('Intro ended, playing main video');
                    hls.loadSource(mainUrl);
                    currentlyPlaying = 'main';
                } else closeOverlay();
            });
            hls.on(Hls.Events.ERROR, function(event, data) {
                console.error('HLS error:', event, data);
            });
        } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
            console.log('Native HLS playback supported');
            videoElement.src = introUrl;
            videoElement.addEventListener('loadedmetadata', function() {
                console.log('Intro video metadata loaded, attempting to play');
                videoElement.play().then(()=>console.log('Intro video playback started successfully')).catch((error)=>{
                    console.error('Error playing intro video:', error);
                });
            });
            videoElement.addEventListener('ended', function() {
                if (videoElement.src === introUrl) {
                    console.log('Intro ended, playing main video');
                    videoElement.src = mainUrl;
                    videoElement.play();
                } else closeOverlay();
            });
        } else {
            console.error('HLS is not supported in this browser');
            const fallbackMessage = document.createElement('div');
            fallbackMessage.textContent = 'Video playback is not supported in this browser';
            fallbackMessage.style.color = '#ffffff';
            videoOverlay.appendChild(fallbackMessage);
        }
    }
    videoElement.addEventListener('error', function(e) {
        console.error('Error with Znews video playback:', e);
    });
    playVideo(introVideoUrl, mainVideoUrl);
}
// ===== ITEM STOLEN NOTIFICATION =====
function $788ff41eb2df4559$export$31f3cf3256e53c73(data) {
    const { message: message, botName: botName, stolenItemName: stolenItemName } = data;
    const notificationPopup = document.createElement('div');
    notificationPopup.className = 'subsidy-popup';
    const messageDiv = document.createElement('div');
    messageDiv.style.cssText = 'color: #ff4d4d; font-weight: bold; margin-bottom: 10px; text-shadow: 0 0 5px #ff4d4d;';
    messageDiv.textContent = message;
    notificationPopup.appendChild(messageDiv);
    const closeButton = document.createElement('button');
    closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
    closeButton.className = 'close-button-subsidy';
    closeButton.style.marginTop = '10px';
    closeButton.addEventListener('click', ()=>{
        if (notificationPopup.parentNode) document.body.removeChild(notificationPopup);
    });
    notificationPopup.appendChild(closeButton);
    document.body.appendChild(notificationPopup);
}
// ===== SPECIAL ACTION NOTIFICATION (Generic) =====
function $788ff41eb2df4559$export$3f11d1f2c5a135aa(data) {
    const { type: type, message: message, details: details } = data;
    // For Subsidy_Success, always show detailed popup with recipient information
    if (type === 'Subsidy_Success' && details) {
        const notificationPopup = document.createElement('div');
        notificationPopup.className = 'subsidy-popup';
        notificationPopup.style.maxHeight = '70vh';
        notificationPopup.style.overflowY = 'auto';
        let content = `<div style="font-weight: bold; color: #3dd202; margin-bottom: 15px; font-size: 1.1em;">\u{2705} ${message}</div>`;
        // Show social score boost prominently
        if (details.lifeProfitBoost) content += `<div style="background: rgba(61, 210, 2, 0.2); padding: 12px; border-radius: 8px; margin-bottom: 15px; border: 2px solid #3dd202;">
        <div style="font-weight: bold; color: #3dd202; margin-bottom: 8px;">Social Score Boost: +${details.lifeProfitBoost}</div>
        <div style="color: #aaa; font-size: 0.9em;">New Life Profit: ${details.newLifeProfit || 'N/A'}</div>
        <div style="color: #bbb; font-size: 0.85em; margin-top: 5px; font-style: italic;">You helped ${details.recipientCount || 0} people - your positive social impact has been recorded!</div>
      </div>`;
        // Show what was redistributed per person
        if (details.amountPerRecipient !== undefined || details.zollarsPerRecipient !== undefined) {
            content += `<div style="margin-bottom: 15px;">
        <div style="font-weight: bold; margin-bottom: 8px;"> Distributed per recipient:</div>
        <ul style="list-style: none; padding-left: 10px;">`;
            if (details.amountPerRecipient > 0) content += `<li style="margin: 5px 0;"> Capital: <span style="color: #3dd202; font-weight: bold;">+${details.amountPerRecipient.toFixed(2)}</span></li>`;
            if (details.zollarsPerRecipient > 0) content += `<li style="margin: 5px 0;">\u{1B5} Zollars: <span style="color: #3dd202; font-weight: bold;">+${details.zollarsPerRecipient.toFixed(2)}</span></li>`;
            content += `</ul></div>`;
        }
        // Show recipient list
        if (details.recipientList && details.recipientList.length > 0) {
            content += `<div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #444;">
        <div style="font-weight: bold; margin-bottom: 8px;"> Beneficiaries (${details.recipientList.length}):</div>
        <div style="max-height: 200px; overflow-y: auto; background: rgba(0,0,0,0.3); padding: 10px; border-radius: 5px;">
          <ul style="list-style: none; padding: 0; margin: 0;">`;
            details.recipientList.forEach((name)=>{
                content += `<li style="padding: 4px 0; color: #3dd202;">\u{2713} ${name}</li>`;
            });
            content += `</ul></div></div>`;
        }
        // Show target info
        if (details.targetName) content += `<div style="margin-top: 10px; font-size: 0.9em; color: #888;">
        <em>Wealth redistributed from: ${details.targetName}</em>
      </div>`;
        notificationPopup.innerHTML = content;
        const closeButton = document.createElement('button');
        closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
        closeButton.className = 'close-button-subsidy';
        closeButton.style.marginTop = '15px';
        closeButton.addEventListener('click', ()=>{
            if (notificationPopup.parentNode) document.body.removeChild(notificationPopup);
        });
        notificationPopup.appendChild(closeButton);
        document.body.appendChild(notificationPopup);
        return;
    }
    // For other action types, use LED notification or simple popup
    if (typeof (0, $eD3DY.showNotification) === 'function') {
        // Determine if this is a negative or positive action
        const isNegative = type && (type.includes('Target') || type.includes('Steal') || type.includes('LBO') || type.includes('DeletePortfolio') || type.includes('Subsidy_Target'));
        // Show LED notification (less intrusive)
        (0, $eD3DY.showNotification)(message, !isNegative);
    } else {
        // Fallback to popup if showNotification is not available
        const notificationPopup = document.createElement('div');
        notificationPopup.className = 'subsidy-popup';
        let content = `<div style="font-weight: bold; margin-bottom: 10px;">${message}</div>`;
        if (details) {
            content += '<div style="margin-top: 10px; font-size: 0.9em; color: #00ff00;">';
            if (details.executorName) content += `<p style="margin: 5px 0;">Executor: ${details.executorName}</p>`;
            if (details.impact) content += `<p style="margin: 5px 0;">Impact: ${details.impact}</p>`;
            content += '</div>';
        }
        notificationPopup.innerHTML = content;
        const closeButton = document.createElement('button');
        closeButton.textContent = (0, $fUPn2.t)('triggers.close', 'Close');
        closeButton.className = 'close-button-subsidy';
        closeButton.style.marginTop = '10px';
        closeButton.addEventListener('click', ()=>{
            if (notificationPopup.parentNode) document.body.removeChild(notificationPopup);
        });
        notificationPopup.appendChild(closeButton);
        document.body.appendChild(notificationPopup);
    }
}

});

parcelRegister("kJdNP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4zQMZ").then(()=>parcelRequire('l9yWn'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});



parcelRegister("bzRv7", function(module, exports) {

$parcel$export(module.exports, "initializeSimulationTimer", () => $86dc76c45b2250dc$export$cc7efffc33e38fab);
$parcel$export(module.exports, "cleanupSimulationTimer", () => $86dc76c45b2250dc$export$e42ace8a14893918);
// simulationTimer.js - Standalone simulation timer module

var $5W4EI = parcelRequire("5W4EI");

var $eD3DY = parcelRequire("eD3DY");

var $cJVho = parcelRequire("cJVho");
parcelRequire("21EbS");
// ────── TIMER STATE MANAGEMENT ──────
let $86dc76c45b2250dc$var$simulationTimer = null;
let $86dc76c45b2250dc$var$simulationEndTime = null;
let $86dc76c45b2250dc$var$warningTimers = [];
function $86dc76c45b2250dc$var$showFreestyleLoadingPopup() {
    // Remove existing popup if any
    const existing = document.getElementById('freestyle-loading-popup');
    if (existing) existing.remove();
    // Create popup
    const popup = document.createElement('div');
    popup.id = 'freestyle-loading-popup';
    popup.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.95);
    color: #0f0;
    padding: 30px 50px;
    border: 2px solid #0f0;
    border-radius: 8px;
    z-index: 999999;
    font-family: monospace;
    font-size: 18px;
    text-align: center;
    box-shadow: 0 0 20px rgba(0, 255, 0, 0.5);
  `;
    popup.innerHTML = `
    <div>\u{23F3} Processing simulation results...</div>
    <div style="margin-top: 10px; font-size: 14px;">Please wait</div>
  `;
    document.body.appendChild(popup);
    console.log("\u2705 Freestyle loading popup displayed");
}
function $86dc76c45b2250dc$var$broadcastLogoutToAllClients(resultsData = {}) {
    const portfolioId = localStorage.getItem('portfolioId') || resultsData.portfolioId || '';
    const enriched = {
        ...resultsData,
        portfolioId: portfolioId
    };
    try {
        localStorage.setItem('SIM_LOGOUT', JSON.stringify(enriched));
        setTimeout(()=>localStorage.removeItem('SIM_LOGOUT'), 500);
    } catch  {}
    try {
        const bc = new BroadcastChannel('sim-control');
        bc.postMessage({
            type: 'logout',
            resultsData: enriched
        });
        bc.close();
    } catch  {}
}
function $86dc76c45b2250dc$export$cc7efffc33e38fab(endTime, timerId) {
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    const simulationType = localStorage.getItem('simulationType');
    if (!isSimulated && !simulationType) {
        console.log("\uD83D\uDEE1\uFE0F Normal user detected \u2014 skipping timer initialization.");
        return;
    }
    const isMementoMori = simulationType === 'memento-mori';
    const isStorySimulation = simulationType === 'story-simulation';
    // Story Simulation uses its own phase-based timer (storyPhaseManager.js)
    if (isStorySimulation) {
        console.log("\uD83D\uDCD6 Story Simulation detected - using phase-based timer instead");
        return; // Exit early - story simulation has its own timer system
    }
    // If no parameters provided, try to get from localStorage
    if (!endTime) {
        endTime = localStorage.getItem('simulationEndTime');
        timerId = localStorage.getItem('simulationTimerId');
        console.log("\uD83D\uDCE6 Retrieved from localStorage:", {
            endTime: endTime,
            timerId: timerId
        });
    }
    // If still no endTime, check if we should show a demo timer for testing
    if (!endTime) {
        console.log("\u26A0\uFE0F No simulation timer data found");
        if (isSimulated) {
            console.log("\uD83E\uDDEA Creating demo timer for testing (2 minutes)");
            endTime = new Date(Date.now() + 120000).toISOString(); // 2 minutes from now
            timerId = 'demo-timer-' + Date.now();
        }
    }
    $86dc76c45b2250dc$var$simulationEndTime = new Date(endTime);
    console.log("\u23F0 Simulation timer initialized:", {
        endTime: $86dc76c45b2250dc$var$simulationEndTime,
        timerId: timerId,
        timeRemaining: $86dc76c45b2250dc$var$getTimeRemaining(),
        currentTime: new Date(),
        isMementoMori: isMementoMori
    });
    $86dc76c45b2250dc$var$clearSimulationTimers();
    $86dc76c45b2250dc$var$createTimerDisplay(isMementoMori);
    $86dc76c45b2250dc$var$updateTimerDisplay(isMementoMori);
    $86dc76c45b2250dc$var$simulationTimer = setInterval(()=>$86dc76c45b2250dc$var$updateTimerDisplay(isMementoMori), 1000);
    $86dc76c45b2250dc$var$scheduleWarnings();
    // Schedule freestyle LLM analysis pre-fetch (20s before end)
    if (simulationType === 'freestyle') $86dc76c45b2250dc$var$scheduleFreestyleLLMPreFetch();
    localStorage.setItem('simulationEndTime', endTime);
    localStorage.setItem('simulationTimerId', timerId);
}
function $86dc76c45b2250dc$export$6926c343f2a973ed(endTime, timerId) {
    if (!endTime) return false;
    const next = new Date(endTime);
    if (Number.isNaN(next.getTime())) return false;
    if ($86dc76c45b2250dc$var$simulationEndTime && next <= $86dc76c45b2250dc$var$simulationEndTime) return false; // never shorten
    console.log("\u23F3 Simulation extended to", next.toISOString());
    $86dc76c45b2250dc$export$cc7efffc33e38fab(endTime, timerId || localStorage.getItem('simulationTimerId'));
    return true;
}
function $86dc76c45b2250dc$var$getTimeRemaining() {
    if (!$86dc76c45b2250dc$var$simulationEndTime) return 0;
    return Math.max(0, $86dc76c45b2250dc$var$simulationEndTime.getTime() - Date.now());
}
function $86dc76c45b2250dc$var$clearSimulationTimers() {
    if ($86dc76c45b2250dc$var$simulationTimer) {
        clearInterval($86dc76c45b2250dc$var$simulationTimer);
        $86dc76c45b2250dc$var$simulationTimer = null;
    }
    // Clear memento eulogy interval
    if (window.mementoEulogyInterval) {
        clearInterval(window.mementoEulogyInterval);
        window.mementoEulogyInterval = null;
    }
    $86dc76c45b2250dc$var$warningTimers.forEach((timerId)=>clearTimeout(timerId));
    $86dc76c45b2250dc$var$warningTimers = [];
    // Reset fetch guard
    $86dc76c45b2250dc$var$eulogyFetchInProgress = false;
}
function $86dc76c45b2250dc$var$createTimerDisplay(isMementoMori = false) {
    const existingTimer = document.getElementById('simulationTimer');
    if (existingTimer) existingTimer.remove();
    const timerDisplay = document.createElement('div');
    timerDisplay.id = 'simulationTimer';
    if (isMementoMori) {
        timerDisplay.className = 'simulation-timer-display memento-mori';
        timerDisplay.innerHTML = `
      <div>
        <div style="color:#ff4444; font-size:0.8rem; font-weight:bold;">
          Memento Mori Session Timer
        </div>
        <div id="simulationTimerText" style="font-size:.8rem; font-weight:bold; color:#00ff00;">
          --:--
        </div>
      </div>
    `;
    } else {
        timerDisplay.className = 'simulation-timer-display freestyle';
        timerDisplay.innerHTML = `
      <div id="simulationTimerText">
        Freestyle Session Timer: --:--
      </div>
    `;
    }
    document.body.appendChild(timerDisplay); // ✅ always append
}
function $86dc76c45b2250dc$var$updateTimerDisplay(isMementoMori = false) {
    const timerText = document.getElementById('simulationTimerText');
    if (!timerText) return;
    const remaining = $86dc76c45b2250dc$var$getTimeRemaining();
    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor(remaining % 60000 / 1000);
    if (remaining <= 0) {
        timerText.innerHTML = isMementoMori ? `<span style="color:#ff0000;">Memento Mori Ended</span>` : `<span style="color:#ff0000;">Freestyle Session Ended</span>`;
        $86dc76c45b2250dc$var$clearSimulationTimers();
        // ✅ CRITICAL: Re-read simulation type from localStorage at the moment of expiry
        // to ensure we have the most current value, but also use parameter as backup
        const currentSimulationType = localStorage.getItem('simulationType');
        const isMementoMoriFromStorage = currentSimulationType === 'memento-mori';
        const isStorySimulationFromStorage = currentSimulationType === 'story-simulation';
        // Use parameter as backup if localStorage is cleared (belt-and-suspenders approach)
        const finalIsMementoMori = isMementoMoriFromStorage || isMementoMori;
        const finalSimulationType = currentSimulationType || (isMementoMori ? 'memento-mori' : 'freestyle');
        console.log("\u23F0 [updateTimerDisplay] Timer expired, routing to correct ending:", {
            currentSimulationType: currentSimulationType,
            isMementoMoriFromStorage: isMementoMoriFromStorage,
            isMementoMoriParam: isMementoMori,
            finalIsMementoMori: finalIsMementoMori,
            finalSimulationType: finalSimulationType,
            isStorySimulationFromStorage: isStorySimulationFromStorage
        });
        $86dc76c45b2250dc$var$handleSimulationEnd(finalSimulationType, finalIsMementoMori, isStorySimulationFromStorage);
        return;
    }
    // 🎨 Freestyle timer colors
    if (!isMementoMori) {
        let timeColor = '#fcba03';
        if (remaining <= 60000) timeColor = '#ff6b6b'; // last minute
        else if (remaining <= 120000) timeColor = '#ff8c00'; // last 2 min
        else if (remaining <= 300000) timeColor = '#ffd700'; // last 5 min
        timerText.style.color = timeColor;
        timerText.textContent = `Freestyle Session Timer: ${minutes}:${seconds.toString().padStart(2, '0')}`;
    } else {
        // ⚰️ Memento Mori colors
        timerText.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        const timerElement = document.getElementById('simulationTimer');
        if (remaining <= 60000) {
            timerText.style.color = '#ff0000';
            timerElement.style.borderColor = '#ff0000';
            timerElement.style.boxShadow = '0 0 30px rgba(255,0,0,0.5)';
        } else if (remaining <= 180000) {
            timerText.style.color = '#ff6600';
            timerElement.style.borderColor = '#ff6600';
        } else {
            timerText.style.color = '#00ff00';
            timerElement.style.borderColor = '#ff6666';
        }
    }
}
function $86dc76c45b2250dc$export$6b3b92bb17f71559() {
    $86dc76c45b2250dc$var$clearSimulationTimers();
    const type = localStorage.getItem('simulationType');
    return $86dc76c45b2250dc$var$handleSimulationEnd(type, type === 'memento-mori', type === 'story-simulation');
}
function $86dc76c45b2250dc$export$e42ace8a14893918() {
    $86dc76c45b2250dc$var$clearSimulationTimers();
    const timerDisplay = document.getElementById('simulationTimer');
    if (timerDisplay) timerDisplay.remove();
    $86dc76c45b2250dc$var$simulationEndTime = null;
    localStorage.removeItem('simulationEndTime');
    localStorage.removeItem('simulationTimerId');
}
function $86dc76c45b2250dc$var$scheduleWarnings() {
    const timeRemaining = $86dc76c45b2250dc$var$getTimeRemaining();
    // ✅ Capture simulation type at scheduling time to preserve it
    const simulationType = localStorage.getItem('simulationType');
    const isMementoMori = simulationType === 'memento-mori';
    const isStorySimulation = simulationType === 'story-simulation';
    console.log("\uD83D\uDCC5 [scheduleWarnings] Scheduling warnings for simulation:", {
        simulationType: simulationType,
        isMementoMori: isMementoMori,
        isStorySimulation: isStorySimulation,
        timeRemaining: timeRemaining,
        timeRemainingMinutes: Math.floor(timeRemaining / 60000)
    });
    // Schedule warnings at 5 min, 2 min, 1 min, and 30 seconds
    const warningTimes = [
        300000,
        120000,
        60000,
        30000
    ]; // milliseconds
    warningTimes.forEach((warningTime)=>{
        if (timeRemaining > warningTime) {
            const delay = timeRemaining - warningTime;
            const timerId = setTimeout(()=>{
                $86dc76c45b2250dc$var$showTimerWarning(warningTime);
            }, delay);
            $86dc76c45b2250dc$var$warningTimers.push(timerId);
        }
    });
    // Schedule simulation end - PASS simulation type to preserve it
    if (timeRemaining > 0) {
        const endTimerId = setTimeout(()=>{
            // ✅ Re-read localStorage at the moment of execution, with captured values as backup
            const currentSimulationType = localStorage.getItem('simulationType');
            const currentIsMementoMori = currentSimulationType === 'memento-mori';
            const currentIsStorySimulation = currentSimulationType === 'story-simulation';
            // ✅ CRITICAL: Use OR logic (not ternary) to detect from EITHER source
            // If EITHER the captured value OR the current localStorage says it's memento-mori, it is
            const finalSimulationType = currentSimulationType || simulationType;
            const finalIsMementoMori = currentIsMementoMori || isMementoMori;
            const finalIsStorySimulation = currentIsStorySimulation || isStorySimulation;
            console.log("\u23F0 [scheduleWarnings timeout] Simulation end triggered:", {
                capturedType: simulationType,
                currentType: currentSimulationType,
                finalType: finalSimulationType,
                finalIsMementoMori: finalIsMementoMori,
                finalIsStorySimulation: finalIsStorySimulation
            });
            $86dc76c45b2250dc$var$handleSimulationEnd(finalSimulationType, finalIsMementoMori, finalIsStorySimulation);
        }, timeRemaining);
        $86dc76c45b2250dc$var$warningTimers.push(endTimerId);
    }
}
// ────── SCHEDULE FREESTYLE LLM PRE-FETCH (20s BEFORE END) ──────
function $86dc76c45b2250dc$var$scheduleFreestyleLLMPreFetch() {
    const timeRemaining = $86dc76c45b2250dc$var$getTimeRemaining();
    const preFetchTime = 20000; // 20 seconds before end
    if (timeRemaining > preFetchTime) {
        const delay = timeRemaining - preFetchTime;
        console.log(`\u{23F0} [scheduleFreestyleLLMPreFetch] Scheduling LLM pre-fetch in ${Math.floor(delay / 1000)}s (20s before end)`);
        const preFetchTimerId = setTimeout(async ()=>{
            console.log("\uD83E\uDD16 [Pre-fetch] Fetching LLM analysis 20s before timer ends...");
            try {
                const timerId = localStorage.getItem('simulationTimerId');
                const token = localStorage.getItem('token');
                if (!timerId || !token) {
                    console.warn("\u26A0\uFE0F [Pre-fetch] Missing timerId or token");
                    return;
                }
                // Fetch simulation results
                const resultsResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/sim/simulation/results/${timerId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!resultsResponse.ok) {
                    console.warn("\u26A0\uFE0F [Pre-fetch] Failed to fetch simulation results:", resultsResponse.status);
                    return;
                }
                const resultsData = await resultsResponse.json();
                const summary = resultsData?.summary || resultsData;
                // Cache the full live summary too: at T=0 the server logout may have
                // already deleted the portfolio, making the final results fetch come
                // back all-zeros. This snapshot from 20s before end is the fallback.
                if (summary && summary.finalPortfolio) {
                    window.freestyleSummaryCache = summary;
                    console.log("\u2705 [Pre-fetch] Live summary cached as end-of-sim fallback");
                }
                // Fetch LLM analysis
                const llmAnalysis = await $86dc76c45b2250dc$var$fetchFreestyleLLMAnalysis(summary, token);
                if (llmAnalysis) {
                    // Cache it globally (like memento-mori does with window.currentEulogyText)
                    window.freestyleLLMAnalysis = llmAnalysis;
                    console.log("\u2705 [Pre-fetch] LLM analysis cached:", llmAnalysis.substring(0, 100) + '...');
                }
            } catch (error) {
                console.error("\u274C [Pre-fetch] Error fetching LLM analysis:", error);
            }
        }, delay);
        $86dc76c45b2250dc$var$warningTimers.push(preFetchTimerId);
    } else console.log(`\u{26A0}\u{FE0F} [scheduleFreestyleLLMPreFetch] Not enough time remaining (${Math.floor(timeRemaining / 1000)}s), skipping pre-fetch`);
}
function $86dc76c45b2250dc$var$showTimerWarning(timeLeft) {
    const minutes = Math.floor(timeLeft / 60000);
    const seconds = Math.floor(timeLeft % 60000 / 1000);
    let message;
    if (minutes > 0) message = `${minutes} minute${minutes > 1 ? 's' : ''} remaining in simulation`;
    else message = `${seconds} seconds remaining in simulation`;
    // Create warning popup
    const warning = document.createElement('div');
    warning.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 107, 107, 0.95);
    color: white;
    padding: 20px 30px;
    border-radius: 10px;
    font-family: 'bithigh', monospace;
    font-size: 18px;
    font-weight: bold;
    z-index: 900;
    box-shadow: 0 0 20px rgba(255, 107, 107, 0.7);
    text-align: center;
    animation: pulse 0.5s ease-in-out;
  `;
    // Add CSS animation
    const style = document.createElement('style');
    style.textContent = `
    @keyframes pulse {
      0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0; }
      50% { transform: translate(-50%, -50%) scale(1.1); opacity: 1; }
      100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
    }
  `;
    document.head.appendChild(style);
    warning.textContent = message;
    document.body.appendChild(warning);
    // Remove warning after 3 seconds
    setTimeout(()=>{
        warning.remove();
        style.remove();
    }, 3000);
}
// ────── LOADING POPUP FOR EULOGY ──────
function $86dc76c45b2250dc$var$showEulogyLoadingPopup() {
    const existing = document.getElementById('eulogy-loading-popup');
    if (existing) existing.remove();
    const popup = document.createElement('div');
    popup.id = 'eulogy-loading-popup';
    popup.innerHTML = `
    <div style="
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0, 0, 0, 0.9);
      display: flex; flex-direction: column; justify-content: center; align-items: center;
      z-index: 10000; color: #fff; font-family: Georgia, serif;
    ">
      <div style="font-size: 28px; margin-bottom: 20px; color: #c9a227;">Your Time Has Come</div>
      <div style="font-size: 18px; margin-bottom: 30px; color: #ccc;">Composing your eulogy...</div>
      <div style="width: 200px; height: 4px; background: #333; border-radius: 2px; overflow: hidden;">
        <div id="eulogy-progress-bar" style="
          width: 0%; height: 100%;
          background: linear-gradient(90deg, #8b0000, #dc143c);
          transition: width 0.5s ease;
        "></div>
      </div>
      <div style="font-size: 14px; margin-top: 15px; color: #888;">Please wait...</div>
    </div>
  `;
    document.body.appendChild(popup);
    // Animate progress bar over 20 seconds
    setTimeout(()=>{
        const bar = document.getElementById('eulogy-progress-bar');
        if (bar) {
            bar.style.width = '100%';
            bar.style.transition = 'width 19s linear';
        }
    }, 100);
}
// ────── PRE-FETCH EULOGY 15 SECONDS BEFORE END ──────
let $86dc76c45b2250dc$var$eulogyFetchInProgress = false;
async function $86dc76c45b2250dc$var$preFetchFinalEulogy() {
    if ($86dc76c45b2250dc$var$eulogyFetchInProgress) {
        console.log("\u23F8\uFE0F [preFetch] Already fetching eulogy, skipping duplicate");
        return;
    }
    const objectiveId = localStorage.getItem('mementoMoriObjectiveId');
    const token = localStorage.getItem('token');
    if (!objectiveId) {
        console.warn("\u26A0\uFE0F [preFetch] No objective ID");
        return;
    }
    $86dc76c45b2250dc$var$eulogyFetchInProgress = true;
    // Show loading indicator
    $86dc76c45b2250dc$var$showEulogyLoadingPopup();
    try {
        console.log("\uD83D\uDD04 [preFetch] Fetching eulogy from API (no timeout - LLM has 15s)...");
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/current-eulogy`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...token && {
                    Authorization: `Bearer ${token}`
                }
            },
            body: JSON.stringify({
                objectiveId: objectiveId
            })
        });
        if (response.ok) {
            const data = await response.json();
            if (data.eulogyText) {
                window.currentEulogyText = data.eulogyText;
                console.log("\u2705 [preFetch] Eulogy cached:", data.eulogyText.substring(0, 80) + '...');
            }
        } else console.warn("\u26A0\uFE0F [preFetch] API returned", response.status);
    } catch (err) {
        console.warn("\u26A0\uFE0F [preFetch] Error:", err.message);
    } finally{
        $86dc76c45b2250dc$var$eulogyFetchInProgress = false;
    }
}
// ────── HANDLE MEMENTO MORI END ──────
async function $86dc76c45b2250dc$var$handleMementoMoriEnd() {
    console.log("\u26B0\uFE0F Memento Mori session ending...");
    // Clear eulogy interval immediately
    if (window.mementoEulogyInterval) {
        console.log("\uD83D\uDDD1\uFE0F Clearing memento eulogy interval");
        clearInterval(window.mementoEulogyInterval);
        window.mementoEulogyInterval = null;
    }
    window.mementoMoriInitialized = false;
    const FALLBACK_EULOGY = "Your journey through life's marketplace has concluded. In facing mortality, you have positioned yourself into your vision of Life Value.";
    // ✅ Show loading popup immediately so user knows we're working
    $86dc76c45b2250dc$var$showEulogyLoadingPopup();
    try {
        const objectiveId = localStorage.getItem('mementoMoriObjectiveId');
        const token = localStorage.getItem('token');
        if (!objectiveId) {
            console.error("\u274C No objective ID found - redirecting with fallback");
            $86dc76c45b2250dc$var$redirectToMementoMoriEndPage({
                eulogy: FALLBACK_EULOGY,
                portfolioInsights: []
            });
            return;
        }
        // ✅ PRIORITY 1: Use cached eulogy from periodic fetches (instant, no LLM wait)
        let currentEulogy = window.currentEulogyText;
        console.log("\uD83D\uDCCB Cached eulogy available:", !!currentEulogy, currentEulogy ? `(${currentEulogy.length} chars)` : '');
        // ✅ PRIORITY 2: Fetch from API - user sees loading popup so we can wait longer (20s)
        if (!currentEulogy) {
            console.log("\u23F3 No cached eulogy, fetching from API (20s timeout - user sees loading)...");
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(()=>controller.abort(), 20000); // 20s - user sees loading
                const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/memento-mori/current-eulogy`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...token && {
                            Authorization: `Bearer ${token}`
                        }
                    },
                    body: JSON.stringify({
                        objectiveId: objectiveId
                    }),
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
                if (response.ok) {
                    const data = await response.json();
                    currentEulogy = data.eulogyText;
                    console.log("\u2705 API fetch succeeded:", currentEulogy?.substring(0, 80));
                }
            } catch (fetchError) {
                console.warn("\u26A0\uFE0F API fetch failed/timed out - using fallback:", fetchError.message);
            }
        }
        // ✅ PRIORITY 3: Use fallback if still nothing
        if (!currentEulogy) {
            console.warn("\u26A0\uFE0F No eulogy available, using fallback");
            currentEulogy = FALLBACK_EULOGY;
        }
        console.log("\uD83D\uDCDC Redirecting with eulogy:", currentEulogy.substring(0, 80) + '...');
        // Redirect with eulogy data
        $86dc76c45b2250dc$var$redirectToMementoMoriEndPage({
            eulogy: currentEulogy,
            portfolioInsights: []
        });
    } catch (error) {
        console.error("\u274C Error completing Memento Mori:", error);
        $86dc76c45b2250dc$var$redirectToMementoMoriEndPage({
            eulogy: FALLBACK_EULOGY,
            portfolioInsights: []
        });
    }
}
// ────── REDIRECT TO MEMENTO MORI END PAGE ──────
function $86dc76c45b2250dc$var$redirectToMementoMoriEndPage(eulogyData) {
    console.log("\uD83E\uDEA6 Redirecting to Memento Mori ending page...");
    try {
        localStorage.setItem('simulationEnding', 'true');
        localStorage.setItem('preventBotRecreation', 'true');
        localStorage.setItem('tempMementoMoriResults', JSON.stringify({
            ...eulogyData,
            timestamp: Date.now()
        }));
        console.log("\uD83D\uDCBE Stored eulogy data for ending page");
        // Redirect to memento mori ending page
        console.log("\uD83C\uDFAF Final redirect to mementomoriend.html");
        window.location.replace('/mementomoriend.html');
    } catch (error) {
        console.error("\u274C Error storing data:", error);
        // Try redirect anyway with flag set
        localStorage.setItem('simulationEnding', 'true');
        window.location.replace('/mementomoriend.html');
    }
}
async function $86dc76c45b2250dc$var$handleSimulationEnd(simulationTypeParam = null, isMementoMoriParam = null, isStorySimulationParam = null) {
    console.log("\uD83C\uDFC1 [handleSimulationEnd] Simulation timer ended - determining route...");
    // ✅ CRITICAL ROUTING LOGIC: Check both parameters AND localStorage
    // Parameters are captured when timer starts, localStorage is current value
    const localStorageType = localStorage.getItem('simulationType');
    const simulationType = simulationTypeParam || localStorageType;
    // Calculate flags from BOTH sources and use OR logic for maximum detection
    const isMementoMoriFromParam = isMementoMoriParam === true;
    const isMementoMoriFromType = simulationType === 'memento-mori';
    const isMementoMori = isMementoMoriFromParam || isMementoMoriFromType;
    const isStorySimulationFromParam = isStorySimulationParam === true;
    const isStorySimulationFromType = simulationType === 'story-simulation';
    const isStorySimulation = isStorySimulationFromParam || isStorySimulationFromType;
    console.log("\uD83D\uDD0D [handleSimulationEnd] ROUTING DECISION:", {
        "\uD83D\uDCE6 Parameters": {
            simulationTypeParam: simulationTypeParam,
            isMementoMoriParam: isMementoMoriParam,
            isStorySimulationParam: isStorySimulationParam
        },
        "\uD83D\uDCBE LocalStorage": {
            localStorageType: localStorageType
        },
        "\u2705 Final Decision": {
            simulationType: simulationType,
            isMementoMori: isMementoMori ? ' YES - Route to mementomori.html' : 'no',
            isStorySimulation: isStorySimulation ? ' YES - Route to storysimend.html' : 'no',
            fallbackTo: !isMementoMori && !isStorySimulation ? "\uD83C\uDFAE Freestyle - Route to freeend.html" : 'N/A'
        }
    });
    if (isMementoMori) {
        console.log("\u26B0\uFE0F Memento Mori timer expired - completing and redirecting to eulogy");
        await $86dc76c45b2250dc$var$handleMementoMoriEnd();
        return; // Exit early - memento mori has its own flow
    }
    if (isStorySimulation) {
        console.log("\uD83D\uDCD6 Story Simulation timer expired - handled by storyPhaseManager.js");
        return; // Exit early - story simulation uses phase-based timer
    }
    console.log("\uD83C\uDFAE Freestyle simulation timer expired - redirecting to results");
    // ✅ Show loading popup FIRST (like memento-mori does)
    $86dc76c45b2250dc$var$showFreestyleLoadingPopup();
    // Freestyle simulation logic
    try {
        const portfolioId = localStorage.getItem('portfolioId');
        const timerId = localStorage.getItem('simulationTimerId');
        const isSimulated = localStorage.getItem('isSimulated') === 'true';
        const token = localStorage.getItem('token');
        if (!portfolioId || !timerId) {
            console.error("\u274C Missing portfolio ID or timer ID for simulation end");
            return;
        }
        // ────── CLOSE SHORT POSITIONS ──────
        console.log("\uD83D\uDCC9 Closing all short positions for simulation end...");
        try {
            const portfolioResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/${portfolioId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const portfolioData = await portfolioResponse.json();
            const shortPositions = portfolioData.shortPositions || [];
            for (const short of shortPositions)try {
                await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/stocks/${short.stockId}/closeShortPosition`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        portfolioId: portfolioId
                    })
                });
            } catch (error) {
                console.error(`\u{26A0}\u{FE0F} Error closing short for stock ${short.stockId}:`, error);
            }
        } catch (error) {
            console.error("\u26A0\uFE0F Error closing short positions:", error);
        }
        // ────── FETCH SIMULATION RESULTS ──────
        let simulationResults = null;
        try {
            const token = localStorage.getItem('token');
            // Try both possible backend mount paths for compatibility
            let response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/sim/simulation/results/${timerId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) {
                console.warn("\u26A0\uFE0F Primary results route failed, retrying alternate path...");
                response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/simulation/results/${timerId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
            }
            if (response.ok) {
                const data = await response.json();
                // Backend returns { summary: {...} } - keep the wrapper structure
                simulationResults = data;
                console.log("\u2705 Successfully fetched simulation results");
            } else {
                console.error("\u274C Failed to fetch simulation results (status:", response.status, ')');
                simulationResults = {
                    summary: $86dc76c45b2250dc$var$createDefaultResults?.() || $86dc76c45b2250dc$var$getDefaultResultsFallback()
                };
            }
        } catch (error) {
            console.error("\uD83D\uDCA5 Error fetching simulation results:", error);
            simulationResults = {
                summary: $86dc76c45b2250dc$var$createDefaultResults?.() || $86dc76c45b2250dc$var$getDefaultResultsFallback()
            };
        }
        // ────── USE CACHED LLM ANALYSIS (PRE-FETCHED 20s BEFORE END) ──────
        let summary = simulationResults?.summary || simulationResults;
        // If the server already cleaned up the portfolio, the fetched summary is
        // all zeros ("Ended With: Nothing"). Prefer the live snapshot cached 20s
        // before the end — it has the real holdings detail.
        const summaryLooksEmpty = (s)=>{
            const fp = s?.finalPortfolio || {};
            return !fp.totalValue && !fp.points && !fp.stocks && !fp.items && !fp.zollars && !fp.bonds;
        };
        if (summaryLooksEmpty(summary) && window.freestyleSummaryCache && !summaryLooksEmpty(window.freestyleSummaryCache)) {
            console.log("\u267B\uFE0F Fetched summary is empty (portfolio already cleaned up) \u2014 using pre-fetched live snapshot");
            summary = window.freestyleSummaryCache;
        }
        let llmAnalysis = window.freestyleLLMAnalysis || null;
        if (llmAnalysis) console.log("\u2705 Using pre-fetched LLM analysis from cache");
        else if (token) {
            console.log("\u26A0\uFE0F No cached LLM analysis, fetching now (fallback)...");
            llmAnalysis = await $86dc76c45b2250dc$var$fetchFreestyleLLMAnalysis(summary, token);
        }
        // ────── REDIRECT TO FREEEND.HTML WITH COMPLETE DATA ──────
        await $86dc76c45b2250dc$var$redirectToFreeendWithResults(summary, portfolioId, timerId, llmAnalysis);
    } catch (error) {
        console.error("\uD83D\uDCA5 Error handling simulation end:", error);
        await $86dc76c45b2250dc$var$redirectToFreeendWithResults($86dc76c45b2250dc$var$getDefaultResultsFallback(), null, null, null);
    }
}
// ────── LOCAL DEFAULT RESULTS FALLBACK ──────
function $86dc76c45b2250dc$var$getDefaultResultsFallback() {
    return {
        performance: 'Complete',
        duration: 10,
        netGain: 0,
        tradesCompleted: 0,
        socialInteractions: 0,
        finalPortfolio: {
            points: 0,
            totalValue: 0,
            stocks: 0,
            items: 0,
            zollars: 0
        }
    };
}
// ────── FETCH LLM ANALYSIS WHILE STILL AUTHENTICATED ──────
async function $86dc76c45b2250dc$var$fetchFreestyleLLMAnalysis(summary, authToken) {
    if (!authToken) {
        console.warn("\u26A0\uFE0F No auth token for LLM analysis");
        return null;
    }
    try {
        console.log("\uD83E\uDD16 Fetching LLM analysis BEFORE redirect (30s timeout)...");
        console.log("\uD83D\uDCCA [LLM Request] Summary data being sent:", {
            netGain: summary?.netGain,
            tradesCompleted: summary?.tradesCompleted,
            socialInteractions: summary?.socialInteractions,
            duration: summary?.duration,
            hasSensitivitySignals: !!summary?.sensitivitySignals,
            sensitivitySignals: summary?.sensitivitySignals
        });
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>{
            console.warn("\u23F1\uFE0F LLM analysis request timed out after 30 seconds");
            controller.abort();
        }, 30000);
        // style 'news': the end screen shows this as THE ZEXCHANGE TIMES item.
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/sim/simulation/analysis`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            // The dilemma choices made on the floor (zfloor.js checkDilemma) — so
            // the news says what they chose, not only what they held.
            body: JSON.stringify({
                summary: {
                    ...summary,
                    dilemmaChoices: $86dc76c45b2250dc$var$readDilemmaChoices()
                },
                style: 'news',
                lang: localStorage.getItem('preferredLanguage') || 'en'
            }),
            credentials: 'include',
            signal: controller.signal
        });
        clearTimeout(timeoutId);
        if (response.ok) {
            const data = await response.json();
            console.log("\u2705 LLM analysis pre-fetched:", data.paragraph?.substring(0, 100) + '...');
            return data.paragraph || null;
        } else {
            console.warn("\u26A0\uFE0F LLM analysis API returned", response.status);
            return null;
        }
    } catch (error) {
        console.warn("\u26A0\uFE0F Error pre-fetching LLM analysis:", error.message);
        return null;
    }
}
// ────── REDIRECT TO FREEEND WITH RESULTS ──────
async function $86dc76c45b2250dc$var$redirectToFreeendWithResults(summary, portfolioId, timerId, llmAnalysis = null) {
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    const simulationType = localStorage.getItem('simulationType');
    const authToken = localStorage.getItem('token');
    // ✅ Guard: only simulations should ever run this redirect
    if (!isSimulated && !simulationType) {
        console.log("\uD83D\uDEE1\uFE0F Normal user detected \u2014 skipping redirectToFreeendWithResults entirely.");
        return;
    }
    console.log("\uD83D\uDD04 Preparing redirect to freeend.html with simulation results");
    const pid = portfolioId || localStorage.getItem('portfolioId') || '';
    const tid = timerId || localStorage.getItem('simulationTimerId') || '';
    try {
        // Build the results payload with pre-fetched LLM analysis
        const resultsData = {
            summary: summary || $86dc76c45b2250dc$var$createDefaultResults?.() || {},
            portfolioId: pid,
            timerId: tid,
            timestamp: Date.now(),
            llmAnalysis: llmAnalysis // ✅ Include pre-generated analysis (passed from caller)
        };
        // Keep a one-time copy of the auth token so the results page can
        // refresh data/LLM without leaking it via the URL backup.
        if (authToken) localStorage.setItem('tempSimulationToken', authToken);
        // Store in session/local for redundancy
        console.log("\uD83D\uDCBE Storing results in sessionStorage & localStorage...");
        try {
            sessionStorage.setItem('simulationResults', JSON.stringify(resultsData));
        } catch  {}
        try {
            localStorage.setItem('tempSimulationResults', JSON.stringify(resultsData));
        } catch  {}
        // The results travel in storage, not in the address. Packing them into the
        // URL made a ~16,000-character address once the end screen gained the
        // verdict, flows and room ranking, and Safari refused to open it ("Safari
        // cannot open the page"). btoa() also throws on any character outside
        // Latin-1, such as the em dashes in the written analysis. freeend.js reads
        // tempSimulationResults first, so the short address loses nothing.
        const endUrl = $86dc76c45b2250dc$var$endPageUrl(resultsData);
        // Mark simulation ending before anything else
        localStorage.setItem('simulationEnding', 'true');
        localStorage.setItem('preventBotRecreation', 'true');
        // Wait to ensure storage writes complete and verify data
        await new Promise((r)=>setTimeout(r, 800));
        // ✅ Verify data was actually stored before redirecting
        const verifyStored = localStorage.getItem('tempSimulationResults');
        if (!verifyStored) {
            console.warn("\u26A0\uFE0F Data verification failed, retrying storage...");
            try {
                localStorage.setItem('tempSimulationResults', JSON.stringify(resultsData));
            } catch  {}
            await new Promise((r)=>setTimeout(r, 400));
        }
        console.log("\u2705 Data storage verified successfully");
        // Fan-out to other tabs if needed
        try {
            if (isSimulated && typeof $86dc76c45b2250dc$var$broadcastLogoutToAllClients === 'function') $86dc76c45b2250dc$var$broadcastLogoutToAllClients({
                ...resultsData,
                portfolioId: pid
            });
            else console.log("\uD83D\uDEE1\uFE0F Skipping broadcast logout for non-sim users.");
        } catch (e) {
            console.warn('broadcastLogoutToAllClients failed:', e);
        }
        // Notify local listeners
        try {
            window.dispatchEvent(new CustomEvent('simulation-ended', {
                detail: {
                    payload: {
                        ...resultsData,
                        portfolioId: pid
                    }
                }
            }));
        } catch  {}
        // ✅ Immediate redirect first — before any logout
        console.log("\uD83C\uDFAF Redirecting immediately to freeend.html");
        window.location.replace(endUrl);
        // ───────────────────────────────
        // ⏳ AFTER REDIRECT: run logout async in background (10s delay to allow LLM response)
        // ───────────────────────────────
        setTimeout(async ()=>{
            try {
                const simulationType = localStorage.getItem('simulationType');
                const isSimulated = localStorage.getItem('isSimulated') === 'true';
                // Skip server logout for freestyle to avoid redirect override
                if (simulationType === 'freestyle' || simulationType === 'free-style') {
                    console.log("\uD83D\uDEE1\uFE0F Freestyle simulation - skipping blocking logout.");
                    return;
                }
                if (isSimulated || simulationType) {
                    console.log("\uD83D\uDEAA Performing async logout after redirect (10s delay)...");
                    const logoutPromise = typeof $86dc76c45b2250dc$var$logout === 'function' ? $86dc76c45b2250dc$var$logout() : Promise.resolve();
                    await Promise.race([
                        logoutPromise,
                        new Promise((r)=>setTimeout(r, 2000))
                    ]);
                }
            } catch (e) {
                console.warn('Async logout failed silently (ignored):', e);
            }
        }, 10000); // ✅ Changed from 2000ms to 10000ms (10 seconds)
    } catch (error) {
        console.error('Error during redirect to freeend:', error);
        // Emergency fallback
        const fallbackData = {
            summary: summary || (typeof $86dc76c45b2250dc$var$createDefaultResults === 'function' ? $86dc76c45b2250dc$var$createDefaultResults() : {}),
            portfolioId: pid,
            timerId: tid,
            timestamp: Date.now()
        };
        try {
            localStorage.setItem('tempSimulationResults', JSON.stringify(fallbackData));
        } catch  {}
        window.location.replace($86dc76c45b2250dc$var$endPageUrl(fallbackData));
    }
}
// The end page's address. Results ride along in the URL only when they are
// small enough for every browser and encodable; otherwise storage carries them.
function $86dc76c45b2250dc$var$endPageUrl(data) {
    try {
        const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
        if (encoded.length <= 1500) return `/freeend.html?data=${encoded}`;
    } catch  {}
    return '/freeend.html';
}
function $86dc76c45b2250dc$var$createDefaultResults() {
    return {
        performance: 'Complete',
        duration: 10,
        netGain: 0,
        tradesCompleted: 0,
        socialInteractions: 0,
        finalPortfolio: {
            points: 0,
            totalValue: 0,
            stocks: 0,
            items: 0,
            zollars: 0,
            bonds: 0
        },
        improvements: []
    };
}
// ────── LOGOUT FUNCTION ──────
async function $86dc76c45b2250dc$var$logout() {
    console.log('[logout()] CALLED', {
        isSimulated: localStorage.getItem('isSimulated'),
        simulationType: localStorage.getItem('simulationType'),
        simulationEnding: localStorage.getItem('simulationEnding')
    });
    console.trace('[logout()] stack');
    const portfolioId = localStorage.getItem('portfolioId');
    const token = localStorage.getItem('token');
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    const isMementoMori = localStorage.getItem('simulationType') === 'memento-mori';
    // 🛡️ Preserve Memento Mori eulogy data before cleanup
    const preservedEulogy = localStorage.getItem('tempMementoMoriResults');
    // ADD THIS BLOCK - Visual feedback immediately
    const logoutButton = document.getElementById('logOut');
    const originalText = logoutButton ? logoutButton.textContent : 'Logout';
    if (logoutButton) {
        logoutButton.textContent = 'Logging out...';
        logoutButton.disabled = true;
        logoutButton.style.opacity = '0.6';
        logoutButton.style.pointerEvents = 'none';
    }
    // Show a processing overlay
    const overlay = document.createElement('div');
    overlay.style.cssText = `
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background: rgba(0, 0, 0, 0.8);
   z-index: 10000;
   display: flex;
   align-items: center;
   justify-content: center;
   color: #00ff00;
   font-family: 'bithigh', Arial, sans-serif;
   font-size: 12px;
   `;
    overlay.textContent = 'Disconnecting...';
    document.body.appendChild(overlay);
    if (!portfolioId || !token) {
        console.error('Portfolio ID or token not found in local storage');
        if (overlay) overlay.remove();
        if (logoutButton) {
            logoutButton.textContent = originalText;
            logoutButton.disabled = false;
            logoutButton.style.opacity = '1';
            logoutButton.style.pointerEvents = 'auto';
        }
        return;
    }
    try {
        // First, disconnect all bot sockets if this is a simulated user
        if (isSimulated && (0, $cJVho.socket) && (0, $cJVho.socket).connected) {
            console.log("\uD83E\uDD16 Disconnecting bots for simulated user logout...");
            (0, $cJVho.socket).emit('disconnectUserBots', {
                portfolioId: portfolioId
            });
            // Wait a moment for bot disconnection to complete
            await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        // Update the active status to false on the server
        const response = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/portfolios/${portfolioId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                active: false
            })
        });
        if (!response.ok) throw new Error('Failed to update active status during logout');
    } catch (error) {
        console.error('Error updating active status during logout:', error);
        (0, $eD3DY.showNotification)('Error updating active status during logout. Please try again.', false);
    }
    try {
        // Call the logout endpoint on the server
        const logoutResponse = await fetch(`${(0, $5W4EI.apiBaseUrl)}/api/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                portfolioId: portfolioId,
                isSimulated: isSimulated
            }),
            credentials: 'include'
        });
        if (!logoutResponse.ok) throw new Error('Failed to logout from server');
        const logoutData = await logoutResponse.json();
        console.log(logoutData.message);
        // Show success message for simulated users
        if (isSimulated) console.log("\uD83C\uDFAF Simulation cleanup completed successfully");
    } catch (error) {
        console.error('Error during server logout:', error);
        (0, $eD3DY.showNotification)('Error during server logout. Please try again.', false);
    }
    const simulationEnding = localStorage.getItem('simulationEnding') === 'true';
    console.log(`\u{1F50D} [Logout] simulationEnding flag captured: ${simulationEnding}`);
    // Disconnect main socket
    if ((0, $cJVho.socket) && (0, $cJVho.socket).connected) {
        console.log("\uD83D\uDD0C Disconnecting main socket...");
        (0, $cJVho.socket).disconnect();
    }
    if (simulationEnding || isSimulated) $86dc76c45b2250dc$export$e42ace8a14893918();
    if (isMementoMori) cleanupMementoMoriTimer?.();
    // Clear local storage and redirect to the login page
    localStorage.removeItem('portfolioId');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('socketId');
    localStorage.removeItem('initialPortfolioState');
    localStorage.removeItem('selectedItems');
    localStorage.removeItem('superUserId');
    localStorage.removeItem('isSimulated');
    localStorage.removeItem('simulatedCompany');
    localStorage.removeItem('firstLogin');
    localStorage.removeItem('activeMementoMori');
    localStorage.removeItem('mementoMoriChecked');
    localStorage.removeItem('mementoMoriStarted');
    // ⚠️ CRITICAL: Only remove simulationType if NOT in simulation ending flow
    // (Otherwise it breaks the redirect detection on the end page)
    if (!simulationEnding) {
        localStorage.removeItem('simulationType');
        console.log("\uD83D\uDDD1\uFE0F Removed simulationType (normal logout)");
    } else console.log("\uD83D\uDCBE Preserved simulationType for simulation end page");
    localStorage.removeItem('mementoMoriObjectiveId');
    localStorage.removeItem('mementoMoriMode');
    localStorage.removeItem('mementoShowAllCompanies');
    localStorage.removeItem('stockBidData');
    localStorage.removeItem('tradeStory');
    localStorage.removeItem('tradeStoryTimestamp');
    localStorage.removeItem('lastConnectedStableKey');
    localStorage.removeItem('simulationEndTime');
    localStorage.removeItem('simulationTimerId');
    localStorage.removeItem('simulationEnding');
    localStorage.removeItem('botTradeOffer');
    localStorage.removeItem('botTradeRecommendation');
    localStorage.removeItem('tradingRecommendation');
    localStorage.removeItem('botTradeTimestamp');
    localStorage.removeItem('psychologyAnalysis');
    localStorage.removeItem('preventBotRecreation');
    localStorage.removeItem('preferredLanguage');
    // 🔄 NEW — wipe any key that starts with "trade_"
    for(let i = localStorage.length - 1; i >= 0; i--){
        const key = localStorage.key(i);
        if (key && key.startsWith('trade_')) localStorage.removeItem(key);
    }
    // ✅ Restore preserved eulogy after cleanup
    if (preservedEulogy) {
        localStorage.setItem('tempMementoMoriResults', preservedEulogy);
        console.log("\uD83D\uDCBE Preserved tempMementoMoriResults through logout");
    }
    // Clear cookies related to the session (if applicable)
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'sessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'portfolioId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    if (!simulationEnding) window.location.href = '/index.html';
    // 🧹 Cleanup overlay & restore button state
    if (overlay) overlay.remove();
    if (logoutButton) {
        logoutButton.textContent = originalText;
        logoutButton.disabled = false;
        logoutButton.style.opacity = '1';
        logoutButton.style.pointerEvents = 'auto';
    }
}
// ────── SOCKET LISTENER FOR SERVER-TRIGGERED END ──────
// This handles the case where the server ends the simulation via checkExpiredSimulations
function $86dc76c45b2250dc$var$setupSimulationSocketListeners() {
    if (!(0, $cJVho.socket)) {
        console.log("\u26A0\uFE0F Socket not available for simulation listeners");
        return;
    }
    // Remove any existing listener to prevent duplicates
    (0, $cJVho.socket).off('simulation:ended');
    (0, $cJVho.socket).on('simulation:ended', async (payload)=>{
        console.log("\uD83D\uDCE1 [Socket] Received simulation:ended from server:", payload);
        const { summary: summary, portfolioId: portfolioId, timerId: timerId } = payload;
        // Only process if this is for our portfolio
        const myPortfolioId = localStorage.getItem('portfolioId');
        if (portfolioId && myPortfolioId && portfolioId !== myPortfolioId) {
            console.log("\u23ED\uFE0F Ignoring simulation:ended for different portfolio");
            return;
        }
        // Check simulation type to route correctly
        const simulationType = localStorage.getItem('simulationType');
        const isMementoMori = simulationType === 'memento-mori';
        const isStorySimulation = simulationType === 'story-simulation';
        if (isMementoMori) {
            console.log("\u26B0\uFE0F Server ended Memento Mori - handled separately");
            return; // Memento Mori has its own end flow
        }
        if (isStorySimulation) {
            console.log("\uD83D\uDCD6 Server ended Story Simulation - handled separately");
            return;
        }
        // Freestyle: use server-provided summary if available
        if (summary && Object.keys(summary).length > 0) {
            console.log("\u2705 Using server-provided summary for redirect");
            // Prefer the pre-fetched live snapshot if the payload summary is empty
            const fp = summary.finalPortfolio || {};
            const payloadEmpty = !fp.totalValue && !fp.points && !fp.stocks && !fp.items && !fp.zollars && !fp.bonds;
            const bestSummary = payloadEmpty && window.freestyleSummaryCache ? window.freestyleSummaryCache : summary;
            await $86dc76c45b2250dc$var$redirectToFreeendWithResults(bestSummary, portfolioId, timerId, window.freestyleLLMAnalysis || null);
        } else {
            console.log("\u26A0\uFE0F No summary in payload, triggering normal end flow");
            $86dc76c45b2250dc$var$handleSimulationEnd('freestyle', false, false);
        }
    });
    (0, $cJVho.socket).on('forceLogout', (payload)=>{
        console.log("\uD83D\uDCE1 [Socket] Received forceLogout:", payload);
        // If we're already on an end page, ignore
        if (window.location.pathname.includes('freeend') || window.location.pathname.includes('mementomoriend') || window.location.pathname.includes('storysimend')) {
            console.log("\u23ED\uFE0F Already on end page, ignoring forceLogout");
            return;
        }
    // Otherwise let normal flow handle it
    });
    console.log("\u2705 Simulation socket listeners registered");
}
// ────── AUTO-INITIALIZE ON PAGE LOAD (SAFE VERSION) ──────
document.addEventListener('DOMContentLoaded', ()=>{
    console.log("\uD83D\uDE80 SimulationTimer module loaded (safe mode)");
    const simulationEndTime = localStorage.getItem('simulationEndTime');
    const simulationTimerId = localStorage.getItem('simulationTimerId');
    const isSimulated = localStorage.getItem('isSimulated') === 'true';
    const simulationType = localStorage.getItem('simulationType');
    // Setup socket listeners for server-triggered simulation end
    // Wait a moment for socket to be ready
    setTimeout(()=>{
        $86dc76c45b2250dc$var$setupSimulationSocketListeners();
    }, 1000);
    // 🛡️ Only proceed for simulations
    if (!isSimulated && !simulationType) {
        console.log("\uD83D\uDED1 Normal user detected \u2014 skipping simulation timer entirely.");
        // Clean up any leftover visual timer from previous sessions
        const strayTimer = document.getElementById('simulationTimer');
        if (strayTimer) {
            console.log("\uD83E\uDDF9 Removing stray timer display for normal user.");
            strayTimer.remove();
        }
        return;
    }
    if (simulationEndTime && simulationTimerId) {
        const endTime = new Date(simulationEndTime);
        if (endTime instanceof Date && !isNaN(endTime)) {
            if (endTime > new Date()) {
                console.log("\uD83D\uDD04 Restoring simulation timer from localStorage");
                $86dc76c45b2250dc$export$cc7efffc33e38fab(simulationEndTime, simulationTimerId);
            } else {
                console.log("\u23F0 Timer expired, cleaning up");
                localStorage.removeItem('simulationEndTime');
                localStorage.removeItem('simulationTimerId');
            }
        } else {
            console.warn("\u26A0\uFE0F Invalid simulationEndTime detected \u2014 cleaning up.");
            localStorage.removeItem('simulationEndTime');
            localStorage.removeItem('simulationTimerId');
        }
    } else console.log("\uD83E\uDDD8 No simulation data yet \u2014 timer module idle.");
});
// ────── TESTING FUNCTIONS ──────
// Add global test functions for debugging
window.testSimulationTimer = function(minutes = 2) {
    console.log(`\u{1F9EA} Starting test timer for ${minutes} minutes`);
    const endTime = new Date(Date.now() + minutes * 60000).toISOString();
    const timerId = 'test-timer-' + Date.now();
    $86dc76c45b2250dc$export$cc7efffc33e38fab(endTime, timerId);
};
window.clearSimulationTimer = function() {
    console.log("\uD83E\uDDF9 Clearing simulation timer");
    $86dc76c45b2250dc$export$e42ace8a14893918();
};
window.checkTimerStatus = function() {
    console.log("\uD83D\uDCCA Timer Status:", {
        simulationEndTime: $86dc76c45b2250dc$var$simulationEndTime,
        timeRemaining: $86dc76c45b2250dc$var$getTimeRemaining(),
        timerExists: !!document.getElementById('simulationTimer'),
        localStorage: {
            endTime: localStorage.getItem('simulationEndTime'),
            timerId: localStorage.getItem('simulationTimerId')
        }
    });
};
let $86dc76c45b2250dc$var$scrollTimeout;
window.addEventListener('scroll', ()=>{
    const timer = document.getElementById('simulationTimer');
    if (timer) {
        if (window.scrollY > 50) timer.classList.add('scrolled');
        else timer.classList.remove('scrolled');
    }
});
// Dilemma choices from the floor, stored per participant by zfloor.js.
function $86dc76c45b2250dc$var$readDilemmaChoices() {
    try {
        const pid = localStorage.getItem('portfolioId');
        return JSON.parse(localStorage.getItem(`zxGoal_${pid}_choices`) || '[]');
    } catch  {
        return [];
    }
}

});

parcelRegister("gwQDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c08876841dbc6bba$export$2e2bcd8739ae039);
// frontend/js/emotionalDebtMeter.js

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
parcelRequire("cNeIB");
if (!globalThis.ZTranslations) globalThis.ZTranslations = (0, $15BR8.default);
if (typeof globalThis.$t !== 'function') globalThis.$t = (key, params)=>{
    return (0, $fUPn2.t)(key);
};
class $c08876841dbc6bba$var$EmotionalDebtMeter {
    constructor(containerId, portfolioId){
        this.container = document.getElementById(containerId);
        this.portfolioId = portfolioId;
        this.data = null;
        this.active = false;
    }
    async init() {
        if (!this.container) return console.warn('[EmotionalDebtMeter] container not found');
        // Initial backend fetch (only once)
        await this.fetchData();
        // Listen for socket updates if available
        if (socket && !this.active) {
            this.active = true;
            this.registerSocketListeners();
        }
    }
    registerSocketListeners() {
        // Emotion or trust index updates from backend
        socket.on('emotionalUpdate', (payload)=>{
            if (!payload || payload.portfolioId !== this.portfolioId) return;
            this.updateFromSocket(payload);
        });
        // Trust index change event (optional if separate)
        socket.on('trustIndexUpdate', (payload)=>{
            if (!payload || payload.portfolioId !== this.portfolioId) return;
            this.updateFromSocket(payload);
        });
    }
    async fetchData() {
        try {
            const res = await fetch(`/api/social-economy/emotional-state/${this.portfolioId}`);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await res.json();
            if (!json.success) throw new Error('Invalid response');
            this.data = json;
            this.render();
        } catch (err) {
            console.error('[EmotionalDebtMeter] fetch error', err);
            this.container.innerHTML = `<div class="emotional-debt-meter loading"><div class="loading-text">loading emotional state...</div></div>`;
        }
    }
    updateFromSocket(payload) {
        this.data = {
            ...this.data,
            emotionalState: payload.emotionalState ?? this.data?.emotionalState,
            trustIndex: payload.trustIndex ?? this.data?.trustIndex,
            lifeProfitCache: payload.lifeProfitCache ?? this.data?.lifeProfitCache,
            recentTransactions: payload.recentTransactions ?? this.data?.recentTransactions
        };
        this.render();
    }
    // Convert intensity (0-1) to qualitative description
    getIntensityQualifier(intensity) {
        if (intensity >= 0.9) return {
            label: 'Overwhelming',
            color: '#ff00ff'
        };
        if (intensity >= 0.75) return {
            label: 'Intense',
            color: '#ff3366'
        };
        if (intensity >= 0.6) return {
            label: 'Strong',
            color: '#ff6699'
        };
        if (intensity >= 0.45) return {
            label: 'Moderate',
            color: '#00ffcc'
        };
        if (intensity >= 0.3) return {
            label: 'Gentle',
            color: '#66ff99'
        };
        if (intensity >= 0.15) return {
            label: 'Faint',
            color: '#99ff99'
        };
        return {
            label: 'Barely Perceptible',
            color: '#ccffcc'
        };
    }
    // Convert trust (0-1) to qualitative description
    getTrustQualifier(trust) {
        if (trust >= 0.9) return {
            label: 'Absolute Faith',
            color: '#00ffff'
        };
        if (trust >= 0.75) return {
            label: 'Deep Trust',
            color: '#00ddff'
        };
        if (trust >= 0.6) return {
            label: 'Solid Confidence',
            color: '#00bbff'
        };
        if (trust >= 0.45) return {
            label: 'Growing Bond',
            color: '#0099ff'
        };
        if (trust >= 0.3) return {
            label: 'Tentative',
            color: '#ffaa00'
        };
        if (trust >= 0.15) return {
            label: 'Fragile',
            color: '#ff8800'
        };
        return {
            label: 'Broken',
            color: '#ff4444'
        };
    }
    // Convert life profit to qualitative description
    getLifeProfitQualifier(profit) {
        if (profit >= 500) return {
            label: 'Radiant Abundance',
            color: '#00ffff'
        };
        if (profit >= 300) return {
            label: 'Flourishing',
            color: '#00ff99'
        };
        if (profit >= 150) return {
            label: 'Thriving',
            color: '#66ff66'
        };
        if (profit >= 50) return {
            label: 'Growing',
            color: '#99ff99'
        };
        if (profit >= 10) return {
            label: 'Emerging',
            color: '#ccff99'
        };
        if (profit >= -10) return {
            label: 'Balanced',
            color: '#ffff99'
        };
        if (profit >= -50) return {
            label: 'Strained',
            color: '#ffcc66'
        };
        if (profit >= -150) return {
            label: 'Burdened',
            color: '#ff9944'
        };
        if (profit >= -300) return {
            label: 'Depleted',
            color: '#ff6633'
        };
        if (profit >= -500) return {
            label: 'Exhausted',
            color: '#ff4422'
        };
        return {
            label: 'Crushing Weight',
            color: '#ff0000'
        };
    }
    render() {
        if (!this.data) {
            const loadingText = (0, $fUPn2.t)('emotional_debt.loading_state', 'loading human capital flux...');
            this.container.innerHTML = `<div class="emotional-debt-meter loading"><div class="loading-text">${loadingText}</div></div>`;
            return;
        }
        const { emotionalState: emotionalState, trustIndex: trustIndex, lifeProfitCache: lifeProfitCache, recentTransactions: recentTransactions } = this.data;
        const emotion = emotionalState?.dominant || 'neutral';
        const intensityRaw = emotionalState?.intensity || 0;
        const trustRaw = trustIndex || 0;
        // Map emotion → color
        const emotionColor = this.getEmotionColor(emotion);
        // Apply CSS variable for unified tone
        this.container.style.setProperty('--emotion-color', emotionColor);
        // Convert to qualitative descriptions
        const intensityQual = this.getIntensityQualifier(intensityRaw);
        const trustQual = this.getTrustQualifier(trustRaw);
        const lifeProfitQual = this.getLifeProfitQualifier(lifeProfitCache);
        const meterTitle = (0, $fUPn2.t)('emotional_debt.meter_title', 'Human Capital Flux Index');
        const meterSubtitle = (0, $fUPn2.t)('emotional_debt.meter_subtitle', 'Relational Topology');
        const trustIndexLabel = (0, $fUPn2.t)('emotional_debt.trust_index_label', 'Relational Trust');
        const lifeProfitLabel = (0, $fUPn2.t)('emotional_debt.life_profit_label', 'Existential Balance');
        const synergyDescription = (0, $fUPn2.t)('emotional_debt.synergy_description', 'moral / emotional / capital synergy');
        const recentEventsTitle = (0, $fUPn2.t)('emotional_debt.recent_events_title', 'Recent Flux Events');
        this.container.innerHTML = `
      <div class="emotional-debt-meter">
        <div class="meter-header">
          <div class="meter-title">${meterTitle}</div>
          <div class="meter-subtitle">${meterSubtitle}</div>
        </div>

        <div class="meter-body">
          <div class="emotion-display">
            <div class="emotion-icon" style="background: radial-gradient(circle, ${emotionColor} 0%, ${emotionColor}88 50%, transparent 100%); border-color: ${emotionColor};"></div>
            <div class="emotion-info">
              <div class="emotion-name">${this.formatEmotion(emotion)}</div>
              <div class="emotion-intensity">
                <div class="intensity-bar">
                  <div class="intensity-fill" style="width:${Math.round(intensityRaw * 100)}%; background: linear-gradient(90deg, ${emotionColor}dd, ${emotionColor}99);"></div>
                </div>
                <div class="intensity-text" style="color: ${intensityQual.color};">${intensityQual.label}</div>
              </div>
            </div>
          </div>

          <div class="metrics-grid">
            <div class="metric-card">
              <div class="metric-label">${trustIndexLabel}</div>
              <div class="metric-value" style="color: ${trustQual.color}; text-shadow: 0 0 6px ${trustQual.color}88;">
                ${trustQual.label}
              </div>
              <div class="metric-bar">
                <div class="metric-fill trust" style="width:${Math.round(trustRaw * 100)}%; background: linear-gradient(90deg, ${trustQual.color}dd, ${trustQual.color}99);"></div>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-label">${lifeProfitLabel}</div>
              <div class="metric-value" style="color: ${lifeProfitQual.color}; text-shadow: 0 0 6px ${lifeProfitQual.color}88;">
                ${lifeProfitQual.label}
              </div>
              <div class="metric-description">${synergyDescription}</div>
            </div>
          </div>

          ${recentTransactions?.length ? `<div class="recent-transactions">
                <div class="transactions-title">${recentEventsTitle}</div>
                <div class="transactions-list">
                  ${recentTransactions.slice(-5).map((tx)=>this.renderTransaction(tx)).join('')}
                </div>
              </div>` : ''}
        </div>
      </div>`;
    }
    renderTransaction(tx) {
        const color = this.getTransactionColor(tx.type);
        const timeAgo = this.timeAgo(new Date(tx.timestamp));
        const partner = tx.from?.name || tx.to?.name || 'unknown';
        const typeKey = `emotional_debt.transaction_types.${tx.type}`;
        const typeLabel = (0, $fUPn2.t)(typeKey, tx.type);
        const withLabel = (0, $fUPn2.t)('emotional_debt.transaction_with', 'with');
        return `
      <div class="transaction-item" style="border-left-color:${color}">
        <div class="tx-text">${typeLabel} ${withLabel} ${partner}</div>
        <div class="tx-time">${timeAgo}</div>
      </div>`;
    }
    formatEmotion(emotion) {
        if (!emotion) return (0, $fUPn2.t)('emotional_debt.emotions.neutral', 'Neutral');
        const emotionKey = `emotional_debt.emotions.${emotion}`;
        const fallback = emotion.charAt(0).toUpperCase() + emotion.slice(1);
        return (0, $fUPn2.t)(emotionKey, fallback);
    }
    getEmotionColor(emotion) {
        const map = {
            hopeful: '#00ff66',
            anxious: '#ff8800',
            despairing: '#555555',
            resentful: '#ff3333',
            grateful: '#66ff99',
            numb: '#999999',
            altruistic: '#33ffee',
            indebted: '#00ffee',
            empowered: '#00bfff',
            rejected: '#cc00ff',
            relieved: '#00ffcc',
            neutral: '#00ff00'
        };
        return map[emotion] || '#00ff00';
    }
    getTransactionColor(type) {
        const colors = {
            help: '#00ff66',
            loan: '#00bfff',
            forgiveness: '#66ff99',
            betrayal: '#ff3333'
        };
        return colors[type] || '#00ff00';
    }
    timeAgo(date) {
        const seconds = Math.floor((Date.now() - date) / 1000);
        if (seconds < 60) return (0, $fUPn2.t)('emotional_debt.time_labels.now', 'now');
        const m = Math.floor(seconds / 60);
        if (m < 60) return (0, $fUPn2.t)('emotional_debt.time_labels.minutes_ago', '{m}m ago').replace('{m}', m);
        const h = Math.floor(m / 60);
        if (h < 24) return (0, $fUPn2.t)('emotional_debt.time_labels.hours_ago', '{h}h ago').replace('{h}', h);
        const d = Math.floor(h / 24);
        return (0, $fUPn2.t)('emotional_debt.time_labels.days_ago', '{d}d ago').replace('{d}', d);
    }
}
var $c08876841dbc6bba$export$2e2bcd8739ae039 // =======================================================
 // USAGE EXAMPLE (anywhere after portfolio load)
 // =======================================================
 // import EmotionalDebtMeter from './emotionalDebtMeter.js';
 // const meter = new EmotionalDebtMeter('emotionalDebtContainer', currentPortfolioId);
 // meter.init();
 = $c08876841dbc6bba$var$EmotionalDebtMeter;

});

parcelRegister("iD9HX", function(module, exports) {

$parcel$export(module.exports, "qualitativeFromFraction_LOCAL", () => $d90366524d26acbf$export$9366fd60be9e5643);
$parcel$export(module.exports, "modalManager", () => $d90366524d26acbf$export$78d35f50a4fd5552);
$parcel$export(module.exports, "handleCDSVictimCollapse", () => $d90366524d26acbf$export$df02e6407caad277);
$parcel$export(module.exports, "handleCDSExploiterGuilt", () => $d90366524d26acbf$export$ce26b1f430b884de);
$parcel$export(module.exports, "handleCDSInitiation", () => $d90366524d26acbf$export$e136fdf6cbbbf403);
// frontend/js/socialEconomyHandlers.js
// Social Economy Integration for Trader Interface

var $cNeIB = parcelRequire("cNeIB");

var $21EbS = parcelRequire("21EbS");

var $fUPn2 = parcelRequire("fUPn2");

var $15BR8 = parcelRequire("15BR8");
if (!globalThis.ZTranslations) globalThis.ZTranslations = (0, $15BR8.default);
if (typeof globalThis.$t !== 'function') globalThis.$t = (key, params)=>{
    return (0, $fUPn2.t)(key);
};
// === Utility Setup ===
const $d90366524d26acbf$var$CACHE_DURATION = 10000; // 10 seconds
const $d90366524d26acbf$var$portfolioCache = new Map();
// === Local, self-contained Z$ slider utilities (no imports needed) ===
async function $d90366524d26acbf$var$fetchPortfolioZollars_LOCAL(apiBaseUrl, portfolioId, token) {
    const res = await fetch(`${apiBaseUrl}/api/trader/${portfolioId}/zollars`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!res.ok) throw new Error(`Failed to fetch zollars ${res.status}`);
    return res.json();
}
// === Shared "Zollars / Capital" holographic switch ===
function $d90366524d26acbf$var$createModeSwitch(start = 'zollars') {
    const wrap = document.createElement('div');
    wrap.style.cssText = 'display:flex;gap:12px;justify-content:center;margin:12px 0 8px;';
    const make = (id, label)=>{
        const b = document.createElement('button');
        b.id = id;
        b.textContent = label;
        b.style.cssText = `
      padding:10px 18px;border-radius:10px;font-family:'bithigh',monospace;
      cursor:pointer;transition:all .2s ease;background:rgba(0,0,0,.4);
      box-shadow:0 0 8px rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.3);
      color:#fcba03;
    `;
        b.dataset.active = '0';
        return b;
    };
    const zol = make('modeZollars', 'Zollars');
    const cap = make('modeCapital', 'Capital');
    const setActive = (btnOn)=>{
        [
            zol,
            cap
        ].forEach((b)=>{
            b.dataset.active = b === btnOn ? '1' : '0';
            if (b === btnOn) {
                b.style.background = 'rgba(252,186,3,.25)';
                b.style.boxShadow = '0 0 12px rgba(252,186,3,.8)';
                b.style.border = '1px solid #fcba03';
                b.style.color = '#fff';
            } else {
                b.style.background = 'rgba(0,0,0,.4)';
                b.style.boxShadow = '0 0 8px rgba(255,255,255,.08)';
                b.style.border = '1px solid rgba(255,255,255,.3)';
                b.style.color = '#fcba03';
            }
        });
    };
    wrap.appendChild(zol);
    wrap.appendChild(cap);
    setActive(start === 'zollars' ? zol : cap);
    return {
        el: wrap,
        zol: zol,
        cap: cap,
        setActive: setActive
    };
}
function $d90366524d26acbf$var$aggregateZollarsByType_LOCAL(zollars) {
    const map = {
        erotic: 'erotic',
        'Erotic': 'erotic',
        fellow: 'fellowship',
        'Fellow': 'fellowship',
        'fellowship': 'fellowship',
        'FellowShip': 'fellowship',
        friend: 'friendship',
        'Friend': 'friendship',
        'friendship': 'friendship',
        'Friendship': 'friendship',
        'FriendShip': 'friendship',
        hate: 'hate',
        'Hate': 'hate',
        love: 'love',
        'Love': 'love',
        superficial: 'superficial',
        'SuperFicial': 'superficial',
        'Superficial': 'superficial',
        superficiality: 'superficial',
        'Superficiality': 'superficial',
        toxic: 'toxic',
        'Toxic': 'toxic',
        death: 'death',
        'Death': 'death',
        'long life': 'long life',
        'Long Life': 'long life',
        'longlife': 'long life'
    };
    const totals = {};
    console.log(`\u{1F4CA} [aggregateZollars] Processing ${(zollars || []).length} zollars`);
    (zollars || []).forEach((z)=>{
        // Use regex to handle case-insensitive "Zollar" removal (matches backend logic)
        let t = String(z.zollar_name || '').replace(/\s*[Zz]ollar\s*$/i, '').trim().toLowerCase();
        // Check map for normalized version
        t = map[t] || t;
        if (!t) return;
        totals[t] = (totals[t] || 0) + 1;
        console.log(`  "${z.zollar_name}" \u{2192} "${t}" (total: ${totals[t]})`);
    });
    console.log(`\u{1F4CA} [aggregateZollars] Final totals:`, totals);
    return totals;
}
function $d90366524d26acbf$export$9366fd60be9e5643(r) {
    if (r <= 0) return 'None';
    if (r <= 0.03) return 'Barely Any';
    if (r <= 0.07) return 'A Trace';
    if (r <= 0.12) return 'A Hint';
    if (r <= 0.18) return 'A Little';
    if (r <= 0.26) return 'A Few';
    if (r <= 0.33) return 'Some';
    if (r <= 0.40) return 'Several';
    if (r <= 0.50) return 'Moderate';
    if (r <= 0.58) return 'Noticeable';
    if (r <= 0.65) return 'Considerable';
    if (r <= 0.72) return 'Many';
    if (r <= 0.78) return 'A Lot';
    if (r <= 0.83) return 'Abundant';
    if (r <= 0.88) return 'Heaps';
    if (r <= 0.92) return 'A Great Deal';
    if (r <= 0.95) return 'Almost All';
    if (r <= 0.97) return 'Nearly Everything';
    if (r <= 0.985) return 'Overflowing';
    if (r <= 0.995) return 'Virtually Everything';
    return 'All You Have';
}
function $d90366524d26acbf$var$colorForFraction_LOCAL(p) {
    const r = Math.max(0, Math.min(1, p));
    if (r <= 0.02) return 'rgba(255, 255, 153, 0.35)';
    if (r <= 0.05) return 'rgba(255, 247, 130, 0.4)';
    if (r <= 0.08) return 'rgba(255, 239, 100, 0.45)';
    if (r <= 0.12) return 'rgba(255, 230, 80, 0.5)';
    if (r <= 0.16) return 'rgba(255, 216, 60, 0.55)';
    if (r <= 0.20) return 'rgba(255, 204, 40, 0.6)';
    if (r <= 0.26) return 'rgba(255, 190, 30, 0.65)';
    if (r <= 0.32) return 'rgba(255, 175, 20, 0.68)';
    if (r <= 0.38) return 'rgba(255, 160, 10, 0.7)';
    if (r <= 0.44) return 'rgba(255, 145, 5, 0.72)';
    if (r <= 0.50) return 'rgba(255, 130, 0, 0.74)';
    if (r <= 0.58) return 'rgba(255, 115, 0, 0.76)';
    if (r <= 0.66) return 'rgba(255, 100, 0, 0.78)';
    if (r <= 0.74) return 'rgba(255, 85, 0, 0.75)';
    if (r <= 0.82) return 'rgba(255, 70, 10, 0.75)';
    if (r <= 0.88) return 'rgba(255, 55, 20, 0.75)';
    if (r <= 0.93) return 'rgba(255, 40, 25, 0.75)';
    if (r <= 0.97) return 'rgba(255, 25, 30, 0.75)';
    if (r <= 0.99) return 'rgba(240, 15, 40, 0.75)';
    return 'rgba(220, 5, 30, 0.88)';
}
/**
 * Create abstract sliders for borrowing (no specific quantities)
 */ function $d90366524d26acbf$var$createAbstractBorrowSliders_LOCAL() {
    const container = document.createElement('div');
    container.style.cssText = 'display:flex;flex-direction:column;gap:20px;padding:12px 0;';
    let zollarValue = 0;
    let capitalValue = 0;
    // Zollar Slider
    const zollarSection = document.createElement('div');
    zollarSection.innerHTML = `
    <label style="display:block;margin-bottom:8px;font-family:'bithigh',monospace;color:#fcba03;font-size:1.1em;">
      Zollars
    </label>
    <input type="range" class="abstract-zollar-slider range-slider" min="0" max="100" value="0" style="width:100%;height:10px;background:rgba(252,186,3,0.2);border-radius:4px;outline:none;cursor:pointer;-webkit-appearance:none;appearance:none;">
    <div style="display:flex;justify-content:space-between;margin-top:4px;font-family:'bithigh',monospace;font-size:0.85em;color:#999;">
      <span>None</span>
      <span class="zollar-magnitude" style="color:#fcba03;">None</span>
      <span>Maximum</span>
    </div>
  `;
    const zollarSlider = zollarSection.querySelector('.abstract-zollar-slider');
    const zollarMagnitude = zollarSection.querySelector('.zollar-magnitude');
    zollarSlider.addEventListener('input', ()=>{
        zollarValue = parseInt(zollarSlider.value) || 0;
        const frac = zollarValue / 100;
        zollarMagnitude.textContent = $d90366524d26acbf$export$9366fd60be9e5643(frac);
        zollarSlider.style.background = `linear-gradient(to right, rgba(252,186,3,0.6) 0%, rgba(252,186,3,0.6) ${zollarValue}%, rgba(252,186,3,0.2) ${zollarValue}%, rgba(252,186,3,0.2) 100%)`;
    });
    // Capital Slider
    const capitalSection = document.createElement('div');
    capitalSection.innerHTML = `
    <label style="display:block;margin-bottom:8px;font-family:'bithigh',monospace;color:#fcba03;font-size:1.1em;">
      Capital
    </label>
    <input type="range" class="abstract-capital-slider range-slider" min="0" max="100" value="0" style="width:100%;height:10px;background:rgba(252,186,3,0.2);border-radius:4px;outline:none;cursor:pointer;-webkit-appearance:none;appearance:none;">
    <div style="display:flex;justify-content:space-between;margin-top:4px;font-family:'bithigh',monospace;font-size:0.85em;color:#999;">
      <span>None</span>
      <span class="capital-magnitude" style="color:#fcba03;">None</span>
      <span>Maximum</span>
    </div>
  `;
    const capitalSlider = capitalSection.querySelector('.abstract-capital-slider');
    const capitalMagnitude = capitalSection.querySelector('.capital-magnitude');
    capitalSlider.addEventListener('input', ()=>{
        capitalValue = parseInt(capitalSlider.value) || 0;
        const frac = capitalValue / 100;
        capitalMagnitude.textContent = $d90366524d26acbf$export$9366fd60be9e5643(frac);
        capitalSlider.style.background = `linear-gradient(to right, rgba(252,186,3,0.6) 0%, rgba(252,186,3,0.6) ${capitalValue}%, rgba(252,186,3,0.2) ${capitalValue}%, rgba(252,186,3,0.2) 100%)`;
    });
    container.appendChild(zollarSection);
    container.appendChild(capitalSection);
    return {
        el: container,
        getZollarMagnitude: ()=>zollarValue,
        getCapitalMagnitude: ()=>capitalValue,
        hasSelection: ()=>zollarValue > 0 || capitalValue > 0
    };
}
function $d90366524d26acbf$var$createLocalZollarSliders_LOCAL(relationshipTotals) {
    const container = document.createElement('div');
    container.style.cssText = 'display:flex;flex-direction:column;gap:14px;padding:6px 0;';
    const bid = {};
    const types = Object.keys(relationshipTotals || {}).filter((k)=>relationshipTotals[k] > 0);
    const cap = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
    types.forEach((type)=>{
        const max = Number(relationshipTotals[type]) || 0;
        bid[type] = 0;
        const row = document.createElement('div');
        row.style.cssText = 'display:flex;flex-direction:column;gap:6px;';
        const head = document.createElement('div');
        head.style.cssText = 'display:flex;justify-content:space-between;align-items:center;';
        head.innerHTML = `
      <span style="font-family:'bithigh',monospace;color:#fcba03;">${cap(type)}</span>
      <span id="desc-${type}" style="font-family:'bithigh',monospace;color:#fcba03;opacity:.9;">None</span>
    `;
        const bar = document.createElement('div');
        bar.style.cssText = `
      position:relative;width:100%;height:40px;background:rgba(0,0,0,.3);
      border:2px solid #fcba03;border-radius:8px;overflow:hidden;cursor:pointer;box-shadow:0 0 10px rgba(252,186,3,.5);
    `;
        const base = document.createElement('div');
        base.style.cssText = 'position:absolute;inset:0;background:#fcba03;opacity:.15;';
        const fill = document.createElement('div');
        fill.id = `fill-${type}`;
        fill.style.cssText = `
      position:absolute;top:0;left:0;height:100%;width:0%;
      background:rgba(252,186,3,.4);box-shadow:0 0 12px rgba(252,186,3,.7);
      transition:width .15s ease, background-color .15s ease;
    `;
        bar.appendChild(base);
        bar.appendChild(fill);
        const hidden = document.createElement('input');
        hidden.type = 'range';
        hidden.min = '0';
        hidden.max = String(max);
        hidden.value = '0';
        hidden.style.display = 'none';
        hidden.id = `slider-${type}`;
        const updateAt = (clientX)=>{
            const rect = bar.getBoundingClientRect();
            const p = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
            const raw = Math.round(p * max);
            hidden.value = String(raw);
            bid[type] = raw;
            const frac = max > 0 ? raw / max : 0;
            fill.style.width = `${frac * 100}%`;
            const c = $d90366524d26acbf$var$colorForFraction_LOCAL(frac);
            fill.style.backgroundColor = c;
            fill.style.boxShadow = `0 0 15px ${c}`;
            const d = document.getElementById(`desc-${type}`);
            if (d) d.textContent = $d90366524d26acbf$export$9366fd60be9e5643(frac);
        };
        let dragging = false;
        bar.addEventListener('mousedown', (e)=>{
            dragging = true;
            updateAt(e.clientX);
        });
        document.addEventListener('mousemove', (e)=>{
            if (dragging) updateAt(e.clientX);
        });
        document.addEventListener('mouseup', ()=>dragging = false);
        bar.addEventListener('click', (e)=>updateAt(e.clientX));
        bar.addEventListener('touchstart', (e)=>{
            dragging = true;
            updateAt(e.touches[0].clientX);
            e.preventDefault();
        });
        document.addEventListener('touchmove', (e)=>{
            if (dragging) updateAt(e.touches[0].clientX);
        });
        document.addEventListener('touchend', ()=>dragging = false);
        row.appendChild(head);
        row.appendChild(bar);
        row.appendChild(hidden);
        container.appendChild(row);
    });
    return {
        el: container,
        getBid: ()=>({
                ...bid
            }),
        total: ()=>Object.values(bid).reduce((a, b)=>a + (b || 0), 0),
        validate: ()=>true // holdings are baked into max; can’t exceed
    };
}
function $d90366524d26acbf$var$renderModeSwitch_LOCAL(defaultMode = 'capital') {
    const wrap = document.createElement('div');
    wrap.style.cssText = 'display:flex;gap:10px;margin:10px 0 6px;';
    const mk = (id, label, active = false)=>{
        const b = document.createElement('button');
        b.id = id;
        b.textContent = label;
        b.className = active ? 'mode-btn active' : 'mode-btn';
        b.style.cssText = `
      flex:1;padding:10px 12px;border:1px solid #fcba03;background:rgba(0,0,0,.35);
      color:#fcba03;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;
      box-shadow:${active ? '0 0 14px rgba(252,186,3,.8) inset' : '0 0 6px rgba(252,186,3,.4) inset'};
    `;
        return b;
    };
    const cap = mk('modeCapital', 'Capital', defaultMode === 'capital');
    const zol = mk('modeZollars', 'Zollars', defaultMode === 'zollars');
    wrap.appendChild(cap);
    wrap.appendChild(zol);
    return wrap;
}
// === Portfolio Preload + Cache System ===
async function $d90366524d26acbf$var$preloadPortfolios() {
    const sessionId = localStorage.getItem('sessionId');
    if (!sessionId) return;
    try {
        const [active, richest] = await Promise.all([
            fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${(0, $21EbS.getAuthToken)()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: sessionId
                })
            }).then((r)=>r.json()),
            fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/richest`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${(0, $21EbS.getAuthToken)()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: sessionId
                })
            }).then((r)=>r.json())
        ]);
        const now = Date.now();
        $d90366524d26acbf$var$portfolioCache.set('active', {
            data: active,
            timestamp: now
        });
        $d90366524d26acbf$var$portfolioCache.set('richest', {
            data: richest,
            timestamp: now
        });
        console.log("\uD83D\uDCE6 Preloaded active and richest portfolios");
    } catch (error) {
        console.error("\u274C Failed to preload portfolios:", error);
    }
}
async function $d90366524d26acbf$var$getCachedPortfolios(sessionId, endpoint = '/api/portfolios/active') {
    const cacheKey = endpoint.includes('richest') ? 'richest' : 'active';
    const cached = $d90366524d26acbf$var$portfolioCache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < $d90366524d26acbf$var$CACHE_DURATION) return cached.data;
    try {
        const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}${endpoint}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${(0, $21EbS.getAuthToken)()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await response.json();
        $d90366524d26acbf$var$portfolioCache.set(cacheKey, {
            data: data,
            timestamp: Date.now()
        });
        return data;
    } catch (error) {
        console.error("\u274C Portfolio fetch failed:", error);
        return {
            portfolios: []
        };
    }
}
// === Emotional Debt Meter Initialization ===
document.addEventListener('DOMContentLoaded', ()=>{
    const portfolioId = localStorage.getItem('portfolioId');
    if (portfolioId && typeof EmotionalDebtMeter !== 'undefined') {
        const emotionalMeter = new EmotionalDebtMeter('emotional-debt-meter', portfolioId);
        emotionalMeter.init();
        console.log("\uD83D\uDC9E Emotional Debt Meter initialized");
        window.emotionalMeter = emotionalMeter;
    }
    $d90366524d26acbf$var$preloadPortfolios(); // Preload early
});
// === Social Economy Modal Manager ===
class $d90366524d26acbf$var$SocialEconomyModal {
    constructor(){
        this.activeModal = null;
    }
    async fetchAllActivePortfolios() {
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        if (!sessionId) {
            console.warn("\u26A0\uFE0F No session found for portfolio fetch");
            return {
                portfolios: [],
                currentPortfolioId: portfolioId,
                hasSession: false
            };
        }
        try {
            const data = await $d90366524d26acbf$var$getCachedPortfolios(sessionId, '/api/portfolios/active');
            const portfolios = data.portfolios || data.data?.portfolios || [];
            return {
                portfolios: portfolios,
                currentPortfolioId: portfolioId,
                hasSession: true
            };
        } catch (error) {
            console.error("\u274C [SocialEconomy] Failed to fetch portfolios:", error);
            return {
                portfolios: [],
                currentPortfolioId: portfolioId,
                hasSession: false
            };
        }
    }
    createModal(title, content, onConfirm, onCancel) {
        this.closeModal();
        const overlay = document.createElement('div');
        overlay.className = 'social-economy-popup-overlay active';
        const modal = document.createElement('div');
        modal.className = 'social-economy-popup-content';
        const titleElement = document.createElement('h2');
        titleElement.textContent = title;
        modal.appendChild(titleElement);
        if (typeof content === 'string') modal.innerHTML += content;
        else modal.appendChild(content);
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'social-economy-popup-buttons';
        const confirmBtn = document.createElement('button');
        confirmBtn.className = 'confirm-btn';
        confirmBtn.textContent = 'Confirm';
        confirmBtn.onclick = ()=>onConfirm?.(modal);
        const cancelBtn = document.createElement('button');
        cancelBtn.className = 'cancel-btn';
        cancelBtn.textContent = 'Cancel';
        cancelBtn.onclick = ()=>{
            this.closeModal();
            onCancel?.();
        };
        buttonContainer.appendChild(confirmBtn);
        buttonContainer.appendChild(cancelBtn);
        modal.appendChild(buttonContainer);
        overlay.appendChild(modal);
        document.body.appendChild(overlay);
        this.activeModal = overlay;
        overlay.addEventListener('click', (e)=>{
            if (e.target === overlay) {
                this.closeModal();
                onCancel?.();
            }
        });
    }
    closeModal() {
        if (this.activeModal) {
            this.activeModal.remove();
            this.activeModal = null;
            // Always restore body scroll when closing modal
            document.body.style.overflow = '';
        }
    }
    showMessage(message, isSuccess = true, autoCloseMs = 5000, keepModalOpen = false) {
        // Close any existing modal first UNLESS keepModalOpen is true
        if (!keepModalOpen) this.closeModal();
        // Create overlay with forced visibility
        const overlay = document.createElement('div');
        overlay.className = 'social-economy-popup-overlay active';
        overlay.dataset.message = message;
        // Force display immediately to prevent CSS timing issues
        overlay.style.display = 'flex';
        overlay.style.position = 'fixed';
        overlay.style.inset = '0';
        overlay.style.zIndex = '10000'; // Higher than modal (9999) so it appears on top
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.85)';
        overlay.style.justifyContent = 'center';
        overlay.style.alignItems = 'center';
        const modal = document.createElement('div');
        modal.className = 'social-economy-popup-content';
        const titleElement = document.createElement('h2');
        titleElement.textContent = isSuccess ? 'Success' : 'Error';
        modal.appendChild(titleElement);
        const content = document.createElement('div');
        content.style.cssText = 'text-align: center; padding: 20px;';
        content.innerHTML = `<p style="font-size: 16px; color: ${isSuccess ? 'rgba(61, 210, 2, 0.9)' : '#ff4444'};">${message}</p>`;
        modal.appendChild(content);
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'social-economy-popup-buttons';
        const closeBtn = document.createElement('button');
        closeBtn.className = 'cancel-btn';
        closeBtn.textContent = 'Close';
        closeBtn.onclick = (e)=>{
            e.stopPropagation();
            e.preventDefault();
            overlay.remove();
        };
        buttonContainer.appendChild(closeBtn);
        modal.appendChild(buttonContainer);
        overlay.appendChild(modal);
        // Ensure DOM is ready and append
        requestAnimationFrame(()=>{
            document.body.appendChild(overlay);
            // Force a reflow to ensure rendering
            overlay.offsetHeight;
        });
        // Auto-close after specified time (default 5000ms = 5 seconds)
        // Pass null or 0 to disable auto-close for important messages
        if (autoCloseMs !== null && autoCloseMs > 0) setTimeout(()=>overlay.remove(), autoCloseMs);
        overlay.addEventListener('click', (e)=>{
            if (e.target === overlay) overlay.remove();
        });
    }
    createPortfolioSelection(portfolios, label) {
        const container = document.createElement('div');
        const labelElement = document.createElement('label');
        labelElement.textContent = label;
        container.appendChild(labelElement);
        const currentId = localStorage.getItem('portfolioId');
        const filtered = portfolios.filter((p)=>p._id !== currentId);
        const select = document.createElement('select');
        select.className = 'portfolio-selector';
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = '-- Select --';
        select.appendChild(defaultOption);
        filtered.forEach((p)=>{
            const option = document.createElement('option');
            option.value = p._id;
            option.dataset.isBot = p.isBot ? 'true' : 'false';
            option.textContent = `${p.name} (${p.wealth || 0})`;
            select.appendChild(option);
        });
        container.appendChild(select);
        return container;
    }
    getSelectedPortfolio(modal) {
        const selector = modal.querySelector('.portfolio-selector');
        if (!selector) return null;
        return selector.tagName === 'SELECT' ? {
            type: 'id',
            value: selector.value
        } : {
            type: 'name',
            value: selector.value.trim()
        };
    }
}
const $d90366524d26acbf$export$78d35f50a4fd5552 = new $d90366524d26acbf$var$SocialEconomyModal();
window.modalManager = $d90366524d26acbf$export$78d35f50a4fd5552;
const $d90366524d26acbf$export$1490a3f595688acf = {};
// === Action Handlers ===
document.addEventListener('DOMContentLoaded', ()=>{
    const token = (0, $21EbS.getAuthToken)();
    // ✅ Helper function for authorized POST
    async function authorizedPost(url, payload) {
        return fetch(`${(0, $cNeIB.apiBaseUrl)}${url}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then((r)=>r.json());
    }
    // === Help Friend (Z$ default, toggle to Capital) ===
    const onHelpFriend = async ()=>{
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        const token = localStorage.getItem('token');
        if (!portfolioId || !sessionId || !token) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.common.error_login_required', 'Please log in first'), false);
        const res = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await res.json();
        const portfolios = Array.isArray(data) ? data : data.portfolios || [];
        const contentDiv = document.createElement('div');
        contentDiv.innerHTML = `<p>${(0, $fUPn2.t)('debt_actions.help_friend.intro', 'Give help. Choose <b>Z$</b> or <b>Capital</b> for the gift.')}</p>`;
        // holographic perceived label
        const badgeRow = document.createElement('div');
        badgeRow.style.cssText = 'display:flex;justify-content:flex-end;margin:6px 0 4px;';
        badgeRow.innerHTML = `<span id="help-perceived" style="
        font-family:'bithigh',monospace;color:#fcba03;border:1px solid #fcba03;
        padding:6px 10px;border-radius:8px;background:rgba(0,0,0,.35);
        box-shadow:0 0 6px rgba(252,186,3,.4) inset;">${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None')}</span>`;
        contentDiv.appendChild(badgeRow);
        const setBadge = (txt)=>contentDiv.querySelector('#help-perceived').textContent = `${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${txt}`;
        // toggle (default zollars)
        const sw = $d90366524d26acbf$var$createModeSwitch('zollars');
        contentDiv.appendChild(sw.el);
        // capital UI
        const capWrap = document.createElement('div');
        capWrap.style.display = 'none';
        capWrap.innerHTML = `
        <label>${(0, $fUPn2.t)('debt_actions.help_friend.capital_label', 'Capital (amount)')}</label>
        <input type="number" class="help-capital" min="1" value="50" placeholder="${(0, $fUPn2.t)('debt_actions.help_friend.capital_placeholder', 'Enter capital')}">`;
        contentDiv.appendChild(capWrap);
        // zollars UI
        const zWrap = document.createElement('div');
        zWrap.id = 'help-zollars-ui';
        zWrap.innerHTML = `<p style="margin:8px 0 0;">${(0, $fUPn2.t)('debt_actions.help_friend.select_zollars', 'Select Z$ categories to gift.')}</p>`;
        contentDiv.appendChild(zWrap);
        // recipient
        const sel = $d90366524d26acbf$export$78d35f50a4fd5552.createPortfolioSelection(portfolios, (0, $fUPn2.t)('debt_actions.help_friend.recipient_label', 'Recipient:'));
        contentDiv.appendChild(sel);
        // helpers
        const clamp01 = (v)=>Math.max(0, Math.min(1, v));
        const perceivedLabelFrom01 = (v)=>$d90366524d26acbf$export$9366fd60be9e5643(clamp01(v));
        const affordabilityProxy01 = (amount, wealthNow = Number(localStorage.getItem('tradingPoints') || 0), near = 0)=>{
            const z = Number(wealthNow) || 0, need = Number(near) || 0;
            const buffer = Math.max(1, z - need);
            return clamp01(Math.log1p(Number(amount) || 0) / Math.log1p(buffer + (Number(amount) || 0)));
        };
        // mount Z$ sliders immediately (default)
        try {
            const zData = await $d90366524d26acbf$var$fetchPortfolioZollars_LOCAL((0, $cNeIB.apiBaseUrl), portfolioId, token);
            const totals = $d90366524d26acbf$var$aggregateZollarsByType_LOCAL(zData);
            zWrap._ZTOTAL = Object.values(totals).reduce((a, b)=>a + (b || 0), 0);
            const comp = $d90366524d26acbf$var$createLocalZollarSliders_LOCAL(totals);
            const slot = document.createElement('div');
            slot.style.marginTop = '8px';
            slot.appendChild(comp.el);
            zWrap.appendChild(slot);
            zWrap._ZCOMP = comp;
            const recomputeZ = ()=>{
                const frac = zWrap._ZTOTAL > 0 ? comp.total() / zWrap._ZTOTAL : 0;
                setBadge(perceivedLabelFrom01(frac));
            };
            slot.addEventListener('mouseup', recomputeZ);
            slot.addEventListener('touchend', recomputeZ, {
                passive: true
            });
            slot.addEventListener('click', recomputeZ);
            setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint')); // gentle default
        } catch (e) {
            console.error('Z$ load failed:', e);
            zWrap.innerHTML = `<p style="color:#ff3333;">${(0, $fUPn2.t)('debt_actions.help_friend.no_zollars', 'No Z$ available.')}</p>`;
            setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None'));
        }
        const toCapital = ()=>{
            sw.setActive(sw.cap);
            zWrap.style.display = 'none';
            capWrap.style.display = '';
            const amt = parseFloat(contentDiv.querySelector('.help-capital')?.value) || 0;
            setBadge(perceivedLabelFrom01(affordabilityProxy01(amt)));
        };
        const toZollars = ()=>{
            sw.setActive(sw.zol);
            capWrap.style.display = 'none';
            zWrap.style.display = '';
            const total = zWrap._ZCOMP ? zWrap._ZCOMP.total() : 0;
            const frac = zWrap._ZTOTAL > 0 ? total / zWrap._ZTOTAL : 0;
            setBadge(perceivedLabelFrom01(frac));
        };
        sw.cap.onclick = toCapital;
        sw.zol.onclick = toZollars;
        // live update for capital
        contentDiv.addEventListener('input', (e)=>{
            if (e.target && e.target.classList.contains('help-capital')) {
                const amt = parseFloat(e.target.value) || 0;
                setBadge(perceivedLabelFrom01(affordabilityProxy01(amt)));
            }
        });
        $d90366524d26acbf$export$78d35f50a4fd5552.createModal((0, $fUPn2.t)('debt_actions.help_friend.modal_title', 'Altrau Z Bill (Altruistic Gift)'), contentDiv, async (modal)=>{
            const recipient = $d90366524d26acbf$export$78d35f50a4fd5552.getSelectedPortfolio(modal);
            if (!recipient || !recipient.value) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_no_recipient', 'Select a recipient.'), false, 3000, true);
            let payload;
            if (capWrap.style.display === '') {
                const points = parseFloat(contentDiv.querySelector('.help-capital').value) || 0;
                if (points <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_invalid_capital', 'Enter a valid capital amount.'), false, 3000, true);
                payload = {
                    helperId: portfolioId,
                    targetId: recipient.value,
                    amount: points,
                    package: {
                        points: points,
                        zollars: 0,
                        stocks: 0
                    },
                    sessionId: sessionId,
                    type: 'help'
                };
            } else {
                if (!zWrap._ZCOMP) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_no_zollars_to_give', 'No Z$ to give.'), false, 3000, true);
                const zBid = zWrap._ZCOMP.getBid(), totalZ = zWrap._ZCOMP.total();
                if (totalZ <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_select_zollars', 'Select some Z$ to give.'), false, 3000, true);
                // Validate each zollar type against available holdings
                const availableTotals = $d90366524d26acbf$var$aggregateZollarsByType_LOCAL(await $d90366524d26acbf$var$fetchPortfolioZollars_LOCAL((0, $cNeIB.apiBaseUrl), portfolioId, token));
                for (const [type, count] of Object.entries(zBid)){
                    if (count > (availableTotals[type] || 0)) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.error_insufficient_zollars', 'Insufficient {type} zollars. You have {available}, trying to send {count}.').replace('{type}', type).replace('{available}', availableTotals[type] || 0).replace('{count}', count), false, 3000, true);
                }
                payload = {
                    helperId: portfolioId,
                    targetId: recipient.value,
                    amount: totalZ,
                    package: {
                        points: 0,
                        zollars: zBid,
                        stocks: 0
                    },
                    sessionId: sessionId,
                    type: 'help'
                };
            }
            $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
            await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/help`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.help_friend.success', 'Altrau Z Bill given. Your ledgers are now bound.'), true);
            if (window.emotionalMeter) window.emotionalMeter.fetchData();
        });
    };
    $d90366524d26acbf$export$1490a3f595688acf.helpFriendButton = onHelpFriend;
    document.getElementById('helpFriendButton')?.addEventListener('click', onHelpFriend);
    // === Predatory Lend (CDS) — Z$ default, toggle to Capital, calls /cds ===
    const onPredatoryLend = async ()=>{
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        const token = localStorage.getItem('token');
        if (!portfolioId || !sessionId || !token) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.common.error_login_required', 'Please log in first'), false);
        const res = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await res.json();
        const portfolios = Array.isArray(data) ? data : data.portfolios || [];
        const contentDiv = document.createElement('div');
        contentDiv.innerHTML = `
        <p>${(0, $fUPn2.t)('debt_actions.predatory_lend.intro', 'Z-Payday CDO: Offer a compounding loan that reloads every 60 seconds.')}</p>
        <p style="color:#ff4d4d;font-size:.9em;">${(0, $fUPn2.t)('debt_actions.predatory_lend.warning', 'WARNING: Each cycle increases the debt by 15% until repayment or bankruptcy.')}</p>
        <p style="color:#fcba03;font-size:.85em;font-style:italic;">${(0, $fUPn2.t)('debt_actions.predatory_lend.exploitation_note', '(Exploitation disguised as empathic connection.)')}</p>
      `;
        // Add "Target Victim" vs "List on Market" choice
        const targetChoice = document.createElement('div');
        targetChoice.style.cssText = 'margin:12px 0;display:flex;gap:10px;';
        targetChoice.innerHTML = `
        <button class="mode-btn active" id="targetVictimBtn" style="flex:1;padding:10px;background:rgba(255,77,77,.25);border:1px solid #ff4d4d;color:#fff;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;">Target Specific Victim</button>
        <button class="mode-btn" id="listCDOOnMarketBtn" style="flex:1;padding:10px;background:rgba(0,0,0,.35);border:1px solid rgba(255,255,255,.3);color:#ff4d4d;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;">List on Market</button>
      `;
        contentDiv.appendChild(targetChoice);
        // perceived label (red-themed)
        const badgeRow = document.createElement('div');
        badgeRow.style.cssText = 'display:flex;justify-content:flex-end;margin:6px 0 4px;';
        badgeRow.innerHTML = `<span id="cds-perceived" style="
        font-family:'bithigh',monospace;color:#ff4d4d;border:1px solid #ff4d4d;
        padding:6px 10px;border-radius:8px;background:rgba(0,0,0,.35);
        box-shadow:0 0 6px rgba(255,77,77,.4) inset;">${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint')}</span>`;
        contentDiv.appendChild(badgeRow);
        const setBadge = (txt)=>contentDiv.querySelector('#cds-perceived').textContent = `${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${txt}`;
        // toggle (default zollars)
        const sw = $d90366524d26acbf$var$createModeSwitch('zollars');
        contentDiv.appendChild(sw.el);
        // capital UI
        const capWrap = document.createElement('div');
        capWrap.style.display = 'none';
        capWrap.innerHTML = `
        <label>${(0, $fUPn2.t)('debt_actions.predatory_lend.capital_label', 'Capital (amount to "lend")')}</label>
        <input type="number" class="cds-capital" min="10" value="100" placeholder="${(0, $fUPn2.t)('debt_actions.predatory_lend.capital_placeholder', 'Amount')}">`;
        contentDiv.appendChild(capWrap);
        // zollars UI
        const zWrap = document.createElement('div');
        zWrap.id = 'cds-zollars-ui';
        zWrap.innerHTML = `<p style="margin:8px 0 0;">${(0, $fUPn2.t)('debt_actions.predatory_lend.select_zollars', 'Select Z$ bait for collapse.')}</p>`;
        contentDiv.appendChild(zWrap);
        // Victim selection (only shown when targeting specific victim)
        const victimSelectContainer = document.createElement('div');
        victimSelectContainer.id = 'victimSelectContainer';
        const victimSelect = $d90366524d26acbf$export$78d35f50a4fd5552.createPortfolioSelection(portfolios, (0, $fUPn2.t)('debt_actions.predatory_lend.victim_label', 'Target Victim:'));
        victimSelectContainer.appendChild(victimSelect);
        contentDiv.appendChild(victimSelectContainer);
        // Toggle between target victim and list on market
        let isMarketListing = false;
        const targetVictimBtn = targetChoice.querySelector('#targetVictimBtn');
        const listCDOOnMarketBtn = targetChoice.querySelector('#listCDOOnMarketBtn');
        const showVictimSelect = ()=>{
            isMarketListing = false;
            victimSelectContainer.style.display = '';
            targetVictimBtn.style.background = 'rgba(255,77,77,.25)';
            targetVictimBtn.style.color = '#fff';
            listCDOOnMarketBtn.style.background = 'rgba(0,0,0,.35)';
            listCDOOnMarketBtn.style.color = '#ff4d4d';
        };
        const showMarketListing = ()=>{
            isMarketListing = true;
            victimSelectContainer.style.display = 'none';
            listCDOOnMarketBtn.style.background = 'rgba(255,77,77,.25)';
            listCDOOnMarketBtn.style.color = '#fff';
            targetVictimBtn.style.background = 'rgba(0,0,0,.35)';
            targetVictimBtn.style.color = '#ff4d4d';
        };
        targetVictimBtn.onclick = showVictimSelect;
        listCDOOnMarketBtn.onclick = showMarketListing;
        // helpers
        const clamp01 = (v)=>Math.max(0, Math.min(1, v));
        const perceivedLabelFrom01 = (v)=>$d90366524d26acbf$export$9366fd60be9e5643(clamp01(v));
        const affordabilityProxy01 = (amount, wealthNow = Number(localStorage.getItem('tradingPoints') || 0), near = 0)=>{
            const z = Number(wealthNow) || 0, need = Number(near) || 0;
            const buffer = Math.max(1, z - need);
            return clamp01(Math.log1p(Number(amount) || 0) / Math.log1p(buffer + (Number(amount) || 0)));
        };
        // mount zollar sliders immediately (default)
        try {
            const zData = await $d90366524d26acbf$var$fetchPortfolioZollars_LOCAL((0, $cNeIB.apiBaseUrl), portfolioId, token);
            const totals = $d90366524d26acbf$var$aggregateZollarsByType_LOCAL(zData);
            zWrap._ZTOTAL = Object.values(totals).reduce((a, b)=>a + (b || 0), 0);
            const comp = $d90366524d26acbf$var$createLocalZollarSliders_LOCAL(totals);
            const slot = document.createElement('div');
            slot.style.marginTop = '8px';
            slot.appendChild(comp.el);
            zWrap.appendChild(slot);
            zWrap._ZCOMP = comp;
            const recomputeZ = ()=>{
                const frac = zWrap._ZTOTAL > 0 ? comp.total() / zWrap._ZTOTAL : 0;
                setBadge(perceivedLabelFrom01(Math.min(1, frac * 1.15))); // CDS bias
            };
            slot.addEventListener('mouseup', recomputeZ);
            slot.addEventListener('touchend', recomputeZ, {
                passive: true
            });
            slot.addEventListener('click', recomputeZ);
            setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint'));
        } catch (e) {
            console.error('Z$ load failed:', e);
            zWrap.innerHTML = `<p style="color:#ff3333;">${(0, $fUPn2.t)('debt_actions.predatory_lend.no_zollars', 'No Z$ available.')}</p>`;
            setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None'));
        }
        const toCapital = ()=>{
            sw.setActive(sw.cap);
            zWrap.style.display = 'none';
            capWrap.style.display = '';
            const amt = parseFloat(contentDiv.querySelector('.cds-capital')?.value) || 0;
            const v = Math.min(1, affordabilityProxy01(amt) * 1.15); // CDS perceived inflation
            setBadge(perceivedLabelFrom01(v));
        };
        const toZollars = ()=>{
            sw.setActive(sw.zol);
            capWrap.style.display = 'none';
            zWrap.style.display = '';
            const total = zWrap._ZCOMP ? zWrap._ZCOMP.total() : 0;
            const frac = zWrap._ZTOTAL > 0 ? total / zWrap._ZTOTAL : 0;
            setBadge(perceivedLabelFrom01(Math.min(1, frac * 1.15)));
        };
        sw.cap.onclick = toCapital;
        sw.zol.onclick = toZollars;
        // live update for capital
        contentDiv.addEventListener('input', (e)=>{
            if (e.target && e.target.classList.contains('cds-capital')) {
                const amt = parseFloat(e.target.value) || 0;
                setBadge(perceivedLabelFrom01(Math.min(1, affordabilityProxy01(amt) * 1.15)));
            }
        });
        $d90366524d26acbf$export$78d35f50a4fd5552.createModal((0, $fUPn2.t)('debt_actions.predatory_lend.modal_title', 'Z-Payday CDO (Predatory Loan)'), contentDiv, async (modal)=>{
            if (!isMarketListing) {
                // Target specific victim
                const victim = $d90366524d26acbf$export$78d35f50a4fd5552.getSelectedPortfolio(modal);
                if (!victim || !victim.value) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_no_victim', 'Select a victim.'), false, 3000, true);
                let payload;
                if (capWrap.style.display === '') {
                    const amount = parseFloat(contentDiv.querySelector('.cds-capital').value) || 0;
                    if (!amount || amount <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_invalid_amount', 'Enter a valid amount.'), false, 3000, true);
                    payload = {
                        exploiterId: portfolioId,
                        victimId: victim.value,
                        amount: amount,
                        sessionId: sessionId,
                        package: {
                            points: amount,
                            zollars: 0,
                            stocks: 0
                        }
                    };
                } else {
                    if (!zWrap._ZCOMP) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_no_zollars_selected', 'No Z$ selected.'), false, 3000, true);
                    const zBid = zWrap._ZCOMP.getBid(), totalZ = zWrap._ZCOMP.total();
                    if (totalZ <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_select_zollars', 'Select some Z$.'), false, 3000, true);
                    payload = {
                        exploiterId: portfolioId,
                        victimId: victim.value,
                        amount: totalZ,
                        sessionId: sessionId,
                        package: {
                            points: 0,
                            zollars: zBid,
                            stocks: 0
                        }
                    };
                }
                $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
                await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/cds`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.success_targeted', 'Z-Payday CDO offer sent to victim. Reloads every 60 seconds once accepted.'), true);
            } else {
                // List on market
                let payload;
                if (capWrap.style.display === '') {
                    const amount = parseFloat(contentDiv.querySelector('.cds-capital').value) || 0;
                    if (!amount || amount <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_invalid_amount', 'Enter a valid amount.'), false, 3000, true);
                    payload = {
                        exploiterId: portfolioId,
                        amount: amount,
                        sessionId: sessionId,
                        package: {
                            points: amount,
                            zollars: 0,
                            stocks: 0
                        },
                        principalType: 'capital'
                    };
                } else {
                    if (!zWrap._ZCOMP) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_no_zollars_selected', 'No Z$ selected.'), false, 3000, true);
                    const zBid = zWrap._ZCOMP.getBid(), totalZ = zWrap._ZCOMP.total();
                    if (totalZ <= 0) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.error_select_zollars', 'Select some Z$.'), false, 3000, true);
                    payload = {
                        exploiterId: portfolioId,
                        amount: totalZ,
                        sessionId: sessionId,
                        package: {
                            points: 0,
                            zollars: zBid,
                            stocks: 0
                        },
                        principalType: 'zollars',
                        zollarBreakdown: zBid
                    };
                }
                $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
                await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/market/list-cdo`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.predatory_lend.success_market', 'Z-Payday CDO listed on market. Disguised as attractive offer.'), true);
            }
            if (window.emotionalMeter) window.emotionalMeter.fetchData();
        });
    };
    $d90366524d26acbf$export$1490a3f595688acf.predatoryLendButton = onPredatoryLend;
    document.getElementById('predatoryLendButton')?.addEventListener('click', onPredatoryLend);
    // === Borrow (Z$ default, toggle to Capital) - Borrower initiates M Note ===
    const onBorrowCapital = async ()=>{
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        const token = localStorage.getItem('token');
        if (!portfolioId || !sessionId || !token) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.common.error_login_required', 'Please log in first'), false);
        const res = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await res.json();
        const portfolios = Array.isArray(data) ? data : data.portfolios || [];
        const humanInterestMap = {
            Amazing: 0.08,
            Great: 0.12,
            Good: 0.16,
            Neutral: 0.26,
            Bad: 0.35,
            Horrible: 0.45,
            Catastrophic: 0.60
        };
        const contentDiv = document.createElement('div');
        contentDiv.innerHTML = `<p style="font-family:'bithigh',monospace;color:#fcba03;"><strong>${(0, $fUPn2.t)('debt_actions.borrow.intro', 'Request a loan (M Note).')}</strong> ${(0, $fUPn2.t)('debt_actions.borrow.vulnerability_required', 'Disclose your emotional debt. Vulnerability.')}</p>`;
        // M Note: Vulnerability disclosure (required) - FIRST
        const vulnDiv = document.createElement('div');
        vulnDiv.style.cssText = 'margin-top:12px;';
        vulnDiv.innerHTML = `
        <label style="display:block;margin-bottom:4px;font-family:'bithigh',monospace;color:#fcba03;font-size:1.05em;font-weight:bold;">
          ${(0, $fUPn2.t)('debt_actions.borrow.vulnerability_label', 'Why do you need this loan? (Emotional debt disclosure - min 20 chars)')}
        </label>
        <textarea class="vuln-reason" rows="3" placeholder="${(0, $fUPn2.t)('debt_actions.borrow.vulnerability_placeholder', 'Disclose your emotional debt / vulnerability here...')}" style="
          width:100%;padding:8px;font-family:'bithigh',monospace;background:rgba(0,0,0,.3);
          border:1px solid #fcba03;border-radius:6px;color:#fcba03;resize:vertical;
        "></textarea>
        <div style="display:flex;justify-content:space-between;margin-top:4px;">
          <span class="vuln-char-count" style="font-family:'bithigh',monospace;font-size:0.85em;color:#999;">${(0, $fUPn2.t)('debt_actions.borrow.char_count', '0 / 20 chars')}</span>
          <span class="vuln-severity-label" style="font-family:'bithigh',monospace;font-size:0.85em;color:#fcba03;">${(0, $fUPn2.t)('debt_actions.borrow.severity_label', 'Severity')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint')}</span>
        </div>
        <label style="display:block;margin-top:6px;font-family:'bithigh',monospace;font-size:0.9em;color:#fcba03;">
          ${(0, $fUPn2.t)('debt_actions.borrow.severity_question', 'How severe is your need?')}
        </label>
        <input type="range" class="vuln-severity" min="0" max="100" value="35" style="width:100%;margin-top:4px;">
      `;
        contentDiv.appendChild(vulnDiv);
        const badgeRow = document.createElement('div');
        badgeRow.style.cssText = 'display:flex;justify-content:flex-end;margin:16px 0 4px;';
        badgeRow.innerHTML = `<span id="lend-perceived" style="
        font-family:'bithigh',monospace;color:#fcba03;border:1px solid #fcba03;
        padding:6px 10px;border-radius:8px;background:rgba(0,0,0,.35);
        box-shadow:0 0 6px rgba(252,186,3,.4) inset;">${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None')}</span>`;
        contentDiv.appendChild(badgeRow);
        const setBadge = (txt)=>contentDiv.querySelector('#lend-perceived').textContent = `${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${txt}`;
        // Abstract sliders section
        const sliderWrap = document.createElement('div');
        sliderWrap.id = 'abstract-loan-sliders';
        sliderWrap.innerHTML = `<p style="margin:12px 0 4px;font-family:'bithigh',monospace;color:#999;font-size:0.9em;">${(0, $fUPn2.t)('debt_actions.borrow.move_sliders', 'Move sliders to express your need:')}</p>`;
        contentDiv.appendChild(sliderWrap);
        // Add "Target Lender" vs "List on Market" choice
        const targetChoice = document.createElement('div');
        targetChoice.style.cssText = 'margin:12px 0;display:flex;gap:10px;';
        targetChoice.innerHTML = `
        <button class="mode-btn active" id="targetLenderBtn" style="flex:1;padding:10px;background:rgba(252,186,3,.25);border:1px solid #fcba03;color:#fff;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;">Target Specific Lender</button>
        <button class="mode-btn" id="listOnMarketBtn" style="flex:1;padding:10px;background:rgba(0,0,0,.35);border:1px solid rgba(255,255,255,.3);color:#fcba03;font-family:'bithigh',monospace;cursor:pointer;border-radius:8px;">List on Market</button>
      `;
        contentDiv.appendChild(targetChoice);
        // Lender selection (only shown when targeting specific lender)
        const lenderSelectContainer = document.createElement('div');
        lenderSelectContainer.id = 'lenderSelectContainer';
        const lenderSelect = $d90366524d26acbf$export$78d35f50a4fd5552.createPortfolioSelection(portfolios, (0, $fUPn2.t)('debt_actions.borrow.lender_label', 'Choose Lender:'));
        lenderSelectContainer.appendChild(lenderSelect);
        contentDiv.appendChild(lenderSelectContainer);
        // Toggle between target lender and list on market
        let isMarketListing = false;
        const targetLenderBtn = targetChoice.querySelector('#targetLenderBtn');
        const listOnMarketBtn = targetChoice.querySelector('#listOnMarketBtn');
        const showLenderSelect = ()=>{
            isMarketListing = false;
            lenderSelectContainer.style.display = '';
            targetLenderBtn.style.background = 'rgba(252,186,3,.25)';
            targetLenderBtn.style.color = '#fff';
            listOnMarketBtn.style.background = 'rgba(0,0,0,.35)';
            listOnMarketBtn.style.color = '#fcba03';
        };
        const showMarketListing = ()=>{
            isMarketListing = true;
            lenderSelectContainer.style.display = 'none';
            listOnMarketBtn.style.background = 'rgba(252,186,3,.25)';
            listOnMarketBtn.style.color = '#fff';
            targetLenderBtn.style.background = 'rgba(0,0,0,.35)';
            targetLenderBtn.style.color = '#fcba03';
        };
        targetLenderBtn.onclick = showLenderSelect;
        listOnMarketBtn.onclick = showMarketListing;
        // Update char count and severity label
        const vulnTextarea = vulnDiv.querySelector('.vuln-reason');
        const charCount = vulnDiv.querySelector('.vuln-char-count');
        const severitySlider = vulnDiv.querySelector('.vuln-severity');
        const severityLabel = vulnDiv.querySelector('.vuln-severity-label');
        vulnTextarea.addEventListener('input', ()=>{
            const len = vulnTextarea.value.length;
            charCount.textContent = `${len} ${(0, $fUPn2.t)('debt_actions.borrow.char_suffix', '/ 20 chars')}`;
            charCount.style.color = len >= 20 ? '#3dd202' : '#ff3333';
        });
        severitySlider.addEventListener('input', ()=>{
            const severity01 = Number(severitySlider.value) / 100;
            severityLabel.textContent = `${(0, $fUPn2.t)('debt_actions.borrow.severity_label', 'Severity')}: ${perceivedLabelFrom01(severity01)}`;
        });
        const clamp01 = (v)=>Math.max(0, Math.min(1, v));
        const perceivedLabelFrom01 = (v)=>$d90366524d26acbf$export$9366fd60be9e5643(clamp01(v));
        const affordabilityProxy01 = (amount, wealthNow = Number(localStorage.getItem('tradingPoints') || 0), near = 0)=>{
            const z = Number(wealthNow) || 0, need = Number(near) || 0;
            const buffer = Math.max(1, z - need);
            return clamp01(Math.log1p(Number(amount) || 0) / Math.log1p(buffer + (Number(amount) || 0)));
        };
        // Mount abstract sliders
        const sliderComp = $d90366524d26acbf$var$createAbstractBorrowSliders_LOCAL();
        sliderWrap.appendChild(sliderComp.el);
        // Update badge when sliders change
        const updateBadge = ()=>{
            const zMag = sliderComp.getZollarMagnitude();
            const cMag = sliderComp.getCapitalMagnitude();
            const maxMag = Math.max(zMag, cMag);
            const frac = maxMag / 100;
            setBadge(perceivedLabelFrom01(frac));
        };
        sliderWrap.addEventListener('input', updateBadge);
        setBadge((0, $fUPn2.t)('debt_actions.common.magnitude_none', 'None'));
        $d90366524d26acbf$export$78d35f50a4fd5552.createModal((0, $fUPn2.t)('debt_actions.borrow.modal_title', 'M Note (Request Loan)'), contentDiv, async (modal)=>{
            // Validate vulnerability disclosure
            const vulnerabilityReason = vulnTextarea.value.trim();
            if (vulnerabilityReason.length < 20) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.error_vulnerability_required', 'M Note requires vulnerability disclosure (min 20 characters).'), false, 3000, true);
            const vulnerabilityScore = Number(severitySlider.value) / 100;
            // Get abstract slider values
            const zollarMag = sliderComp.getZollarMagnitude();
            const capitalMag = sliderComp.getCapitalMagnitude();
            if (!sliderComp.hasSelection()) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.error_move_slider', 'Please move at least one slider to express your need.'), false, 3000, true);
            // Determine principal type and calculate actual amounts
            let principalType, packageData, totalAmount;
            if (zollarMag > capitalMag) {
                // Zollar-based loan
                principalType = 'zollars';
                const zollarCount = Math.max(1, Math.floor(zollarMag / 10)); // 0-100 → 1-10 zollars
                // Create a generic zollar breakdown (will use borrower's actual zollars)
                // Backend will handle the actual transfer from borrower's holdings
                packageData = {
                    points: 0,
                    zollars: {
                        _abstract: true,
                        _count: zollarCount,
                        _magnitude: zollarMag
                    },
                    stocks: 0
                };
                totalAmount = zollarCount * 50; // Estimate value
            } else {
                // Capital-based loan
                principalType = 'capital';
                const capitalAmount = Math.max(1, Math.floor(capitalMag * 10)); // 0-100 → 1-1000 capital
                packageData = {
                    points: capitalAmount,
                    zollars: 0,
                    stocks: 0
                };
                totalAmount = capitalAmount;
            }
            // Emotional interest scales with perceived need
            const needIntensity = Math.max(zollarMag, capitalMag) / 100;
            const baseRate = 0.16 + needIntensity * 0.24; // 16% to 40% based on need
            // Check if targeting lender or listing on market
            if (!isMarketListing) {
                // Target specific lender
                const lender = $d90366524d26acbf$export$78d35f50a4fd5552.getSelectedPortfolio(modal);
                if (!lender || !lender.value) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.error_no_lender', 'Please select a lender.'), false, 3000, true);
                const payload = {
                    borrowerId: portfolioId,
                    lenderId: lender.value,
                    amount: totalAmount,
                    principalType: principalType,
                    humanInterest: baseRate,
                    package: packageData,
                    sessionId: sessionId,
                    type: 'loan',
                    vulnerabilityReason: vulnerabilityReason,
                    vulnerabilityScore: vulnerabilityScore,
                    abstractRequest: {
                        zollarMagnitude: zollarMag,
                        capitalMagnitude: capitalMag
                    }
                };
                $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
                await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/lend`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.success_targeted', 'M Note loan request sent to lender.'), true);
            } else {
                // List on market
                const payload = {
                    borrowerId: portfolioId,
                    amount: totalAmount,
                    principalType: principalType,
                    humanInterest: baseRate,
                    package: packageData,
                    vulnerabilityReason: vulnerabilityReason,
                    vulnerabilityScore: vulnerabilityScore,
                    sessionId: sessionId,
                    abstractRequest: {
                        zollarMagnitude: zollarMag,
                        capitalMagnitude: capitalMag
                    }
                };
                $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
                await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/market/list-mnote`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });
                $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.borrow.success_market', 'M Note listed on market for lenders to purchase.'), true);
            }
            if (window.emotionalMeter) window.emotionalMeter.fetchData();
        });
    };
    $d90366524d26acbf$export$1490a3f595688acf.borrowCapitalButton = onBorrowCapital;
    document.getElementById('borrowCapitalButton')?.addEventListener('click', onBorrowCapital);
    // === Request Aid (V Note) - Target specific user with vulnerability request ===
    const onRequestHandout = async ()=>{
        const portfolioId = localStorage.getItem('portfolioId');
        const sessionId = localStorage.getItem('sessionId');
        const token = localStorage.getItem('token');
        if (!portfolioId || !sessionId || !token) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.common.error_login_required', 'Please log in first'), false);
        // Fetch active portfolios
        const res = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/portfolios/active`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: sessionId
            })
        });
        const data = await res.json();
        const portfolios = Array.isArray(data) ? data : data.portfolios || [];
        const clamp01 = (v)=>Math.max(0, Math.min(1, v));
        const perceivedLabelFrom01 = (v)=>$d90366524d26acbf$export$9366fd60be9e5643(clamp01(v));
        const contentDiv = document.createElement('div');
        contentDiv.innerHTML = `
        <p><strong>${(0, $fUPn2.t)('debt_actions.request_aid.intro', 'Request aid (V Note).')}</strong> ${(0, $fUPn2.t)('debt_actions.request_aid.description', 'Ask someone for a handout by sharing your vulnerability.')}</p>
        <p style="font-size:0.9em;color:#fcba03;">${(0, $fUPn2.t)('debt_actions.request_aid.accept_decline_note', 'They can accept or decline your request.')}</p>
      `;
        // Vulnerability disclosure FIRST - most important
        const justDiv = document.createElement('div');
        justDiv.style.cssText = 'margin-top:12px;';
        justDiv.innerHTML = `
        <label style="font-family:'bithigh',monospace;color:#fcba03;font-size:1.05em;font-weight:bold;">${(0, $fUPn2.t)('debt_actions.request_aid.vulnerability_label', 'Explain why you need aid (vulnerability disclosure - min 20 chars)')}</label>
        <textarea class="handout-just" rows="4" placeholder="${(0, $fUPn2.t)('debt_actions.request_aid.vulnerability_placeholder', 'Share your vulnerability...')}" style="
          width:100%;padding:8px;font-family:'bithigh',monospace;background:rgba(0,0,0,.3);
          border:1px solid #fcba03;border-radius:6px;color:#fcba03;resize:vertical;
        "></textarea>
        <div style="margin-top:10px;">
          <label style="font-family:'bithigh',monospace;color:#fcba03;">${(0, $fUPn2.t)('debt_actions.request_aid.severity_question', 'Situation severity (how urgent is this)')}</label>
          <input type="range" class="handout-severity" min="0" max="100" value="35" style="width:100%;">
          <div style="display:flex;justify-content:flex-end;">
            <span id="handout-perceived-label" style="
              margin-top:6px;font-family:'bithigh',monospace;color:#fcba03;border:1px solid #fcba03;
              padding:6px 10px;border-radius:8px;background:rgba(0,0,0,.35);
              box-shadow:0 0 6px rgba(252,186,3,.4) inset;">${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${(0, $fUPn2.t)('debt_actions.common.magnitude_hint', 'A Hint')}</span>
          </div>
        </div>
      `;
        contentDiv.appendChild(justDiv);
        // Target selection - comes after vulnerability disclosure
        const targetSelect = $d90366524d26acbf$export$78d35f50a4fd5552.createPortfolioSelection(portfolios, (0, $fUPn2.t)('debt_actions.request_aid.target_label', 'Request aid from:'));
        contentDiv.appendChild(targetSelect);
        const sev = contentDiv.querySelector('.handout-severity');
        const badge = contentDiv.querySelector('#handout-perceived-label');
        const recompute = ()=>badge.textContent = `${(0, $fUPn2.t)('debt_actions.common.perceived_magnitude', 'Perceived magnitude')}: ${perceivedLabelFrom01((Number(sev.value) || 0) / 100)}`;
        setTimeout(recompute, 0);
        contentDiv.addEventListener('input', (e)=>{
            if (e.target === sev) recompute();
        });
        $d90366524d26acbf$export$78d35f50a4fd5552.createModal((0, $fUPn2.t)('debt_actions.request_aid.modal_title', 'V Note (Request Aid)'), contentDiv, async (modal)=>{
            // Validate target
            const target = $d90366524d26acbf$export$78d35f50a4fd5552.getSelectedPortfolio(modal);
            if (!target || !target.value) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.request_aid.error_no_target', 'Please select who to request aid from.'), false, 3000, true);
            // Validate vulnerability disclosure
            const justification = contentDiv.querySelector('.handout-just').value.trim();
            if (justification.length < 20) return $d90366524d26acbf$export$78d35f50a4fd5552.showMessage((0, $fUPn2.t)('debt_actions.request_aid.error_vulnerability_required', 'V Note requires vulnerability disclosure (min 20 characters).'), false, 3000, true);
            const severity01 = (Number(sev.value) || 0) / 100;
            $d90366524d26acbf$export$78d35f50a4fd5552.closeModal();
            const response = await fetch(`${(0, $cNeIB.apiBaseUrl)}/api/social-economy/vnote`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    requesterId: portfolioId,
                    targetId: target.value,
                    justification: justification,
                    vulnerabilityScore: severity01,
                    sessionId: sessionId
                })
            });
            const result = await response.json();
            $d90366524d26acbf$export$78d35f50a4fd5552.showMessage(result.message || (0, $fUPn2.t)('debt_actions.request_aid.success', 'V Note request sent. Awaiting response.'), result.success !== false);
            if (window.emotionalMeter) window.emotionalMeter.fetchData();
        });
    };
    $d90366524d26acbf$export$1490a3f595688acf.requestHandoutButton = onRequestHandout;
    document.getElementById('requestHandoutButton')?.addEventListener('click', onRequestHandout);
});
function $d90366524d26acbf$export$df02e6407caad277({ title: title, message: message }) {
    if (typeof showPopup === 'function') showPopup(title, message, {
        theme: 'danger'
    });
    if (typeof showNotification === 'function') showNotification('You lost assets in a CDS collapse.', false);
    if (window.emotionalMeter) window.emotionalMeter.fetchData();
}
function $d90366524d26acbf$export$ce26b1f430b884de({ title: title, message: message }) {
    if (typeof showPopup === 'function') showPopup(title, message, {
        theme: 'warning'
    });
    setTimeout(()=>{
        if (typeof showNotification === 'function') showNotification('You profited, but your victim has fallen into debt.', true);
    }, 12000);
    if (window.emotionalMeter) window.emotionalMeter.fetchData();
}
function $d90366524d26acbf$export$e136fdf6cbbbf403({ title: title, message: message }) {
    if (typeof showNotification === 'function') showNotification(message || 'Predatory loan initiated.', true);
}
// expose to global (optional)
window.modalManager = $d90366524d26acbf$export$78d35f50a4fd5552;
window.handleCDSVictimCollapse = $d90366524d26acbf$export$df02e6407caad277;
window.handleCDSExploiterGuilt = $d90366524d26acbf$export$ce26b1f430b884de;
window.handleCDSInitiation = $d90366524d26acbf$export$e136fdf6cbbbf403;

});

parcelRegister("epcPG", function(module, exports) {

$parcel$export(module.exports, "showHoloModal", () => $a7cd5ac15d74341a$export$3316965de6cf85a5);
$parcel$export(module.exports, "showHoloConfirm", () => $a7cd5ac15d74341a$export$ea7f61922f616639);
$parcel$export(module.exports, "holoNotify", () => $a7cd5ac15d74341a$export$b7d5dd0847a5d722);
// frontend/js/holoModal.js
// Holographic modal system for Emotional Debt notifications
let $a7cd5ac15d74341a$var$_lockScrollY = 0;
function $a7cd5ac15d74341a$var$getLockCount() {
    return Number(document.body.dataset.holoLockCount || 0);
}
function $a7cd5ac15d74341a$var$setLockCount(n) {
    document.body.dataset.holoLockCount = String(n);
}
function $a7cd5ac15d74341a$var$lockScrollIfNeeded() {
    const count = $a7cd5ac15d74341a$var$getLockCount();
    if (count === 0) {
        $a7cd5ac15d74341a$var$_lockScrollY = window.scrollY || window.pageYOffset || 0;
        const inline = document.body.style.overflow;
        document.body.dataset.holoPrevOverflow = inline || '';
        // iOS-friendly lock: fix body in place
        document.body.style.position = 'fixed';
        document.body.style.top = `-${$a7cd5ac15d74341a$var$_lockScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
    }
    $a7cd5ac15d74341a$var$setLockCount(count + 1);
}
function $a7cd5ac15d74341a$var$unlockScrollIfNeeded() {
    const count = $a7cd5ac15d74341a$var$getLockCount();
    const next = Math.max(0, count - 1);
    $a7cd5ac15d74341a$var$setLockCount(next);
    if (next === 0) {
        const prev = document.body.dataset.holoPrevOverflow || '';
        // Restore before scrolling back
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.body.style.overflow = prev;
        window.scrollTo(0, $a7cd5ac15d74341a$var$_lockScrollY);
        delete document.body.dataset.holoPrevOverflow;
    }
}
function $a7cd5ac15d74341a$export$3316965de6cf85a5({ title: title = 'Notification', message: message = '', type: type = 'success', buttons: buttons = null, autoClose: autoClose = true }) {
    // If one exists, we’re replacing it; don’t double-lock
    const existing = document.querySelector('.holo-modal-overlay');
    const replacingExisting = !!existing;
    if (existing) existing.remove();
    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'holo-modal-overlay';
    overlay.style.overflow = 'hidden'; // modal body will handle scrolling
    // Create modal
    const modal = document.createElement('div');
    modal.className = `holo-modal holo-${type}`;
    // Accessibility
    overlay.setAttribute('role', 'presentation');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', title);
    // Modal content
    const content = document.createElement('div');
    content.className = 'holo-modal-content';
    // Header
    const header = document.createElement('div');
    header.className = 'holo-modal-header';
    const titleEl = document.createElement('h3');
    titleEl.className = 'holo-modal-title';
    titleEl.textContent = title;
    header.appendChild(titleEl);
    // Body
    const body = document.createElement('div');
    body.className = 'holo-modal-body';
    body.innerHTML = message;
    // Footer with buttons
    const footer = document.createElement('div');
    footer.className = 'holo-modal-footer';
    if (buttons && buttons.length > 0) buttons.forEach((btn)=>{
        const button = document.createElement('button');
        button.className = `holo-btn ${btn.type ? 'holo-btn-' + btn.type : ''}`;
        button.textContent = btn.text || 'OK';
        button.onclick = (e)=>{
            e.stopPropagation();
            if (btn.onClick) btn.onClick();
            closeModal();
        };
        footer.appendChild(button);
    });
    else {
        const okBtn = document.createElement('button');
        okBtn.className = 'holo-btn holo-btn-primary';
        okBtn.textContent = 'OK';
        okBtn.onclick = (e)=>{
            e.stopPropagation();
            closeModal();
        };
        footer.appendChild(okBtn);
    }
    // Assemble
    content.appendChild(header);
    content.appendChild(body);
    content.appendChild(footer);
    modal.appendChild(content);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    // Generate unique ID for tracking
    const modalId = `holoModal_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    overlay.id = modalId;
    // Track popup state for bot interaction management
    if (window.popupTracker && !replacingExisting) window.popupTracker.trackElement(overlay, 'holo-modal');
    // Scroll lock: only lock if we weren't replacing an existing modal
    if (!replacingExisting) $a7cd5ac15d74341a$var$lockScrollIfNeeded();
    // Close on overlay click (but not on internal clicks)
    overlay.onclick = (e)=>{
        if (e.target === overlay) {
            e.stopPropagation();
            closeModal();
        }
    };
    // Prevent scroll chaining on overlay (swipes should stay in the body scroller)
    overlay.addEventListener('touchmove', (e)=>{
        const scroller = e.target.closest('.holo-modal-body');
        if (!scroller) e.preventDefault();
    }, {
        passive: false
    });
    // Auto-close
    if (autoClose && !buttons) setTimeout(closeModal, 5000);
    let isClosing = false;
    function closeModal() {
        if (isClosing) return;
        isClosing = true;
        // Untrack popup before removing
        if (window.popupTracker && overlay.id) window.popupTracker.unregisterPopup(overlay.id);
        overlay.style.animation = 'holo-fade-in 0.2s ease reverse';
        setTimeout(()=>{
            if (overlay.parentNode) overlay.remove();
            // Unlock scroll if no more overlays remain
            const remaining = document.querySelectorAll('.holo-modal-overlay').length;
            if (remaining === 0) $a7cd5ac15d74341a$var$unlockScrollIfNeeded();
        }, 200);
    }
    return {
        overlay: overlay,
        modal: modal,
        closeModal: closeModal
    };
}
function $a7cd5ac15d74341a$export$ea7f61922f616639({ title: title = 'Confirm', message: message = '', type: type = 'warning', onAccept: onAccept = ()=>{}, onDecline: onDecline = ()=>{}, acceptText: acceptText = 'Accept', declineText: declineText = 'Decline' }) {
    return $a7cd5ac15d74341a$export$3316965de6cf85a5({
        title: title,
        message: message,
        type: type,
        autoClose: false,
        buttons: [
            {
                text: declineText,
                type: 'danger',
                onClick: onDecline
            },
            {
                text: acceptText,
                type: 'primary',
                onClick: onAccept
            }
        ]
    });
}
function $a7cd5ac15d74341a$export$b7d5dd0847a5d722(message, type = 'success') {
    return $a7cd5ac15d74341a$export$3316965de6cf85a5({
        title: type === 'success' ? 'Success' : type === 'danger' ? 'Error' : 'Notice',
        message: message,
        type: type,
        autoClose: true
    });
}
var $a7cd5ac15d74341a$export$2e2bcd8739ae039 = {
    showHoloModal: $a7cd5ac15d74341a$export$3316965de6cf85a5,
    showHoloConfirm: $a7cd5ac15d74341a$export$ea7f61922f616639,
    holoNotify: $a7cd5ac15d74341a$export$b7d5dd0847a5d722
};

});

parcelRegister("lfdrK", function(module, exports) {

$parcel$export(module.exports, "registerDebtPopupHandlers", () => $f7756de821ba796a$export$b48f3c974c7de4d3);
/**
 * Debt Instrument Popup Handlers
 *
 * This module contains all the popup/modal logic for debt instruments:
 * - Altrau Z Bills
 * - M Notes
 * - Z-Payday CDOs
 * - V Notes
 * - Generic debt notifications
 */ 
var $epcPG = parcelRequire("epcPG");

var $iD9HX = parcelRequire("iD9HX");

var $fUPn2 = parcelRequire("fUPn2");
/**
 * Helper function to get qualitative label from fraction
 */ const $f7756de821ba796a$var$qLabel = (num, denom = 100)=>{
    const n = Number(num) || 0;
    const d = Math.max(1, Number(denom) || 100);
    return (0, $iD9HX.qualitativeFromFraction_LOCAL)(Math.max(0, Math.min(1, n / d)));
};
/**
 * Helper to get descriptive amount for M Notes
 */ const $f7756de821ba796a$var$getDescriptiveAmount = (amt)=>{
    if (!amt || amt <= 0) return (0, $fUPn2.t)('debt.amounts.none', 'None');
    if (amt <= 1) return (0, $fUPn2.t)('debt.amounts.barelyAny', 'Barely Any');
    if (amt <= 2) return (0, $fUPn2.t)('debt.amounts.aTrace', 'A Trace');
    if (amt <= 3) return (0, $fUPn2.t)('debt.amounts.aHint', 'A Hint');
    if (amt <= 5) return (0, $fUPn2.t)('debt.amounts.aLittle', 'A Little');
    if (amt <= 8) return (0, $fUPn2.t)('debt.amounts.aFew', 'A Few');
    if (amt <= 12) return (0, $fUPn2.t)('debt.amounts.some', 'Some');
    if (amt <= 18) return (0, $fUPn2.t)('debt.amounts.several', 'Several');
    if (amt <= 25) return (0, $fUPn2.t)('debt.amounts.moderate', 'Moderate');
    if (amt <= 35) return (0, $fUPn2.t)('debt.amounts.noticeable', 'Noticeable');
    if (amt <= 45) return (0, $fUPn2.t)('debt.amounts.considerable', 'Considerable');
    if (amt <= 60) return (0, $fUPn2.t)('debt.amounts.many', 'Many');
    if (amt <= 80) return (0, $fUPn2.t)('debt.amounts.aLot', 'A Lot');
    if (amt <= 100) return (0, $fUPn2.t)('debt.amounts.abundant', 'Abundant');
    if (amt <= 150) return (0, $fUPn2.t)('debt.amounts.heaps', 'Heaps');
    if (amt <= 200) return (0, $fUPn2.t)('debt.amounts.aGreatDeal', 'A Great Deal');
    if (amt <= 300) return (0, $fUPn2.t)('debt.amounts.substantial', 'Substantial');
    return (0, $fUPn2.t)('debt.amounts.immense', 'Immense');
};
/**
 * Helper to get descriptive interest rate for M Notes
 */ const $f7756de821ba796a$var$getDescriptiveInterest = (rate)=>{
    const pct = rate * 100;
    if (pct <= 5) return (0, $fUPn2.t)('debt.interest.minimal', 'Minimal Emotional Interest');
    if (pct <= 10) return (0, $fUPn2.t)('debt.interest.light', 'Light Emotional Interest');
    if (pct <= 15) return (0, $fUPn2.t)('debt.interest.modest', 'Modest Emotional Interest');
    if (pct <= 20) return (0, $fUPn2.t)('debt.interest.fair', 'Fair Emotional Interest');
    if (pct <= 25) return (0, $fUPn2.t)('debt.interest.moderate', 'Moderate Emotional Interest');
    if (pct <= 30) return (0, $fUPn2.t)('debt.interest.notable', 'Notable Emotional Interest');
    if (pct <= 35) return (0, $fUPn2.t)('debt.interest.considerable', 'Considerable Emotional Interest');
    if (pct <= 40) return (0, $fUPn2.t)('debt.interest.heavy', 'Heavy Emotional Interest');
    if (pct <= 50) return (0, $fUPn2.t)('debt.interest.intense', 'Intense Emotional Interest');
    return (0, $fUPn2.t)('debt.interest.crushing', 'Crushing Emotional Interest');
};
/**
 * Helper to get descriptive amount for V Notes
 */ const $f7756de821ba796a$var$getDescriptiveAmountVNote = (amt)=>{
    if (!amt || amt <= 0) return (0, $fUPn2.t)('debt.amounts.none', 'None');
    if (amt <= 10) return (0, $fUPn2.t)('debt.amounts.aHint', 'A Hint');
    if (amt <= 30) return (0, $fUPn2.t)('debt.amounts.aFew', 'A Few');
    if (amt <= 60) return (0, $fUPn2.t)('debt.amounts.some', 'Some');
    if (amt <= 100) return (0, $fUPn2.t)('debt.amounts.several', 'Several');
    if (amt <= 150) return (0, $fUPn2.t)('debt.amounts.noticeable', 'Noticeable');
    if (amt <= 200) return (0, $fUPn2.t)('debt.amounts.considerable', 'Considerable');
    return (0, $fUPn2.t)('debt.amounts.many', 'Many');
};
/**
 * Helper to format numbers for CDO display
 */ const $f7756de821ba796a$var$fmtNum = (n)=>{
    const v = Number(n);
    return Number.isFinite(v) ? v.toLocaleString() : String(n ?? '');
};
/**
 * Helper to resolve zollar count for CDO
 */ const $f7756de821ba796a$var$resolveZCount = (raw)=>{
    if (Array.isArray(raw)) return raw.length;
    if (typeof raw === 'object' && raw !== null) return Object.values(raw).reduce((a, b)=>a + (Number(b) || 0), 0);
    return Number(raw);
};
/**
 * Refreshes the emotional debt meter if available
 */ const $f7756de821ba796a$var$refreshEmotionalMeter = ()=>{
    if (window.emotionalMeter) window.emotionalMeter.fetchData();
};
/**
 * Refreshes portfolio data if the function is available
 */ const $f7756de821ba796a$var$refreshPortfolioData = ()=>{
    if (typeof loadPortfolioData === 'function') loadPortfolioData();
};
function $f7756de821ba796a$export$eb5a9d2428dab8a7(data) {
    console.log('Z Bill Altrau Received:', data);
    const { from: from, amount: amount, type: type, instrumentId: instrumentId, perceivedLabel: perceivedLabel, zollarBreakdown: zollarBreakdown } = data;
    // Prefer the backend's qualitative label, otherwise generate one
    let label = perceivedLabel;
    if (!label) {
        if (type === 'zollars') label = $f7756de821ba796a$var$qLabel(amount, 100);
        else if (type === 'capital' || type === 'points') label = $f7756de821ba796a$var$qLabel(amount, 1000);
    }
    const unitText = type === 'zollars' ? "\u01B5" : (0, $fUPn2.t)('debt.capital', 'capital');
    const giftText = label ? `${label} ${unitText}` : `${amount} ${type}`;
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.altrau.receivedTitle', 'Z Bill Altrau Received'),
        message: `<p><strong>${from}</strong> ${(0, $fUPn2.t)('debt.altrau.hasGivenYou', 'has given you')} <strong>${giftText}</strong>.</p>
              <p>${(0, $fUPn2.t)('debt.altrau.ledgersBound', 'Your ledgers are now bound. Their Life Profit affects yours.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$55738db6221cc039(data) {
    console.log('Z Bill Altrau issued:', data);
    const { to: to, amount: amount, type: type, perceivedLabel: perceivedLabel } = data;
    const normType = (type || '').toLowerCase();
    let label = perceivedLabel;
    if (!label) {
        if (normType === 'zollars') label = $f7756de821ba796a$var$qLabel(amount, 100);
        else if (normType === 'capital' || normType === 'points') label = $f7756de821ba796a$var$qLabel(amount, 1000);
        else // fallback: treat unknown as capital scale
        label = $f7756de821ba796a$var$qLabel(amount, 1000);
    }
    const unitText = normType === 'zollars' ? "\u01B5" : (0, $fUPn2.t)('debt.capital', 'capital');
    const giftText = `${label} ${unitText}`;
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.altrau.issuedTitle', 'Z Bill Altrau Issued'),
        message: `<p>${(0, $fUPn2.t)('debt.altrau.youHaveSent', 'You have sent')} <strong>${giftText}</strong> ${(0, $fUPn2.t)('debt.altrau.toRecipient', 'to')} <strong>${to}</strong>.</p>
              <p>${(0, $fUPn2.t)('debt.altrau.fatesBound', 'Your fates are now bound. Your Life Profit affects theirs.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$22034bdd75d488d8(data) {
    console.log("\uD83D\uDCAD [Frontend] ========================================");
    console.log("\uD83D\uDCAD [Frontend] M Note created event received!");
    console.log("\uD83D\uDCAD [Frontend] Data:", JSON.stringify(data, null, 2));
    const { role: role, from: from, to: to, amount: amount, interestRate: interestRate, instrumentId: instrumentId, message: message } = data;
    const title = role === 'borrower' ? (0, $fUPn2.t)('debt.mnote.acceptedTitle', 'M Note Accepted') : (0, $fUPn2.t)('debt.mnote.createdTitle', 'M Note Created');
    console.log("\uD83D\uDCAD [Frontend] Title:", title);
    console.log("\uD83D\uDCAD [Frontend] Role:", role);
    const msg = role === 'borrower' ? `<p><strong>${from}</strong> ${(0, $fUPn2.t)('debt.mnote.witnessedVulnerability', 'has witnessed your vulnerability')}.</p><p>${(0, $fUPn2.t)('debt.mnote.loanLabel', 'Loan')}: <strong>${$f7756de821ba796a$var$getDescriptiveAmount(amount)}</strong> ${(0, $fUPn2.t)('debt.mnote.atRate', 'at')} <strong>${$f7756de821ba796a$var$getDescriptiveInterest(interestRate || 0.26)}</strong>.</p><p style="font-size:0.9em;color:#3dd202;margin-top:8px;">\u{1F4A1} ${(0, $fUPn2.t)('debt.mnote.positiveTradeTip', 'Make positive trades to automatically reduce this debt!')}</p>` : `<p>${(0, $fUPn2.t)('debt.mnote.createdWith', 'M Note created with')} <strong>${to}</strong>.</p><p>${(0, $fUPn2.t)('debt.mnote.tradeableAfter', 'Tradeable after 5 exchanges. Convertible after max trades.')}</p>`;
    console.log("\uD83D\uDCAD [Frontend] Message HTML:", msg);
    console.log("\uD83D\uDCAD [Frontend] showHoloModal defined?", typeof (0, $epcPG.showHoloModal) === 'function');
    console.log("\uD83D\uDCAD [Frontend] Calling showHoloModal...");
    (0, $epcPG.showHoloModal)({
        title: title,
        message: msg,
        type: 'success'
    });
    console.log("\uD83D\uDCAD [Frontend] showHoloModal called successfully");
    $f7756de821ba796a$var$refreshEmotionalMeter();
    console.log("\uD83D\uDCAD [Frontend] ========================================");
}
function $f7756de821ba796a$export$60e5f18fbf40fa1(data) {
    console.log("\uD83D\uDCCA M Note progress:", data);
    const { milestone: milestone, percentRepaid: percentRepaid, remainingAmount: remainingAmount, message: message } = data;
    (0, $epcPG.holoNotify)(`<p><strong>${(0, $fUPn2.t)('debt.mnote.progressTitle', 'M Note Repayment Progress')}</strong></p>
     <p>${(0, $fUPn2.t)('debt.mnote.repaidPercent', "You've repaid")} <strong>${milestone}%</strong> ${(0, $fUPn2.t)('debt.mnote.throughTrading', 'through positive trading')}!</p>
     <p style="font-size:0.9em;color:#999;">${(0, $fUPn2.t)('debt.mnote.keepTrading', 'Keep trading well to continue reducing your debt.')}</p>`, 'success');
    $f7756de821ba796a$var$refreshPortfolioData();
}
function $f7756de821ba796a$export$e811bb0d4bb84631(data) {
    console.log("\u2705 M Note repaid:", data);
    const { role: role, instrumentId: instrumentId, borrowerName: borrowerName, lenderName: lenderName, message: message, repaymentMethod: repaymentMethod } = data;
    const title = role === 'borrower' ? (0, $fUPn2.t)('debt.mnote.debtClearedTitle', 'Debt Cleared!') : (0, $fUPn2.t)('debt.mnote.repaidTitle', 'M Note Repaid');
    const repaymentMethodText = repaymentMethod === 'trading' ? (0, $fUPn2.t)('debt.mnote.positiveTrading', 'positive trading') : (0, $fUPn2.t)('debt.mnote.directRepayment', 'direct repayment');
    const msg = role === 'borrower' ? `<p>\u{1F389} ${(0, $fUPn2.t)('debt.mnote.fullyRepaidTo', "You've fully repaid your M Note to")} <strong>${lenderName}</strong> ${(0, $fUPn2.t)('debt.mnote.throughMethod', 'through')} ${repaymentMethodText}!</p><p>${(0, $fUPn2.t)('debt.mnote.emotionalDebtCleared', 'Your emotional debt is cleared. Well done!')}</p>` : `<p><strong>${borrowerName}</strong> ${(0, $fUPn2.t)('debt.mnote.hasFullyRepaid', 'has fully repaid their M Note')} ${(0, $fUPn2.t)('debt.mnote.throughMethod', 'through')} ${repaymentMethodText}.</p><p>${(0, $fUPn2.t)('debt.mnote.instrumentClosed', 'The debt instrument has been closed.')}</p>`;
    (0, $epcPG.showHoloModal)({
        title: title,
        message: msg,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshPortfolioData();
}
function $f7756de821ba796a$export$dd62890455bb572(data) {
    console.log("\uD83D\uDD14 M Note trade alert:", data);
    const { borrowerName: borrowerName, lenderName: lenderName, tradesRemaining: tradesRemaining, message: message } = data;
    (0, $epcPG.holoNotify)(`<p><strong>${(0, $fUPn2.t)('debt.mnote.alertTitle', 'M Note Alert')}</strong></p><p>${message}</p>`, 'warning');
}
function $f7756de821ba796a$export$b5805e5d8b8057e0(data) {
    console.log("\u2728 M Note convertible:", data);
    const { borrowerName: borrowerName, amount: amount, message: message } = data;
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.mnote.convertibleTitle', 'M Note Convertible'),
        message: `<p>${(0, $fUPn2.t)('debt.mnote.nowConvertible', 'Your M Note is now')} <strong>${(0, $fUPn2.t)('debt.mnote.convertibleCaps', 'CONVERTIBLE')}</strong>!</p><p>${(0, $fUPn2.t)('debt.mnote.canConvertTo', 'You can convert it to')} <strong>${amount}</strong> ${(0, $fUPn2.t)('debt.mnote.inLiquidAssets', 'in liquid assets')}.</p><p style="font-size:0.9em;color:#fcba03;margin-top:8px;">${(0, $fUPn2.t)('socketFront.checkDebtHeldSection', 'Check your Debt Held section to convert.')}</p>`,
        type: 'success'
    });
}
function $f7756de821ba796a$export$42c390334c7db64a(data) {
    console.log("\u2620\uFE0F Z-Payday CDO created:", data);
    const { role: role, from: from, to: to, amount: amount, instrumentId: instrumentId, message: message, principalType: principalType, zollarCount: zollarCount, pkg: pkg } = data;
    // Try to show zollars if provided; otherwise fall back to capital
    let headline;
    if (String(principalType).toLowerCase() === 'zollars') {
        let count = $f7756de821ba796a$var$resolveZCount(zollarCount);
        if (!Number.isFinite(count) || count <= 0) {
            const raw = pkg?.zollars;
            const derived = $f7756de821ba796a$var$resolveZCount(raw);
            count = Number.isFinite(derived) && derived > 0 ? derived : Number(amount) || 0;
        }
        // Use qualitative descriptor for zollars (assume max ~100 for context)
        const qualitativeLabel = $f7756de821ba796a$var$qLabel(count, 100);
        headline = `<strong>${qualitativeLabel} \u{1B5}</strong> ${(0, $fUPn2.t)('debt.cdo.availableImmediately', 'available immediately')}!`;
    } else headline = `<strong>${$f7756de821ba796a$var$fmtNum(amount)} ${(0, $fUPn2.t)('debt.capital', 'capital')}</strong> ${(0, $fUPn2.t)('debt.cdo.availableImmediately', 'available immediately')}!`;
    if (role === 'victim') (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.cdo.acceptedTitle', 'Z-Payday CDO Accepted'),
        message: `<p><strong>${from}</strong> ${(0, $fUPn2.t)('debt.cdo.offeredLoan', 'has offered you a loan')}.</p>
                <p style="font-size:1.1em;color:#3dd202;margin:10px 0;">${headline}</p>
                <p>${(0, $fUPn2.t)('socketFront.debtWarningPrefix', 'WARNING: This debt reloads every 60 seconds at 15% compound until repayment.')}</p>`,
        type: 'danger',
        autoClose: false
    });
    else (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.cdo.createdTitle', 'Z-Payday CDO Created'),
        message: `<p>${(0, $fUPn2.t)('debt.cdo.createdWith', 'Z-Payday CDO created with')} <strong>${to}</strong>.</p>
                <p>${(0, $fUPn2.t)('debt.cdo.tradeableCompounds', 'Tradeable. Compounds every 60s at 15%.')}</p>`,
        type: 'warning'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$52be63a85f106281(data) {
    console.log("\uD83D\uDCB8 Z-Payday CDO reloaded:", data);
    const { role: role, cycle: cycle, newDebt: newDebt, totalDebt: totalDebt, isBankrupt: isBankrupt, message: message } = data;
    const modalType = isBankrupt ? 'danger' : role === 'victim' ? 'warning' : 'success';
    const title = isBankrupt ? (0, $fUPn2.t)('debt.cdo.bankruptcyWarningTitle', 'BANKRUPTCY WARNING') : (0, $fUPn2.t)('debt.cdo.reloadCycle', 'CDO Reload: Cycle {cycle}').replace('{cycle}', cycle);
    const msg = role === 'victim' ? `<p>${(0, $fUPn2.t)('socketFront.debtCompounded', 'Debt compounded:')} <strong>+${newDebt}</strong></p><p>${(0, $fUPn2.t)('socketFront.totalDebt', 'Total debt:')} <strong>${totalDebt}</strong></p>${isBankrupt ? `<p style="color:#ff4d4d;">${(0, $fUPn2.t)('socketFront.bankruptcyWarning', 'WARNING: You are approaching bankruptcy!')}</p>` : ''}` : `<p>${(0, $fUPn2.t)('debt.cdo.cdoCompounded', 'Your CDO compounded')}.</p><p>${(0, $fUPn2.t)('debt.cdo.victimOwes', 'Victim owes')}: <strong>${totalDebt}</strong></p>`;
    (0, $epcPG.holoNotify)(`${title}: ${message}`, modalType);
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$27ddba50e36b177c(data) {
    console.log("\uD83D\uDCA5 Z-Payday CDO bankruptcy:", data);
    const { role: role, totalDebt: totalDebt, seized: seized, message: message } = data;
    if (role === 'victim') (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.cdo.bankruptcyTitle', 'BANKRUPTCY'),
        message: `<p><strong>${(0, $fUPn2.t)('debt.cdo.cdoCollapsed', 'Your Z-Payday CDO collapsed')}.</strong></p><p>${(0, $fUPn2.t)('debt.cdo.totalDebtLabel', 'Total debt')}: <strong>${totalDebt}</strong></p><p>${(0, $fUPn2.t)('debt.cdo.assetsSeized', 'Assets seized')}: <strong>${seized}</strong> ${(0, $fUPn2.t)('debt.capital', 'capital')}</p><p style="color:#ff4d4d;">${(0, $fUPn2.t)('debt.cdo.standingDamaged', 'Your financial standing has been severely damaged.')}</p>`,
        type: 'danger',
        autoClose: false
    });
    else (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.cdo.maturedTitle', 'CDO Matured'),
        message: `<p>${(0, $fUPn2.t)('debt.cdo.victimBankrupt', 'Your victim declared bankruptcy')}.</p><p>${(0, $fUPn2.t)('debt.cdo.youSeized', 'You seized')}: <strong>${seized}</strong> ${(0, $fUPn2.t)('debt.capital', 'capital')}</p><p style="color:#fcba03;">${(0, $fUPn2.t)('debt.cdo.toxicGainRecorded', 'Toxic relationship gain recorded.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
}
function $f7756de821ba796a$export$8baf2e763aa92bb8(data) {
    console.log("\uD83D\uDE4F V Note granted:", data);
    const { from: from, amount: amount, message: message } = data;
    const descriptiveAmount = $f7756de821ba796a$var$getDescriptiveAmountVNote(amount);
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.vnote.aidGrantedTitle', 'V Note Aid Granted'),
        message: `<p><strong>${from}</strong> ${(0, $fUPn2.t)('debt.vnote.hasGrantedAid', 'has granted you aid')}!</p>
      <p style="font-size:1.1em;color:#3dd202;margin:10px 0;">${(0, $fUPn2.t)('debt.vnote.received', 'Received')}: <strong>${descriptiveAmount} ${(0, $fUPn2.t)('debt.capital', 'capital')}</strong> (${amount})</p>
      <p style="font-size:0.9em;color:#fcba03;">${(0, $fUPn2.t)('debt.vnote.vulnerabilityWitnessed', 'Your vulnerability was witnessed and met with compassion.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
    $f7756de821ba796a$var$refreshPortfolioData();
}
function $f7756de821ba796a$export$64d03892c78bf290(data) {
    console.log("\u2705 V Note grant confirmed:", data);
    const { to: to, amount: amount, message: message } = data;
    const descriptiveAmount = $f7756de821ba796a$var$getDescriptiveAmountVNote(amount);
    (0, $epcPG.showHoloModal)({
        title: (0, $fUPn2.t)('debt.vnote.aidGrantedTitle', 'Aid Granted'),
        message: `<p>${(0, $fUPn2.t)('debt.vnote.youGranted', 'You granted')} <strong>${descriptiveAmount} ${(0, $fUPn2.t)('debt.capital', 'capital')}</strong> (${amount}) ${(0, $fUPn2.t)('debt.vnote.toRecipient', 'to')} <strong>${to}</strong>.</p>
      <p style="font-size:0.9em;color:#fcba03;">${(0, $fUPn2.t)('debt.vnote.compassionRecorded', 'Your compassion has been recorded in the social ledger.')}</p>`,
        type: 'success'
    });
    $f7756de821ba796a$var$refreshEmotionalMeter();
    $f7756de821ba796a$var$refreshPortfolioData();
}

function $f7756de821ba796a$export$2065a027b0dcfec2(data) {
    console.log("\uD83D\uDCB8 Debt notification received:", data);
    const { showNotification: showNotification } = (parcelRequire("eD3DY"));
    if (data.type === 'debt_warning') showNotification(`${(0, $fUPn2.t)('socketFront.warningPrefix', 'WARNING:')} ${data.message}`, false);
    else if (data.type === 'default_warning') showNotification(`${(0, $fUPn2.t)('socketFront.criticalPrefix', 'CRITICAL:')} ${data.message}`, false);
    else if (data.type === 'margin_notice') showNotification(`${data.message}`, true);
    else if (data.type === 'payment_received') showNotification(`${data.message}`, true);
    else if (data.type === 'recovery_offered') showNotification(`${data.message} ${(0, $fUPn2.t)('socketFront.debtPageVisit', 'Visit the Debt page for details.')}`, true);
}

function $f7756de821ba796a$export$599cf2b7ea32622f(data) {
    console.log("\uD83D\uDCA5 Debt wipeout event received:", data);
    const { showNotification: showNotification } = (parcelRequire("eD3DY"));
    showNotification(data.message || (0, $fUPn2.t)('socketFront.debtWipeoutDefault', 'Your portfolio has been wiped out due to excessive debt.'), false);
    setTimeout(()=>{
        window.location.href = data.redirectUrl || '/debtend.html';
    }, 2000);
}

function $f7756de821ba796a$export$529e377b6a0f0af1(data) {
    console.log("\uD83D\uDCB0 Debt closed notification received:", data);
    const { instrumentType: instrumentType, instrumentId: instrumentId, message: message, amount: amount } = data;
    const { showNotification: showNotification } = (parcelRequire("eD3DY"));
    const defaultMessage = instrumentType ? (0, $fUPn2.t)('debt.closedDefault', 'A {type} debt instrument has been closed.').replace('{type}', instrumentType) : (0, $fUPn2.t)('debt.closedGeneric', 'A debt instrument has been closed.');
    showNotification(message || defaultMessage, true);
}
function $f7756de821ba796a$export$b48f3c974c7de4d3(socket) {
    // Altrau Z Bill handlers
    socket.on('altrauZBillReceived', $f7756de821ba796a$export$eb5a9d2428dab8a7);
    socket.on('altrauZBillGiven', $f7756de821ba796a$export$55738db6221cc039);
    // M Note handlers
    socket.on('mNoteCreated', $f7756de821ba796a$export$22034bdd75d488d8);
    socket.on('mNoteProgress', $f7756de821ba796a$export$60e5f18fbf40fa1);
    socket.on('mNoteRepaid', $f7756de821ba796a$export$e811bb0d4bb84631);
    socket.on('mNoteTradeAlert', $f7756de821ba796a$export$dd62890455bb572);
    socket.on('mNoteConvertible', $f7756de821ba796a$export$b5805e5d8b8057e0);
    // Z-Payday CDO handlers
    socket.on('zPaydayCDOCreated', $f7756de821ba796a$export$42c390334c7db64a);
    socket.on('zPaydayCDOReloaded', $f7756de821ba796a$export$52be63a85f106281);
    socket.on('zPaydayCDOBankruptcy', $f7756de821ba796a$export$27ddba50e36b177c);
    // V Note handlers
    socket.on('vNoteGranted', $f7756de821ba796a$export$8baf2e763aa92bb8);
    socket.on('vNoteGrantConfirm', $f7756de821ba796a$export$64d03892c78bf290);
    // Generic debt notifications
    socket.on('debtNotification', $f7756de821ba796a$export$2065a027b0dcfec2);
    socket.on('debtWipeout', $f7756de821ba796a$export$599cf2b7ea32622f);
    socket.on('debtClosed', $f7756de821ba796a$export$529e377b6a0f0af1);
}

});

parcelRegister("ehiC0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jqanU").then(()=>parcelRequire('5AjYu'));

});


var $c1f4553d08db67a9$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"abTjN\",\"mood.6b4ce996.js\",\"jqanU\",\"ransom.2c583a01.js\",\"4zQMZ\",\"botChatHandler.78aa02a8.js\",\"iPtyb\",\"mood.a70c36df.js\",\"hiUMQ\",\"mood.14a37bdb.js\",\"4fgzv\",\"mood.0dd4a47b.js\",\"idog4\",\"mood.1b6a8b22.js\"]"));


parcelRequire("bNbKd");

//# sourceMappingURL=mood.6b4ce996.js.map
